/* tslint:disable */
/* eslint-disable */
/**
 * Fay API
 * Fay API
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export interface AIPrefillFieldsetResponse {
    'ai_prefill_fieldset_id': string;
    'appointment_id': string;
    'created_at': string;
    'in_progress_at'?: string | null;
    'completed_at'?: string | null;
    'failed_permanently_at'?: string | null;
    'canceled_at'?: string | null;
    'status': AIPrefillStatusResponse;
    'prefilled_fields'?: Array<ClinicalFieldKey> | null;
}



export const AIPrefillStatusResponse = {
    Created: 'created',
    InProgress: 'in_progress',
    Failed: 'failed',
    FailedPermanently: 'failed_permanently',
    Completed: 'completed',
    Canceled: 'canceled'
} as const;

export type AIPrefillStatusResponse = typeof AIPrefillStatusResponse[keyof typeof AIPrefillStatusResponse];



export const APIAppointmentStatus = {
    Scheduled: 'Scheduled',
    Occurred: 'Occurred',
    Canceled: 'Canceled',
    NoShow: 'No-show',
    ReScheduled: 'Re-scheduled'
} as const;

export type APIAppointmentStatus = typeof APIAppointmentStatus[keyof typeof APIAppointmentStatus];



export const APIAppointmentType = {
    InitialConsultation: 'Initial Consultation',
    FollowUp: 'Follow-up'
} as const;

export type APIAppointmentType = typeof APIAppointmentType[keyof typeof APIAppointmentType];


export interface APIClaimSpecificationBillingProvider {
    'phone_number': string;
    'name': string;
    'street_address': string;
    'city': string;
    'state': USState;
    'postal_code': string;
    'npi': string;
}


export interface APIClaimSpecificationInput {
    'appointment_id'?: string | null;
    'place_of_service': PlaceOfService;
    'patient': APIClaimSpecificationPatient;
    'patient_insurance': APIClaimSpecificationPatientInsurance;
    'provider_details': APIClaimSpecificationProviderDetails;
    'supervising_provider'?: APIClaimSpecificationProviderDetails | null;
    'service_location_details': APIClaimSpecificationServiceLocation;
    'billing_provider_details': APIClaimSpecificationBillingProvider;
    'tax_id': string;
    'payer_id'?: PayerId | null;
    'payer_name'?: PayerName | null;
    'resubmission_code'?: ResubmissionCode | null;
    'parent_claim_id'?: string | null;
    'parent_claim_carrier_control_number'?: string | null;
    'claim_account_number'?: string | null;
    'created_at'?: string | null;
    'billable_remote_encounter_id'?: string | null;
    'service_line_items': Array<APIClaimSpecificationServiceLineItemInput>;
}


export interface APIClaimSpecificationOutput {
    'appointment_id'?: string | null;
    'place_of_service': PlaceOfService;
    'patient': APIClaimSpecificationPatient;
    'patient_insurance': APIClaimSpecificationPatientInsurance;
    'provider_details': APIClaimSpecificationProviderDetails;
    'supervising_provider'?: APIClaimSpecificationProviderDetails | null;
    'service_location_details': APIClaimSpecificationServiceLocation;
    'billing_provider_details': APIClaimSpecificationBillingProvider;
    'tax_id': string;
    'payer_id'?: PayerId | null;
    'payer_name'?: PayerName | null;
    'resubmission_code'?: ResubmissionCode | null;
    'parent_claim_id'?: string | null;
    'parent_claim_carrier_control_number'?: string | null;
    'claim_account_number'?: string | null;
    'created_at'?: string | null;
    'billable_remote_encounter_id'?: string | null;
    'service_line_items': Array<APIClaimSpecificationServiceLineItemOutput>;
}


export interface APIClaimSpecificationPatient {
    'patient_id': string;
    'first_name': string;
    'last_name': string;
    'date_of_birth'?: string | null;
    'sex'?: Sex | null;
    'phone_number'?: string | null;
    'address_line1': string;
    'address_line2'?: string | null;
    'city': string;
    'state': USState;
    'postal_code': string;
    'bmi'?: string | null;
}


export interface APIClaimSpecificationPatientInsurance {
    'company': InsuranceCompany;
    'member_id': string;
    'relationship_to_insured': HolderRelationship;
    'insured_first_name': string;
    'insured_last_name': string;
    'insured_date_of_birth'?: string | null;
    'insured_sex'?: Sex | null;
    'insured_address_line1': string;
    'insured_address_line2'?: string | null;
    'insured_address_city': string;
    'insured_address_state': USState;
    'insured_address_postal_code': string;
    'is_eligible'?: boolean | null;
}


export interface APIClaimSpecificationProviderDetails {
    'provider_id': string;
    'name': string;
    'npi': string;
}
export interface APIClaimSpecificationServiceLineItemInput {
    'date_of_service': string;
    'cpt_code': CPTCode;
    'cpt_modifiers': Array<CPTModifier>;
    'amount_billed_per_unit': AmountBilledPerUnit;
    'units': number;
    'diagnosis_codes': Array<ICDCode>;
}


export interface APIClaimSpecificationServiceLineItemOutput {
    'date_of_service': string;
    'cpt_code': CPTCode;
    'cpt_modifiers': Array<CPTModifier>;
    'amount_billed_per_unit': string;
    'units': number;
    'diagnosis_codes': Array<ICDCode>;
}


export interface APIClaimSpecificationServiceLocation {
    'name': string;
    'street_address': string;
    'city': string;
    'state': USState;
    'postal_code': string;
    'npi'?: string | null;
}



export const APIRecurrenceType = {
    Weekly: 'Weekly',
    Monthly: 'Monthly',
    BiWeekly: 'Bi-weekly'
} as const;

export type APIRecurrenceType = typeof APIRecurrenceType[keyof typeof APIRecurrenceType];


export interface AccountSessionResponse {
    'client_secret': string;
}
/**
 * Types of ad-hoc line items that can be added to provider payouts.
 */

export const AdHocLineItemType = {
    Appointment: 'Appointment',
    FayChampion: 'Fay Champion',
    ClientEngagementReward: 'Client Engagement Reward',
    ReferralBonus: 'Referral Bonus',
    GroupPracticePassthrough: 'Group Practice Passthrough'
} as const;

export type AdHocLineItemType = typeof AdHocLineItemType[keyof typeof AdHocLineItemType];


export interface AddClaimPrefixesPayload {
    'type': PrefixType;
    'prefixes': Array<string>;
}


export interface AddPatientLabFeedbackPayload {
    'is_feedback_positive': boolean;
}
export interface AddPrefixesResult {
    'added_count': number;
    'skipped_count': number;
    'prefix_type': string;
}
export interface AddToCartPayload {
    'product_id': string;
    'variant_id': string;
    'quantity': number;
}
export interface AddressDetails {
    'address_line1': string;
    'address_line2'?: string | null;
    'city': string;
    'state': string;
    'zip_code': string;
}
export interface AdminProviderDetailsResponse {
    'provider_id': string;
    'cognito_id': string;
    'first_name': string;
    'last_name': string;
    'preferred_first_name': string;
    'full_name': string;
    'full_legal_name': string;
    'slug': string;
    'email': string;
    'npi': string;
    'timezone': string;
    'has_set_password': boolean;
    'is_admin': boolean;
    'is_churned': boolean;
    'is_test': boolean;
}
export interface AllNotificationsResponse {
    'notifications': Array<BasicNotification>;
    'total': number;
}
export interface AllSettingsResponse {
    'settings': Array<GroupSettingItem>;
}

export const AllowedSortParam = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type AllowedSortParam = typeof AllowedSortParam[keyof typeof AllowedSortParam];


export interface AmazonHBCReferralPrefillResponse {
    'first_name'?: string | null;
    'last_name'?: string | null;
    'date_of_birth'?: string | null;
    'email_address'?: string | null;
    'insurance_company'?: InsuranceCompany | null;
}


export interface Amount {
}
export interface AmountBilledPerUnit {
}
export interface AnnouncementResponse {
    'announcement_type': AnnouncementType;
    'title': string;
    'description': string;
    'dismiss_text': string | null;
}



export const AnnouncementType = {
    AsyncBillingAnnouncement: 'ASYNC_BILLING_ANNOUNCEMENT',
    AuditProofedChartNotesAnnouncement: 'AUDIT_PROOFED_CHART_NOTES_ANNOUNCEMENT',
    OnDemandBookingsAnnouncement: 'ON_DEMAND_BOOKINGS_ANNOUNCEMENT'
} as const;

export type AnnouncementType = typeof AnnouncementType[keyof typeof AnnouncementType];


export interface AnnouncementsToShowResponse {
    'announcements_to_show': Array<AnnouncementResponse>;
}
export interface AppReviewPayload {
    'rating': number;
    'feedback'?: string | null;
    'metadata'?: object | null;
}
export interface AppReviewResponse {
    'rating': number;
    'feedback'?: string | null;
}
export interface AppUpdateResponse {
    'show_upgrade_screen': boolean;
}
export interface AppointmentAddToCalendarDetailsResponse {
    'start': string;
    'end': string;
    'title': string;
    'description': string;
    'join_url': string | null;
    'location': string;
    'ics_data': string;
    'add_to_google_calendar_url': string;
    'add_to_outlook_url': string;
}
export interface AppointmentCanceledResponse {
    'appointment_id': string;
}
export interface AppointmentDetailsResponse {
    'appointment_id': string;
    'patient_id': string;
    'provider_id': string;
    'status': APIAppointmentStatus;
    'appointment_type': APIAppointmentType;
    'duration_in_minutes': number;
    'location_type': AppointmentLocationType;
    'location': string | null;
}


export interface AppointmentInfo {
    'selected_time': string;
    'end_time': string;
    'reason': string | null;
    'is_video_call': boolean | null;
    'is_in_person': boolean | null;
    'appointment_description': string;
}

export const AppointmentLocationType = {
    InPerson: 'in_person',
    Virtual: 'virtual',
    Unknown: 'unknown'
} as const;

export type AppointmentLocationType = typeof AppointmentLocationType[keyof typeof AppointmentLocationType];


/**
 * Response model for the Appointments API.
 */
export interface AppointmentResponse {
    'appointment_id': string;
    'patient_id': string;
    'provider_id': string;
    'calendar_event_id': string;
    'status': APIAppointmentStatus;
    'appointment_type': APIAppointmentType;
    'start': string;
    'end': string;
    'duration_in_minutes': number;
    'recurrence_type': RecurrenceType | null;
    'recurrence_id': string | null;
    'is_fully_paid'?: boolean;
    'location_type': AppointmentLocationType;
    'location': string | null;
    'reward_type': RewardType | null;
}



export const AppointmentStatus = {
    Scheduled: 'Scheduled',
    Occurred: 'Occurred',
    Canceled: 'Canceled',
    NoShow: 'No-show',
    ReScheduled: 'Re-scheduled'
} as const;

export type AppointmentStatus = typeof AppointmentStatus[keyof typeof AppointmentStatus];



export const AppointmentType = {
    InitialConsultation: 'Initial Consultation',
    FollowUp: 'Follow-up'
} as const;

export type AppointmentType = typeof AppointmentType[keyof typeof AppointmentType];


export interface AppointmentVideoCallResponse {
    'appointment_id': string;
    'provider_id': string;
    'patient_id': string;
    'join_url': string;
}
export interface AvailabilitySlot {
    'window': DateTimeWindow;
    'availability_type': ProviderAvailabilityType;
}


export interface AvailabilitySlotsResponse {
    'slots': Array<string>;
    'available_slots': Array<AvailabilitySlot>;
}
export interface AvailabilityTypeUpdatePayload {
    'availability_type': ProviderAvailabilityType;
    'status': AvailabilityTypeUpdatePayloadStatusEnum;
}

export const AvailabilityTypeUpdatePayloadStatusEnum = {
    Active: 'active',
    Disabled: 'disabled'
} as const;

export type AvailabilityTypeUpdatePayloadStatusEnum = typeof AvailabilityTypeUpdatePayloadStatusEnum[keyof typeof AvailabilityTypeUpdatePayloadStatusEnum];

export interface BMI {
    'value': string;
}
export interface BackgroundJobPayload {
    'job_name': string;
    'schedule_expression': string;
}
export interface BaseAddress {
    'line1': string;
    'line2'?: string | null;
    'city': string;
    'state': USState;
    'postal_code': string;
    'country'?: string;
}


export interface BasicNotification {
    'notification_id': string;
    'recipient': Recipient;
    'subject': Subject | null;
    'notification_type': NotificationType;
    'should_send_at': string;
    'did_send_at'?: string | null;
    'is_cancelled'?: boolean;
    'destination_medium'?: DestinationMedium | null;
    'destination_address'?: string | null;
    'external_id'?: string | null;
}


export interface BeginPhoneLoginChallengePayload {
    'user_type': UserType;
    'phone_number': string;
}


export interface BeginResetPasswordPayload {
    'email': string;
    'user_type': UserType;
}


export interface BookAppointmentPayload {
    'patient_id'?: PatientId1 | null;
    'provider_id'?: ProviderId1 | null;
    'start': string;
    'duration_in_minutes': number;
    'appointment_type': APIAppointmentType;
    'recurrence_type'?: APIRecurrenceType | null;
    'location_type'?: AppointmentLocationType;
}


export interface BookAppointmentResponse {
    'appointment_id': string;
}

export const BookingCodeFlag = {
    DisableInsuranceNotifications: 'disable_insurance_notifications',
    DisablePaymentNotifications: 'disable_payment_notifications',
    DisableWelcomeNotifications: 'disable_welcome_notifications',
    EnableFayPrefilledInsurance: 'enable_fay_prefilled_insurance',
    EnableFayPrefilledPayment: 'enable_fay_prefilled_payment',
    DisableDonations: 'disable_donations'
} as const;

export type BookingCodeFlag = typeof BookingCodeFlag[keyof typeof BookingCodeFlag];


export interface BookingCodeResponse {
    'booking_code_id': string;
    'code': string;
    'description': string;
    'code_type': BookingCodeType;
    'created_at': string;
    'is_active': boolean;
}


export interface BookingCodeResponseWithConfig {
    'booking_code_id': string;
    'code': string;
    'description': string;
    'code_type': BookingCodeType;
    'created_at': string;
    'is_active': boolean;
    'config': { [key: string]: boolean; };
}



export const BookingCodeType = {
    Influencer: 'influencer',
    MealVoucher: 'meal_voucher',
    SocialShare: 'social_share',
    PatientReferral: 'patient_referral',
    Partnership: 'partnership'
} as const;

export type BookingCodeType = typeof BookingCodeType[keyof typeof BookingCodeType];


export interface BookingCodesResponse {
    'booking_codes': Array<BookingCodeResponse>;
}

export const BookingInfoAppointmentConfirmationStatus = {
    Cancelled: 'CANCELLED',
    Confirmed: 'CONFIRMED',
    Unconfirmed: 'UNCONFIRMED'
} as const;

export type BookingInfoAppointmentConfirmationStatus = typeof BookingInfoAppointmentConfirmationStatus[keyof typeof BookingInfoAppointmentConfirmationStatus];


export interface BookingInfoResponse {
    'appointment_confirmation_status': BookingInfoAppointmentConfirmationStatus;
    'is_patient_insurance_needed': boolean;
    'is_patient_address_needed': boolean;
    'appointment_info': AppointmentInfo;
    'patient_info': PatientInfo;
    'provider_info': ProviderInfo;
}


/**
 * Payload for bulk MRR submission operations (send, download, etc.).
 */
export interface BulkMRRSubmissionsPayload {
    'medical_record_request_submission_ids'?: Array<string>;
}
export interface BusResubmissionPayload {
    'command_or_event_name': string;
    'payload': object;
}
export interface BusResubmissionResponse {
    'success': boolean;
    'message': string;
}
/**
 * A CPT code for a claim.
 */

export const CPTCode = {
    _97802: '97802',
    _97803: '97803',
    _99401: '99401',
    _99402: '99402',
    _99403: '99403',
    _99404: '99404',
    _99424: '99424',
    _99425: '99425',
    _98970: '98970',
    _98971: '98971',
    _98972: '98972',
    S5170: 'S5170',
    G0108: 'G0108',
    G0109: 'G0109',
    G2012: 'G2012',
    S9470: 'S9470',
    _99457: '99457',
    _99201: '99201',
    _99202: '99202',
    G2063: 'G2063',
    _99423: '99423',
    G0270: 'G0270',
    _99453: '99453',
    _99454: '99454',
    _994572: '99457',
    _99458: '99458',
    _98975: '98975',
    _98980: '98980',
    _98981: '98981',
    _99091: '99091'
} as const;

export type CPTCode = typeof CPTCode[keyof typeof CPTCode];


/**
 * CPT modifiers provide additional information about the performed procedure or service.  There are many more of these, so we\'ll add additional modifiers as needed.
 */

export const CPTModifier = {
    Gt: 'GT',
    Gq: 'GQ',
    _95: '95',
    _25: '25',
    _33: '33'
} as const;

export type CPTModifier = typeof CPTModifier[keyof typeof CPTModifier];


export interface CalendarEventResponse {
    'calendar_event_id': string;
    'title': string;
    'start': string;
    'end': string;
    'recurrence_type': APIRecurrenceType | null;
    'appointment': AppointmentDetailsResponse | null;
    'synced_calendar_event': SyncedCalendarEventDetailsResponse | null;
    'location': string | null;
    'location_type': AppointmentLocationType;
}


export interface CalendarEventsResponse {
    'events': Array<CalendarEventResponse>;
}
export interface CaptureFeedbackNextAction {
    'type': CaptureFeedbackNextActionTypeEnum;
    'url'?: string | null;
}

export const CaptureFeedbackNextActionTypeEnum = {
    Note: 'note',
    Redirect: 'redirect'
} as const;

export type CaptureFeedbackNextActionTypeEnum = typeof CaptureFeedbackNextActionTypeEnum[keyof typeof CaptureFeedbackNextActionTypeEnum];

export interface CaptureFeedbackNoteRequest {
    /**
     * Feedback note text
     */
    'note': string;
}
export interface CaptureFeedbackRatingRequest {
    /**
     * Star rating from 1-5
     */
    'rating': number;
}
export interface CaptureFeedbackRatingResponse {
    'next_action': CaptureFeedbackNextAction;
}

export const CardBrand = {
    Visa: 'Visa',
    Mastercard: 'Mastercard',
    AmericanExpress: 'American Express',
    Discover: 'Discover',
    Jcb: 'JCB',
    DinersClub: 'Diners Club',
    Fay: 'Fay',
    Unknown: 'Unknown'
} as const;

export type CardBrand = typeof CardBrand[keyof typeof CardBrand];



export const CardSource = {
    CreditCard: 'Credit Card',
    HsaCard: 'HSA Card',
    FsaCard: 'FSA Card',
    FayCard: 'Fay Card'
} as const;

export type CardSource = typeof CardSource[keyof typeof CardSource];


export interface CartDetailsResponse {
    'patient_id': string;
    'total_price': string;
    'items': Array<CartItemDetailsResponse>;
}
export interface CartItemDetailsResponse {
    'cart_item_id': string;
    'product_id': string;
    'product_variant_id': string;
    'product_name': string;
    'variant_name': string;
    'image_url': string;
    'quantity': number;
    'unit_price': string;
    'total_price': string;
}
export interface CatalogResponse {
    'products': Array<ProductDetailsResponse>;
    'total_count': number;
    'page': number;
    'limit': number;
}
/**
 * Sort options for the catalog.
 */

export const CatalogSortOptions = {
    DayStableShuffle: 'day_stable_shuffle',
    NameAsc: 'name_asc',
    NameDesc: 'name_desc',
    PriceAsc: 'price_asc',
    PriceDesc: 'price_desc'
} as const;

export type CatalogSortOptions = typeof CatalogSortOptions[keyof typeof CatalogSortOptions];


export interface CategoryDetailsResponse {
    'category_id': string;
    'name': string;
    'slug': string;
    'product_count': number;
}
export interface ChallengeDetailsResponse {
    'patient_challenge_id': string;
    'patient_id': string;
    'start': string;
    'end': string;
    'label': string;
    'task_type': ChallengeTaskType;
    'task_description': string;
    'total_tasks': number;
    'completed_tasks': number;
    'is_completed': boolean;
    'is_active': boolean;
    'reward'?: RewardResponse | null;
}


/**
 * Task types for challenges.
 */

export const ChallengeTaskType = {
    CompleteAppointment: 'complete_appointment'
} as const;

export type ChallengeTaskType = typeof ChallengeTaskType[keyof typeof ChallengeTaskType];


export interface ChallengesResponse {
    'challenges': Array<ChallengeDetailsResponse>;
}
/**
 * A reason for a charge to a patient. This is mostly used for internal tracking.
 */

export const ChargeReason = {
    DeductibleOwed: 'deductible owed',
    ClaimPartiallyPaid: 'claim partially paid',
    ClaimRejected: 'claim rejected',
    ClaimDenied: 'claim denied',
    ClaimStuckInSent: 'claim stuck in sent',
    NoShowFee: 'no-show fee',
    LateCancellationFee: 'late cancellation fee',
    PatientMissingInsurance: 'patient missing insurance',
    FullyPaidFee: 'fully paid fee',
    OutstandingBalanceCollection: 'outstanding balance collection'
} as const;

export type ChargeReason = typeof ChargeReason[keyof typeof ChargeReason];



export const ChargeStatus = {
    Initiated: 'initiated',
    Succeeded: 'succeeded',
    Authorized: 'authorized',
    Failed: 'failed',
    Unknown: 'unknown',
    Canceled: 'canceled',
    Scheduled: 'scheduled',
    Refunded: 'refunded',
    WillNotSend: 'will_not_send'
} as const;

export type ChargeStatus = typeof ChargeStatus[keyof typeof ChargeStatus];


export interface ChartNoteResponse {
    'chart_note_id': string;
    'appointment_id': string;
    'note': string;
    'scribe': ScribeResponse | null;
    'signature': SignatureResponse | null;
    'is_started': boolean;
    'is_valid': boolean;
    'is_signed': boolean;
    'is_locked': boolean;
    'has_attempted_signing': boolean;
    'clinical_form': ClinicalFormResponse;
    'follow_up_appointment': FollowUpAppointmentDetails | null;
    'created_at': string;
    'updated_at': string;
}
export interface ChatChannelResponse {
    'chat_channel_id': string;
    'latest_message': ChatMessageResponse | null;
    'patient'?: PatientSenderResponse | null;
    'provider'?: ProviderSenderResponse | null;
    'has_active_relationship': boolean;
}
export interface ChatChannelsResponse {
    'channels': Array<ChatChannelResponse>;
    'latest_updated_at': string | null;
    'earliest_updated_at': string | null;
}
export interface ChatChannelsUnreadCountResponse {
    'count': number;
}
export interface ChatMessageAttachmentPayload {
    'file_key': string;
    'file_name': string;
}
export interface ChatMessageAttachmentResponse {
    'attachment_id': string;
    'file_name': string;
    'storage_key': string;
    'signed_url': string;
    'signed_preview_url'?: string | null;
    'signed_thumbnail_url'?: string | null;
    'signature_expires_at': string;
}

export const ChatMessageContentTypeResponse = {
    TextPlain: 'text/plain',
    TextHtml: 'text/html'
} as const;

export type ChatMessageContentTypeResponse = typeof ChatMessageContentTypeResponse[keyof typeof ChatMessageContentTypeResponse];


export interface ChatMessageResponse {
    'message_id': string;
    'chat_channel_id': string;
    'sender_id': string;
    'sent_at': string;
    'read_at': string | null;
    'deleted_at': string | null;
    'updated_at': string | null;
    'content': string;
    'content_type': ChatMessageContentTypeResponse;
    'attachments': Array<ChatMessageAttachmentResponse>;
    'journal_entry': JournalEntryResponse | null;
    'patient_lab': PatientLabResponse | null;
}


export interface ChatMessagesResponse {
    'messages': Array<ChatMessageResponse>;
    'earliest_sent_at': string | null;
    'latest_sent_at': string | null;
}
export interface CheckoutPayload {
    'shipping_address': ShippingAddress;
}
export interface CheckoutTotalDetailsResponse {
    'patient_id': string;
    /**
     * A US postal code in 5-digit or ZIP+4 format (12345 or 12345-6789)
     */
    'postal_code': string;
    'subtotal_amount': string;
    'tax_amount': string;
    'shipping_amount': string;
    'total_amount': string;
}
export interface ChimeBridgePayload {
    'messages': Array<object>;
}
export interface ClaimPreviewFromClaimsPayload {
    'claim_ids': Array<string>;
}
export interface ClaimPreviewPayload {
    'appointment_ids': Array<string>;
    'payer_id_override'?: PayerId | null;
}


export interface ClaimPrizePayload {
    'delivery_method_override'?: PrizeDeliveryMethod | null;
}


export interface ClaimRewardResponse {
    'prize': PrizeResponse | null;
}
export interface ClaimSpecificationsResponse {
    'claims': Array<APIClaimSpecificationOutput>;
}
export interface ClientCareDetailsResponse {
    'date_of_service': string;
    'service_type': ClientCareServiceType;
    'billable_remote_encounter_id'?: string | null;
    'billable_units'?: number | null;
    'summary'?: string | null;
    'patient': PatientDetails;
}


export interface ClientCareResponse {
    'date_of_service': string;
    'service_type': ClientCareServiceType;
    'appointment_id'?: string | null;
    'calendar_event_id'?: string | null;
    'billable_remote_encounter_id'?: string | null;
    'is_cancelled'?: boolean;
    'should_notify_at'?: string | null;
}



export const ClientCareServiceType = {
    InitialConsultation: 'initial_consultation',
    FollowUp: 'follow_up',
    Chat: 'chat'
} as const;

export type ClientCareServiceType = typeof ClientCareServiceType[keyof typeof ClientCareServiceType];


export interface ClientEngagementRewardResponse {
    'potential_client_engagement_reward': boolean;
}
export interface ClientReferralImpressionPayload {
    'link_url': string;
}
export interface ClientReferralImpressionResponse {
    'token': string;
}
export interface ClientReferralResponse {
    'referral_url': string;
    'converted_client_count': number;
}
/**
 * Generated enum of ClinicalFormInput fields.
 */

export const ClinicalFieldKey = {
    PatientUsualBodyWeight: 'patient_usual_body_weight',
    PatientIdealBodyWeight: 'patient_ideal_body_weight',
    PatientWeightIncreased: 'patient_weight_increased',
    PatientWeightDecreased: 'patient_weight_decreased',
    PatientWeightChangeNotes: 'patient_weight_change_notes',
    Patient24HourRecall: 'patient_24_hour_recall',
    PatientAppetite: 'patient_appetite',
    PatientFoodAllergies: 'patient_food_allergies',
    PatientFoodPreferences: 'patient_food_preferences',
    PatientAdaptiveDevices: 'patient_adaptive_devices',
    PatientDifficultyChewingSwallowing: 'patient_difficulty_chewing_swallowing',
    PatientFeedingAssistance: 'patient_feeding_assistance',
    PatientMedicalConditions: 'patient_medical_conditions',
    PatientLabResults: 'patient_lab_results',
    PatientMedications: 'patient_medications',
    OrbitalFatAssessment: 'orbital_fat_assessment',
    TricepsFatAssessment: 'triceps_fat_assessment',
    OverlyingRibsFatAssessment: 'overlying_ribs_fat_assessment',
    TempleMassAssessment: 'temple_mass_assessment',
    PectoralisMassAssessment: 'pectoralis_mass_assessment',
    ShoulderMassAssessment: 'shoulder_mass_assessment',
    BackMassAssessment: 'back_mass_assessment',
    HandMassAssessment: 'hand_mass_assessment',
    ThighMassAssessment: 'thigh_mass_assessment',
    PatientPhysicalAppearance: 'patient_physical_appearance',
    PatientHydrationStatus: 'patient_hydration_status',
    PatientMalnutritionStatus: 'patient_malnutrition_status',
    TotalCalories: 'total_calories',
    TotalCaloriesEstimationMethod: 'total_calories_estimation_method',
    TotalProtein: 'total_protein',
    TotalProteinEstimationMethod: 'total_protein_estimation_method',
    TotalFluids: 'total_fluids',
    TotalFluidsEstimationMethod: 'total_fluids_estimation_method',
    CurrentIntakeMeetsEstimatedNeeds: 'current_intake_meets_estimated_needs',
    EstimatedNutritionNeedsNotes: 'estimated_nutrition_needs_notes',
    NutritionDiagnosisProblem: 'nutrition_diagnosis_problem',
    NutritionDiagnosisProblemEtiology: 'nutrition_diagnosis_problem_etiology',
    NutritionDiagnosisSymptoms: 'nutrition_diagnosis_symptoms',
    SmartGoals: 'smart_goals',
    CarePlanUpdatedForNutritionGoals: 'care_plan_updated_for_nutrition_goals',
    Interventions: 'interventions',
    AdditionalInterventions: 'additional_interventions',
    MetricsToMonitor: 'metrics_to_monitor',
    FollowUpAppointmentId: 'follow_up_appointment_id'
} as const;

export type ClinicalFieldKey = typeof ClinicalFieldKey[keyof typeof ClinicalFieldKey];



export const ClinicalFormFatAssessment = {
    None: 'none',
    Mild: 'mild',
    Moderate: 'moderate',
    Severe: 'severe',
    UnableToAssess: 'unable_to_assess'
} as const;

export type ClinicalFormFatAssessment = typeof ClinicalFormFatAssessment[keyof typeof ClinicalFormFatAssessment];



export const ClinicalFormMassAssessment = {
    None: 'none',
    Mild: 'mild',
    Moderate: 'moderate',
    Severe: 'severe',
    UnableToAssess: 'unable_to_assess'
} as const;

export type ClinicalFormMassAssessment = typeof ClinicalFormMassAssessment[keyof typeof ClinicalFormMassAssessment];



export const ClinicalFormNutritionDiagnosisEtiology = {
    PathologicalOrPhysiologicalCausesThatResultInIncreasedEnergyRequirements: 'Pathological or physiological causes that result in increased energy requirements',
    DecreasedAbilityToConsumeSufficientEnergy: 'Decreased ability to consume sufficient energy',
    FoodInsecurity: 'Food insecurity',
    LimitedAccessToNutritionRelatedSupplies: 'Limited access to nutrition related supplies',
    CulturalPracticesThatAffectAbilityToAccessFood: 'Cultural practices that affect ability to access food',
    FoodAndNutritionRelatedKnowledgeDeficitConcerningEnergyIntake: 'Food and nutrition related knowledge deficit concerning energy intake',
    PsychologicalCausesSuchAsDepressionAndDisorderedEating: 'Psychological causes such as depression and disordered eating',
    BeliefFindingThatHindersFoodAndOrNutritionBehaviorChange: 'Belief finding that hinders food and/or nutrition behavior change',
    AttitudeFindingThatHindersFoodAndOrNutritionBehaviorChange: 'Attitude finding that hinders food and/or nutrition behavior change',
    LimitedValueForBehaviorChangeCompetingValues: 'Limited value for behavior change, competing values',
    MedicationsThatIncreaseAppetiteEgSteroidsAntidepressants: 'Medications that increase appetite, eg, steroids, antidepressants',
    OverfeedingOfParenteralEnteralNutritionPnEn: 'Overfeeding of parenteral/enteral nutrition (PN/EN)',
    CaloriesKcalKJUnaccountedForFromIvInfusionAndOrMedications: 'Calories/kcal/kJ unaccounted for from IV infusion and/or medications',
    LimitedInterestInReducingEnergyIntake: 'Limited interest in reducing energy intake',
    LimitedAdjustmentForLifestyleChangesAndDecreasedMetabolismEgAging: 'Limited adjustment for lifestyle changes and decreased metabolism (eg, aging)',
    LimitedAdjustmentForRestrictedMobilityDueToRecoveryFromInjurySurgicalProcedureOther: 'Limited adjustment for restricted mobility due to recovery from injury, surgical procedure, other',
    ResolutionOfPriorHypermetabolismWithoutReductionInIntake: 'Resolution of prior hypermetabolism without reduction in intake',
    LimitedFoodAndNutritionRelatedSkill: 'Limited food and nutrition related skill',
    AlteredAbsorptionOrMetabolismOfNutrient: 'Altered absorption or metabolism of nutrient',
    CompromiseOfOrgansRelatedToGiFunction: 'Compromise of organs related to GI function',
    DecreasedFunctionalLengthOfIntestine: 'Decreased functional length of intestine',
    DecreasedOrCompromisedFunctionOfIntestine: 'Decreased or compromised function of intestine',
    IncreasedDemandForNutrient: 'Increased demand for nutrient',
    RenalDysfunction: 'Renal dysfunction',
    LiverDysfunction: 'Liver dysfunction',
    AlteredCholesterolMetabolismRegulation: 'Altered cholesterol metabolism/regulation',
    HeartFailure: 'Heart failure',
    FoodIntolerances: 'Food intolerances',
    ConsumptionOfHighDoseNutrientSupplements: 'Consumption of high-dose nutrient supplements',
    FoodAndNutritionRelatedKnowledgeDeficitConcerningNutrientInteractions: 'Food- and nutrition-related knowledge deficit concerning nutrient interactions',
    FoodFaddism: 'Food faddism',
    InsufficientElectrolyteReplacementWhenInitiatingFeedingPnEnIncludingOral: 'Insufficient electrolyte replacement when initiating feeding (PN/EN, including oral)',
    MechanicalCauses: 'Mechanical causes',
    MotorCauses: 'Motor causes',
    CraniofacialMalformations: 'Craniofacial malformations',
    OralSurgery: 'Oral surgery',
    NeuromuscularDysfunction: 'Neuromuscular dysfunction',
    PartialOrCompleteEdentulism: 'Partial or complete edentulism',
    SoftTissueDiseasePrimaryOrOralManifestationsOfASystemicDisease: 'Soft tissue disease (primary or oral manifestations of a systemic disease)',
    Xerostomia: 'Xerostomia',
    DifficultyLatchingOn: 'Difficulty latching on',
    PoorSuckingAbility: 'Poor sucking ability',
    OralPain: 'Oral pain',
    MalnutritionMalabsorption: 'Malnutrition/malabsorption',
    LethargySleepiness: 'Lethargy, sleepiness',
    Irritability: 'Irritability',
    IntroductionOfFeedingViaBottleOrOtherRouteThatMayAffectBreastfeeding: 'Introduction of feeding via bottle or other route that may affect breastfeeding',
    SwallowingDifficulty: 'Swallowing difficulty',
    PainfulBreastTissueWithLactatingCapabilityNipples: 'Painful breast tissue with lactating capability, nipples',
    BreastOrNippleAbnormality: 'Breast or nipple abnormality',
    Mastitis: 'Mastitis',
    PerceptionOfOrActualInadequateBreastmilkSupply: 'Perception of or actual inadequate breastmilk supply',
    LimitedSocialOrEnvironmentalSupport: 'Limited social or environmental support',
    CulturalPracticesThatMayAffectTheAbilityToBreastfeed: 'Cultural practices that may affect the ability to breastfeed',
    AlterationInGastrointestinalTractStructureAndOrFunction: 'Alteration in gastrointestinal tract structure and/or function',
    ChangesInTheGiTractMotility: 'Changes in the GI tract motility',
    CompromisedExocrineFunctionOfRelatedGiOrgans: 'Compromised exocrine function of related GI organs',
    DecreasedFunctionalLengthOfTheGiTract: 'Decreased functional length of the GI tract',
    CompromisedEndocrineFunctionOfRelatedGastrointestinalOrgans: 'Compromised endocrine function of related gastrointestinal organs',
    MetabolicDisordersIncludingInbornErrorsOfMetabolism: 'Metabolic disorders, including inborn errors of metabolism',
    MedicationsThatAffectNutrientMetabolism: 'Medications that affect nutrient metabolism',
    AlcoholOrDrugAddiction: 'Alcohol or drug addiction',
    DisorderedEatingPattern: 'Disordered eating pattern',
    ExcessivePhysicalActivity: 'Excessive physical activity',
    InadequateEnergyIntake: 'Inadequate energy intake',
    IncreasedEnergyNeeds: 'Increased energy needs',
    SmallForGestationalAgeIntrauterineGrowthRetardationRestrictionAndOrLackOfProgressAppropriateWeightGainPerDay: 'Small for gestational age, intrauterine growth retardation/restriction and/or lack of progress/appropriate weight gain per day',
    DecreasedEnergyNeeds: 'Decreased energy needs',
    ExcessiveEnergyIntake: 'Excessive energy intake',
    NotReadyForNutritionRelatedBehaviorChange: 'Not ready for nutrition related behavior change',
    LimitedPhysicalActivity: 'Limited physical activity',
    IncreasedPsychologicalLifeStress: 'Increased psychological/life stress',
    PhysiologicalCausesIncreasingNutrientNeedsDueToIllnessOrCondition: 'Physiological causes increasing nutrient needs due to illness or condition',
    PhysiologicalCausesResultingInAnorexiaOrDiminishedIntakeIncludingFeedingIntolerance: 'Physiological causes resulting in anorexia or diminished intake (including feeding intolerance)',
    AlteredUtilizationOfNutrients: 'Altered utilization of nutrients',
    FoodAndNutritionRelatedKnowledgeDeficit: 'Food and nutrition-related knowledge deficit',
    SocialEconomicBehavioralCulturalOrReligiousPracticesThatAffectTheAbilityToAccessFood: 'Social, economic, behavioral, cultural, or religious practices that affect the ability to access food',
    PsychologicalOrBehavioralCauses: 'Psychological or behavioral causes',
    OralHealthLimitations: 'Oral health limitations',
    ImpairedSensoryPerceptionImpactingFoodConsumption: 'Impaired sensory perception impacting food consumption',
    InterruptionsOfOrIntoleranceToFeedings: 'Interruptions of or intolerance to feedings',
    LimitedPriorNutritionRelatedEducation: 'Limited prior nutrition-related education',
    LimitedLiteracy: 'Limited literacy',
    LimitedNumeracy: 'Limited numeracy',
    CulturalBeliefsThatMayAffectAccessToAndReceptivityToInformation: 'Cultural beliefs that may affect access to and receptivity to information',
    ImpairedCognitiveAbility: 'Impaired cognitive ability',
    PriorExposureToMisinformationDisinformationAndOrContradictoryInformation: 'Prior exposure to misinformation, disinformation, and/or contradictory information',
    LimitedPrioritizationForLearningFoodAndNutritionInformation: 'Limited prioritization for learning food and nutrition information',
    LimitedSelfEfficacyForLearningFoodAndNutritionInformation: 'Limited self-efficacy for learning food and nutrition information',
    RecentMedicalDiagnosisOrChangeInHealthOrDiseaseStatus: 'Recent medical diagnosis or change in health or disease status',
    ChangeInLifeCourseStageOrResponsibilityForSelfOrOthers: 'Change in life-course stage or responsibility for self or others',
    LimitedAccessToSourcesOfReliableFoodAndNutritionInformation: 'Limited access to sources of reliable food and nutrition information',
    CulturalSocietalBiologicalGeneticAndOrEnvironmentalRelatedFearOfWeightGain: 'Cultural, societal, biological/genetic, and/or environmental-related fear of weight gain',
    WeightRegulationPreoccupation: 'Weight regulation/preoccupation',
    ObsessiveDesireToBeHealthyOrHaveASpecificBodyShape: 'Obsessive desire to be healthy or have a specific body shape',
    PhysiologicalCausesThatPutEmphasisOnFoodWeightOrShape: 'Physiological causes that put emphasis on food, weight, or shape',
    PsychologicalCausesThatPutEmphasisOnFoodWeightOrShape: 'Psychological causes that put emphasis on food, weight, or shape',
    PersonalityCharacteristicsOrTemperamentAssociatedWithEatingDisorders: 'Personality characteristics or temperament associated with eating disorders',
    TraumaticEventSThatCausesAPhysicalOrPsychologicalStressReaction: 'Traumatic event(s) that causes a physical or psychological stress reaction',
    PhysiologicalCausesRequiringModifiedCarbohydrateIntakeEgDiabetesMellitusLactaseDeficiencySucraseIsomaltaseDeficiencyAldolaseBDeficiency: 'Physiological causes requiring modified carbohydrate intake, eg, diabetes mellitus, lactase deficiency, sucrase-isomaltase deficiency, aldolase-B deficiency',
    CulturalPracticesThatAffectTheAbilityToReduceCarbohydrateIntake: 'Cultural practices that affect the ability to reduce carbohydrate intake',
    FoodAndNutritionRelatedKnowledgeDeficitConcerningAppropriateAmountOfCarbohydrateIntake: 'Food and nutrition related knowledge deficit concerning appropriate amount of carbohydrate intake',
    LimitedAdherenceWithRecommendationsToModifyCarbohydrateIntake: 'Limited adherence with recommendations to modify carbohydrate intake',
    LackOfOrLimitedAccessToFiberContainingFoodsFluids: 'Lack of or limited access to fiber-containing foods/fluids',
    FoodAndNutritionRelatedKnowledgeDeficitConcerningDesirableQuantitiesOfFiber: 'Food and nutrition related knowledge deficit concerning desirable quantities of fiber',
    ProlongedAdherenceToALowFiberOrLowResidueDiet: 'Prolonged adherence to a low-fiber or low-residue diet',
    DifficultyChewingOrSwallowingHighFiberFoods: 'Difficulty chewing or swallowing high-fiber foods',
    EconomicConstraintsThatLimitAvailabilityOfHigherFiberFoods: 'Economic constraints that limit availability of higher fiber foods',
    LimitedAbilityOrLimitedMotivationToPurchaseOrConsumeFiberContainingFoods: 'Limited ability or limited motivation to purchase or consume fiber-containing foods',
    LessThanOptimalFoodPreparationPracticesEgRelianceOnOverprocessedOvercookedFoods: 'Less than optimal food preparation practices, eg, reliance on overprocessed, overcooked foods',
    FoodAndNutritionRelatedKnowledgeDeficitConcerningAppropriateAmountOfDietaryFat: 'Food and nutrition related knowledge deficit concerning appropriate amount of dietary fat',
    ChangesInTasteAndAppetiteOrPreference: 'Changes in taste and appetite or preference',
    PhysiologicalCausesDecreasingTotalFatNeedsOrRecommendations: 'Physiological causes decreasing total fat needs or recommendations',
    PhysiologicalCausesIncreasingNutrientNeedsEGMalabsorption: 'Physiological causes increasing nutrient needs (e.g., malabsorption)',
    DecreasedAbilityToConsumeSufficientAmountOfAVitaminS: 'Decreased ability to consume sufficient amount of a vitamin(s)',
    FoodAndNutritionRelatedKnowledgeDeficitConcerningFoodAndSupplementalSourcesOfVitamins: 'Food and nutrition related knowledge deficit concerning food and supplemental sources of vitamins',
    AccessCausesIncludingSeasonGeographyLimitedAccessToSunlight: 'Access causes including season, geography, limited access to sunlight',
    PhysiologicalCausesIncreasingNutrientNeedsDueToProlongedCatabolicIllnessMalabsorptionHyperexcretionNutrientDrugAndNutrientNutrientInteractionGrowthAndMaturation: 'Physiological causes increasing nutrient needs due to prolonged catabolic illness, malabsorption, hyperexcretion, nutrient/drug and nutrient/nutrient interaction, growth and maturation',
    DecreasedAbilityToConsumeSufficientAmountOfAMineralS: 'Decreased ability to consume sufficient amount of a mineral(s)',
    FoodAndNutritionRelatedKnowledgeDeficitConcerningFoodAndSupplementalSourcesOfMinerals: 'Food and nutrition related knowledge deficit concerning food and supplemental sources of minerals',
    MisdiagnosisOfLactoseIntoleranceLactaseDeficiencyPerceptionOfConflictingNutritionMessagesLessThanOptimalRelianceOnSupplements: 'Misdiagnosis of lactose intolerance/lactase deficiency; perception of conflicting nutrition messages; less than optimal reliance on supplements',
    PsychologicalCausesEgDepressionOrEatingDisorders: 'Psychological causes, eg, depression or eating disorders',
    EnvironmentalCausesEgInadequatelyTestedNutrientBioavailabilityOfFortifiedFoodsBeveragesAndSupplementsLessThanOptimalMarketingOfFortifiedFoodsBeveragesSupplementsAsASubstituteForNaturalFoodSourceOfNutrientS: 'Environmental causes, eg, inadequately tested nutrient bioavailability of fortified foods, beverages, and supplements; less than optimal marketing of fortified foods/beverages/supplements as a substitute for natural food source of nutrient(s)'
} as const;

export type ClinicalFormNutritionDiagnosisEtiology = typeof ClinicalFormNutritionDiagnosisEtiology[keyof typeof ClinicalFormNutritionDiagnosisEtiology];



export const ClinicalFormNutritionDiagnosisProblem = {
    InadequateEnergyIntake: 'Inadequate energy intake',
    ExcessiveEnergyIntake: 'Excessive energy intake',
    IncreasedNutrientNeeds: 'Increased nutrient needs',
    DecreasedNutrientNeeds: 'Decreased nutrient needs',
    ImbalanceOfNutrients: 'Imbalance of nutrients',
    SwallowingDifficulty: 'Swallowing difficulty',
    DifficultyChewing: 'Difficulty chewing',
    BreastfeedingDifficulty: 'Breastfeeding difficulty',
    AlteredGiFunction: 'Altered GI function',
    ImpairedNutrientUtilization: 'Impaired nutrient utilization',
    Underweight: 'Underweight',
    OverweightObesity: 'Overweight/obesity',
    MalnutritionUndernutrition: 'Malnutrition (undernutrition)',
    FoodAndNutritionRelatedKnowledgeDeficit: 'Food and nutrition related knowledge deficit',
    DisorderedEatingPattern: 'Disordered eating pattern',
    ExcessiveCarbohydrateIntake: 'Excessive carbohydrate intake',
    InadequateFiberIntake: 'Inadequate fiber intake',
    ExcessiveFatIntake: 'Excessive fat intake',
    InadequateVitaminIntake: 'Inadequate vitamin intake',
    InadequateMineralIntake: 'Inadequate mineral intake'
} as const;

export type ClinicalFormNutritionDiagnosisProblem = typeof ClinicalFormNutritionDiagnosisProblem[keyof typeof ClinicalFormNutritionDiagnosisProblem];



export const ClinicalFormNutritionDiagnosisSymptom = {
    FailureToGainOrMaintainAppropriateBodyWeight: 'Failure to gain or maintain appropriate body weight',
    PoorDentition: 'Poor dentition',
    EstimatedEnergyIntakeFromDietLessThanNeedsBasedOnEstimatedOrMeasuredRestingMetabolicRate: 'Estimated energy intake from diet less than needs based on estimated or measured resting metabolic rate',
    RestrictionOrOmissionOfEnergyDenseFoodsFromDietFoodAvoidanceAndOrLackOfInterestInFood: 'Restriction or omission of energy-dense foods from diet Food avoidance and/or lack of interest in food',
    LimitedAbilityToIndependentlyConsumeFoodsFluidsDiminishedJointMobilityOfWristHandOrDigits: 'Limited ability to independently consume foods/fluids (diminished joint mobility of wrist, hand, or digits)',
    EstimatedParenteralOrEnteralNutritionIntakeInsufficientToMeetNeedsBasedOnEstimatedOrMeasuredRestingMetabolicRate: 'Estimated parenteral or enteral nutrition intake insufficient to meet needs based on estimated or measured resting metabolic rate',
    ExcessiveConsumptionOfAlcoholOrOtherDrugsThatReduceHunger: 'Excessive consumption of alcohol or other drugs that reduce hunger',
    MedicationsThatAffectAppetite: 'Medications that affect appetite',
    ConditionsAssociatedWithDiagnosisOrTreatment: 'Conditions associated with diagnosis or treatment',
    TotalEnergyEstimatedNeedsIn24Hours: 'Total energy estimated needs in 24 hours',
    MethodForEstimatingTotal24HourEnergyNeeds: 'Method for estimating total 24 hour energy needs',
    EnergyEstimatedNeedsPerKgOfBodyWeightIn24Hours: 'Energy estimated needs per kg of body weight in 24 hours',
    AbnormalLiverFunctionTestsAfterProlongedExposure3To6WeeksToParenteralNutrition: 'Abnormal liver function tests after prolonged exposure (3 to 6 weeks) to parenteral nutrition',
    RespiratoryQuotientIsGreaterThan10: 'Respiratory quotient is greater than 1.0',
    BodyFatPercentage25ForMenAnd32ForWomen: 'Body fat percentage > 25% for men and > 32% for women',
    Bmi25AdultsBmi95thPercentilePediatrics: 'BMI > 25 (adults); BMI > 95th percentile (pediatrics)',
    BodyWeightGain: 'Body weight gain',
    IncreasedBodyAdiposity: 'Increased body adiposity',
    IncreasedRespiratoryRate: 'Increased respiratory rate',
    IntakeOfEnergyInExcessOfEstimatedOrMeasuredEnergyNeeds: 'Intake of energy in excess of estimated or measured energy needs',
    IntakeOfHighCaloricDensityOrLargePortionsOfFoodsBeverages: 'Intake of high caloric density or large portions of foods/beverages',
    EnPnMoreThanEstimatedOrMeasuredEgIndirectCalorimetryEnergyExpenditure: 'EN/PN more than estimated or measured (eg, indirect calorimetry) energy expenditure',
    TotalCholesterol160MgDLAlbuminPrealbuminCReactiveProteinIndicatingIncreasedStressAndIncreasedMetabolicNeeds: 'Total cholesterol < 160 mg/dL, albumin, prealbumin, C-reactive protein, indicating increased stress and increased metabolic needs',
    ElectrolyteMineralAbnormalities: 'Electrolyte/mineral abnormalities',
    UrinaryOrFecalLossesOfSpecificOrRelatedNutrient: 'Urinary or fecal losses of specific or related nutrient',
    VitaminAndOrMineralDeficiency: 'Vitamin and/or mineral deficiency',
    GrowthFailureBasedOnReferenceGrowthStandardsAndFetalGrowthFailure: 'Growth failure, based on reference growth standards and fetal growth failure',
    UnintentionalWeightLossOf5In1MonthOr10In6Months: 'Unintentional weight loss of ≥ 5% in 1 month or ≥ 10% in 6 months',
    UnderweightBmi185: 'Underweight (BMI < 18.5)',
    LowPercentBodyFatAndMuscleMass: 'Low percent body fat and muscle mass',
    ClinicalEvidenceOfVitaminMineralDeficiency: 'Clinical evidence of vitamin/mineral deficiency',
    LossOfSkinIntegrityDelayedWoundHealingOrPressureUlcers: 'Loss of skin integrity, delayed wound healing, or pressure ulcers',
    LossOfMuscleMassSubcutaneousFat: 'Loss of muscle mass, subcutaneous fat',
    EstimatedIntakeOfFoodsSupplementsContainingNeededNutrientLessThanEstimatedRequirements: 'Estimated intake of foods/supplements containing needed nutrient less than estimated requirements',
    IntakeOfFoodsThatDoNotContainSufficientQuantitiesOfAvailableNutrient: 'Intake of foods that do not contain sufficient quantities of available nutrient',
    FoodAndNutritionRelatedKnowledgeDeficit: 'Food- and nutrition-related knowledge deficit',
    MedicationsAffectingAbsorptionOrMetabolismOfNeededNutrient: 'Medications affecting absorption or metabolism of needed nutrient',
    AthletesOrActiveIndividualsEngagedInIntensePhysicalActivity: 'Athletes or active individuals engaged in intense physical activity',
    ConditionsAssociatedWithADiagnosisOrTreatment: 'Conditions associated with a diagnosis or treatment',
    TotalCholesterol200MgDL52MmolLLdlCholesterol100MgDL259MmolLHdlCholesterol40MgDL1036MmolLAndOrTriglycerides150MgDL1695MmolL: 'Total cholesterol > 200 mg/dL (5.2 mmol/L), LDL cholesterol > 100 mg/dL (2.59 mmol/L), HDL cholesterol < 40 mg/dL (1.036 mmol/L), and/or triglycerides > 150 mg/dL (1.695 mmol/L)',
    Phosphorus55MgDL178MmolL: 'Phosphorus > 5.5 mg/dL (1.78 mmol/L)',
    GlomerularFiltrationRateGfr90MLMin173M2: 'Glomerular filtration rate (GFR) < 90 mL/min/1.73 m^2',
    BunCreatininePotassium: 'BUN, creatinine, potassium',
    LiverFunctionTestsIndicatingSevereLiverDisease: 'Liver function tests indicating severe liver disease',
    InterdialyticWeightGainGreaterThanExpected: 'Interdialytic weight gain greater than expected',
    EdemaFluidRetention: 'Edema/fluid retention',
    EstimatedIntakeHigherThanRecommendedForFatPhosphorusSodiumProteinFiber: 'Estimated intake higher than recommended for fat, phosphorus, sodium, protein, fiber',
    ConditionsAssociatedWithADiagnosisOrTreatmentThatRequireASpecificTypeAndOrAmountOfNutrient: 'Conditions associated with a diagnosis or treatment that require a specific type and/or amount of nutrient',
    DiagnosisOfHypertensionConfusionRelatedToLiverDisease: 'Diagnosis of hypertension, confusion related to liver disease',
    SevereHypophosphatemiaInThePresenceOfIncreasedCarbohydrate: 'Severe hypophosphatemia (in the presence of increased carbohydrate)',
    SevereHypokalemiaInThePresenceOfIncreasedProtein: 'Severe hypokalemia (in the presence of increased protein)',
    SevereHypomagnesemiaInThePresenceOfIncreasedCarbohydrate: 'Severe hypomagnesemia (in the presence of increased carbohydrate)',
    DiarrheaOrConstipationIronSupplements: 'Diarrhea or constipation (iron supplements)',
    EpigastricPainNauseaVomitingDiarrheaZincSupplements: 'Epigastric pain, nausea, vomiting, diarrhea (zinc supplements)',
    EstimatedIntakeOfIronSupplementsDecreasedZincAbsorptionHigherThanRecommended: 'Estimated intake of iron supplements (decreased zinc absorption) higher than recommended',
    EstimatedIntakeOfZincSupplementsDecreasedCopperStatusHigherThanRecommended: 'Estimated intake of zinc supplements (decreased copper status) higher than recommended',
    EstimatedIntakeOfManganeseDecreasedIronStatusHigherThanRecommended: 'Estimated intake of manganese (decreased iron status) higher than recommended',
    ReFeedingSyndrome: 'Re-feeding syndrome',
    RadiologicalFindings: 'Radiological findings',
    EvidenceOfDehydration: 'Evidence of dehydration',
    FindingsInCranialNervesAndCnViiMusclesOfFacialExpressionNerveIxGagReflexSwallowNerveXAndTongueRangeOfMotionsNerveXiiAndCoughReflex: 'Findings in cranial nerves and (CN VII) muscles of facial expression, (Nerve IX) gag reflex, swallow (Nerve X) and tongue range of motions (Nerve XII), and cough reflex',
    CoughingChokingProlongedChewingPouchingOfFoodRegurgitationFacialExpressionChangesDuringEatingDroolingNoisyWetUpperAirwaySoundsFeelingOfFoodGettingStuckPainWhileSwallowing: 'Coughing, choking, prolonged chewing, pouching of food, regurgitation, facial expression changes during eating, drooling, noisy wet upper airway sounds, feeling of food getting stuck, pain while swallowing',
    ProlongedEatingTime: 'Prolonged eating time',
    DecreasedEstimatedFoodIntake: 'Decreased estimated food intake',
    ReluctanceToConsumeSpecificFoods: 'Reluctance to consume specific foods',
    MealtimeEatingOccasionResistance: 'Mealtime/eating occasion resistance',
    RepeatedUpperRespiratoryInfectionsAndOrPneumonia: 'Repeated upper respiratory infections and or pneumonia',
    InternationalDysphagiaDietStandardisationInitiativeFrameworkDrinksLevel: 'International Dysphagia Diet Standardisation Initiative Framework drinks level',
    InternationalDysphagiaDietStandardisationInitiativeFrameworkFoodLevel: 'International Dysphagia Diet Standardisation Initiative Framework food level',
    InternationalDysphagiaDietStandardisationInitiativeFunctionalDietScaleScore: 'International Dysphagia Diet Standardisation Initiative Functional Diet Scale score',
    ResultsOfModifiedBariumSwallowBariumSwallowVideoFluoroscopicSwallowingStudy: 'Results of modified barium swallow, barium swallow, video-fluoroscopic swallowing study',
    WeightChangeEspeciallyWeightLoss: 'Weight change, especially weight loss',
    GrowthLessThanExpectedInChildren: 'Growth less than expected in children',
    PartialOrCompleteEdentulism: 'Partial or complete edentulism',
    AlterationsInCranialNerveFunctionVViiIxXXii: 'Alterations in cranial nerve function (V, VII, IX, X, XII)',
    DryMouth: 'Dry mouth',
    OralLesionsInterferingWithEatingAbility: 'Oral lesions interfering with eating ability',
    ImpairedTongueMovement: 'Impaired tongue movement',
    IllFittingDenturesOrBrokenDentures: 'Ill-fitting dentures or broken dentures',
    Dysphagia: 'Dysphagia',
    AlterationsInEstimatedFoodIntakeFromUsual: 'Alterations in estimated food intake from usual',
    DecreasedEstimatedIntakeOrAvoidanceOfFoodDifficultToFormIntoABolus: 'Decreased estimated intake or avoidance of food difficult to form into a bolus',
    AvoidanceOfFoodsOfAgeAppropriateTexture: 'Avoidance of foods of age-appropriate texture',
    SpittingFoodOutOrProlongedEatingTime: 'Spitting food out or prolonged eating time',
    PreferenceForEasyToChewFood: 'Preference for easy to chew food',
    RecentMajorOralSurgery: 'Recent major oral surgery',
    WiredJaw: 'Wired jaw',
    ChemotherapyWithOralSideEffects: 'Chemotherapy with oral side effects',
    RadiationTherapyToOralCavity: 'Radiation therapy to oral cavity',
    SubjectiveGlobalAssessmentSgaRating: 'Subjective global assessment (SGA) rating',
    SubjectiveGlobalAssessmentSgaScore: 'Subjective global assessment (SGA) score',
    PatientGeneratedSubjectiveGlobalAssessmentPgSgaRating: 'Patient generated subjective global assessment (PG-SGA) rating',
    PatientGeneratedSubjectiveGlobalAssessmentPgSgaScore: 'Patient generated subjective global assessment (PG-SGA) score',
    MiniNutritionalAssessmentLongFormMnaLfRating: 'Mini nutritional assessment long form (MNA-LF) rating',
    MiniNutritionalAssessmentLongFormMnaLfScore: 'Mini nutritional assessment long form (MNA-LF) score',
    SubjectiveGlobalNutritionalAssessmentSgnaForChildrenRating: 'Subjective global nutritional assessment (SGNA) for children rating',
    SubjectiveGlobalNutritionalAssessmentSgnaForChildrenScore: 'Subjective global nutritional assessment (SGNA) for children score',
    LaboratoryEvidenceOfDehydrationInfant: 'Laboratory evidence of dehydration (infant)',
    FewerThanReferenceStandard: 'Fewer than reference standard',
    AnyWeightLossOrLimitedWeightGainInfant: 'Any weight loss or limited weight gain (infant)',
    FrenulumAbnormalityInfant: 'Frenulum abnormality (infant)',
    VomitingOrDiarrheaInfant: 'Vomiting or diarrhea (infant)',
    HungerLimitedSatietyAfterFeedingInfant: 'Hunger, limited satiety after feeding (infant)',
    Coughing: 'Coughing',
    CryingLatchingOnAndOffPoundingOnBreasts: 'Crying, latching on and off, pounding on breasts',
    DecreasedFeedingFrequencyDurationEarlyCessationOfFeedingAndOrFeedingResistance: 'Decreased feeding frequency/duration, early cessation of feeding, and/or feeding resistance',
    Lethargy: 'Lethargy',
    SmallAmountOfBreastmilkWhenPumping: 'Small amount of breastmilk when pumping',
    LimitedConfidenceInAbilityToBreastfeed: 'Limited confidence in ability to breastfeed',
    DoesntHearInfantSwallowing: 'Doesn\'t hear infant swallowing',
    LimitedSupportOfMothersChoiceToBreastfeed: 'Limited support of mother\'s choice to breastfeed',
    LimitedKnowledgeOfBreastfeeding: 'Limited knowledge of breastfeeding',
    LimitedKnowledgeOfInfantHungerSatietySignals: 'Limited knowledge of infant hunger/satiety signals',
    LimitedSupportForEngagingEmployerInDiscussionsAboutBreastfeedingFacilities: 'Limited support for engaging employer in discussions about breastfeeding facilities',
    LimitedFacilitiesOrAccommodationsAtPlaceOfEmploymentOrInCommunityForBreastfeeding: 'Limited facilities or accommodations at place of employment or in community for breastfeeding',
    FeedingViaBottleOrOtherRoute: 'Feeding via bottle or other route',
    ConditionsAssociatedWithADiagnosisOrTreatmentInfant: 'Conditions associated with a diagnosis or treatment (infant)',
    ConditionsAssociatedWithADiagnosisOrTreatmentMother: 'Conditions associated with a diagnosis or treatment (mother)',
    SocialOrPersonalConsiderationsOfTheMother: 'Social or personal considerations of the mother',
    AbnormalDigestiveEnzymeAndFecalStudies: 'Abnormal digestive enzyme and fecal studies',
    AbnormalHydrogenBreathTestDXyloseTestStoolCultureAndGastricEmptyingAndOrBowelTransitTime: 'Abnormal hydrogen breath test, d-xylose test, stool culture, and gastric emptying and/or bowel transit time',
    EndoscopicOrColonoscopyExaminationAbdominalScanBiopsyResults: 'Endoscopic or colonoscopy examination, abdominal scan, biopsy results',
    AbnormalPHSphincterMotilityMorphologyOrRefluxStudies: 'Abnormal pH, sphincter, motility, morphology or reflux studies',
    AbnormalAnemiaProfile: 'Abnormal anemia profile',
    AbnormalVitaminMineralFattyAcidTraceElementAndPthResults: 'Abnormal vitamin, mineral, fatty acid, trace element, and PTH results',
    AbnormalTissueTransglutaminaseAntibodiesIgAIgG: 'Abnormal tissue transglutaminase antibodies (IgA/IgG)',
    WeightLossOf5InOneMonth10InSixMonths: 'Weight loss of ≥ 5% in one month, ≥ 10% in six months',
    GrowthStuntingOrFailureInChildren: 'Growth stunting or failure in children',
    AbnormalBoneMineralDensityTests: 'Abnormal bone mineral density tests',
    AbdominalDistension: 'Abdominal distension',
    IncreasedOrSometimesDecreasedBowelSounds: 'Increased (or sometimes decreased) bowel sounds',
    WastingDueToMalnutritionInSevereCases: 'Wasting due to malnutrition in severe cases',
    AnorexiaNauseaVomitingDiarrheaSteatorrheaConstipationAbdominalPainRefluxGasBelchingFlatusBloatingFecalIncontinence: 'Anorexia, nausea, vomiting, diarrhea, steatorrhea, constipation, abdominal pain, reflux, gas, belching, flatus, bloating, fecal incontinence',
    EvidenceOfVitaminAndOrMineralDeficiency: 'Evidence of vitamin and/or mineral deficiency',
    AvoidanceOrLimitationOfEstimatedTotalIntakeOrIntakeOfSpecificFoodsFoodGroupsDueToGiSymptoms: 'Avoidance or limitation of estimated total intake or intake of specific foods/food groups due to GI symptoms',
    SurgicalProcedures: 'Surgical procedures',
    AbnormalProteinFattyAcidOrCarbohydrateMetabolismProfileTests: 'Abnormal protein, fatty acid or carbohydrate metabolism profile tests',
    AbnormalLiverFunctionTests: 'Abnormal liver function tests',
    AbnormalPituitaryHormonesGrowthHormoneGhAdrenocorticotropicHormoneActhLuteinizingHormoneLhAndFollicleStimulatingHormoneFsh: 'Abnormal pituitary hormones (growth hormone [GH], adrenocorticotropic hormone [ACTH], luteinizing hormone [LH] and follicle-stimulating hormone [FSH])',
    HypoglycemiaHyperglycemia: 'Hypoglycemia, hyperglycemia',
    AbnormalParathyroidHormonePth: 'Abnormal parathyroid hormone (PTH)',
    PositiveResultForUrinePorphyrins: 'Positive result for urine porphyrins',
    EvidenceOfVitaminAndOrMineralDeficiencyEgGlossitisCheilosisMouthLesions: 'Evidence of vitamin and/or mineral deficiency, eg, glossitis, cheilosis, mouth lesions',
    ThinWastedAppearance: 'Thin, wasted appearance',
    AvoidanceOrLimitationOfIntakeOfSpecificFoodsFoodGroupsDueToPhysicalSymptoms: 'Avoidance or limitation of intake of specific foods/food groups due to physical symptoms',
    AlcoholOrDrugUse: 'Alcohol or drug use',
    MeasuredRestingMetabolicRateRmrHigherThanExpectedAndOrEstimated: 'Measured resting metabolic rate (RMR) higher than expected and/or estimated',
    DecreasedSkinFoldThicknessAndMidArmMuscleCircumference: 'Decreased skin fold thickness and mid-arm muscle circumference',
    Bmi185Adults: 'BMI < 18.5 (adults)',
    BmiForOlderAdultsOlderThan65Years23: 'BMI for older adults (older than 65 years) < 23',
    BirthTo2YearsWeightForAge5thPercentile: '(Birth to 2 years) Weight for age < 5th percentile',
    BirthTo2YearsWeightForLength5thPercentile: '(Birth to 2 years) Weight for length < 5th percentile',
    Ages2To20YearsWeightForStature5thPercentile: '(Ages 2 to 20 years) Weight for stature < 5th percentile',
    Ages2To20YearsBmi5thPercentile: '(Ages 2 to 20 years) BMI < 5th percentile',
    Ages2To20YearsWeightForAge5thPercentile: '(Ages 2 to 20 years)Weight for age < 5th percentile',
    DecreasedMuscleMassMuscleWastingGlutealAndTemporal: 'Decreased muscle mass, muscle wasting (gluteal and temporal)',
    Hunger: 'Hunger',
    EstimatedIntakeOfFoodLessThanEstimatedOrMeasuredNeeds: 'Estimated intake of food less than estimated or measured needs',
    LimitedSupplyOfFoodInHome: 'Limited supply of food in home',
    DietingFoodFaddism: 'Dieting, food faddism',
    RefusalToEat: 'Refusal to eat',
    PhysicalActivityMoreThanRecommendedAmount: 'Physical activity more than recommended amount',
    Malnutrition: 'Malnutrition',
    IllnessOrPhysicalDisability: 'Illness or physical disability',
    MentalIllnessDementiaConfusion: 'Mental illness, dementia, confusion',
    AthleteDancerGymnast: 'Athlete, dancer, gymnast',
    VitaminMineralDeficiency: 'Vitamin/mineral deficiency',
    IdealReferenceBodyWeightIbw: 'Ideal/reference body weight (IBW)',
    RecommendedBodyMassIndexBmi: 'Recommended body mass index (BMI)',
    GoalBodyWeight: 'Goal body weight',
    GoalBodyWeightForLengthZScore: 'Goal body weight for length z score',
    GoalBodyMassIndexBmiForAgeZScore: 'Goal body mass index (BMI) for age z score',
    MeasuredRestingMetabolicRateRmrLessThanExpectedAndOrEstimated: 'Measured resting metabolic rate (RMR) less than expected and/or estimated',
    Overweight25To299Adults85thTo95thPercentilesPediatrics: 'Overweight: 25 to 29.9 (adults), 85th to 95th percentiles (pediatrics)',
    ObesityClassI30To349Adults: 'Obesity class I: 30 to 34.9 (adults)',
    ObesityClassIi35To399Adults: 'Obesity class II: 35 to 39.9 (adults)',
    ObesityClassIii40Adults: 'Obesity class III: 40+ (adults)',
    Obesity95thPercentilePediatrics: 'Obesity > 95th percentile (pediatrics)',
    WaistCircumferenceMoreThanNormativeStandardForAgeAndSex: 'Waist circumference more than normative standard for age and sex',
    IncreasedSkinFoldThickness: 'Increased skin fold thickness',
    WeightForHeightMoreThanNormativeStandardForAgeAndSex: 'Weight for height more than normative standard for age and sex',
    ExcessSubcutaneousFat: 'Excess subcutaneous fat',
    CentralAdiposity: 'Central adiposity',
    AcanthosisNigricans: 'Acanthosis nigricans',
    JointArthralgia: 'Joint arthralgia',
    ConsumptionOfEnergyDenseNutrientPoorFoodOrBeverage: 'Consumption of energy-dense, nutrient poor food or beverage',
    LimitedIntakeOfFoodsLowEnergyHighNutrientFoods: 'Limited intake of foods low-energy, high-nutrient foods',
    LargePortionsOfFood: 'Large portions of food',
    EstimatedExcessiveEnergyIntake: 'Estimated excessive energy intake',
    InfrequentLowDurationAndOrLowIntensityPhysicalActivityFactorsAffectingPhysicalActivityAccess: 'Infrequent, low-duration and/or low-intensity physical activity, factors affecting physical activity access',
    LargeAmountsOfSedentaryActivities: 'Large amounts of sedentary activities',
    UncertaintyRegardingNutritionRelatedRecommendations: 'Uncertainty regarding nutrition-related recommendations',
    LimitedAbilityToApplyNutritionRelatedRecommendations: 'Limited ability to apply nutrition-related recommendations',
    LimitedMotivationToApplyNutritionRelatedRecommendations: 'Limited motivation to apply nutrition-related recommendations',
    LimitedAbilityToLoseASignificantAmountOfExcessWeightThroughConventionalWeightLossIntervention: 'Limited ability to lose a significant amount of excess weight through conventional weight loss intervention',
    MedicationsThatImpactRestingMetabolicRateRmr: 'Medications that impact resting metabolic rate (RMR)',
    PhysicalDisabilityOrLimitation: 'Physical disability or limitation',
    HistoryOfFamilialObesity: 'History of familial obesity',
    HistoryOfChildhoodObesity: 'History of childhood obesity',
    HistoryOfPhysicalSexualOrEmotionalAbuse: 'History of physical, sexual, or emotional abuse',
    InsufficientEnergyIntake: 'Insufficient energy intake',
    WeightLoss: 'Weight loss',
    LossOfMuscleMass: 'Loss of muscle mass',
    LossOfSubcutaneousFat: 'Loss of subcutaneous fat',
    LocalizedOrGeneralizedFluidAccumulationThatMaySometimesMaskWeightLoss: 'Localized or generalized fluid accumulation that may sometimes mask weight loss',
    DiminishedFunctionalStatusAsMeasuredByHandgripStrength: 'Diminished functional status as measured by handgrip strength',
    AlteredLaboratoryValue: 'Altered laboratory value',
    BodyWeightAboveOrBelowExpectedBodyWeight: 'Body weight above or below expected body weight',
    BodyWeightChange: 'Body weight change',
    GrowthParametersInconsistentWithExpected: 'Growth parameters inconsistent with expected',
    NutritionKnowledgeLevelNoneToIntermediateOfCommunitySupportiveIndividualsAndOrIndividualClient: 'Nutrition knowledge level (none to intermediate) of community, supportive individuals, and/or individual client',
    NoPriorAwarenessOfNeedForFoodAndNutritionRelatedInformation: 'No prior awareness of need for food- and nutrition-related information',
    NutritionRelatedEducationIsNotConsideredAPriority: 'Nutrition related education is not considered a priority',
    InformationConflictsWithIndividualClientsValues: 'Information conflicts with individual client\'s values',
    InformationConflictsWithClientsSupportiveIndividualsClientsSupportiveStructuresClientsStakeholdersValueSystem: 'Information conflicts with client\'s supportive individuals\', client\'s supportive structures\', client\'s stakeholder\'s value system',
    LimitedReadinessToChangeNutritionRelatedBehavior: 'Limited readiness to change nutrition related behavior',
    PresenceOfLimitedSelfEfficacyForLearningInformation: 'Presence of limited self-efficacy for learning information',
    RelatesDifficultiesAboutPreviousAttemptsToLearnInformation: 'Relates difficulties about previous attempts to learn information',
    DisinterestInLearningInformation: 'Disinterest in learning information',
    LowPerceivedSusceptibilityOfNutritionRelatedHealthProblemsScore: 'Low perceived susceptibility of nutrition related health problems score',
    LowPerceivedSeverityOfRiskToHealthScore: 'Low perceived severity of risk to health score',
    LowPerceivedBenefitOfNutritionRelatedChangeScore: 'Low perceived benefit of nutrition related change score',
    HighPerceivedBarrierToNutritionRelatedBehaviorChangeScore: 'High perceived barrier to nutrition related behavior change score',
    LowFoodAndOrNutritionLiteracyScore: 'Low food and/or nutrition literacy score',
    LimitedNumeracyUnderstanding: 'Limited numeracy understanding',
    QuestionsRelatingToNutritionAndFood: 'Questions relating to nutrition and food',
    LimitedPreviousFoodAndNutritionEducation: 'Limited previous food and nutrition education',
    LimitedExperienceRelatedToFoodAndNutritionNeed: 'Limited experience related to food and nutrition need',
    LimitedRelevantFoodAndNutritionKnowledge: 'Limited relevant food and nutrition knowledge',
    LimitedAdherenceToFoodAndNutritionRecommendations: 'Limited adherence to food and nutrition recommendations',
    LimitedSupportForBehaviorChange: 'Limited support for behavior change',
    CulturalBeliefThatMayImpactEngagementInLearningInformation: 'Cultural belief that may impact engagement in learning information',
    NewMedicalDiagnosisOrChangeInExistingDiagnosisOrCondition: 'New medical diagnosis or change in existing diagnosis or condition',
    ChangeInLifeCourseStrangeAndResponsibilities: 'Change in life-course strange and responsibilities',
    SocioEconomicFactorsThatPresentBarriers: 'Socio economic factors that present barriers',
    UnfavorableSocialAndOrEconomicConditionsOfCommunity: 'Unfavorable social and/or economic conditions of community',
    InequitiesInAccessToHealthcareOrInsurance: 'Inequities in access to healthcare or insurance',
    HighCholesterolAbnormalLipidProfiles: 'High cholesterol, abnormal lipid profiles',
    Hypoglycemia: 'Hypoglycemia',
    HyperglycemiaElevatedHgbA1c: 'Hyperglycemia, elevated HgbA1c',
    HypokalemiaAndHypochloremicAlkalosis: 'Hypokalemia and hypochloremic alkalosis',
    Hypophosphatemia: 'Hypophosphatemia',
    Hypomagnesemia: 'Hypomagnesemia',
    LowSerumVitaminD: 'Low serum Vitamin D',
    Hyponatremia: 'Hyponatremia',
    Hypothyroid: 'Hypothyroid',
    HighBloodUreaNitrogenBun: 'High blood urea nitrogen (BUN)',
    HighCarbonDioxideCo2: 'High carbon dioxide (CO2)',
    UrinePositiveForKetones: 'Urine positive for ketones',
    LaboratoryDataIndicatingAnemia: 'Laboratory data indicating anemia',
    AbnormalElectrocardiogramEcg: 'Abnormal electrocardiogram (ECG)',
    HighLiverFunctionTests: 'High liver function tests',
    HyperosmolarityHypoosmolarity: 'Hyperosmolarity, hypoosmolarity',
    LowLuteinizingHormoneFollicleStimulatingHormoneEstradiolOrTestosteroneLevels: 'Low luteinizing hormone, follicle stimulating hormone, estradiol, or testosterone levels',
    LowBoneMineralizationFindings: 'Low bone mineralization findings',
    Bmi175: 'BMI < 17.5',
    ArrestedGrowthAndDevelopment: 'Arrested growth and development',
    FailureToGainWeightAccordingToPredictedGrowthTrajectoryWeightLessThan85OfExpected: 'Failure to gain weight according to predicted growth trajectory, weight less than 85% of expected',
    SignificantWeightFluctuation: 'Significant weight fluctuation',
    SignificantWeightLossOrSignificantWeightGain: 'Significant weight loss or significant weight gain',
    FrequentWeighingOrMeasuringOfOneself: 'Frequent weighing or measuring of oneself',
    NormalOrDepletedAdiposeAndSomaticProteinStores: 'Normal or depleted adipose and somatic protein stores',
    Cachexia: 'Cachexia',
    LanugoHairFormation: 'Lanugo hair formation',
    BrittleListlessHair: 'Brittle listless hair',
    DrySkin: 'Dry skin',
    DamagedToothEnamel: 'Damaged tooth enamel',
    EnlargedParotidGlands: 'Enlarged parotid glands',
    PeripheralAndCentralEdema: 'Peripheral and central edema',
    SkeletalMuscleLoss: 'Skeletal muscle loss',
    LowBodyTemperature: 'Low body temperature',
    InabilityToConcentrate: 'Inability to concentrate',
    ReportsOfAlwaysFeelingCold: 'Reports of always feeling cold',
    BradycardiaHeartRate60BeatsMinForAdults50BeatsMinPediatrics: 'Bradycardia (heart rate < 60 beats/min for adults, < 50 beats/min pediatrics),',
    HypotensionSystolicBloodPressure90MmHg: 'Hypotension (systolic blood pressure < 90 mm HG)',
    OrthostaticHypotension: 'Orthostatic hypotension',
    PosturalTachycardia: 'Postural tachycardia',
    CyanosisOfHandsAndFeet: 'Cyanosis of hands and feet',
    DelayedCapillaryRefill: 'Delayed capillary refill',
    SelfInducedVomiting: 'Self-induced vomiting',
    PositiveRussellsSignCallousOnBackOfHandFromSelfInducedVomiting: 'Positive Russell\'s sign, callous on back of hand from self-induced vomiting',
    GastroesophagealRefluxDisease: 'Gastroesophageal reflux disease',
    Diarrhea: 'Diarrhea',
    BloatingFlatulence: 'Bloating, flatulence',
    Constipation: 'Constipation',
    BloodInVomit: 'Blood in vomit',
    BloodInStool: 'Blood in stool',
    MuscleWeakness: 'Muscle weakness',
    MuscleOrJointPain: 'Muscle or joint pain',
    DryMucusMembranes: 'Dry mucus membranes',
    AbsenceOfHungerCues: 'Absence of hunger cues',
    AmenorrheaOrDisruptionOfMenstrualCycle: 'Amenorrhea or disruption of menstrual cycle',
    DelayInSexualDevelopmentAndOrPuberty: 'Delay in sexual development and/or puberty',
    BodyImageDisturbance: 'Body image disturbance',
    LimitedRecognitionOfLowBodyWeight: 'Limited recognition of low body weight',
    SelfEvaluationIsBasedUponBodyShapeAndOrWeight: 'Self-evaluation is based upon body shape and/or weight',
    AvoidanceOfFoodOrEnergyContainingBeverages: 'Avoidance of food or energy-containing beverages',
    AvoidanceOfSocialEventsAtWhichFoodIsServed: 'Avoidance of social events at which food is served',
    FearOfFoodsOrDysfunctionalThoughtsRegardingFoodOrFoodExperiences: 'Fear of foods or dysfunctional thoughts regarding food or food experiences',
    FoodAndWeightPreoccupation: 'Food and weight preoccupation',
    ConflictWithIndividualClientValueSystem: 'Conflict with individual client value system',
    ConflictWithClientsSupportiveIndividualsValueSystem: 'Conflict with client\'s supportive individuals value system',
    PreoccupationWithEnergyOrNutrientContentOfFoods: 'Preoccupation with energy or nutrient content of foods',
    AvoidanceOfSpecificFoodTexturesOrConsistencies: 'Avoidance of specific food textures or consistencies',
    KnowledgeableAboutCurrentDietFads: 'Knowledgeable about current diet fads',
    FastingForLongPeriodsOfTimeDuringTypicalEatingHours: 'Fasting for long periods of time during typical eating hours',
    EstimatedIntakeOfLargerQuantityOfFoodInADefinedTimePeriodASenseOfLimitedControlOverEating: 'Estimated intake of larger quantity of food in a defined time period, a sense of limited control over eating',
    RitualizedEatingBehavior: 'Ritualized eating behavior',
    ExcessivePhysicalActivity: 'Excessive physical activity',
    EatingMuchMoreRapidlyThanNormalUntilFeelingUncomfortablyFull: 'Eating much more rapidly than normal, until feeling uncomfortably full',
    ConsumingLargeAmountsOfFoodWhenNotFeelingPhysicallyHungry: 'Consuming large amounts of food when not feeling physically hungry',
    EatingMoreSlowlyThanUsualToDelayEating: 'Eating more slowly than usual to delay eating',
    HidingFood: 'Hiding food',
    DistortedPerceptionOfAppropriateAmountsToEat: 'Distorted perception of appropriate amounts to eat',
    EatingAloneBecauseOfEmbarrassment: 'Eating alone because of embarrassment',
    EatsInPrivate: 'Eats in private',
    FeelingUnpleasantEmotionsSuchAsGuiltDisgustShameAngerOrDepressionAfterEating: 'Feeling unpleasant emotions, such as, guilt, disgust, shame, anger, or depression after eating',
    PatternOfChronicDieting: 'Pattern of chronic dieting',
    PreviousFoodRestrictionIntentionalOrUnintentional: 'Previous food restriction (intentional or unintentional)',
    RecentChangeInFoodOrNutrientIntakePattern: 'Recent change in food or nutrient intake pattern',
    ExcessiveRelianceOnNutritionTermingIncludingPlacingLabelsOnFoodsThatRankTheSuperiorityOfOneFoodOverAnother: 'Excessive reliance on nutrition terming, including placing labels on foods that rank the superiority of one food over another',
    InflexibilityWithFoodSelection: 'Inflexibility with food selection',
    UseOfLaxativesEnemasDiureticsStimulantsMetabolicEnhancersMedicationsPerformanceEnhancingProducts: 'Use of laxatives, enemas, diuretics, stimulants, metabolic enhancers, medications, performance enhancing products',
    InClientsWithDiabetesPurposefulOmissionOfInsulin: 'In clients with diabetes, purposeful omission of insulin',
    NightEating: 'Night eating',
    PerceivedControlAroundNutritionIntakeThroughCalorieCountingMacronutrientMonitoringRecordKeeping: 'Perceived control around nutrition intake through calorie counting, macronutrient monitoring, record keeping',
    ChewingAndSpittingOfFood: 'Chewing and spitting of food',
    PersistentBehaviorThatInterferesWithWeightGain: 'Persistent behavior that interferes with weight gain',
    PersistentUseOfAMirror: 'Persistent use of a mirror',
    ExcessiveTimeSpentSourcingFood: 'Excessive time spent sourcing food',
    ExcessiveTimeSpentPreparingFood: 'Excessive time spent preparing food',
    AvoidanceOfFoodDeemedToBeTooProcessedOrUnhealthy: 'Avoidance of food deemed to be too processed or unhealthy',
    ExcessiveUseOfCondimentsAndFoodMixing: 'Excessive use of condiments and food mixing',
    DiagnosisEGAnorexiaNervosaBulimiaNervosaBingeEatingDisorderOtherSpecifiedFeedingOrEatingDisorder: 'Diagnosis (e.g., anorexia nervosa, bulimia nervosa, binge eating disorder, other specified feeding or eating disorder)',
    HistoryOfMentalHealthConditionDepressionAnxietyObsessiveCompulsiveDisorderOcdPersonalityDisordersSubstanceAbuseDisordersSelfInjury: 'History of mental health condition, depression, anxiety, obsessive/compulsive disorder (OCD), personality disorders, substance abuse disorders, self injury',
    FamilyHistoryOfMentalHealthConditionEatingDisorderDepressionOcdAnxietyDisorders: 'Family history of mental health condition, eating disorder, depression, OCD, anxiety disorders',
    OsteoporosisOsteopenia: 'Osteoporosis, osteopenia',
    SocialIsolation: 'Social isolation',
    SexualAbuse: 'Sexual abuse',
    PreviousTraumaticEventS: 'Previous traumatic event(s)',
    Infertility: 'Infertility',
    GallBladderDisease: 'Gall bladder disease',
    CompetitiveOrProfessionalAthlete: 'Competitive or professional athlete',
    BariatricSurgery: 'Bariatric surgery',
    CardiacArrhythmiasBradycardia: 'Cardiac arrhythmias, bradycardia',
    HyperglycemiaFastingBloodGlucose126MgDL: 'Hyperglycemia (Fasting blood glucose > 126 mg/dL)',
    HemoglobinA1C6: 'Hemoglobin A1C > 6%',
    OralGlucoseToleranceTest2HourPostLoadGlucose200MgDL: 'Oral glucose tolerance test (2-hour post load glucose > 200 mg/dL)',
    DentalCaries: 'Dental caries',
    CulturalOrReligiousPracticesThatDoNotSupportModificationOfDietaryCarbohydrateIntake: 'Cultural or religious practices that do not support modification of dietary carbohydrate intake',
    EstimatedCarbohydrateIntakeThatIsConsistentlyMoreThanRecommendedAmounts: 'Estimated carbohydrate intake that is consistently more than recommended amounts',
    ChronicUseOfMedicationsThatCauseHyperglycemia: 'Chronic use of medications that cause hyperglycemia',
    VerbalizesInaccurateOrIncompleteKnowledge: 'Verbalizes inaccurate or incomplete knowledge',
    PancreaticInsufficiencyResultingInReducedInsulinProduction: 'Pancreatic insufficiency resulting in reduced insulin production',
    EconomicConstraintsThatLimitAvailabilityOfAppropriateFoods: 'Economic constraints that limit availability of appropriate foods',
    TotalCarbohydrateEstimatedNeedsIn24Hours: 'Total carbohydrate estimated needs in 24 hours',
    CarbohydrateEstimatedNeedsPerKgOfBodyWeightIn24Hours: 'Carbohydrate estimated needs per kg of body weight in 24 hours',
    MethodForEstimatingTotal24HourCarbohydrateNeeds: 'Method for estimating total 24 hour carbohydrate needs',
    ProportionOfEnergyNeedsFromCarbohydrateIn24Hours: 'Proportion of energy needs from carbohydrate in 24 hours',
    InadequateFecalBulk: 'Inadequate fecal bulk',
    EstimatedIntakeOfFiberThatIsInsufficientWhenComparedToRecommendedAmounts38GDayForMenAnd25GDayForWomen: 'Estimated intake of fiber that is insufficient when compared to recommended amounts (38 g/day for men and 25 g/day for women)',
    ConditionsAssociatedWithADiagnosisOrTreatmentEGUlcerDiseaseIbd: 'Conditions associated with a diagnosis or treatment (e.g., ulcer disease,IBD)',
    TotalFiberEstimatedNeedsIn24Hours: 'Total fiber estimated needs in 24 hours',
    MethodForEstimatingTotal24HourFiberNeeds: 'Method for estimating total 24 hour fiber needs',
    Cholesterol200MgDL52MmolLLdlCholesterol100MgDL259MmolLHdlCholesterol40MgDL1036MmolLTriglycerides150MgDL1695MmolL: 'Cholesterol > 200 mg/dL (5.2 mmol/L), LDL cholesterol > 100 mg/dL (2.59 mmol/L), HDL cholesterol < 40 mg/dL (1.036 mmol/L), triglycerides > 150 mg/dL (1.695 mmol/L)',
    SerumAmylaseAndOrLipase: 'Serum amylase and/or lipase',
    LftsTBilirubin: 'LFTs, T. bilirubin',
    FecalFat7g24Hours: 'Fecal fat > 7g/24 hours',
    EvidenceOfXanthomas: 'Evidence of xanthomas',
    DiarrheaCrampingSteatorrheaEpigastricPain: 'Diarrhea, cramping, steatorrhea, epigastric pain',
    FrequentOrLargePortionsOfHighFatFoods: 'Frequent or large portions of high-fat foods',
    FrequentFoodPreparationWithAddedFat: 'Frequent food preparation with added fat',
    FrequentConsumptionOfHighRiskLipidsIESaturatedFatTransFatCholesterol: 'Frequent consumption of high-risk lipids (i.e., saturated fat, trans fat, cholesterol)',
    ReportOfFoodsContainingFatMoreThanDietPrescription: 'Report of foods containing fat more than diet prescription',
    MedicationEgPancreaticEnzymesCholesterolOrOtherLipidLoweringMedications: 'Medication, eg, pancreatic enzymes, cholesterol or other lipid-lowering medications',
    VerbalizesUnsupportedBeliefsAndAttitudes: 'Verbalizes unsupported beliefs and attitudes',
    ConditionsAssociatedWithADiagnosisOrTreatmentEGHyperlipidemia: 'Conditions associated with a diagnosis or treatment (e.g., hyperlipidemia)',
    FamilyHistoryOfHyperlipidemiaAtherosclerosisOrPancreatitis: 'Family history of hyperlipidemia, atherosclerosis, or pancreatitis',
    TotalFatEstimatedNeedsIn24Hours: 'Total fat estimated needs in 24 hours',
    FatEstimatedNeedsPerKgOfBodyWeightIn24Hours: 'Fat estimated needs per kg of body weight in 24 hours',
    MethodForEstimatingTotal24HourFatNeeds: 'Method for estimating total 24 hour fat needs',
    ProportionOfEnergyNeedsFromFatIn24Hours: 'Proportion of energy needs from fat in 24 hours',
    VitaminASerumRetinol10GDL035MolL: 'Vitamin A: Serum retinol < 10 µg/dL (0.35 µmol/L)',
    VitaminCPlasmaConcentrations02MgDL114MolL: 'Vitamin C: Plasma concentrations < 0.2 mg/dL (11.4 µmol/L)',
    VitaminD25Ohd50NmolLIonizedCalcium39MgDL098MmolLWithHighParathyroidHormoneNormalSerumCalciumAndLowSerumPhosphorus26MgDL084MmolL: 'Vitamin D: 25(OH)D <50 nmol/L, ionized calcium < 3.9 mg/dL (0.98 mmol/L) with high parathyroid hormone, normal serum calcium, and low serum phosphorus < 2.6 mg/dL (0.84 mmol/L)',
    VitaminEPlasmaAlphaTocopherol18MolG418MolL: 'Vitamin E: Plasma alpha-tocopherol < 18 µmol/g (41.8 µmol/L)',
    VitaminKProthrombinTimeAlteredInrWithoutAnticoagulationTherapy: 'Vitamin K: Prothrombin time; altered INR (without anticoagulation therapy)',
    ThiaminErythrocyteTransketolaseActivity120GMLH: 'Thiamin: Erythrocyte transketolase activity > 1.20 µg/mL/h',
    RiboflavinErythrocyteGlutathioneReductase12IuGHemoglobin: 'Riboflavin: Erythrocyte glutathione reductase > 1.2 IU/g hemoglobin',
    NiacinNmethylNicotinamideExcretion58MolDay: 'Niacin: N\'methyl-nicotinamide excretion < 5.8 µmol/day',
    VitaminB6PlasmaPryrdoxal5phosphate5NgML20NmolL: 'Vitamin B-6: Plasma pryrdoxal 5\'phosphate <5 ng/mL (20 nmol/L)',
    VitaminB12SerumConcentration244NgDL180PmolLHighHomocysteine: 'Vitamin B-12: Serum concentration < 24.4 ng/dL (180 pmol/L); high homocysteine',
    FolicAcidSerumConcentration03GDL7NmolLRedCellFolate315NmolL: 'Folic acid: Serum concentration < 0.3 µg/dL (7 nmol/L); red cell folate < 315 nmol/L',
    PantothenicAcidLowPlasma: 'Pantothenic acid: Low plasma',
    BiotinLowSerum: 'Biotin: Low serum',
    VitaminANightBlindnessBitotsSpotsXerophthalmiaFollicularHyperkeratosis: 'Vitamin A: night blindness, Bitot\'s spots, xerophthalmia, follicular hyperkeratosis',
    VitaminCFollicularHyperkeratosisPetechiaeEcchymosisCoiledHairsInflamedAndBleedingGumsPerifolicularHemorrhagesJointEffusionsArthralgiaAndImpairedWoundHealing: 'Vitamin C: follicular hyperkeratosis, petechiae, ecchymosis, coiled hairs, inflamed and bleeding gums, perifolicular hemorrhages, joint effusions, arthralgia, and impaired wound healing',
    VitaminDWideningAtEndsOfLongBones: 'Vitamin D: widening at ends of long bones',
    RiboflavinSoreThroatHyperemiaEdemaOfPharyngealAndOralMucousMembranesCheilosisAngularStomatitisGlossitisMagentaTongueSeborrheicDermatitisAndNormochromicNormocyticAnemiaWithPureErythrocyteCytoplasiaOfTheBoneMarrow: 'Riboflavin: sore throat, hyperemia, edema of pharyngeal and oral mucous membranes, cheilosis, angular stomatitis, glossitis, magenta tongue, seborrheic dermatitis, and normochromic, normocytic anemia with pure erythrocyte cytoplasia of the bone marrow',
    NiacinSymmetricalPigmentedRashOnAreasExposedToSunlightBrightRedTongue: 'Niacin: symmetrical, pigmented rash on areas exposed to sunlight; bright red tongue',
    VitaminB6SeborrheicDermatitisStomatitisCheilosisGlossitisConfusionDepression: 'Vitamin B-6: seborrheic dermatitis, stomatitis, cheilosis, glossitis, confusion, depression',
    VitaminB12TinglingAndNumbnessInExtremitiesDiminishedVibratoryAndPositionSenseMotorDisturbancesIncludingGaitDisturbances: 'Vitamin B-12: tingling and numbness in extremities, diminished vibratory and position sense, motor disturbances including gait disturbances',
    PantothenicAcidIrritabilityAndRestlessnessFatigueApathyMalaiseSleepDisturbancesNauseaVomitingAbdominalCrampsNumbnessMuscleCrampsHypoglycemiaSensitivityToInsulin: 'Pantothenic acid: irritability and restlessness, fatigue, apathy, malaise, sleep disturbances, nausea, vomiting, abdominal cramps, numbness, muscle cramps, hypoglycemia, sensitivity to insulin',
    BiotinDermatitisConjunctivitisAlopeciaDepressionLethargyHallucinationsAndParesthesiaHypotoniaDevelopmentalDelays: 'Biotin: dermatitis, conjunctivitis, alopecia, depression, lethargy, hallucinations and paresthesia, hypotonia, developmental delays',
    EstimatedIntakeOfFoodsContainingSpecificVitaminsLessThanRequirementsOrRecommendedLevel: 'Estimated intake of foods containing specific vitamins less than requirements or recommended level',
    IntakeOfFoodsThatDoNotContainAvailableVitaminsEGOverProcessedOvercookedOrImproperlyStoredFoods: 'Intake of foods that do not contain available vitamins (e.g., over processed, overcooked, or improperly stored foods)',
    ProlongedUseOfSubstancesKnownToIncreaseVitaminRequirementsOrReduceVitaminAbsorption: 'Prolonged use of substances known to increase vitamin requirements or reduce vitamin absorption',
    LackOfInterestInFoods: 'Lack of interest in foods',
    ConditionsAssociatedWithADiagnosisOrTreatmentEGMalabsorptionAsAResultOfCeliacDiseaseShortBowelSyndromeOrInflammatoryBowel: 'Conditions associated with a diagnosis or treatment (e.g., malabsorption as a result of celiac disease, short-bowel syndrome, or inflammatory bowel)',
    CertainEnvironmentalConditionsEgInfantsExclusivelyFedBreastmilkWithLimitedExposureToSunlightVitaminD: 'Certain environmental conditions, eg, infants exclusively fed breastmilk with limited exposure to sunlight (Vitamin D)',
    HistoryOfChronicKidneyDiseaseDecreasedConversionOf25Ohd: 'History of chronic kidney disease - decreased conversion of 25(OH)D',
    PrematureInfantExtremelyLowBirthWeightInfantVitaminD: 'Premature infant, extremely low-birth-weight infant (vitamin D)',
    RachiticRosaryInChildrenRicketsOsteomalacia: 'Rachitic rosary in children, rickets, osteomalacia',
    Pellagra: 'Pellagra',
    EstimatedVitaminANeedsIn24Hours: 'Estimated vitamin A needs in 24 hours',
    EstimatedVitaminCNeedsIn24Hours: 'Estimated vitamin C needs in 24 hours',
    EstimatedVitaminDNeedsIn24Hours: 'Estimated vitamin D needs in 24 hours',
    EstimatedVitaminENeedsIn24Hours: 'Estimated vitamin E needs in 24 hours',
    EstimatedVitaminKNeedsIn24Hours: 'Estimated vitamin K needs in 24 hours',
    EstimatedThiaminNeedsIn24Hours: 'Estimated thiamin needs in 24 hours',
    EstimatedRiboflavinNeedsIn24Hours: 'Estimated riboflavin needs in 24 hours',
    EstimatedNiacinNeedsIn24Hours: 'Estimated niacin needs in 24 hours',
    EstimatedFolateNeedsIn24Hours: 'Estimated folate needs in 24 hours',
    EstimatedVitaminB6NeedsIn24Hours: 'Estimated vitamin B6 needs in 24 hours',
    EstimatedVitaminB12NeedsIn24Hours: 'Estimated vitamin B12 needs in 24 hours',
    EstimatedPantothenicAcidNeedsIn24Hours: 'Estimated pantothenic acid needs in 24 hours',
    EstimatedBiotinNeedsIn24Hours: 'Estimated biotin needs in 24 hours',
    MethodForEstimating24HourVitaminNeeds: 'Method for estimating 24 hour vitamin needs',
    CalciumBoneMineralContentBmcLowerThanTheYoungAdultMeanHypocalciuriaSerum25Ohd32NgML: 'Calcium: bone mineral content (BMC) lower than the young adult mean. Hypocalciuria, serum 25(OH)D < 32 ng/mL',
    LowPhosphorus26MgDL084MmolL: 'Low Phosphorus < 2.6 mg/dL (0.84 mmol/L)',
    FerritinInClientWithALowMeanCorpuscularVolumeMcv: 'Ferritin in client with a low Mean Corpuscular Volume (MCV)',
    LowZincPlasma: 'Low Zinc, plasma',
    LowMagnesium18MgDL07MmolL: 'Low Magnesium <1.8 mg/dL (0.7 mmol/L)',
    IronLowHemoglobin13GL2MmolLMales12GL186MmolLFemales: 'Iron: low hemoglobin < 13 g/L (2 mmol/L) (males); < 12 g/L (1.86 mmol/L) (females)',
    IodineLowUrinaryExcretion100GL788NmolL: 'Iodine: low urinary excretion < 100 µg/L (788 nmol/L)',
    CopperLowSerumCopper64GDL10MolL: 'Copper: Low serum copper < 64 µg/dL (10 µmol/L)',
    LowSeleniumPlasma: 'Low Selenium, plasma',
    LowFluoridePlasma: 'Low Fluoride, plasma',
    LowManganeseSerum: 'Low Manganese, serum',
    LowMolybdenumSerum: 'Low Molybdenum, serum',
    LowBoronSerumOrPlasma: 'Low Boron, serum or plasma',
    ChangesInUrineLabsAssociatedWithKidneyStones: 'Changes in urine labs associated with kidney stones',
    CalciumBodyHeightLoss: 'Calcium: body height loss',
    IodineGrowthAbnormalities: 'Iodine: growth abnormalities',
    ChromiumUnintentionalBodyWeightLoss: 'Chromium: unintentional body weight loss',
    CalciumHypertensionAcuteHyperactiveReflexesTetanyMuscleSpasmIrregularHeartRhythm: 'Calcium: hypertension, acute - hyperactive reflexes, tetany, muscle spasm, irregular heart rhythm',
    IronPallorOfFaceMucosaPaleGumsTachycardiaFatigue: 'Iron: pallor of face, mucosa, pale gums, tachycardia, fatigue',
    PotassiumWeaknessConstipationHypoactiveReflexes: 'Potassium - weakness, constipation, hypoactive reflexes',
    PhosphorousFatigueMyalgiaAtaxiaConfusionParasthesias: 'Phosphorous: fatigue, myalgia, ataxia, confusion, parasthesias',
    ZincDysgeusiaPoorWoundHealingSkinLesionsButtocksPerianalAreaMouthNoseEyesAlopecia: 'Zinc: dysgeusia, poor wound healing, skin lesions (buttocks, perianal area, mouth, nose, eyes), alopecia',
    CopperDepigmentationOfHairAndSkinOsteoporosis: 'Copper: depigmentation of hair and skin, osteoporosis',
    SeleniumDepigmentationOfHairAndSkin: 'Selenium:depigmentation of hair and skin',
    IodineEnlargedThyroid: 'Iodine: enlarged thyroid',
    FluorideDentalCaries: 'Fluoride: dental caries',
    ManganeseDermatitis: 'Manganese: dermatitis',
    EstimatedMineralIntakeFromDietLessThanRecommendedIntake: 'Estimated mineral intake from diet less than recommended intake',
    FoodAvoidanceAndOrEliminationOfWholeFoodGroupSFromDiet: 'Food avoidance and/or elimination of whole food group(s) from diet',
    LackOfInterestInFood: 'Lack of interest in food',
    LessThanOptimalFoodChoicesAndOrChronicDietingBehavior: 'Less than optimal food choices and/or chronic dieting behavior',
    CulturalOrReligiousPracticesThatAffectIntake: 'Cultural or religious practices that affect intake',
    ConditionsAssociatedWithADiagnosisOrTreatmentEGMalabsorptionAsAResultOfCeliacDisease: 'Conditions associated with a diagnosis or treatment (e.g., malabsorption as a result of celiac disease)',
    PolycysticOvarySyndromePremenstrualSyndromeKidneyStonesColonPolyps: 'Polycystic ovary syndrome, premenstrual syndrome, kidney stones, colon polyps',
    OtherSignificantMedicalDiagnosesAndTherapies: 'Other significant medical diagnoses and therapies',
    GeographicLatitudeAndHistoryOfUltravioletBExposureUseOfSunscreen: 'Geographic latitude and history of Ultraviolet-B exposure/use of sunscreen',
    ChangeInLivingEnvironmentIndependence: 'Change in living environment/independence',
    CalciumObesity: 'Calcium: obesity',
    EstimatedCalciumNeedsIn24Hours: 'Estimated calcium needs in 24 hours',
    EstimatedChlorideNeedsIn24Hours: 'Estimated chloride needs in 24 hours',
    EstimatedIronNeedsIn24Hours: 'Estimated iron needs in 24 hours',
    EstimatedMagnesiumNeedsIn24Hours: 'Estimated magnesium needs in 24 hours',
    EstimatedPotassiumNeedsIn24Hours: 'Estimated potassium needs in 24 hours',
    EstimatedPhosphorusNeedsIn24Hours: 'Estimated phosphorus needs in 24 hours',
    EstimatedSodiumNeedsIn24Hours: 'Estimated sodium needs in 24 hours',
    EstimatedZincNeedsIn24Hours: 'Estimated zinc needs in 24 hours',
    EstimatedSulfateNeedsIn24Hours: 'Estimated sulfate needs in 24 hours',
    EstimatedFluorideNeedsIn24Hours: 'Estimated fluoride needs in 24 hours',
    EstimatedCopperNeedsIn24Hours: 'Estimated copper needs in 24 hours',
    EstimatedIodineNeedsIn24Hours: 'Estimated iodine needs in 24 hours',
    EstimatedSeleniumNeedsIn24Hours: 'Estimated selenium needs in 24 hours',
    EstimatedManganeseNeedsIn24Hours: 'Estimated manganese needs in 24 hours',
    EstimatedChromiumNeedsIn24Hours: 'Estimated chromium needs in 24 hours',
    EstimatedMolybdenumNeedsIn24Hours: 'Estimated molybdenum needs in 24 hours',
    EstimatedBoronNeedsIn24Hours: 'Estimated boron needs in 24 hours',
    EstimatedCobaltNeedsIn24Hours: 'Estimated cobalt needs in 24 hours',
    MethodForEstimating24HourMineralNeeds: 'Method for estimating 24 hour mineral needs'
} as const;

export type ClinicalFormNutritionDiagnosisSymptom = typeof ClinicalFormNutritionDiagnosisSymptom[keyof typeof ClinicalFormNutritionDiagnosisSymptom];



export const ClinicalFormNutritionIntervention = {
    Nd11: 'nd_11',
    Nd12: 'nd_12',
    Nd13: 'nd_13',
    Nd21: 'nd_21',
    Nd22: 'nd_22',
    Nd31: 'nd_31',
    Nd32: 'nd_32',
    Nd33: 'nd_33',
    E11: 'e_11',
    E12: 'e_12',
    E13: 'e_13',
    E14: 'e_14',
    E15: 'e_15',
    E21: 'e_21',
    E22: 'e_22',
    C11: 'c_11',
    C12: 'c_12',
    C13: 'c_13',
    C14: 'c_14',
    C21: 'c_21',
    C22: 'c_22',
    C23: 'c_23',
    C24: 'c_24',
    C25: 'c_25',
    C26: 'c_26',
    C27: 'c_27',
    C28: 'c_28',
    C29: 'c_29',
    C210: 'c_210'
} as const;

export type ClinicalFormNutritionIntervention = typeof ClinicalFormNutritionIntervention[keyof typeof ClinicalFormNutritionIntervention];


export interface ClinicalFormResponse {
    'patient_age'?: number | null;
    'patient_sex'?: Sex | null;
    'patient_weight'?: string | null;
    'patient_height'?: string | null;
    'patient_bmi'?: BMI | null;
    'orbital_fat_assessment'?: ClinicalFormFatAssessment;
    'triceps_fat_assessment'?: ClinicalFormFatAssessment;
    'overlying_ribs_fat_assessment'?: ClinicalFormFatAssessment;
    'temple_mass_assessment'?: ClinicalFormMassAssessment;
    'pectoralis_mass_assessment'?: ClinicalFormMassAssessment;
    'shoulder_mass_assessment'?: ClinicalFormMassAssessment;
    'back_mass_assessment'?: ClinicalFormMassAssessment;
    'hand_mass_assessment'?: ClinicalFormMassAssessment;
    'thigh_mass_assessment'?: ClinicalFormMassAssessment;
    'patient_usual_body_weight'?: string | null;
    'patient_ideal_body_weight'?: string | null;
    'patient_weight_increased'?: boolean;
    'patient_weight_decreased'?: boolean;
    'patient_weight_change_notes'?: string | null;
    'patient_24_hour_recall'?: string | null;
    'patient_appetite'?: string | null;
    'patient_food_allergies'?: string | null;
    'patient_food_preferences'?: string | null;
    'patient_adaptive_devices'?: string | null;
    'patient_difficulty_chewing_swallowing'?: string | null;
    'patient_feeding_assistance'?: string | null;
    'patient_medical_conditions'?: string | null;
    'patient_lab_results'?: string | null;
    'patient_medications'?: string | null;
    'patient_physical_appearance'?: string | null;
    'patient_hydration_status'?: string | null;
    'patient_malnutrition_status'?: string | null;
    'total_calories'?: string | null;
    'total_calories_estimation_method'?: string | null;
    'total_protein'?: string | null;
    'total_protein_estimation_method'?: string | null;
    'total_fluids'?: string | null;
    'total_fluids_estimation_method'?: string | null;
    'current_intake_meets_estimated_needs'?: boolean | null;
    'estimated_nutrition_needs_notes'?: string | null;
    'nutrition_diagnosis_problem'?: ClinicalFormNutritionDiagnosisProblem | null;
    'nutrition_diagnosis_problem_etiology'?: Array<ClinicalFormNutritionDiagnosisEtiology> | null;
    'nutrition_diagnosis_symptoms'?: Array<ClinicalFormNutritionDiagnosisSymptom> | null;
    'smart_goals'?: Array<string> | null;
    'care_plan_updated_for_nutrition_goals'?: boolean;
    'interventions'?: Array<ClinicalFormNutritionIntervention> | null;
    'additional_interventions'?: string | null;
    'metrics_to_monitor'?: string | null;
    'follow_up_appointment_id'?: string | null;
    'last_edited_by'?: Editor | null;
    'created_at'?: string | null;
    'updated_at'?: string | null;
}



export const CognitoUserStatus = {
    Confirmed: 'CONFIRMED',
    Unconfirmed: 'UNCONFIRMED',
    Archived: 'ARCHIVED',
    Compromised: 'COMPROMISED',
    Unknown: 'UNKNOWN',
    ResetRequired: 'RESET_REQUIRED',
    ForceChangePassword: 'FORCE_CHANGE_PASSWORD'
} as const;

export type CognitoUserStatus = typeof CognitoUserStatus[keyof typeof CognitoUserStatus];


export interface CommandOrEventSchema {
    'properties': object;
    'title': string;
}
export interface CommandsAndEventsResponse {
    'commands': Array<CommandOrEventSchema>;
    'events': Array<CommandOrEventSchema>;
}

export const CommercialPlanType = {
    Employer: 'employer',
    School: 'school'
} as const;

export type CommercialPlanType = typeof CommercialPlanType[keyof typeof CommercialPlanType];


export interface CompleteGoalPayload {
    'timezone'?: string | null;
}
export interface CompleteLoginChallengePayload {
    'challenge_id': string;
    'code': string;
}
export interface CompletePartnerBookingPayload {
    'email': string;
    'address'?: AddressDetails | null;
    'insurance'?: InsuranceDetails | null;
    'payment'?: StripePaymentDetails | null;
    'first_name'?: string | null;
    'last_name'?: string | null;
    'date_of_birth'?: string | null;
    'reason': string;
    'weight_in_lbs': number;
    'height_in_inches': number;
    'gender': Sex;
    'mobile_phone_no': string;
    'tags'?: Set<EnrollmentTags>;
}


export interface CompletePartnerBookingResponse {
    'appointment_id': string;
}
export interface CompletePatientGoalResponse {
    'goal': PatientGoalResponse;
    'reward': RewardResponse | null;
    'progress': ProgressResponse;
}
export interface CompleteResetPasswordPayload {
    'token': string;
    'new_password': string;
}
export interface ConfigUsedValue {
}
export interface CreateBookingCodePayload {
    'description': string;
    'code_type': BookingCodeType;
    'custom_code'?: string | null;
}


export interface CreateCalendarBlockPayload {
    'title': string;
    'start': string;
    'end': string;
}
export interface CreateClaimPayload {
    'appointment_id': string;
}
export interface CreateClaimResponse {
    'claim_id': string | null;
}
export interface CreateClaimsFromSpecificationsPayload {
    'claims': Array<APIClaimSpecificationInput>;
}
export interface CreateClaimsResponse {
    'created_claim_ids': Array<string>;
}
/**
 * Payload for creating a deferral rule.  At least one of appointment_ids, provider_ids, or insurance_companies must be provided. All non-empty fields are AND\'d together when evaluating. Within each field, values are OR\'d (e.g., any matching appointment_id).
 */
export interface CreateDeferralRulePayload {
    'rule_name': string;
    'appointment_ids'?: Array<string>;
    'provider_ids'?: Array<string>;
    'insurance_companies'?: Array<InsuranceCompany>;
}
export interface CreateEligibilityFilePayload {
    's3_bucket': string;
    's3_key': string;
}
export interface CreateExternalProvider {
    'provider_type': string;
    'first_name': string;
    'last_name': string;
    'taxonomy': string;
    'state': string;
    'npi_number': string;
    'primary_email'?: string | null;
    'addresses': Array<CreateExternalProviderAddress>;
    'existing_provider_id'?: string | null;
}
export interface CreateExternalProviderAddress {
    'country_code'?: string | null;
    'country_name'?: string | null;
    'address_purpose'?: string | null;
    'address_type'?: string | null;
    'line1'?: string | null;
    'line2'?: string | null;
    'city'?: string | null;
    'state'?: string | null;
    'postal_code'?: string | null;
    'phone_number'?: string | null;
    'fax_number'?: string | null;
}
export interface CreateFormAnswer {
    'label': string;
    'answer'?: string | null;
    'order': number;
    'stable_id': string;
}
export interface CreateGoalPayload {
    'title': string;
}
export interface CreateJournalEntryFilePayload {
    'file_key': string;
}
export interface CreateJournalEntryPayload {
    'content': string;
    'files': Array<CreateJournalEntryFilePayload>;
    'occurred_at': string;
    'current_timezone'?: string | null;
    'add_to_current_provider_chat'?: boolean;
    'is_private'?: boolean;
}
/**
 * Request payload for creating an admin medical record request.  Admin-only endpoint for creating medical record exports.  Attributes:     patient_id: The patient whose medical records are being requested.     claim_carrier_control_numbers: List of claim carrier control numbers (required, non-empty, max 100).
 */
export interface CreateMedicalRecordRequestPayload {
    'claim_carrier_control_numbers'?: Array<string> | null;
    'patient_id'?: string | null;
    'appointment_start_date'?: string | null;
    'appointment_end_date'?: string | null;
}
/**
 * Response for medical record request creation.
 */
export interface CreateMedicalRecordRequestResponse {
    'medical_record_request_group_id': string;
}
export interface CreateNutritionResearchThreadResponse {
    'thread_id': string;
}
export interface CreatePaymentInstrumentPayload {
    'card_token'?: string | null;
    'payment_method_id'?: string | null;
    'card_source': CardSource;
}


export interface CursorPaginatedJournalEntriesResponse {
    'entries': Array<JournalEntryResponse>;
    'next_cursor': string | null;
}
export interface DateRangePaginatedClientCareResponse {
    'client_care': Array<ClientCareResponse>;
    'next_page': number;
}
export interface DateTimeWindow {
    'start': string;
    'end': string;
}

export const DayOfWeek = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5,
    NUMBER_6: 6,
    NUMBER_7: 7
} as const;

export type DayOfWeek = typeof DayOfWeek[keyof typeof DayOfWeek];


export interface DeferralRuleResponse {
    'rule_id': string;
    'name': string;
    'specification_type': string;
    'created_at': string;
}
export interface DeferralRulesListResponse {
    'rules': Array<DeferralRuleResponse>;
}

export const DestinationMedium = {
    Email: 'EMAIL',
    Sms: 'SMS',
    Fax: 'FAX',
    Letter: 'LETTER',
    PushNotification: 'PUSH_NOTIFICATION',
    Unknown: 'UNKNOWN'
} as const;

export type DestinationMedium = typeof DestinationMedium[keyof typeof DestinationMedium];



export const DonationStatusResponse = {
    Active: 'active',
    Canceled: 'canceled',
    PaymentError: 'payment_error'
} as const;

export type DonationStatusResponse = typeof DonationStatusResponse[keyof typeof DonationStatusResponse];


export interface Editor {
    'editor_type': EditorType;
    'editor_id': string;
}



export const EditorType = {
    AiPrefill: 'ai_prefill',
    Provider: 'provider'
} as const;

export type EditorType = typeof EditorType[keyof typeof EditorType];


export interface EligibilityFileResponse {
    'employer_eligibility_file_id': string | null;
    's3_bucket': string;
    's3_key': string;
    'status': EmployerEligibilityFileStatus;
}



export const EligibilityStatus = {
    Eligible: 'ELIGIBLE',
    Ineligible: 'INELIGIBLE',
    Invalid: 'INVALID',
    EligibleOverride: 'ELIGIBLE_OVERRIDE'
} as const;

export type EligibilityStatus = typeof EligibilityStatus[keyof typeof EligibilityStatus];



export const EmployerEligibilityFileStatus = {
    Pending: 'pending',
    Succeeded: 'succeeded',
    Failed: 'failed'
} as const;

export type EmployerEligibilityFileStatus = typeof EmployerEligibilityFileStatus[keyof typeof EmployerEligibilityFileStatus];


export interface EndDate {
}

export const EnrollmentTags = {
    Autoimmune: 'Autoimmune',
    Bariatric: 'Bariatric',
    Celiac: 'Celiac',
    Colitis: 'Colitis',
    CrohnsDisease: 'Crohn\'s Disease',
    Diabetes: 'Diabetes',
    EatingDisordersDisorderedEating: 'Eating Disorders & Disordered Eating',
    FoodAllergiesSensitivities: 'Food Allergies & Sensitivities',
    Gerd: 'GERD',
    GeneralNutrition: 'General Nutrition',
    GutHealth: 'Gut Health',
    HighBloodPressure: 'High Blood Pressure',
    HighCholesterol: 'High Cholesterol',
    Ibd: 'IBD',
    Ibs: 'IBS',
    KidneyDisease: 'Kidney Disease',
    PerimenopauseMenopause: 'Perimenopause & Menopause',
    OncologyCancer: 'Oncology / Cancer',
    Pcos: 'PCOS',
    Pots: 'POTS',
    Pediatrics: 'Pediatrics',
    PregnancyPostpartum: 'Pregnancy & Postpartum',
    Sibo: 'SIBO',
    SportsNutrition: 'Sports Nutrition',
    ThyroidHealth: 'Thyroid Health',
    Transplant: 'Transplant',
    VeganVegetarian: 'Vegan & Vegetarian',
    WeightLoss: 'Weight Loss',
    Menopause: 'Menopause',
    Pregnancy: 'Pregnancy',
    Oncology: 'Oncology'
} as const;

export type EnrollmentTags = typeof EnrollmentTags[keyof typeof EnrollmentTags];


export interface ErrorResponse {
    'detail': string;
}
export interface ExternalProviderList {
    'providers': Array<CreateExternalProvider>;
}
export interface ExternalProviderResponse {
    'external_provider_id': string;
    'provider_type': string;
    'first_name': string;
    'last_name': string;
    'taxonomy': string;
    'npi_number': string;
    'state': string;
    'primary_email'?: string | null;
    'addresses': Array<PatientExternalProviderAddress>;
}
export interface ExternalProviderResponseList {
    'providers': Array<ExternalProviderResponse>;
}

export const ExternalProviderType = {
    PrimaryCareProvider: 'primary care provider',
    Therapist: 'therapist',
    HcaReferralProvider: 'hca referral provider',
    Other: 'other'
} as const;

export type ExternalProviderType = typeof ExternalProviderType[keyof typeof ExternalProviderType];


export interface FCMRegistrationRequest {
    'fcm_registration_token': string;
    'generated_at': string;
}
export interface FCMRegistrationResponse {
    'success'?: boolean;
}
export interface FailedSubmission {
    'medical_record_request_submission_id': string;
    'reason': string;
}
export interface FollowUpAppointmentDetails {
    'appointment_id': string;
    'start': string;
    'duration_in_minutes': number;
    'status': AppointmentStatus;
    'appointment_type': AppointmentType;
    'location_type': AppointmentLocationType;
    'location'?: string | null;
    'recurrence_type'?: RecurrenceType | null;
}


export interface FormAnswerResponse {
    'form_answer_id': string;
    'label': string;
    'answer': string | null;
    'order': number;
    'stable_id': string;
}
export interface FormAnswerResponseList {
    'answers': Array<FormAnswerResponse>;
}
/**
 * Complete provider profile fetched directly from source of truth. Used for provider self-management and admin access.
 */
export interface FullProviderProfileResponse {
    /**
     * Unique identifier for the provider
     */
    'provider_id': string;
    /**
     * URL-friendly unique identifier for the provider
     */
    'slug': string;
    /**
     * Provider\'s full name including credentials (e.g., \'Jane Smith, RD\')
     */
    'full_name_and_credentials': string;
    'booking_url': string | null;
    'photo_url': string | null;
    'profile_url': string | null;
    /**
     * US states where the provider is licensed to practice
     */
    'supported_us_states': Array<USState>;
    'address': BaseAddress | null;
    'background': string | null;
    'approach': string | null;
    /**
     * Clinical specialties the provider focuses on
     */
    'specialties': Array<ProfileSpecialty>;
    /**
     * Treatment modalities the provider offers
     */
    'modalities': Array<ProfileModality>;
    /**
     * Identities the provider identifies with
     */
    'identities': Array<ProfileIdentity>;
    /**
     * Dietary approaches the provider specializes in
     */
    'diets': Array<ProfileDiet>;
    /**
     * Cuisine types the provider has expertise in
     */
    'cuisines': Array<ProfileCuisine>;
    /**
     * Languages the provider speaks
     */
    'languages': Array<ProfileLanguage>;
    /**
     * Insurance plans the provider accepts
     */
    'insurance_accepted': Array<ProfileInsurance>;
    /**
     * Appointment types offered (e.g., in_person, virtual)
     */
    'availability_types': Array<ProviderAvailabilityType>;
    'availability_slots': number | null;
    'offers_free_consultations': boolean | null;
}

export const Gender = {
    Male: 'Male',
    Female: 'Female',
    NonBinary: 'Non-binary',
    PreferNotToSay: 'Prefer not to say'
} as const;

export type Gender = typeof Gender[keyof typeof Gender];


export interface GenerateMealPlanPayload {
    /**
     * The ID of the patient to generate the meal plan for
     */
    'patient_id': string;
    /**
     * A description of the meal plan
     */
    'description': string;
    /**
     * A list of health conditions that the meal plan should be designed to address
     */
    'conditions': Array<MealPlanCondition>;
    'calorie_target'?: number | null;
}
/**
 * Response for medical record request status.
 */
export interface GetMedicalRecordRequestStatusResponse {
    'status': MedicalRecordRequestStatus;
    'warnings'?: Array<MedicalRecordRequestExportWarning>;
}


export interface GetNutritionResearchThreadMessagesResponse {
    'thread_id': string;
    'messages': Array<NutritionResearchMessageDetails>;
}
export interface GetNutritionResearchThreadResponse {
    'thread_id': string;
}
/**
 * @type GetPatientBillingItemsBillingPatientIdBillingItemsGet200ResponseInner
 */
export type GetPatientBillingItemsBillingPatientIdBillingItemsGet200ResponseInner = PatientBillingAppointmentItemDetailsResponse | PatientBillingAsyncItemDetailsResponse;

export interface GoogleBusinessLocationId {
}
export interface GoogleBusinessPlaceId {
}
export interface GroupSettingItem {
    'group_slug': string;
    'is_enabled': boolean;
}
export interface HTTPValidationError {
    'detail'?: Array<ValidationError>;
}
export interface HasGoalsFeatureResponse {
    /**
     * Indicates whether the patient has the goals feature.
     */
    'has_goals_feature': boolean;
}
export interface Height {
}
export interface HeightFieldInput {
    'unit': HeightUnits;
    'value': Value;
}


export interface HeightFieldOutput {
    'unit': HeightUnits;
    'value': string;
}



export const HeightUnits = {
    Inches: 'inches',
    Centimeters: 'centimeters'
} as const;

export type HeightUnits = typeof HeightUnits[keyof typeof HeightUnits];



export const HolderRelationship = {
    Self: 'Self',
    Spouse: 'Spouse',
    Child: 'Child',
    Other: 'Other',
    Unknown: 'Unknown'
} as const;

export type HolderRelationship = typeof HolderRelationship[keyof typeof HolderRelationship];


/**
 * A diagnosis code for a claim.
 */

export const ICDCode = {
    E663: 'E66.3',
    E669: 'E66.9',
    E6601: 'E66.01',
    E6609: 'E66.09',
    E7801: 'E78.01',
    E059: 'E05.9',
    E0590: 'E05.90',
    E162: 'E16.2',
    E106: 'E10.6',
    E1164: 'E11.64',
    E161: 'E16.1',
    E038: 'E03.8',
    E039: 'E03.9',
    E063: 'E06.3',
    E10: 'E10',
    E1064: 'E10.64',
    E11: 'E11',
    E1121: 'E11.21',
    E1122: 'E11.22',
    E660: 'E66.0',
    E668: 'E66.8',
    E7800: 'E78.00',
    E781: 'E78.1',
    E8301: 'E83.01',
    E890: 'E89.0',
    Z713: 'Z71.3',
    Z6823: 'Z68.23',
    Z6824: 'Z68.24',
    Z6835: 'Z68.35',
    Z6836: 'Z68.36',
    Z6837: 'Z68.37',
    Z6838: 'Z68.38',
    Z6839: 'Z68.39',
    Z6840: 'Z68.40',
    Z6841: 'Z68.41',
    Z6842: 'Z68.42',
    Z6843: 'Z68.43',
    Z6844: 'Z68.44',
    Z6845: 'Z68.45',
    Z681: 'Z68.1',
    Z8632: 'Z86.32',
    Z6827: 'Z68.27',
    Z6830: 'Z68.30',
    Z6831: 'Z68.31',
    Z6832: 'Z68.32',
    Z6833: 'Z68.33',
    Z6834: 'Z68.34',
    Z6851: 'Z68.51',
    Z6853: 'Z68.53',
    Z6854: 'Z68.54',
    Z6820: 'Z68.20',
    Z6829: 'Z68.29',
    Z6825: 'Z68.25',
    Z6826: 'Z68.26',
    Z6828: 'Z68.28',
    Z8241: 'Z82.41',
    E109: 'E10.9',
    E1065: 'E10.65',
    E119: 'E11.9',
    E116: 'E11.6',
    E1165: 'E11.65',
    E785: 'E78.5',
    I10: 'I10',
    I2510: 'I25.10',
    R7301: 'R73.01',
    E282: 'E28.2',
    N184: 'N18.4',
    N185: 'N18.5',
    E8881: 'E88.81',
    F5002: 'F50.02',
    Z724: 'Z72.4',
    Z833: 'Z83.3',
    Z8342: 'Z83.42',
    Z8249: 'Z82.49',
    R7303: 'R73.03',
    K580: 'K58.0',
    D509: 'D50.9',
    D573: 'D57.3',
    D649: 'D64.9',
    E1140: 'E11.40',
    E739: 'E73.9',
    F5000: 'F50.00',
    I4891: 'I48.91',
    J40: 'J40',
    K638: 'K63.8',
    K9041: 'K90.41',
    M419: 'M41.9',
    N200: 'N20.0',
    N3010: 'N30.10',
    Z734: 'Z73.4',
    Z91018: 'Z91.018',
    J4540: 'J45.40',
    E83119: 'E83.119',
    F5001: 'F50.01',
    F5081: 'F50.81',
    G20: 'G20',
    I7300: 'I73.00',
    K51: 'K51',
    K58: 'K58',
    K210: 'K21.0',
    K2100: 'K21.00',
    K219: 'K21.9',
    K25: 'K25',
    K2970: 'K29.70',
    K3184: 'K31.84',
    K50018: 'K50.018',
    K5010: 'K50.10',
    K50118: 'K50.118',
    K5090: 'K50.90',
    K581: 'K58.1',
    K582: 'K58.2',
    K589: 'K58.9',
    K900: 'K90.0',
    M328: 'M32.8',
    N183: 'N18.3',
    N1831: 'N18.31',
    N1832: 'N18.32',
    N809: 'N80.9',
    R636: 'R63.6',
    R7309: 'R73.09',
    D519: 'D51.9',
    F3181: 'F31.81',
    F411: 'F41.1',
    F418: 'F41.8',
    F429: 'F42.9',
    F508: 'F50.8',
    F509: 'F50.9',
    F603: 'F60.3',
    R197: 'R19.7',
    R7302: 'R73.02',
    K51919: 'K51.919',
    K5900: 'K59.00',
    K63: 'K63',
    K638219: 'K63.8219',
    D899: 'D89.9',
    F42: 'F42',
    F502: 'F50.2',
    G90A: 'G90.A',
    Z13220: 'Z13.220'
} as const;

export type ICDCode = typeof ICDCode[keyof typeof ICDCode];


export interface InitiateUpdateIdentityPayload {
    'phone_number'?: string | null;
    'email'?: string | null;
}
export interface Instagram {
}
export interface Instagram1 {
}
/**
 * For now, these are the options that a user selects when self-reporting their insurance.
 */

export const InsuranceCompany = {
    CashPay: 'Cash Pay',
    Aetna: 'Aetna',
    Cigna: 'Cigna',
    Humana: 'Humana',
    SelectHealth: 'Select Health',
    Kaiser: 'Kaiser',
    Anthem: 'Anthem',
    BlueCrossBlueShield: 'Blue Cross Blue Shield',
    BlueCareNetwork: 'Blue Care Network',
    BlueCross: 'Blue Cross',
    BlueShield: 'Blue Shield',
    Carefirst: 'Carefirst',
    Empire: 'Empire',
    FloridaBlue: 'Florida Blue',
    Highmark: 'Highmark',
    Horizon: 'Horizon',
    IndependenceBlueCross: 'Independence Blue Cross',
    RegenceBlueCrossBlueShield: 'Regence Blue Cross Blue Shield',
    UnitedHealthcare: 'United Healthcare',
    GoldenRule: 'Golden Rule',
    Optum: 'Optum',
    Oxford: 'Oxford',
    Umr: 'UMR',
    UnitedMedicalResources: 'United Medical Resources',
    Fay: 'Fay'
} as const;

export type InsuranceCompany = typeof InsuranceCompany[keyof typeof InsuranceCompany];


export interface InsuranceDetails {
    'insurance_company': string;
    'member_id': string;
}
export interface InsuranceValidationPayload {
    'first_name': string;
    'last_name': string;
    'date_of_birth': string;
    'insurance_company': InsuranceCompany;
    'member_id'?: string | null;
}


export interface InsuranceValidationResponse {
    'eligibility_status': EligibilityStatus;
    'address': BaseAddress | null;
    'member_id'?: string | null;
}


export interface IntakeFormAnswerList {
    'answers': Array<CreateFormAnswer>;
}
export interface IntakeFormResponse {
    'form_answers'?: FormAnswerResponseList | null;
    'external_providers'?: ExternalProviderResponseList | null;
    'gender'?: Gender | null;
    'pronouns'?: string | null;
    'profession'?: string | null;
    'work_email'?: string | null;
    'student_email'?: string | null;
}



export const IntakeFormVersion = {
    V1: 'v1',
    V2: 'v2'
} as const;

export type IntakeFormVersion = typeof IntakeFormVersion[keyof typeof IntakeFormVersion];


export interface JournalEntryFileResponse {
    'journal_entry_file_id': string;
    'file_key': string;
    'url': string;
    'thumbnail_url': string | null;
    'preview_url': string | null;
    'signature_expires_at': string;
}
export interface JournalEntryResponse {
    'journal_entry_id': string;
    'patient_id': string;
    'content': string;
    'files': Array<JournalEntryFileResponse>;
    'created_at': string;
    'occurred_at': string;
    'updated_at': string | null;
    'deleted_at': string | null;
    'is_private': boolean;
}
export interface JournalStreakResponse {
    /**
     * Total number of journal entries in the consecutive day streak.
     */
    'journal_count': number;
    /**
     * Consecutive days of journaling. Resets to 0if the patient has not journaled today or yesterday.
     */
    'consecutive_days': number;
    'start_date': string | null;
    /**
     * The weekly streak display ([M ✅ , T ✅ , W...]). If there is no streak, an array starting with today in the patient\'s timezone will be returned.
     */
    'weekly_streak_display': Array<WeeklyStreakDisplayResponse>;
}
export interface LabResult {
    'test': string;
    'result': string;
    'units': string | null;
    'reference_interval': string | null;
    'status': LabResultStatus | null;
}



export const LabResultStatus = {
    Low: 'Low',
    Normal: 'Normal',
    High: 'High',
    NotSpecified: 'Not Specified',
    CheckLabReport: 'Check Lab Report'
} as const;

export type LabResultStatus = typeof LabResultStatus[keyof typeof LabResultStatus];


/**
 * Response for listing MRR submissions.
 */
export interface ListMRRSubmissionsResponse {
    'items': Array<MRRSubmissionItem>;
    'page': number;
    'limit': number;
    'next_page'?: number | null;
    'previous_page'?: number | null;
}
export interface LoginResponse {
    'challenge_id': string;
    'expires_at': string;
    'cooldown_expires_at': string;
    'is_authenticated': boolean;
    'cognito_id'?: string | null;
    'token'?: string | null;
}
/**
 * Individual MRR submission item in the list response.
 */
export interface MRRSubmissionItem {
    'medical_record_request_submission_id': string;
    'mrr_submission_s3_key': string | null;
    'payer_id': PayerId;
    'claim_carrier_control_number': string;
    'fax_number': string | null;
    'medical_record_request_group_id': string | null;
    'external_submission_id': string | null;
}



export const MealPlanCondition = {
    GeneralHealthyDiet: 'general_healthy_diet',
    AnemiaB12Deficient: 'anemia_b12_deficient',
    AnemiaIronDeficient: 'anemia_iron_deficient',
    AntiInflammatory: 'anti_inflammatory',
    BariatricStage4: 'bariatric_stage_4',
    CardiovascularDiseaseDiabetes: 'cardiovascular_disease_diabetes',
    CeliacDisease: 'celiac_disease',
    Cirrhosis: 'cirrhosis',
    CkdStage12: 'ckd_stage_1_2',
    CkdStage34: 'ckd_stage_3_4',
    CkdStage5: 'ckd_stage_5',
    CkdStage5Hd: 'ckd_stage_5_hd',
    CkdStage5Pd: 'ckd_stage_5_pd',
    DashDiet: 'dash_diet',
    DiabetesType1: 'diabetes_type_1',
    DiabetesType2: 'diabetes_type_2',
    Diverticulitis: 'diverticulitis',
    Diverticulosis: 'diverticulosis',
    EatMoreVeggies: 'eat_more_veggies',
    Endurance: 'endurance',
    ExtensiveMacroMicro: 'extensive_macro_micro',
    Fertility: 'fertility',
    FollicularOvulationPhase: 'follicular_ovulation_phase',
    Glp1DiabetesManagement: 'glp_1_diabetes_management',
    Glp1WeightLoss: 'glp_1_weight_loss',
    HealthyFlex: 'healthy_flex',
    HeartFailure: 'heart_failure',
    HighCholesterol: 'high_cholesterol',
    HighFiberHighProtein: 'high_fiber_high_protein',
    Hypermetabolism: 'hypermetabolism',
    Hypertension: 'hypertension',
    IncreaseEnergy: 'increase_energy',
    Keto: 'keto',
    Lactation: 'lactation',
    LowCarb: 'low_carb',
    LowCarbHighFat: 'low_carb_high_fat',
    LowFodmap: 'low_fodmap',
    LowSodium: 'low_sodium',
    LutealPhase: 'luteal_phase',
    MediterraneanDiet: 'mediterranean_diet',
    Menopause: 'menopause',
    MenstrualPhase: 'menstrual_phase',
    MicrobiomeBooster: 'microbiome_booster',
    Migraine: 'migraine',
    MindDiet: 'mind_diet',
    MuscleGain: 'muscle_gain',
    Nafld: 'nafld',
    Nash: 'nash',
    Osteoporosis: 'osteoporosis',
    OverweightObesity: 'overweight_obesity',
    Pcos: 'pcos',
    PostMenopause: 'post_menopause',
    Postpartum: 'postpartum',
    Prediabetes: 'prediabetes',
    Pregnancy: 'pregnancy',
    Whole30: 'whole30',
    ZoneDiet: 'zone_diet',
    Autoimmune: 'autoimmune',
    PlannedBariatricSurgery: 'planned_bariatric_surgery',
    Colitis: 'colitis',
    CrohnsDisease: 'crohns_disease',
    Diabetes: 'diabetes',
    EatingDisorder: 'eating_disorder',
    HealthyEating: 'healthy_eating',
    GutHealth: 'gut_health',
    HighBloodPressure: 'high_blood_pressure',
    IrritableBowelSyndrome: 'irritable_bowel_syndrome',
    InflammatoryBowelDisease: 'inflammatory_bowel_disease',
    KidneyDisease: 'kidney_disease',
    Pots: 'pots',
    Sibo: 'sibo',
    Gerd: 'gerd',
    WeightLoss: 'weight_loss',
    WeightGain: 'weight_gain'
} as const;

export type MealPlanCondition = typeof MealPlanCondition[keyof typeof MealPlanCondition];


export interface MealPlanResponse {
    /**
     * The ID of the meal plan
     */
    'meal_plan_id': string;
    /**
     * The ID of the patient for whom the meal plan is generated
     */
    'patient_id': string;
    'chat_completion_id': string | null;
    /**
     * The meals associated with the meal plan
     */
    'meals': Array<MealResponse>;
    /**
     * Indicates if the meal plan has been generated
     */
    'is_generated': boolean;
}
export interface MealResponse {
    /**
     * The ID of the meal
     */
    'meal_id': string;
    /**
     * The type of meal
     */
    'meal_type': MealType;
    /**
     * The recipe associated with the meal
     */
    'recipe': RecipeResponse;
}



export const MealType = {
    Breakfast: 'Breakfast',
    Lunch: 'Lunch',
    Dinner: 'Dinner',
    Snack: 'Snack'
} as const;

export type MealType = typeof MealType[keyof typeof MealType];


export interface MedicalRecordRequestExportInfo {
    'claim_control_number': string;
    'patient_name': string;
    'appointment_date': string;
}
export interface MedicalRecordRequestExportWarning {
    'message': string;
    'extra_detail'?: string | null;
}

export const MedicalRecordRequestStatus = {
    InProgress: 'in_progress',
    Completed: 'completed',
    Failed: 'failed'
} as const;

export type MedicalRecordRequestStatus = typeof MedicalRecordRequestStatus[keyof typeof MedicalRecordRequestStatus];



export const MedicalRecordRequestSubmissionStatus = {
    Initiated: 'initiated',
    LetterRequested: 'letter_requested',
    LetterReceived: 'letter_received',
    NoRequestLetter: 'no_request_letter',
    SubmissionGenerated: 'submission_generated',
    NotSubmitted: 'not_submitted',
    Submitting: 'submitting',
    Submitted: 'submitted',
    SubmitFailed: 'submit_failed',
    Rejected: 'rejected'
} as const;

export type MedicalRecordRequestSubmissionStatus = typeof MedicalRecordRequestSubmissionStatus[keyof typeof MedicalRecordRequestSubmissionStatus];


export interface NPIProviderAddress {
    'country_code'?: string | null;
    'country_name'?: string | null;
    'address_purpose'?: string | null;
    'address_type'?: string | null;
    'address_1'?: string | null;
    'address_2'?: string | null;
    'city'?: string | null;
    'state'?: string | null;
    'postal_code'?: string | null;
    'telephone_number'?: string | null;
    'fax_number'?: string | null;
}
export interface NPIProviderResponse {
    'first_name': string;
    'last_name': string;
    'middle_name'?: string | null;
    'npi_number': string;
    'state': string;
    'taxonomy': string;
    'addresses': Array<NPIProviderAddress>;
}
/**
 * Format your NotificationType name as:  # {PATIENT|PROVIDER}_{DESCRIPTION}_{Optional[TIMEFRAME]}_{MEDIUM}
 */

export const NotificationType = {
    ProviderFayInviteEmail: 'PROVIDER_FAY_INVITE_EMAIL',
    ProviderFollowupConfirmedEmail: 'PROVIDER_FOLLOWUP_CONFIRMED_EMAIL',
    ProviderInitialConsultationConfirmedEmail: 'PROVIDER_INITIAL_CONSULTATION_CONFIRMED_EMAIL',
    ProviderAppointmentReminder15MSms: 'PROVIDER_APPOINTMENT_REMINDER_15M_SMS',
    ProviderAppointmentReminderNowSms: 'PROVIDER_APPOINTMENT_REMINDER_NOW_SMS',
    ProviderAppointmentReminderNowEmail: 'PROVIDER_APPOINTMENT_REMINDER_NOW_EMAIL',
    ProviderAppointmentCanceledEmail: 'PROVIDER_APPOINTMENT_CANCELED_EMAIL',
    ProviderAppointmentRescheduledEmail: 'PROVIDER_APPOINTMENT_RESCHEDULED_EMAIL',
    ProviderAppointmentChargeDeclinedEmail: 'PROVIDER_APPOINTMENT_CHARGE_DECLINED_EMAIL',
    ProviderNoCardOnFileEmail: 'PROVIDER_NO_CARD_ON_FILE_EMAIL',
    ProviderUnreadMessagesEmail: 'PROVIDER_UNREAD_MESSAGES_EMAIL',
    ProviderChartNoteDailyReminderEmail: 'PROVIDER_CHART_NOTE_DAILY_REMINDER_EMAIL',
    ProviderChartNoteReminder2HEmail: 'PROVIDER_CHART_NOTE_REMINDER_2H_EMAIL',
    ProviderChartNoteReminder2HSms: 'PROVIDER_CHART_NOTE_REMINDER_2H_SMS',
    ProviderNewPatientBookedAppointmentSms: 'PROVIDER_NEW_PATIENT_BOOKED_APPOINTMENT_SMS',
    ShareProviderReviewLinkSms: 'SHARE_PROVIDER_REVIEW_LINK_SMS',
    PatientInitialConsultationConfirmedEmail: 'PATIENT_INITIAL_CONSULTATION_CONFIRMED_EMAIL',
    PatientFollowupConfirmedEmail: 'PATIENT_FOLLOWUP_CONFIRMED_EMAIL',
    PatientAppointmentReminder1HSms: 'PATIENT_APPOINTMENT_REMINDER_1H_SMS',
    PatientAppointmentReminder48HSms: 'PATIENT_APPOINTMENT_REMINDER_48H_SMS',
    PatientAppointmentReminderNowSms: 'PATIENT_APPOINTMENT_REMINDER_NOW_SMS',
    PatientAppointmentCancelReplyTooLateSms: 'PATIENT_APPOINTMENT_CANCEL_REPLY_TOO_LATE_SMS',
    PatientAppointmentCancelReplySuccessSms: 'PATIENT_APPOINTMENT_CANCEL_REPLY_SUCCESS_SMS',
    PatientAppointmentReminder23HEmail: 'PATIENT_APPOINTMENT_REMINDER_23H_EMAIL',
    PatientAppointmentReminder1HEmail: 'PATIENT_APPOINTMENT_REMINDER_1H_EMAIL',
    PatientAppointmentReminderNowEmail: 'PATIENT_APPOINTMENT_REMINDER_NOW_EMAIL',
    PatientAppointmentCanceledEmail: 'PATIENT_APPOINTMENT_CANCELED_EMAIL',
    PatientAppointmentRescheduledEmail: 'PATIENT_APPOINTMENT_RESCHEDULED_EMAIL',
    PatientUnreadMessagesEmail: 'PATIENT_UNREAD_MESSAGES_EMAIL',
    PatientUnreadMessagesPushNotification: 'PATIENT_UNREAD_MESSAGES_PUSH_NOTIFICATION',
    PatientWelcomeSms: 'PATIENT_WELCOME_SMS',
    PatientAppointmentFeedbackRequestSms: 'PATIENT_APPOINTMENT_FEEDBACK_REQUEST_SMS',
    PatientProviderAppStoreReviewRequestSms: 'PATIENT_PROVIDER_APP_STORE_REVIEW_REQUEST_SMS',
    PatientProviderThirdReviewRequestSms: 'PATIENT_PROVIDER_THIRD_REVIEW_REQUEST_SMS',
    PatientProviderBetterBusinessBureauReviewRequestSms: 'PATIENT_PROVIDER_BETTER_BUSINESS_BUREAU_REVIEW_REQUEST_SMS',
    PatientProviderReviewRequestEmail: 'PATIENT_PROVIDER_REVIEW_REQUEST_EMAIL',
    PatientFoodJournalReminderSms: 'PATIENT_FOOD_JOURNAL_REMINDER_SMS',
    PatientOutcomeSurveyInviteSms: 'PATIENT_OUTCOME_SURVEY_INVITE_SMS',
    PatientOutcomeSurveyReminderSms: 'PATIENT_OUTCOME_SURVEY_REMINDER_SMS',
    PatientOutcomeSurveyFinalReminderSms: 'PATIENT_OUTCOME_SURVEY_FINAL_REMINDER_SMS',
    PatientNoShowLateCancelChargeEmail: 'PATIENT_NO_SHOW_LATE_CANCEL_CHARGE_EMAIL',
    PatientAppointmentBalanceDueChargeEmail: 'PATIENT_APPOINTMENT_BALANCE_DUE_CHARGE_EMAIL',
    PatientAppointmentChargeDeclinedEmail: 'PATIENT_APPOINTMENT_CHARGE_DECLINED_EMAIL',
    PatientComplimentaryRefundEmail: 'PATIENT_COMPLIMENTARY_REFUND_EMAIL',
    PatientClaimFullyPaidEmail: 'PATIENT_CLAIM_FULLY_PAID_EMAIL',
    PatientNoCardOnFileEmail: 'PATIENT_NO_CARD_ON_FILE_EMAIL',
    PatientRecurringDonationStartedEmail: 'PATIENT_RECURRING_DONATION_STARTED_EMAIL',
    PatientInvalidInsuranceEmail: 'PATIENT_INVALID_INSURANCE_EMAIL',
    PatientInvalidInsuranceSms: 'PATIENT_INVALID_INSURANCE_SMS',
    ProviderPatientCurrentlyInIntakeEmail: 'PROVIDER_PATIENT_CURRENTLY_IN_INTAKE_EMAIL',
    ProviderPatientCurrentlyInIntakeSms: 'PROVIDER_PATIENT_CURRENTLY_IN_INTAKE_SMS',
    PatientPartnerBookingInitialOutreachSms: 'PATIENT_PARTNER_BOOKING_INITIAL_OUTREACH_SMS',
    PatientPartnerBookingInitialOutreachEmail: 'PATIENT_PARTNER_BOOKING_INITIAL_OUTREACH_EMAIL',
    PatientPartnerBookingFirstFollowUpSms: 'PATIENT_PARTNER_BOOKING_FIRST_FOLLOW_UP_SMS',
    PatientPartnerBookingSecondFollowUpSms: 'PATIENT_PARTNER_BOOKING_SECOND_FOLLOW_UP_SMS',
    PatientPartnerBookingOngoingReminderSms: 'PATIENT_PARTNER_BOOKING_ONGOING_REMINDER_SMS',
    PatientPartnerBookingOngoingReminderEmail: 'PATIENT_PARTNER_BOOKING_ONGOING_REMINDER_EMAIL',
    PatientPartnerBookingFinalReminderSms: 'PATIENT_PARTNER_BOOKING_FINAL_REMINDER_SMS',
    PatientPartnerBookingFinalReminderEmail: 'PATIENT_PARTNER_BOOKING_FINAL_REMINDER_EMAIL',
    PatientPartnerBookingCancellationSms: 'PATIENT_PARTNER_BOOKING_CANCELLATION_SMS',
    PatientPartnerBookingCancellationEmail: 'PATIENT_PARTNER_BOOKING_CANCELLATION_EMAIL',
    PatientMealPlanFromProviderEmail: 'PATIENT_MEAL_PLAN_FROM_PROVIDER_EMAIL',
    PatientMissingPhoneNumberEmail: 'PATIENT_MISSING_PHONE_NUMBER_EMAIL',
    PatientAppointmentRewardSms: 'PATIENT_APPOINTMENT_REWARD_SMS',
    PatientPrizeGrantedEmail: 'PATIENT_PRIZE_GRANTED_EMAIL',
    PatientPrizeClaimedToFeedingAmericaEmail: 'PATIENT_PRIZE_CLAIMED_TO_FEEDING_AMERICA_EMAIL',
    ExternalProviderPatientDashboardInitialEmail: 'EXTERNAL_PROVIDER_PATIENT_DASHBOARD_INITIAL_EMAIL',
    ExternalProviderPatientDashboardFollowUpEmail: 'EXTERNAL_PROVIDER_PATIENT_DASHBOARD_FOLLOW_UP_EMAIL',
    PatientOutstandingBalanceCollectionChargeEmail: 'PATIENT_OUTSTANDING_BALANCE_COLLECTION_CHARGE_EMAIL',
    ExternalProviderPatientDashboardFax: 'EXTERNAL_PROVIDER_PATIENT_DASHBOARD_FAX',
    ExternalProviderWelcomeLetter: 'EXTERNAL_PROVIDER_WELCOME_LETTER',
    ProspectiveClientProviderReferralSms: 'PROSPECTIVE_CLIENT_PROVIDER_REFERRAL_SMS',
    EmployerEligibilityFileProcessedEmail: 'EMPLOYER_ELIGIBILITY_FILE_PROCESSED_EMAIL',
    AuthChallengeCodeSms: 'AUTH_CHALLENGE_CODE_SMS',
    AuthChallengeCodeEmail: 'AUTH_CHALLENGE_CODE_EMAIL',
    AuthPasswordResetEmail: 'AUTH_PASSWORD_RESET_EMAIL',
    AuthPhoneNumberAlreadyInUseSms: 'AUTH_PHONE_NUMBER_ALREADY_IN_USE_SMS',
    AuthEmailAlreadyInUseEmail: 'AUTH_EMAIL_ALREADY_IN_USE_EMAIL',
    StreakReminderNotificationRotating1Sms: 'STREAK_REMINDER_NOTIFICATION_ROTATING_1_SMS',
    StreakReminderNotificationRotating2Sms: 'STREAK_REMINDER_NOTIFICATION_ROTATING_2_SMS',
    StreakReminderNotificationRotating3Sms: 'STREAK_REMINDER_NOTIFICATION_ROTATING_3_SMS',
    StreakReminderNotificationRotating4Sms: 'STREAK_REMINDER_NOTIFICATION_ROTATING_4_SMS',
    StreakReminderNotificationRotating5Sms: 'STREAK_REMINDER_NOTIFICATION_ROTATING_5_SMS',
    StreakReminderNotificationRotating6Sms: 'STREAK_REMINDER_NOTIFICATION_ROTATING_6_SMS',
    StreakReminderNotificationRotating7Sms: 'STREAK_REMINDER_NOTIFICATION_ROTATING_7_SMS',
    StreakReminderNotificationRotating8Sms: 'STREAK_REMINDER_NOTIFICATION_ROTATING_8_SMS',
    StreakReminderNotificationRotating9Sms: 'STREAK_REMINDER_NOTIFICATION_ROTATING_9_SMS',
    StreakReminderNotificationRotating10Sms: 'STREAK_REMINDER_NOTIFICATION_ROTATING_10_SMS',
    StreakReminderNotificationRotating11Sms: 'STREAK_REMINDER_NOTIFICATION_ROTATING_11_SMS',
    StreakReminderNotificationRotating12Sms: 'STREAK_REMINDER_NOTIFICATION_ROTATING_12_SMS',
    StreakReminderNotificationRotating13Sms: 'STREAK_REMINDER_NOTIFICATION_ROTATING_13_SMS',
    StreakReminderNotificationRotating14Sms: 'STREAK_REMINDER_NOTIFICATION_ROTATING_14_SMS',
    StreakReminderNotificationRotating15Sms: 'STREAK_REMINDER_NOTIFICATION_ROTATING_15_SMS',
    StreakReminderNotificationRotating16Sms: 'STREAK_REMINDER_NOTIFICATION_ROTATING_16_SMS',
    StreakReminderNotificationRotating17Sms: 'STREAK_REMINDER_NOTIFICATION_ROTATING_17_SMS',
    StreakReminderNotificationRotating18Sms: 'STREAK_REMINDER_NOTIFICATION_ROTATING_18_SMS',
    DailyGoalResetNotification1Sms: 'DAILY_GOAL_RESET_NOTIFICATION_1_SMS',
    DailyGoalResetNotification2Sms: 'DAILY_GOAL_RESET_NOTIFICATION_2_SMS',
    DailyGoalResetNotification3Sms: 'DAILY_GOAL_RESET_NOTIFICATION_3_SMS',
    DailyGoalResetNotification4Sms: 'DAILY_GOAL_RESET_NOTIFICATION_4_SMS',
    DailyGoalResetNotification5Sms: 'DAILY_GOAL_RESET_NOTIFICATION_5_SMS',
    DailyGoalResetNotification6Sms: 'DAILY_GOAL_RESET_NOTIFICATION_6_SMS',
    DailyGoalResetNotification7Sms: 'DAILY_GOAL_RESET_NOTIFICATION_7_SMS',
    DailyGoalResetNotification8Sms: 'DAILY_GOAL_RESET_NOTIFICATION_8_SMS',
    DailyGoalResetNotification9Sms: 'DAILY_GOAL_RESET_NOTIFICATION_9_SMS',
    DailyGoalResetNotification10Sms: 'DAILY_GOAL_RESET_NOTIFICATION_10_SMS',
    DailyGoalResetNotification11Sms: 'DAILY_GOAL_RESET_NOTIFICATION_11_SMS',
    DailyGoalResetNotification12Sms: 'DAILY_GOAL_RESET_NOTIFICATION_12_SMS',
    DailyGoalResetNotification13Sms: 'DAILY_GOAL_RESET_NOTIFICATION_13_SMS',
    DailyGoalResetNotification14Sms: 'DAILY_GOAL_RESET_NOTIFICATION_14_SMS',
    DailyGoalResetNotification15Sms: 'DAILY_GOAL_RESET_NOTIFICATION_15_SMS',
    DailyGoalResetNotification16Sms: 'DAILY_GOAL_RESET_NOTIFICATION_16_SMS',
    DailyGoalResetNotification17Sms: 'DAILY_GOAL_RESET_NOTIFICATION_17_SMS',
    DailyGoalResetNotification18Sms: 'DAILY_GOAL_RESET_NOTIFICATION_18_SMS',
    DailyGoalResetNotification19Sms: 'DAILY_GOAL_RESET_NOTIFICATION_19_SMS',
    DailyGoalResetNotification20Sms: 'DAILY_GOAL_RESET_NOTIFICATION_20_SMS',
    DailyGoalResetNotification21Sms: 'DAILY_GOAL_RESET_NOTIFICATION_21_SMS',
    DailyGoalResetNotification22Sms: 'DAILY_GOAL_RESET_NOTIFICATION_22_SMS',
    DailyGoalResetNotification23Sms: 'DAILY_GOAL_RESET_NOTIFICATION_23_SMS',
    DailyGoalResetNotification24Sms: 'DAILY_GOAL_RESET_NOTIFICATION_24_SMS',
    DailyGoalResetNotification26Sms: 'DAILY_GOAL_RESET_NOTIFICATION_26_SMS',
    DailyGoalResetNotification27Sms: 'DAILY_GOAL_RESET_NOTIFICATION_27_SMS',
    DailyGoalResetNotification28Sms: 'DAILY_GOAL_RESET_NOTIFICATION_28_SMS',
    DailyGoalResetNotification29Sms: 'DAILY_GOAL_RESET_NOTIFICATION_29_SMS',
    DailyGoalResetNotification30Sms: 'DAILY_GOAL_RESET_NOTIFICATION_30_SMS',
    DailyGoalResetNotification31Sms: 'DAILY_GOAL_RESET_NOTIFICATION_31_SMS',
    PatientYouPayZeroEmail: 'PATIENT_YOU_PAY_ZERO_EMAIL',
    ReferrerReferralCodeUsedSms: 'REFERRER_REFERRAL_CODE_USED_SMS',
    ReferrerReferralCodeUsed24HrReminderSms: 'REFERRER_REFERRAL_CODE_USED_24HR_REMINDER_SMS',
    ReferralReferralCodeUsedSms: 'REFERRAL_REFERRAL_CODE_USED_SMS',
    ReferrerPrizeGrantedSms: 'REFERRER_PRIZE_GRANTED_SMS',
    ReferralPrizeGrantedSms: 'REFERRAL_PRIZE_GRANTED_SMS',
    ProviderMetricsRecomputedEmail: 'PROVIDER_METRICS_RECOMPUTED_EMAIL',
    PatientBookingReminderEmail: 'PATIENT_BOOKING_REMINDER_EMAIL',
    ProviderFayImportAnnouncementMinus7DaysEmail: 'PROVIDER_FAY_IMPORT_ANNOUNCEMENT_MINUS_7_DAYS_EMAIL',
    ProviderFayImportAnnouncementMinus3DaysEmail: 'PROVIDER_FAY_IMPORT_ANNOUNCEMENT_MINUS_3_DAYS_EMAIL',
    ProviderFayImportAnnouncementMinus1DayEmail: 'PROVIDER_FAY_IMPORT_ANNOUNCEMENT_MINUS_1_DAY_EMAIL',
    ProviderFayImportInviteEmail: 'PROVIDER_FAY_IMPORT_INVITE_EMAIL',
    ProviderFayImportLoginReminderPlus3DaysEmail: 'PROVIDER_FAY_IMPORT_LOGIN_REMINDER_PLUS3_DAYS_EMAIL',
    ProviderFayImportLoginReminderPlus7DaysEmail: 'PROVIDER_FAY_IMPORT_LOGIN_REMINDER_PLUS7_DAYS_EMAIL',
    PatientFayImportAnnouncementMinus7DaysEmail: 'PATIENT_FAY_IMPORT_ANNOUNCEMENT_MINUS_7_DAYS_EMAIL',
    PatientFayImportAnnouncementMinus1DayEmail: 'PATIENT_FAY_IMPORT_ANNOUNCEMENT_MINUS_1_DAY_EMAIL',
    PatientFayImportAnnouncementMinus1DaySms: 'PATIENT_FAY_IMPORT_ANNOUNCEMENT_MINUS_1_DAY_SMS',
    PatientFayImportInviteEmail: 'PATIENT_FAY_IMPORT_INVITE_EMAIL',
    PatientFayImportInviteSms: 'PATIENT_FAY_IMPORT_INVITE_SMS',
    PatientFayImportLoginReminderPlus2DaysSms: 'PATIENT_FAY_IMPORT_LOGIN_REMINDER_PLUS_2_DAYS_SMS',
    PatientFayImportLoginReminderPlus3DaysEmail: 'PATIENT_FAY_IMPORT_LOGIN_REMINDER_PLUS3_DAYS_EMAIL',
    PatientFayImportLoginReminderPlus7DaysSms: 'PATIENT_FAY_IMPORT_LOGIN_REMINDER_PLUS7_DAYS_SMS',
    StreakReminderNotificationOneTimeSms: 'STREAK_REMINDER_NOTIFICATION_ONE_TIME_SMS',
    PatientRecurringDonationChargeEmail: 'PATIENT_RECURRING_DONATION_CHARGE_EMAIL',
    DailyGoalResetNotification25Sms: 'DAILY_GOAL_RESET_NOTIFICATION_25_SMS'
} as const;

export type NotificationType = typeof NotificationType[keyof typeof NotificationType];


export interface NutritionResearchCitation {
    'nutrition_research_citation_id'?: string;
    'nutrition_research_message_id': string;
    'source_name': string;
    'citation_text': string;
    'citation_text_start_index': number;
}
export interface NutritionResearchCitationDetails {
    'citation_id': string;
    'message_id': string;
    'source_name': string;
    'citation_text': string;
    'citation_text_start_index': number;
}
export interface NutritionResearchFeedbackPayload {
    'message_id': string;
    'feedback_rating': NutritionResearchFeedbackRating;
}



export const NutritionResearchFeedbackRating = {
    Positive: 'positive',
    Negative: 'negative'
} as const;

export type NutritionResearchFeedbackRating = typeof NutritionResearchFeedbackRating[keyof typeof NutritionResearchFeedbackRating];


export interface NutritionResearchMessageDetails {
    'message_id': string;
    'thread_id': string;
    'content': string;
    'role': Role;
    'created_at': string;
    'feedback_rating': NutritionResearchFeedbackRating | null;
    'citations': Array<NutritionResearchCitationDetails>;
}


export interface NutritionResearchRunThreadResponse {
    'response': string;
    'citations': Array<NutritionResearchCitation>;
}
export interface NutritionResearchSendMessagePayload {
    'message': string;
    'thread_id': string;
}
export interface OAuthResponse {
    'is_connected'?: boolean;
    'is_revoked'?: boolean;
    'email'?: string | null;
    'connect_url'?: string | null;
}
export interface OffboardStatusResponse {
    'provider_id': string;
    'provider_name': string;
    'cognito_offboarded': boolean;
    'circle_offboarded': boolean;
    'appointments_cancelled': boolean;
    'database_offboarded': boolean;
}
export interface OnboardableProviderResponse {
    'first_name': string;
    'last_name': string;
    'npi': string;
    'email': string;
    'timezone': string | null;
}
export interface OpenAppResponse {
    'did_add_to_streak': boolean;
    'streak': StreakSummaryResponse | null;
}
export interface OrderDetailsResponse {
    'order_id': string;
    'order_number': string;
    'shipping_address': ShippingAddress;
    'subtotal_price': string;
    'tax_price': string;
    'shipping_price': string;
    'total_price': string;
    'status': OrderStatus;
}



export const OrderStatus = {
    StockNotAvailable: 'stock_not_available',
    PaymentFailed: 'payment_failed',
    PendingPayment: 'pending_payment',
    PendingAllocation: 'pending_allocation',
    PendingPaymentCapture: 'pending_payment_capture',
    Processing: 'processing',
    Shipped: 'shipped',
    Delivered: 'delivered',
    Canceled: 'canceled',
    Refunded: 'refunded'
} as const;

export type OrderStatus = typeof OrderStatus[keyof typeof OrderStatus];


export interface PESOptionsResponse {
    'problems': { [key: string]: string; };
    'etiologies': { [key: string]: Array<ProblemOption>; };
    'symptoms': { [key: string]: Array<ProblemOption>; };
}
export interface PartnerBookingVerifyPaymentMethodPayload {
    'stripe_token': string;
    'card_source': CardSource;
    'partner_booking_code': string;
}


export interface PartnerCode {
    'name': PartnerName;
    'code': string;
}



export const PartnerName = {
    Zocdoc: 'zocdoc',
    Levels: 'levels'
} as const;

export type PartnerName = typeof PartnerName[keyof typeof PartnerName];


export interface PatientAddress {
    'line1': string;
    'line2'?: string | null;
    'city': string;
    'state': USState;
    'postal_code': string;
    'country'?: string;
    'address_id': string;
}


export interface PatientBillingAppointmentItemDetailsResponse {
    'patient_id': string;
    'coverage_status': PatientBillingItemCoverageStatus | null;
    'cost_of_appointment': string;
    'amount_covered': string;
    'amount_charged': string;
    'charge_id': string | null;
    'charge_status': ChargeStatus | null;
    'charged_at': string | null;
    'insurance_company': InsuranceCompany | null;
    'charge_refund_id': string | null;
    'payment_instrument_id': string | null;
    'charge_reason': ChargeReason | null;
    'appointment_id': string;
    'appointment_date': string;
    'appointment_type': APIAppointmentType;
}


export interface PatientBillingAsyncItemDetailsResponse {
    'patient_id': string;
    'coverage_status': PatientBillingItemCoverageStatus | null;
    'cost_of_appointment': string;
    'amount_covered': string;
    'amount_charged': string;
    'charge_id': string | null;
    'charge_status': ChargeStatus | null;
    'charged_at': string | null;
    'insurance_company': InsuranceCompany | null;
    'charge_refund_id': string | null;
    'payment_instrument_id': string | null;
    'charge_reason': ChargeReason | null;
    'billable_remote_encounter_id': string;
    'billable_remote_encounter_date_of_service': string;
}



export const PatientBillingItemCoverageStatus = {
    Covered: 'Covered',
    PartiallyCovered: 'Partially covered',
    NoShow: 'No show',
    Pending: 'Pending'
} as const;

export type PatientBillingItemCoverageStatus = typeof PatientBillingItemCoverageStatus[keyof typeof PatientBillingItemCoverageStatus];


export interface PatientBookingSubmitEmailPayload {
    'email': string;
    'provider_id'?: string | null;
}
export interface PatientBookingSubmitEmailResponse {
    'found': boolean;
    'is_intake_required': boolean;
    'email': string;
    'email_hash': string;
}
export interface PatientCommercialPlanDetails {
    'commercial_plan_id': string;
    'commercial_plan_type': CommercialPlanType;
}


export interface PatientConfirmationByCodePayload {
    'new_password': string;
    'code': string;
}
export interface PatientConfirmationPayload {
    'new_password': string;
}
export interface PatientConfirmationPreflightResponse {
    'email': string;
    'can_confirm': boolean;
    'cognito_id': string;
}
export interface PatientDetails {
    'first_name': string;
    'preferred_first_name': string;
    'last_name': string;
    'patient_id': string;
    'cognito_id': string;
    'email': string;
    'joined_at': string;
    'date_of_birth'?: string | null;
    'phone_number'?: string | null;
    'avatar_url'?: string | null;
    'provider_id'?: string | null;
    'enrollment_reason'?: string | null;
    'enrollment_tags'?: Set<EnrollmentTags> | null;
    'sex'?: Sex | null;
    'gender'?: Gender | null;
    'weight'?: WeightFieldOutput | null;
    'height'?: HeightFieldOutput | null;
    'bmi'?: BMI | null;
    'timezone': string;
    'profession'?: string | null;
    'work_email'?: string | null;
    'student_email'?: string | null;
    'pronouns'?: string | null;
    'insurance_policy'?: PatientInsurancePolicy | null;
    'mailing_address'?: PatientAddress | null;
    'intake_form_answers'?: Array<PatientFormAnswer>;
    'external_providers'?: Array<PatientExternalProviders>;
    'patient_provider_history'?: Array<PatientProviderDetails>;
    'is_fully_registered': boolean;
    'has_phone_authentication_authority': boolean;
    'has_set_password': boolean;
    'has_touched_intake': boolean;
    'has_completed_intake': boolean;
    'should_do_intake': boolean;
    'information_release_authorization'?: PatientInformationReleaseAuthorization | null;
    'onboarding_code'?: string | null;
    'booking_code_id'?: string | null;
    'commercial_plan'?: PatientCommercialPlanDetails | null;
    'payout_program'?: PatientPayoutProgram | null;
    'referral_source'?: ReferralSource | null;
    'provider_referral_source'?: PatientProviderReferralSource | null;
    'levels_user_id'?: string | null;
    'is_test'?: boolean;
    'deleted_at'?: string | null;
    'full_name': string;
    'full_legal_name': string;
    'legal_initials': string;
}



export const PatientDetailsInclusions = {
    NextAppointment: 'next_appointment',
    OldPatients: 'old_patients'
} as const;

export type PatientDetailsInclusions = typeof PatientDetailsInclusions[keyof typeof PatientDetailsInclusions];


export interface PatientDetailsListResponse {
    'patients': Array<PatientDetailsResponse>;
}
export interface PatientDetailsResponse {
    'patient_id': string;
    'provider_id'?: string | null;
    'cognito_id': string;
    'first_name': string;
    'last_name': string;
    'preferred_first_name': string;
    'full_name': string;
    'full_legal_name': string;
    'email': string;
    'has_levels_account': boolean;
    'joined_at': string | null;
    'date_of_birth'?: string | null;
    'phone_number'?: string | null;
    'avatar_url'?: string | null;
    'enrollment_reason'?: string | null;
    'enrollment_tags'?: Set<EnrollmentTags> | null;
    'sex'?: Sex | null;
    'weight'?: WeightFieldOutput | null;
    'height'?: HeightFieldOutput | null;
    'timezone': string;
    'pronouns'?: string | null;
    'insurance_policy'?: PatientInsurancePolicyResponse | null;
    'insurance_policy_hidden'?: boolean;
    'mailing_address'?: PatientAddress | null;
    'next_appointment'?: UpcomingAppointmentSummary | null;
    'external_providers'?: ExternalProviderResponseList | null;
    'information_release_authorization'?: PatientInformationReleaseAuthorization | null;
    'payout_program'?: PatientPayoutProgram | null;
    'has_touched_intake': boolean | null;
    'has_completed_intake': boolean | null;
    'should_do_intake': boolean | null;
    'referral_source'?: PatientReferralSourceResponse | null;
    'provider_referral_source'?: PatientProviderReferralSource | null;
    'is_test': boolean;
}



export const PatientDiscoverySource = {
    FacebookInstagram: 'Facebook / Instagram',
    TikTok: 'TikTok',
    Google: 'Google',
    YouTube: 'YouTube',
    Podcast: 'Podcast',
    TvStreaming: 'TV / Streaming',
    FriendFamilyAcquaintance: 'Friend / family / acquaintance',
    DoctorTherapist: 'Doctor / therapist',
    Employer: 'Employer',
    InsuranceCompany: 'Insurance company',
    NewsArticlePress: 'News article / press',
    NonProfit: 'Non-profit',
    Mail: 'Mail',
    AppStore: 'App Store',
    Reddit: 'Reddit',
    Other: 'Other'
} as const;

export type PatientDiscoverySource = typeof PatientDiscoverySource[keyof typeof PatientDiscoverySource];


export interface PatientExternalFacingDetailsResponse {
    'patient_id': string;
    'provider_id': string;
    'external_provider_id'?: string | null;
    'patient_first_name': string;
    'patient_last_name': string;
    'patient_date_of_birth'?: string | null;
    'appointment_count': number;
    'latest_chart_notes'?: string | null;
    'latest_chart_notes_timestamp'?: string | null;
    'height_in_inches': number | null;
    'weight_in_lbs': number | null;
    'bmi': number | null;
    'enrollment_tags': Set<EnrollmentTags>;
    'provider_full_name': string;
    'provider_first_name': string;
    'provider_last_name': string;
    'provider_avatar_url'?: string | null;
    'provider_slug': string;
    'supported_billing_insurance_companies': Set<InsuranceCompany>;
    'supported_booking_insurance_companies': Set<InsuranceCompany>;
}
export interface PatientExternalProviderAddress {
    'external_provider_address_id': string;
    'external_provider_id': string;
    'created_at': string;
    'country_code': string | null;
    'country_name': string | null;
    'address_purpose': string | null;
    'address_type': string | null;
    'line1': string | null;
    'line2': string | null;
    'city': string | null;
    'state': string | null;
    'postal_code': string | null;
    'phone_number': string | null;
    'fax_number': string | null;
}
export interface PatientExternalProviders {
    'external_provider_id': string;
    'provider_type': string;
    'first_name': string;
    'last_name': string;
    'state': string;
    'npi_number': string;
    'taxonomy': string;
    'primary_email': string | null;
    'addresses': Array<PatientExternalProviderAddress>;
    'created_at': string | null;
    'updated_at': string | null;
}
export interface PatientFormAnswer {
    'form_answer_id': string;
    'label': string;
    'answer': string | null;
    'order': number;
    'stable_id': string;
}
export interface PatientGoalResponse {
    'patient_goal_id': string;
    'title': string;
    'points': number;
    'last_completed_at': string | null;
    'created_at': string;
    'is_default'?: boolean;
}
export interface PatientGoalsResponse {
    'goals': Array<PatientGoalResponse>;
    'progress': ProgressResponse;
    'has_completed_a_goal': boolean;
}
export interface PatientId {
}
export interface PatientId1 {
}
export interface PatientIdealBodyWeight {
}
export interface PatientInfo {
    'first_name': string;
    'last_name': string;
    'date_of_birth': string;
    'gender': string;
    'email_address': string;
    'mobile_phone_no': string;
}
export interface PatientInformationReleaseAuthorization {
    'information_release_authorization_id': string;
    'authorized_at': string;
    'release_form_preview_url': string;
    'version': number;
}
export interface PatientInsurancePolicy {
    'policy_number': string;
    'payer': InsuranceCompany;
    'policy_id': string;
    'holder_relationship': HolderRelationship;
    'effective_date_start': string | null;
    'effective_date_end': string | null;
    'holder_date_of_birth': string | null;
    'patient_first_name': string | null;
    'patient_last_name': string | null;
    'holder_first_name': string | null;
    'holder_last_name': string | null;
    'is_eligible': boolean | null;
    'is_invalid': boolean | null;
    'patient_address_line1'?: string | null;
    'patient_address_line2'?: string | null;
    'patient_address_city'?: string | null;
    'patient_address_state'?: USState | null;
    'patient_address_postal_code'?: string | null;
    'holder_address_line1'?: string | null;
    'holder_address_line2'?: string | null;
    'holder_address_city'?: string | null;
    'holder_address_state'?: USState | null;
    'holder_address_postal_code'?: string | null;
    'external_eligibility_request_id'?: string | null;
    'group_number'?: string | null;
    'insurance_type_code'?: string | null;
    'insurance_plan'?: string | null;
    'payer_id'?: PayerId | null;
    'is_likely_anthem_from_eligibility'?: boolean | null;
}


export interface PatientInsurancePolicyResponse {
    'policy_id': string;
    'policy_number': string;
    'payer': InsuranceCompany;
    'is_invalid'?: boolean | null;
}


export interface PatientLabResponse {
    'patient_lab_id': string;
    'title': string;
    'uploaded_at': string;
    'document_link': string;
    'signature_expires_at': string;
    'lab_results': Array<LabResult>;
    'status': PatientLabStatus;
    'can_accept_feedback': boolean;
}



export const PatientLabStatus = {
    Processing: 'Processing',
    Completed: 'Completed',
    Failed: 'Failed'
} as const;

export type PatientLabStatus = typeof PatientLabStatus[keyof typeof PatientLabStatus];


export interface PatientLabsResponse {
    'patient_labs': Array<PatientLabResponse>;
}

export const PatientPayoutProgram = {
    AffiliateEnrollmentProgram: 'affiliate_enrollment_program'
} as const;

export type PatientPayoutProgram = typeof PatientPayoutProgram[keyof typeof PatientPayoutProgram];


export interface PatientPrizesResponse {
    'patient_id': string;
    'prizes': Array<PrizeResponse>;
}
export interface PatientProviderDetails {
    'patient_provider_id': string;
    'patient_id': string;
    'provider_id': string;
    'created_at': string;
    'is_boosted_provider': boolean;
    'has_free_initial_consultation': boolean;
    'referral_source': PatientProviderReferralSource | null;
}



export const PatientProviderReferralSource = {
    Fay: 'fay',
    FayReferralPartner: 'fay_referral_partner',
    FayBoostedProvider: 'fay_boosted_provider',
    ProviderBookingLink: 'provider_booking_link'
} as const;

export type PatientProviderReferralSource = typeof PatientProviderReferralSource[keyof typeof PatientProviderReferralSource];


export interface PatientRecapResponse {
    'patient_id': string;
    'status': PatientRecapStatus;
    'updated_at': string;
    'personal_life_details'?: string | null;
    'personal_life_details_chat_completion_id'?: string | null;
    'work_life_details'?: string | null;
    'work_life_details_chat_completion_id'?: string | null;
    'foods_to_avoid_details'?: string | null;
    'foods_to_avoid_details_chat_completion_id'?: string | null;
    'income_levels_details'?: string | null;
    'income_levels_details_chat_completion_id'?: string | null;
    'last_appointment_summary'?: string | null;
    'last_appointment_summary_chat_completion_id'?: string | null;
}



export const PatientRecapStatus = {
    Initialized: 'initialized',
    NeedsOccurredAppointment: 'needs_occurred_appointment',
    NeedsUpdatedRecapFields: 'needs_updated_recap_fields',
    Done: 'done'
} as const;

export type PatientRecapStatus = typeof PatientRecapStatus[keyof typeof PatientRecapStatus];


export interface PatientReferralSourceResponse {
    'source_type': ReferralSourceType;
    'source_id': string;
}


export interface PatientReferrerProfileDisplayResponse {
    'display_name': string;
    'referral_value_amount': string;
}
export interface PatientReferrerProfileResponse {
    'patient_id': string;
    'booking_code_code': string;
    'referral_url': string;
    'share_count': number;
    'referral_tier_share_threshold'?: number | null;
    'next_referral_tier_amount'?: string | null;
    'referral_tier_value_amount': string;
    'referral_tier_recipient_value_amount': string;
    'referral_tier_share_count': number;
}
export interface PatientReleaseFormPreviewUrlResponse {
    'release_form_preview_url': string;
    'version': number;
}
export interface PatientRewardsResponse {
    'patient_id': string;
    'rewards': Array<RewardResponse>;
}
export interface PatientSenderResponse {
    'display_name': string;
    'preferred_first_name': string;
    'last_name': string;
    'avatar_url': string | null;
    'cognito_id': string;
    'type'?: PatientSenderResponseTypeEnum;
    'patient_id': string;
}

export const PatientSenderResponseTypeEnum = {
    Patient: 'patient'
} as const;

export type PatientSenderResponseTypeEnum = typeof PatientSenderResponseTypeEnum[keyof typeof PatientSenderResponseTypeEnum];

export interface PatientUsualBodyWeight {
}

export const PayerId = {
    _60054: '60054',
    _00621: '00621',
    Bs001: 'BS001',
    _84980: '84980',
    _62308: '62308',
    _61101: '61101',
    _80840: '80840',
    _87726: '87726',
    Sx107: 'SX107',
    _94135: '94135',
    _94134: '94134',
    _91617: '91617',
    _52095: '52095',
    _91051: '91051',
    _94123: '94123',
    _21313: '21313',
    _00910: '00910',
    _22099: '22099',
    Fay: 'FAY',
    CashPay: 'CASH_PAY'
} as const;

export type PayerId = typeof PayerId[keyof typeof PayerId];


/**
 * This is a human-readable name for the payer associated with a given [PayerId].
 */

export const PayerName = {
    Aetna: 'Aetna',
    BlueCrossBlueShieldOfIllinois: 'Blue Cross Blue Shield of Illinois',
    BlueShieldOfCalifornia: 'Blue Shield of California',
    BcbsTexas: 'BCBS Texas',
    Cigna: 'Cigna',
    Humana: 'Humana',
    Umr: 'UMR',
    UnitedHealthcare: 'United Healthcare',
    SelectHealth: 'Select Health',
    Kaiser: 'Kaiser',
    RegenceBsut: 'Regence BSUT',
    HorizonBcbsOfNewJersey: 'Horizon BCBS of New Jersey',
    Fay: 'Fay',
    CashPay: 'Cash Pay'
} as const;

export type PayerName = typeof PayerName[keyof typeof PayerName];


export interface PaymentInstrumentResponse {
    'payment_instrument_id': string;
    'brand': CardBrand;
    'last_four': string;
    'expiration_month': number;
    'expiration_year': number;
    'card_source': CardSource;
}


export interface PayoutDetailsResponse {
    'amount': string;
    'period_start': string;
    'period_end': string;
    'payout_type': PayoutType;
    'line_items': Array<PayoutLineItemResponse>;
}


export interface PayoutLineItemResponse {
    'appointment_id': string | null;
    'appointment_time': string;
    'rate': string | null;
    'payment_source': string;
    'amount': string;
    'line_item_type': string;
    'payout_type': AdHocLineItemType | null;
    'payout_date': string | null;
    'notes': string | null;
    'created_at': string;
}


/**
 * Distinguishes between monthly appointment-based payouts and ad-hoc bonus payouts.
 */

export const PayoutType = {
    Monthly: 'Monthly',
    AdHoc: 'Ad Hoc',
    Mixed: 'Mixed'
} as const;

export type PayoutType = typeof PayoutType[keyof typeof PayoutType];


export interface PayoutsListResponse {
    'provider_id': string;
    'payouts': Array<PayoutDetailsResponse>;
}
export interface PhoneAvailabilityResponse {
    'available': boolean;
}
/**
 * The place of service code for a claim. Can be office or telehealth.
 */

export const PlaceOfService = {
    Office: 'office',
    Telehealth: 'telehealth',
    HomeTelehealth: 'home_telehealth'
} as const;

export type PlaceOfService = typeof PlaceOfService[keyof typeof PlaceOfService];


export interface PracticeMetricsResponse {
    'provider_id': string;
    'as_of_date': string;
    'weekly_availability': number;
    'weekly_retention': number | null;
    'monthly_retention': number | null;
    'average_appointment_length': number | null;
    'average_rating': number | null;
    'initial_consultation_occurrence_rate': number | null;
    'weekly_availability_percentile': number | null;
    'weekly_retention_percentile': number | null;
    'monthly_retention_percentile': number | null;
    'average_appointment_length_percentile': number | null;
    'average_rating_percentile': number | null;
    'initial_consultation_occurrence_rate_percentile': number | null;
    'score': number | null;
    'percentile_score': number | null;
}

export const PrefixType = {
    Anthem: 'anthem',
    Bcbsil: 'bcbsil'
} as const;

export type PrefixType = typeof PrefixType[keyof typeof PrefixType];


export interface PreviewMedicalRecordRequestResponse {
    'export_info': Array<MedicalRecordRequestExportInfo>;
    'export_warnings': Array<MedicalRecordRequestExportWarning>;
}

export const PriceCategory = {
    InvalidInfo: 'INVALID_INFO',
    Covered: 'COVERED',
    OutOfPocket: 'OUT_OF_POCKET'
} as const;

export type PriceCategory = typeof PriceCategory[keyof typeof PriceCategory];


export interface PricePayload {
    'first_name': string;
    'last_name': string;
    'insurance_company': InsuranceCompany;
    'member_id'?: string | null;
    'date_of_birth': string;
    'mobile_phone_no'?: string | null;
    'email'?: string | null;
}


export interface PriceResponse {
    'request_id': string;
    'price_result_type': PriceCategory;
    'savings_percentage': number | null;
    'initial_appointment_price': number | null;
    'follow_up_appointment_price': number | null;
    'insurance_plan_name'?: string | null;
    'member_id'?: string | null;
    'address'?: BaseAddress | null;
}


export interface PrimaryConcern {
    'slug': PrimaryConcernSlug;
    'name': string;
    'default_specialties': Array<string>;
    'secondary_concerns'?: Array<SecondaryConcern> | null;
    'show_as_provider_match'?: boolean;
}



export const PrimaryConcernSlug = {
    DiabetesOrPrediabetes: 'diabetes-or-prediabetes',
    EatingDisorder: 'eating-disorder',
    EmotionalEating: 'emotional-eating',
    GeneralHealth: 'general-health',
    GutHealth: 'gut-health',
    HeartHealth: 'heart-health',
    HelpLosingWeight: 'help-losing-weight',
    WomensHealth: 'womens-health',
    Other: 'other'
} as const;

export type PrimaryConcernSlug = typeof PrimaryConcernSlug[keyof typeof PrimaryConcernSlug];


/**
 * How a prize is delivered to the patient.
 */

export const PrizeDeliveryMethod = {
    UberEatsVoucher: 'uber_eats_voucher',
    FeedingAmericaDonation: 'feeding_america_donation'
} as const;

export type PrizeDeliveryMethod = typeof PrizeDeliveryMethod[keyof typeof PrizeDeliveryMethod];


export interface PrizeDisplayOptionsResponse {
    'referred_patient_name'?: string | null;
}
export interface PrizeResponse {
    'prize_id': string;
    'prize_type': PrizeType;
    'delivery_method': PrizeDeliveryMethod;
    'available_claim_delivery_method_overrides': Array<PrizeDeliveryMethod>;
    'value_amount': string;
    'patient_id': string;
    'granted_at': string;
    'claimed_at'?: string | null;
    'voucher'?: VoucherResponse | null;
    'prize_source'?: PrizeSourceType | null;
    'display_options'?: PrizeDisplayOptionsResponse | null;
}


/**
 * The source of this prize: i.e. a goals reward or a referral.
 */

export const PrizeSourceType = {
    Reward: 'reward',
    ReferralReferrerReward: 'referral_referrer_reward',
    ReferralReferralReward: 'referral_referral_reward'
} as const;

export type PrizeSourceType = typeof PrizeSourceType[keyof typeof PrizeSourceType];


/**
 * Types of prizes that can be awarded to patients.
 */

export const PrizeType = {
    OneFreeMeal: 'one_free_meal',
    OneMonthFreeMeals: 'one_month_free_meals',
    OneYearFreeMeals: 'one_year_free_meals',
    LifetimeFreeMeals: 'lifetime_free_meals',
    ReferrerBonus: 'referrer_bonus',
    ReferralBonus: 'referral_bonus'
} as const;

export type PrizeType = typeof PrizeType[keyof typeof PrizeType];


export interface ProblemOption {
    'label': ProblemOptionLabelEnum;
    'group': string;
}

export const ProblemOptionLabelEnum = {
    PathologicalOrPhysiologicalCausesThatResultInIncreasedEnergyRequirements: 'Pathological or physiological causes that result in increased energy requirements',
    DecreasedAbilityToConsumeSufficientEnergy: 'Decreased ability to consume sufficient energy',
    FoodInsecurity: 'Food insecurity',
    LimitedAccessToNutritionRelatedSupplies: 'Limited access to nutrition related supplies',
    CulturalPracticesThatAffectAbilityToAccessFood: 'Cultural practices that affect ability to access food',
    FoodAndNutritionRelatedKnowledgeDeficitConcerningEnergyIntake: 'Food and nutrition related knowledge deficit concerning energy intake',
    PsychologicalCausesSuchAsDepressionAndDisorderedEating: 'Psychological causes such as depression and disordered eating',
    BeliefFindingThatHindersFoodAndOrNutritionBehaviorChange: 'Belief finding that hinders food and/or nutrition behavior change',
    AttitudeFindingThatHindersFoodAndOrNutritionBehaviorChange: 'Attitude finding that hinders food and/or nutrition behavior change',
    LimitedValueForBehaviorChangeCompetingValues: 'Limited value for behavior change, competing values',
    MedicationsThatIncreaseAppetiteEgSteroidsAntidepressants: 'Medications that increase appetite, eg, steroids, antidepressants',
    OverfeedingOfParenteralEnteralNutritionPnEn: 'Overfeeding of parenteral/enteral nutrition (PN/EN)',
    CaloriesKcalKJUnaccountedForFromIvInfusionAndOrMedications: 'Calories/kcal/kJ unaccounted for from IV infusion and/or medications',
    LimitedInterestInReducingEnergyIntake: 'Limited interest in reducing energy intake',
    LimitedAdjustmentForLifestyleChangesAndDecreasedMetabolismEgAging: 'Limited adjustment for lifestyle changes and decreased metabolism (eg, aging)',
    LimitedAdjustmentForRestrictedMobilityDueToRecoveryFromInjurySurgicalProcedureOther: 'Limited adjustment for restricted mobility due to recovery from injury, surgical procedure, other',
    ResolutionOfPriorHypermetabolismWithoutReductionInIntake: 'Resolution of prior hypermetabolism without reduction in intake',
    LimitedFoodAndNutritionRelatedSkill: 'Limited food and nutrition related skill',
    AlteredAbsorptionOrMetabolismOfNutrient: 'Altered absorption or metabolism of nutrient',
    CompromiseOfOrgansRelatedToGiFunction: 'Compromise of organs related to GI function',
    DecreasedFunctionalLengthOfIntestine: 'Decreased functional length of intestine',
    DecreasedOrCompromisedFunctionOfIntestine: 'Decreased or compromised function of intestine',
    IncreasedDemandForNutrient: 'Increased demand for nutrient',
    RenalDysfunction: 'Renal dysfunction',
    LiverDysfunction: 'Liver dysfunction',
    AlteredCholesterolMetabolismRegulation: 'Altered cholesterol metabolism/regulation',
    HeartFailure: 'Heart failure',
    FoodIntolerances: 'Food intolerances',
    ConsumptionOfHighDoseNutrientSupplements: 'Consumption of high-dose nutrient supplements',
    FoodAndNutritionRelatedKnowledgeDeficitConcerningNutrientInteractions: 'Food- and nutrition-related knowledge deficit concerning nutrient interactions',
    FoodFaddism: 'Food faddism',
    InsufficientElectrolyteReplacementWhenInitiatingFeedingPnEnIncludingOral: 'Insufficient electrolyte replacement when initiating feeding (PN/EN, including oral)',
    MechanicalCauses: 'Mechanical causes',
    MotorCauses: 'Motor causes',
    CraniofacialMalformations: 'Craniofacial malformations',
    OralSurgery: 'Oral surgery',
    NeuromuscularDysfunction: 'Neuromuscular dysfunction',
    PartialOrCompleteEdentulism: 'Partial or complete edentulism',
    SoftTissueDiseasePrimaryOrOralManifestationsOfASystemicDisease: 'Soft tissue disease (primary or oral manifestations of a systemic disease)',
    Xerostomia: 'Xerostomia',
    DifficultyLatchingOn: 'Difficulty latching on',
    PoorSuckingAbility: 'Poor sucking ability',
    OralPain: 'Oral pain',
    MalnutritionMalabsorption: 'Malnutrition/malabsorption',
    LethargySleepiness: 'Lethargy, sleepiness',
    Irritability: 'Irritability',
    IntroductionOfFeedingViaBottleOrOtherRouteThatMayAffectBreastfeeding: 'Introduction of feeding via bottle or other route that may affect breastfeeding',
    SwallowingDifficulty: 'Swallowing difficulty',
    PainfulBreastTissueWithLactatingCapabilityNipples: 'Painful breast tissue with lactating capability, nipples',
    BreastOrNippleAbnormality: 'Breast or nipple abnormality',
    Mastitis: 'Mastitis',
    PerceptionOfOrActualInadequateBreastmilkSupply: 'Perception of or actual inadequate breastmilk supply',
    LimitedSocialOrEnvironmentalSupport: 'Limited social or environmental support',
    CulturalPracticesThatMayAffectTheAbilityToBreastfeed: 'Cultural practices that may affect the ability to breastfeed',
    AlterationInGastrointestinalTractStructureAndOrFunction: 'Alteration in gastrointestinal tract structure and/or function',
    ChangesInTheGiTractMotility: 'Changes in the GI tract motility',
    CompromisedExocrineFunctionOfRelatedGiOrgans: 'Compromised exocrine function of related GI organs',
    DecreasedFunctionalLengthOfTheGiTract: 'Decreased functional length of the GI tract',
    CompromisedEndocrineFunctionOfRelatedGastrointestinalOrgans: 'Compromised endocrine function of related gastrointestinal organs',
    MetabolicDisordersIncludingInbornErrorsOfMetabolism: 'Metabolic disorders, including inborn errors of metabolism',
    MedicationsThatAffectNutrientMetabolism: 'Medications that affect nutrient metabolism',
    AlcoholOrDrugAddiction: 'Alcohol or drug addiction',
    DisorderedEatingPattern: 'Disordered eating pattern',
    ExcessivePhysicalActivity: 'Excessive physical activity',
    InadequateEnergyIntake: 'Inadequate energy intake',
    IncreasedEnergyNeeds: 'Increased energy needs',
    SmallForGestationalAgeIntrauterineGrowthRetardationRestrictionAndOrLackOfProgressAppropriateWeightGainPerDay: 'Small for gestational age, intrauterine growth retardation/restriction and/or lack of progress/appropriate weight gain per day',
    DecreasedEnergyNeeds: 'Decreased energy needs',
    ExcessiveEnergyIntake: 'Excessive energy intake',
    NotReadyForNutritionRelatedBehaviorChange: 'Not ready for nutrition related behavior change',
    LimitedPhysicalActivity: 'Limited physical activity',
    IncreasedPsychologicalLifeStress: 'Increased psychological/life stress',
    PhysiologicalCausesIncreasingNutrientNeedsDueToIllnessOrCondition: 'Physiological causes increasing nutrient needs due to illness or condition',
    PhysiologicalCausesResultingInAnorexiaOrDiminishedIntakeIncludingFeedingIntolerance: 'Physiological causes resulting in anorexia or diminished intake (including feeding intolerance)',
    AlteredUtilizationOfNutrients: 'Altered utilization of nutrients',
    FoodAndNutritionRelatedKnowledgeDeficit: 'Food and nutrition-related knowledge deficit',
    SocialEconomicBehavioralCulturalOrReligiousPracticesThatAffectTheAbilityToAccessFood: 'Social, economic, behavioral, cultural, or religious practices that affect the ability to access food',
    PsychologicalOrBehavioralCauses: 'Psychological or behavioral causes',
    OralHealthLimitations: 'Oral health limitations',
    ImpairedSensoryPerceptionImpactingFoodConsumption: 'Impaired sensory perception impacting food consumption',
    InterruptionsOfOrIntoleranceToFeedings: 'Interruptions of or intolerance to feedings',
    LimitedPriorNutritionRelatedEducation: 'Limited prior nutrition-related education',
    LimitedLiteracy: 'Limited literacy',
    LimitedNumeracy: 'Limited numeracy',
    CulturalBeliefsThatMayAffectAccessToAndReceptivityToInformation: 'Cultural beliefs that may affect access to and receptivity to information',
    ImpairedCognitiveAbility: 'Impaired cognitive ability',
    PriorExposureToMisinformationDisinformationAndOrContradictoryInformation: 'Prior exposure to misinformation, disinformation, and/or contradictory information',
    LimitedPrioritizationForLearningFoodAndNutritionInformation: 'Limited prioritization for learning food and nutrition information',
    LimitedSelfEfficacyForLearningFoodAndNutritionInformation: 'Limited self-efficacy for learning food and nutrition information',
    RecentMedicalDiagnosisOrChangeInHealthOrDiseaseStatus: 'Recent medical diagnosis or change in health or disease status',
    ChangeInLifeCourseStageOrResponsibilityForSelfOrOthers: 'Change in life-course stage or responsibility for self or others',
    LimitedAccessToSourcesOfReliableFoodAndNutritionInformation: 'Limited access to sources of reliable food and nutrition information',
    CulturalSocietalBiologicalGeneticAndOrEnvironmentalRelatedFearOfWeightGain: 'Cultural, societal, biological/genetic, and/or environmental-related fear of weight gain',
    WeightRegulationPreoccupation: 'Weight regulation/preoccupation',
    ObsessiveDesireToBeHealthyOrHaveASpecificBodyShape: 'Obsessive desire to be healthy or have a specific body shape',
    PhysiologicalCausesThatPutEmphasisOnFoodWeightOrShape: 'Physiological causes that put emphasis on food, weight, or shape',
    PsychologicalCausesThatPutEmphasisOnFoodWeightOrShape: 'Psychological causes that put emphasis on food, weight, or shape',
    PersonalityCharacteristicsOrTemperamentAssociatedWithEatingDisorders: 'Personality characteristics or temperament associated with eating disorders',
    TraumaticEventSThatCausesAPhysicalOrPsychologicalStressReaction: 'Traumatic event(s) that causes a physical or psychological stress reaction',
    PhysiologicalCausesRequiringModifiedCarbohydrateIntakeEgDiabetesMellitusLactaseDeficiencySucraseIsomaltaseDeficiencyAldolaseBDeficiency: 'Physiological causes requiring modified carbohydrate intake, eg, diabetes mellitus, lactase deficiency, sucrase-isomaltase deficiency, aldolase-B deficiency',
    CulturalPracticesThatAffectTheAbilityToReduceCarbohydrateIntake: 'Cultural practices that affect the ability to reduce carbohydrate intake',
    FoodAndNutritionRelatedKnowledgeDeficitConcerningAppropriateAmountOfCarbohydrateIntake: 'Food and nutrition related knowledge deficit concerning appropriate amount of carbohydrate intake',
    LimitedAdherenceWithRecommendationsToModifyCarbohydrateIntake: 'Limited adherence with recommendations to modify carbohydrate intake',
    LackOfOrLimitedAccessToFiberContainingFoodsFluids: 'Lack of or limited access to fiber-containing foods/fluids',
    FoodAndNutritionRelatedKnowledgeDeficitConcerningDesirableQuantitiesOfFiber: 'Food and nutrition related knowledge deficit concerning desirable quantities of fiber',
    ProlongedAdherenceToALowFiberOrLowResidueDiet: 'Prolonged adherence to a low-fiber or low-residue diet',
    DifficultyChewingOrSwallowingHighFiberFoods: 'Difficulty chewing or swallowing high-fiber foods',
    EconomicConstraintsThatLimitAvailabilityOfHigherFiberFoods: 'Economic constraints that limit availability of higher fiber foods',
    LimitedAbilityOrLimitedMotivationToPurchaseOrConsumeFiberContainingFoods: 'Limited ability or limited motivation to purchase or consume fiber-containing foods',
    LessThanOptimalFoodPreparationPracticesEgRelianceOnOverprocessedOvercookedFoods: 'Less than optimal food preparation practices, eg, reliance on overprocessed, overcooked foods',
    FoodAndNutritionRelatedKnowledgeDeficitConcerningAppropriateAmountOfDietaryFat: 'Food and nutrition related knowledge deficit concerning appropriate amount of dietary fat',
    ChangesInTasteAndAppetiteOrPreference: 'Changes in taste and appetite or preference',
    PhysiologicalCausesDecreasingTotalFatNeedsOrRecommendations: 'Physiological causes decreasing total fat needs or recommendations',
    PhysiologicalCausesIncreasingNutrientNeedsEGMalabsorption: 'Physiological causes increasing nutrient needs (e.g., malabsorption)',
    DecreasedAbilityToConsumeSufficientAmountOfAVitaminS: 'Decreased ability to consume sufficient amount of a vitamin(s)',
    FoodAndNutritionRelatedKnowledgeDeficitConcerningFoodAndSupplementalSourcesOfVitamins: 'Food and nutrition related knowledge deficit concerning food and supplemental sources of vitamins',
    AccessCausesIncludingSeasonGeographyLimitedAccessToSunlight: 'Access causes including season, geography, limited access to sunlight',
    PhysiologicalCausesIncreasingNutrientNeedsDueToProlongedCatabolicIllnessMalabsorptionHyperexcretionNutrientDrugAndNutrientNutrientInteractionGrowthAndMaturation: 'Physiological causes increasing nutrient needs due to prolonged catabolic illness, malabsorption, hyperexcretion, nutrient/drug and nutrient/nutrient interaction, growth and maturation',
    DecreasedAbilityToConsumeSufficientAmountOfAMineralS: 'Decreased ability to consume sufficient amount of a mineral(s)',
    FoodAndNutritionRelatedKnowledgeDeficitConcerningFoodAndSupplementalSourcesOfMinerals: 'Food and nutrition related knowledge deficit concerning food and supplemental sources of minerals',
    MisdiagnosisOfLactoseIntoleranceLactaseDeficiencyPerceptionOfConflictingNutritionMessagesLessThanOptimalRelianceOnSupplements: 'Misdiagnosis of lactose intolerance/lactase deficiency; perception of conflicting nutrition messages; less than optimal reliance on supplements',
    PsychologicalCausesEgDepressionOrEatingDisorders: 'Psychological causes, eg, depression or eating disorders',
    EnvironmentalCausesEgInadequatelyTestedNutrientBioavailabilityOfFortifiedFoodsBeveragesAndSupplementsLessThanOptimalMarketingOfFortifiedFoodsBeveragesSupplementsAsASubstituteForNaturalFoodSourceOfNutrientS: 'Environmental causes, eg, inadequately tested nutrient bioavailability of fortified foods, beverages, and supplements; less than optimal marketing of fortified foods/beverages/supplements as a substitute for natural food source of nutrient(s)',
    FailureToGainOrMaintainAppropriateBodyWeight: 'Failure to gain or maintain appropriate body weight',
    PoorDentition: 'Poor dentition',
    EstimatedEnergyIntakeFromDietLessThanNeedsBasedOnEstimatedOrMeasuredRestingMetabolicRate: 'Estimated energy intake from diet less than needs based on estimated or measured resting metabolic rate',
    RestrictionOrOmissionOfEnergyDenseFoodsFromDietFoodAvoidanceAndOrLackOfInterestInFood: 'Restriction or omission of energy-dense foods from diet Food avoidance and/or lack of interest in food',
    LimitedAbilityToIndependentlyConsumeFoodsFluidsDiminishedJointMobilityOfWristHandOrDigits: 'Limited ability to independently consume foods/fluids (diminished joint mobility of wrist, hand, or digits)',
    EstimatedParenteralOrEnteralNutritionIntakeInsufficientToMeetNeedsBasedOnEstimatedOrMeasuredRestingMetabolicRate: 'Estimated parenteral or enteral nutrition intake insufficient to meet needs based on estimated or measured resting metabolic rate',
    ExcessiveConsumptionOfAlcoholOrOtherDrugsThatReduceHunger: 'Excessive consumption of alcohol or other drugs that reduce hunger',
    MedicationsThatAffectAppetite: 'Medications that affect appetite',
    ConditionsAssociatedWithDiagnosisOrTreatment: 'Conditions associated with diagnosis or treatment',
    TotalEnergyEstimatedNeedsIn24Hours: 'Total energy estimated needs in 24 hours',
    MethodForEstimatingTotal24HourEnergyNeeds: 'Method for estimating total 24 hour energy needs',
    EnergyEstimatedNeedsPerKgOfBodyWeightIn24Hours: 'Energy estimated needs per kg of body weight in 24 hours',
    AbnormalLiverFunctionTestsAfterProlongedExposure3To6WeeksToParenteralNutrition: 'Abnormal liver function tests after prolonged exposure (3 to 6 weeks) to parenteral nutrition',
    RespiratoryQuotientIsGreaterThan10: 'Respiratory quotient is greater than 1.0',
    BodyFatPercentage25ForMenAnd32ForWomen: 'Body fat percentage > 25% for men and > 32% for women',
    Bmi25AdultsBmi95thPercentilePediatrics: 'BMI > 25 (adults); BMI > 95th percentile (pediatrics)',
    BodyWeightGain: 'Body weight gain',
    IncreasedBodyAdiposity: 'Increased body adiposity',
    IncreasedRespiratoryRate: 'Increased respiratory rate',
    IntakeOfEnergyInExcessOfEstimatedOrMeasuredEnergyNeeds: 'Intake of energy in excess of estimated or measured energy needs',
    IntakeOfHighCaloricDensityOrLargePortionsOfFoodsBeverages: 'Intake of high caloric density or large portions of foods/beverages',
    EnPnMoreThanEstimatedOrMeasuredEgIndirectCalorimetryEnergyExpenditure: 'EN/PN more than estimated or measured (eg, indirect calorimetry) energy expenditure',
    TotalCholesterol160MgDLAlbuminPrealbuminCReactiveProteinIndicatingIncreasedStressAndIncreasedMetabolicNeeds: 'Total cholesterol < 160 mg/dL, albumin, prealbumin, C-reactive protein, indicating increased stress and increased metabolic needs',
    ElectrolyteMineralAbnormalities: 'Electrolyte/mineral abnormalities',
    UrinaryOrFecalLossesOfSpecificOrRelatedNutrient: 'Urinary or fecal losses of specific or related nutrient',
    VitaminAndOrMineralDeficiency: 'Vitamin and/or mineral deficiency',
    GrowthFailureBasedOnReferenceGrowthStandardsAndFetalGrowthFailure: 'Growth failure, based on reference growth standards and fetal growth failure',
    UnintentionalWeightLossOf5In1MonthOr10In6Months: 'Unintentional weight loss of ≥ 5% in 1 month or ≥ 10% in 6 months',
    UnderweightBmi185: 'Underweight (BMI < 18.5)',
    LowPercentBodyFatAndMuscleMass: 'Low percent body fat and muscle mass',
    ClinicalEvidenceOfVitaminMineralDeficiency: 'Clinical evidence of vitamin/mineral deficiency',
    LossOfSkinIntegrityDelayedWoundHealingOrPressureUlcers: 'Loss of skin integrity, delayed wound healing, or pressure ulcers',
    LossOfMuscleMassSubcutaneousFat: 'Loss of muscle mass, subcutaneous fat',
    EstimatedIntakeOfFoodsSupplementsContainingNeededNutrientLessThanEstimatedRequirements: 'Estimated intake of foods/supplements containing needed nutrient less than estimated requirements',
    IntakeOfFoodsThatDoNotContainSufficientQuantitiesOfAvailableNutrient: 'Intake of foods that do not contain sufficient quantities of available nutrient',
    FoodAndNutritionRelatedKnowledgeDeficit2: 'Food- and nutrition-related knowledge deficit',
    MedicationsAffectingAbsorptionOrMetabolismOfNeededNutrient: 'Medications affecting absorption or metabolism of needed nutrient',
    AthletesOrActiveIndividualsEngagedInIntensePhysicalActivity: 'Athletes or active individuals engaged in intense physical activity',
    ConditionsAssociatedWithADiagnosisOrTreatment: 'Conditions associated with a diagnosis or treatment',
    TotalCholesterol200MgDL52MmolLLdlCholesterol100MgDL259MmolLHdlCholesterol40MgDL1036MmolLAndOrTriglycerides150MgDL1695MmolL: 'Total cholesterol > 200 mg/dL (5.2 mmol/L), LDL cholesterol > 100 mg/dL (2.59 mmol/L), HDL cholesterol < 40 mg/dL (1.036 mmol/L), and/or triglycerides > 150 mg/dL (1.695 mmol/L)',
    Phosphorus55MgDL178MmolL: 'Phosphorus > 5.5 mg/dL (1.78 mmol/L)',
    GlomerularFiltrationRateGfr90MLMin173M2: 'Glomerular filtration rate (GFR) < 90 mL/min/1.73 m^2',
    BunCreatininePotassium: 'BUN, creatinine, potassium',
    LiverFunctionTestsIndicatingSevereLiverDisease: 'Liver function tests indicating severe liver disease',
    InterdialyticWeightGainGreaterThanExpected: 'Interdialytic weight gain greater than expected',
    EdemaFluidRetention: 'Edema/fluid retention',
    EstimatedIntakeHigherThanRecommendedForFatPhosphorusSodiumProteinFiber: 'Estimated intake higher than recommended for fat, phosphorus, sodium, protein, fiber',
    ConditionsAssociatedWithADiagnosisOrTreatmentThatRequireASpecificTypeAndOrAmountOfNutrient: 'Conditions associated with a diagnosis or treatment that require a specific type and/or amount of nutrient',
    DiagnosisOfHypertensionConfusionRelatedToLiverDisease: 'Diagnosis of hypertension, confusion related to liver disease',
    SevereHypophosphatemiaInThePresenceOfIncreasedCarbohydrate: 'Severe hypophosphatemia (in the presence of increased carbohydrate)',
    SevereHypokalemiaInThePresenceOfIncreasedProtein: 'Severe hypokalemia (in the presence of increased protein)',
    SevereHypomagnesemiaInThePresenceOfIncreasedCarbohydrate: 'Severe hypomagnesemia (in the presence of increased carbohydrate)',
    DiarrheaOrConstipationIronSupplements: 'Diarrhea or constipation (iron supplements)',
    EpigastricPainNauseaVomitingDiarrheaZincSupplements: 'Epigastric pain, nausea, vomiting, diarrhea (zinc supplements)',
    EstimatedIntakeOfIronSupplementsDecreasedZincAbsorptionHigherThanRecommended: 'Estimated intake of iron supplements (decreased zinc absorption) higher than recommended',
    EstimatedIntakeOfZincSupplementsDecreasedCopperStatusHigherThanRecommended: 'Estimated intake of zinc supplements (decreased copper status) higher than recommended',
    EstimatedIntakeOfManganeseDecreasedIronStatusHigherThanRecommended: 'Estimated intake of manganese (decreased iron status) higher than recommended',
    ReFeedingSyndrome: 'Re-feeding syndrome',
    RadiologicalFindings: 'Radiological findings',
    EvidenceOfDehydration: 'Evidence of dehydration',
    FindingsInCranialNervesAndCnViiMusclesOfFacialExpressionNerveIxGagReflexSwallowNerveXAndTongueRangeOfMotionsNerveXiiAndCoughReflex: 'Findings in cranial nerves and (CN VII) muscles of facial expression, (Nerve IX) gag reflex, swallow (Nerve X) and tongue range of motions (Nerve XII), and cough reflex',
    CoughingChokingProlongedChewingPouchingOfFoodRegurgitationFacialExpressionChangesDuringEatingDroolingNoisyWetUpperAirwaySoundsFeelingOfFoodGettingStuckPainWhileSwallowing: 'Coughing, choking, prolonged chewing, pouching of food, regurgitation, facial expression changes during eating, drooling, noisy wet upper airway sounds, feeling of food getting stuck, pain while swallowing',
    ProlongedEatingTime: 'Prolonged eating time',
    DecreasedEstimatedFoodIntake: 'Decreased estimated food intake',
    ReluctanceToConsumeSpecificFoods: 'Reluctance to consume specific foods',
    MealtimeEatingOccasionResistance: 'Mealtime/eating occasion resistance',
    RepeatedUpperRespiratoryInfectionsAndOrPneumonia: 'Repeated upper respiratory infections and or pneumonia',
    InternationalDysphagiaDietStandardisationInitiativeFrameworkDrinksLevel: 'International Dysphagia Diet Standardisation Initiative Framework drinks level',
    InternationalDysphagiaDietStandardisationInitiativeFrameworkFoodLevel: 'International Dysphagia Diet Standardisation Initiative Framework food level',
    InternationalDysphagiaDietStandardisationInitiativeFunctionalDietScaleScore: 'International Dysphagia Diet Standardisation Initiative Functional Diet Scale score',
    ResultsOfModifiedBariumSwallowBariumSwallowVideoFluoroscopicSwallowingStudy: 'Results of modified barium swallow, barium swallow, video-fluoroscopic swallowing study',
    WeightChangeEspeciallyWeightLoss: 'Weight change, especially weight loss',
    GrowthLessThanExpectedInChildren: 'Growth less than expected in children',
    AlterationsInCranialNerveFunctionVViiIxXXii: 'Alterations in cranial nerve function (V, VII, IX, X, XII)',
    DryMouth: 'Dry mouth',
    OralLesionsInterferingWithEatingAbility: 'Oral lesions interfering with eating ability',
    ImpairedTongueMovement: 'Impaired tongue movement',
    IllFittingDenturesOrBrokenDentures: 'Ill-fitting dentures or broken dentures',
    Dysphagia: 'Dysphagia',
    AlterationsInEstimatedFoodIntakeFromUsual: 'Alterations in estimated food intake from usual',
    DecreasedEstimatedIntakeOrAvoidanceOfFoodDifficultToFormIntoABolus: 'Decreased estimated intake or avoidance of food difficult to form into a bolus',
    AvoidanceOfFoodsOfAgeAppropriateTexture: 'Avoidance of foods of age-appropriate texture',
    SpittingFoodOutOrProlongedEatingTime: 'Spitting food out or prolonged eating time',
    PreferenceForEasyToChewFood: 'Preference for easy to chew food',
    RecentMajorOralSurgery: 'Recent major oral surgery',
    WiredJaw: 'Wired jaw',
    ChemotherapyWithOralSideEffects: 'Chemotherapy with oral side effects',
    RadiationTherapyToOralCavity: 'Radiation therapy to oral cavity',
    SubjectiveGlobalAssessmentSgaRating: 'Subjective global assessment (SGA) rating',
    SubjectiveGlobalAssessmentSgaScore: 'Subjective global assessment (SGA) score',
    PatientGeneratedSubjectiveGlobalAssessmentPgSgaRating: 'Patient generated subjective global assessment (PG-SGA) rating',
    PatientGeneratedSubjectiveGlobalAssessmentPgSgaScore: 'Patient generated subjective global assessment (PG-SGA) score',
    MiniNutritionalAssessmentLongFormMnaLfRating: 'Mini nutritional assessment long form (MNA-LF) rating',
    MiniNutritionalAssessmentLongFormMnaLfScore: 'Mini nutritional assessment long form (MNA-LF) score',
    SubjectiveGlobalNutritionalAssessmentSgnaForChildrenRating: 'Subjective global nutritional assessment (SGNA) for children rating',
    SubjectiveGlobalNutritionalAssessmentSgnaForChildrenScore: 'Subjective global nutritional assessment (SGNA) for children score',
    LaboratoryEvidenceOfDehydrationInfant: 'Laboratory evidence of dehydration (infant)',
    FewerThanReferenceStandard: 'Fewer than reference standard',
    AnyWeightLossOrLimitedWeightGainInfant: 'Any weight loss or limited weight gain (infant)',
    FrenulumAbnormalityInfant: 'Frenulum abnormality (infant)',
    VomitingOrDiarrheaInfant: 'Vomiting or diarrhea (infant)',
    HungerLimitedSatietyAfterFeedingInfant: 'Hunger, limited satiety after feeding (infant)',
    Coughing: 'Coughing',
    CryingLatchingOnAndOffPoundingOnBreasts: 'Crying, latching on and off, pounding on breasts',
    DecreasedFeedingFrequencyDurationEarlyCessationOfFeedingAndOrFeedingResistance: 'Decreased feeding frequency/duration, early cessation of feeding, and/or feeding resistance',
    Lethargy: 'Lethargy',
    SmallAmountOfBreastmilkWhenPumping: 'Small amount of breastmilk when pumping',
    LimitedConfidenceInAbilityToBreastfeed: 'Limited confidence in ability to breastfeed',
    DoesntHearInfantSwallowing: 'Doesn\'t hear infant swallowing',
    LimitedSupportOfMothersChoiceToBreastfeed: 'Limited support of mother\'s choice to breastfeed',
    LimitedKnowledgeOfBreastfeeding: 'Limited knowledge of breastfeeding',
    LimitedKnowledgeOfInfantHungerSatietySignals: 'Limited knowledge of infant hunger/satiety signals',
    LimitedSupportForEngagingEmployerInDiscussionsAboutBreastfeedingFacilities: 'Limited support for engaging employer in discussions about breastfeeding facilities',
    LimitedFacilitiesOrAccommodationsAtPlaceOfEmploymentOrInCommunityForBreastfeeding: 'Limited facilities or accommodations at place of employment or in community for breastfeeding',
    FeedingViaBottleOrOtherRoute: 'Feeding via bottle or other route',
    ConditionsAssociatedWithADiagnosisOrTreatmentInfant: 'Conditions associated with a diagnosis or treatment (infant)',
    ConditionsAssociatedWithADiagnosisOrTreatmentMother: 'Conditions associated with a diagnosis or treatment (mother)',
    SocialOrPersonalConsiderationsOfTheMother: 'Social or personal considerations of the mother',
    AbnormalDigestiveEnzymeAndFecalStudies: 'Abnormal digestive enzyme and fecal studies',
    AbnormalHydrogenBreathTestDXyloseTestStoolCultureAndGastricEmptyingAndOrBowelTransitTime: 'Abnormal hydrogen breath test, d-xylose test, stool culture, and gastric emptying and/or bowel transit time',
    EndoscopicOrColonoscopyExaminationAbdominalScanBiopsyResults: 'Endoscopic or colonoscopy examination, abdominal scan, biopsy results',
    AbnormalPHSphincterMotilityMorphologyOrRefluxStudies: 'Abnormal pH, sphincter, motility, morphology or reflux studies',
    AbnormalAnemiaProfile: 'Abnormal anemia profile',
    AbnormalVitaminMineralFattyAcidTraceElementAndPthResults: 'Abnormal vitamin, mineral, fatty acid, trace element, and PTH results',
    AbnormalTissueTransglutaminaseAntibodiesIgAIgG: 'Abnormal tissue transglutaminase antibodies (IgA/IgG)',
    WeightLossOf5InOneMonth10InSixMonths: 'Weight loss of ≥ 5% in one month, ≥ 10% in six months',
    GrowthStuntingOrFailureInChildren: 'Growth stunting or failure in children',
    AbnormalBoneMineralDensityTests: 'Abnormal bone mineral density tests',
    AbdominalDistension: 'Abdominal distension',
    IncreasedOrSometimesDecreasedBowelSounds: 'Increased (or sometimes decreased) bowel sounds',
    WastingDueToMalnutritionInSevereCases: 'Wasting due to malnutrition in severe cases',
    AnorexiaNauseaVomitingDiarrheaSteatorrheaConstipationAbdominalPainRefluxGasBelchingFlatusBloatingFecalIncontinence: 'Anorexia, nausea, vomiting, diarrhea, steatorrhea, constipation, abdominal pain, reflux, gas, belching, flatus, bloating, fecal incontinence',
    EvidenceOfVitaminAndOrMineralDeficiency: 'Evidence of vitamin and/or mineral deficiency',
    AvoidanceOrLimitationOfEstimatedTotalIntakeOrIntakeOfSpecificFoodsFoodGroupsDueToGiSymptoms: 'Avoidance or limitation of estimated total intake or intake of specific foods/food groups due to GI symptoms',
    SurgicalProcedures: 'Surgical procedures',
    AbnormalProteinFattyAcidOrCarbohydrateMetabolismProfileTests: 'Abnormal protein, fatty acid or carbohydrate metabolism profile tests',
    AbnormalLiverFunctionTests: 'Abnormal liver function tests',
    AbnormalPituitaryHormonesGrowthHormoneGhAdrenocorticotropicHormoneActhLuteinizingHormoneLhAndFollicleStimulatingHormoneFsh: 'Abnormal pituitary hormones (growth hormone [GH], adrenocorticotropic hormone [ACTH], luteinizing hormone [LH] and follicle-stimulating hormone [FSH])',
    HypoglycemiaHyperglycemia: 'Hypoglycemia, hyperglycemia',
    AbnormalParathyroidHormonePth: 'Abnormal parathyroid hormone (PTH)',
    PositiveResultForUrinePorphyrins: 'Positive result for urine porphyrins',
    EvidenceOfVitaminAndOrMineralDeficiencyEgGlossitisCheilosisMouthLesions: 'Evidence of vitamin and/or mineral deficiency, eg, glossitis, cheilosis, mouth lesions',
    ThinWastedAppearance: 'Thin, wasted appearance',
    AvoidanceOrLimitationOfIntakeOfSpecificFoodsFoodGroupsDueToPhysicalSymptoms: 'Avoidance or limitation of intake of specific foods/food groups due to physical symptoms',
    AlcoholOrDrugUse: 'Alcohol or drug use',
    MeasuredRestingMetabolicRateRmrHigherThanExpectedAndOrEstimated: 'Measured resting metabolic rate (RMR) higher than expected and/or estimated',
    DecreasedSkinFoldThicknessAndMidArmMuscleCircumference: 'Decreased skin fold thickness and mid-arm muscle circumference',
    Bmi185Adults: 'BMI < 18.5 (adults)',
    BmiForOlderAdultsOlderThan65Years23: 'BMI for older adults (older than 65 years) < 23',
    BirthTo2YearsWeightForAge5thPercentile: '(Birth to 2 years) Weight for age < 5th percentile',
    BirthTo2YearsWeightForLength5thPercentile: '(Birth to 2 years) Weight for length < 5th percentile',
    Ages2To20YearsWeightForStature5thPercentile: '(Ages 2 to 20 years) Weight for stature < 5th percentile',
    Ages2To20YearsBmi5thPercentile: '(Ages 2 to 20 years) BMI < 5th percentile',
    Ages2To20YearsWeightForAge5thPercentile: '(Ages 2 to 20 years)Weight for age < 5th percentile',
    DecreasedMuscleMassMuscleWastingGlutealAndTemporal: 'Decreased muscle mass, muscle wasting (gluteal and temporal)',
    Hunger: 'Hunger',
    EstimatedIntakeOfFoodLessThanEstimatedOrMeasuredNeeds: 'Estimated intake of food less than estimated or measured needs',
    LimitedSupplyOfFoodInHome: 'Limited supply of food in home',
    DietingFoodFaddism: 'Dieting, food faddism',
    RefusalToEat: 'Refusal to eat',
    PhysicalActivityMoreThanRecommendedAmount: 'Physical activity more than recommended amount',
    Malnutrition: 'Malnutrition',
    IllnessOrPhysicalDisability: 'Illness or physical disability',
    MentalIllnessDementiaConfusion: 'Mental illness, dementia, confusion',
    AthleteDancerGymnast: 'Athlete, dancer, gymnast',
    VitaminMineralDeficiency: 'Vitamin/mineral deficiency',
    IdealReferenceBodyWeightIbw: 'Ideal/reference body weight (IBW)',
    RecommendedBodyMassIndexBmi: 'Recommended body mass index (BMI)',
    GoalBodyWeight: 'Goal body weight',
    GoalBodyWeightForLengthZScore: 'Goal body weight for length z score',
    GoalBodyMassIndexBmiForAgeZScore: 'Goal body mass index (BMI) for age z score',
    MeasuredRestingMetabolicRateRmrLessThanExpectedAndOrEstimated: 'Measured resting metabolic rate (RMR) less than expected and/or estimated',
    Overweight25To299Adults85thTo95thPercentilesPediatrics: 'Overweight: 25 to 29.9 (adults), 85th to 95th percentiles (pediatrics)',
    ObesityClassI30To349Adults: 'Obesity class I: 30 to 34.9 (adults)',
    ObesityClassIi35To399Adults: 'Obesity class II: 35 to 39.9 (adults)',
    ObesityClassIii40Adults: 'Obesity class III: 40+ (adults)',
    Obesity95thPercentilePediatrics: 'Obesity > 95th percentile (pediatrics)',
    WaistCircumferenceMoreThanNormativeStandardForAgeAndSex: 'Waist circumference more than normative standard for age and sex',
    IncreasedSkinFoldThickness: 'Increased skin fold thickness',
    WeightForHeightMoreThanNormativeStandardForAgeAndSex: 'Weight for height more than normative standard for age and sex',
    ExcessSubcutaneousFat: 'Excess subcutaneous fat',
    CentralAdiposity: 'Central adiposity',
    AcanthosisNigricans: 'Acanthosis nigricans',
    JointArthralgia: 'Joint arthralgia',
    ConsumptionOfEnergyDenseNutrientPoorFoodOrBeverage: 'Consumption of energy-dense, nutrient poor food or beverage',
    LimitedIntakeOfFoodsLowEnergyHighNutrientFoods: 'Limited intake of foods low-energy, high-nutrient foods',
    LargePortionsOfFood: 'Large portions of food',
    EstimatedExcessiveEnergyIntake: 'Estimated excessive energy intake',
    InfrequentLowDurationAndOrLowIntensityPhysicalActivityFactorsAffectingPhysicalActivityAccess: 'Infrequent, low-duration and/or low-intensity physical activity, factors affecting physical activity access',
    LargeAmountsOfSedentaryActivities: 'Large amounts of sedentary activities',
    UncertaintyRegardingNutritionRelatedRecommendations: 'Uncertainty regarding nutrition-related recommendations',
    LimitedAbilityToApplyNutritionRelatedRecommendations: 'Limited ability to apply nutrition-related recommendations',
    LimitedMotivationToApplyNutritionRelatedRecommendations: 'Limited motivation to apply nutrition-related recommendations',
    LimitedAbilityToLoseASignificantAmountOfExcessWeightThroughConventionalWeightLossIntervention: 'Limited ability to lose a significant amount of excess weight through conventional weight loss intervention',
    MedicationsThatImpactRestingMetabolicRateRmr: 'Medications that impact resting metabolic rate (RMR)',
    PhysicalDisabilityOrLimitation: 'Physical disability or limitation',
    HistoryOfFamilialObesity: 'History of familial obesity',
    HistoryOfChildhoodObesity: 'History of childhood obesity',
    HistoryOfPhysicalSexualOrEmotionalAbuse: 'History of physical, sexual, or emotional abuse',
    InsufficientEnergyIntake: 'Insufficient energy intake',
    WeightLoss: 'Weight loss',
    LossOfMuscleMass: 'Loss of muscle mass',
    LossOfSubcutaneousFat: 'Loss of subcutaneous fat',
    LocalizedOrGeneralizedFluidAccumulationThatMaySometimesMaskWeightLoss: 'Localized or generalized fluid accumulation that may sometimes mask weight loss',
    DiminishedFunctionalStatusAsMeasuredByHandgripStrength: 'Diminished functional status as measured by handgrip strength',
    AlteredLaboratoryValue: 'Altered laboratory value',
    BodyWeightAboveOrBelowExpectedBodyWeight: 'Body weight above or below expected body weight',
    BodyWeightChange: 'Body weight change',
    GrowthParametersInconsistentWithExpected: 'Growth parameters inconsistent with expected',
    NutritionKnowledgeLevelNoneToIntermediateOfCommunitySupportiveIndividualsAndOrIndividualClient: 'Nutrition knowledge level (none to intermediate) of community, supportive individuals, and/or individual client',
    NoPriorAwarenessOfNeedForFoodAndNutritionRelatedInformation: 'No prior awareness of need for food- and nutrition-related information',
    NutritionRelatedEducationIsNotConsideredAPriority: 'Nutrition related education is not considered a priority',
    InformationConflictsWithIndividualClientsValues: 'Information conflicts with individual client\'s values',
    InformationConflictsWithClientsSupportiveIndividualsClientsSupportiveStructuresClientsStakeholdersValueSystem: 'Information conflicts with client\'s supportive individuals\', client\'s supportive structures\', client\'s stakeholder\'s value system',
    LimitedReadinessToChangeNutritionRelatedBehavior: 'Limited readiness to change nutrition related behavior',
    PresenceOfLimitedSelfEfficacyForLearningInformation: 'Presence of limited self-efficacy for learning information',
    RelatesDifficultiesAboutPreviousAttemptsToLearnInformation: 'Relates difficulties about previous attempts to learn information',
    DisinterestInLearningInformation: 'Disinterest in learning information',
    LowPerceivedSusceptibilityOfNutritionRelatedHealthProblemsScore: 'Low perceived susceptibility of nutrition related health problems score',
    LowPerceivedSeverityOfRiskToHealthScore: 'Low perceived severity of risk to health score',
    LowPerceivedBenefitOfNutritionRelatedChangeScore: 'Low perceived benefit of nutrition related change score',
    HighPerceivedBarrierToNutritionRelatedBehaviorChangeScore: 'High perceived barrier to nutrition related behavior change score',
    LowFoodAndOrNutritionLiteracyScore: 'Low food and/or nutrition literacy score',
    LimitedNumeracyUnderstanding: 'Limited numeracy understanding',
    QuestionsRelatingToNutritionAndFood: 'Questions relating to nutrition and food',
    LimitedPreviousFoodAndNutritionEducation: 'Limited previous food and nutrition education',
    LimitedExperienceRelatedToFoodAndNutritionNeed: 'Limited experience related to food and nutrition need',
    LimitedRelevantFoodAndNutritionKnowledge: 'Limited relevant food and nutrition knowledge',
    LimitedAdherenceToFoodAndNutritionRecommendations: 'Limited adherence to food and nutrition recommendations',
    LimitedSupportForBehaviorChange: 'Limited support for behavior change',
    CulturalBeliefThatMayImpactEngagementInLearningInformation: 'Cultural belief that may impact engagement in learning information',
    NewMedicalDiagnosisOrChangeInExistingDiagnosisOrCondition: 'New medical diagnosis or change in existing diagnosis or condition',
    ChangeInLifeCourseStrangeAndResponsibilities: 'Change in life-course strange and responsibilities',
    SocioEconomicFactorsThatPresentBarriers: 'Socio economic factors that present barriers',
    UnfavorableSocialAndOrEconomicConditionsOfCommunity: 'Unfavorable social and/or economic conditions of community',
    InequitiesInAccessToHealthcareOrInsurance: 'Inequities in access to healthcare or insurance',
    HighCholesterolAbnormalLipidProfiles: 'High cholesterol, abnormal lipid profiles',
    Hypoglycemia: 'Hypoglycemia',
    HyperglycemiaElevatedHgbA1c: 'Hyperglycemia, elevated HgbA1c',
    HypokalemiaAndHypochloremicAlkalosis: 'Hypokalemia and hypochloremic alkalosis',
    Hypophosphatemia: 'Hypophosphatemia',
    Hypomagnesemia: 'Hypomagnesemia',
    LowSerumVitaminD: 'Low serum Vitamin D',
    Hyponatremia: 'Hyponatremia',
    Hypothyroid: 'Hypothyroid',
    HighBloodUreaNitrogenBun: 'High blood urea nitrogen (BUN)',
    HighCarbonDioxideCo2: 'High carbon dioxide (CO2)',
    UrinePositiveForKetones: 'Urine positive for ketones',
    LaboratoryDataIndicatingAnemia: 'Laboratory data indicating anemia',
    AbnormalElectrocardiogramEcg: 'Abnormal electrocardiogram (ECG)',
    HighLiverFunctionTests: 'High liver function tests',
    HyperosmolarityHypoosmolarity: 'Hyperosmolarity, hypoosmolarity',
    LowLuteinizingHormoneFollicleStimulatingHormoneEstradiolOrTestosteroneLevels: 'Low luteinizing hormone, follicle stimulating hormone, estradiol, or testosterone levels',
    LowBoneMineralizationFindings: 'Low bone mineralization findings',
    Bmi175: 'BMI < 17.5',
    ArrestedGrowthAndDevelopment: 'Arrested growth and development',
    FailureToGainWeightAccordingToPredictedGrowthTrajectoryWeightLessThan85OfExpected: 'Failure to gain weight according to predicted growth trajectory, weight less than 85% of expected',
    SignificantWeightFluctuation: 'Significant weight fluctuation',
    SignificantWeightLossOrSignificantWeightGain: 'Significant weight loss or significant weight gain',
    FrequentWeighingOrMeasuringOfOneself: 'Frequent weighing or measuring of oneself',
    NormalOrDepletedAdiposeAndSomaticProteinStores: 'Normal or depleted adipose and somatic protein stores',
    Cachexia: 'Cachexia',
    LanugoHairFormation: 'Lanugo hair formation',
    BrittleListlessHair: 'Brittle listless hair',
    DrySkin: 'Dry skin',
    DamagedToothEnamel: 'Damaged tooth enamel',
    EnlargedParotidGlands: 'Enlarged parotid glands',
    PeripheralAndCentralEdema: 'Peripheral and central edema',
    SkeletalMuscleLoss: 'Skeletal muscle loss',
    LowBodyTemperature: 'Low body temperature',
    InabilityToConcentrate: 'Inability to concentrate',
    ReportsOfAlwaysFeelingCold: 'Reports of always feeling cold',
    BradycardiaHeartRate60BeatsMinForAdults50BeatsMinPediatrics: 'Bradycardia (heart rate < 60 beats/min for adults, < 50 beats/min pediatrics),',
    HypotensionSystolicBloodPressure90MmHg: 'Hypotension (systolic blood pressure < 90 mm HG)',
    OrthostaticHypotension: 'Orthostatic hypotension',
    PosturalTachycardia: 'Postural tachycardia',
    CyanosisOfHandsAndFeet: 'Cyanosis of hands and feet',
    DelayedCapillaryRefill: 'Delayed capillary refill',
    SelfInducedVomiting: 'Self-induced vomiting',
    PositiveRussellsSignCallousOnBackOfHandFromSelfInducedVomiting: 'Positive Russell\'s sign, callous on back of hand from self-induced vomiting',
    GastroesophagealRefluxDisease: 'Gastroesophageal reflux disease',
    Diarrhea: 'Diarrhea',
    BloatingFlatulence: 'Bloating, flatulence',
    Constipation: 'Constipation',
    BloodInVomit: 'Blood in vomit',
    BloodInStool: 'Blood in stool',
    MuscleWeakness: 'Muscle weakness',
    MuscleOrJointPain: 'Muscle or joint pain',
    DryMucusMembranes: 'Dry mucus membranes',
    AbsenceOfHungerCues: 'Absence of hunger cues',
    AmenorrheaOrDisruptionOfMenstrualCycle: 'Amenorrhea or disruption of menstrual cycle',
    DelayInSexualDevelopmentAndOrPuberty: 'Delay in sexual development and/or puberty',
    BodyImageDisturbance: 'Body image disturbance',
    LimitedRecognitionOfLowBodyWeight: 'Limited recognition of low body weight',
    SelfEvaluationIsBasedUponBodyShapeAndOrWeight: 'Self-evaluation is based upon body shape and/or weight',
    AvoidanceOfFoodOrEnergyContainingBeverages: 'Avoidance of food or energy-containing beverages',
    AvoidanceOfSocialEventsAtWhichFoodIsServed: 'Avoidance of social events at which food is served',
    FearOfFoodsOrDysfunctionalThoughtsRegardingFoodOrFoodExperiences: 'Fear of foods or dysfunctional thoughts regarding food or food experiences',
    FoodAndWeightPreoccupation: 'Food and weight preoccupation',
    ConflictWithIndividualClientValueSystem: 'Conflict with individual client value system',
    ConflictWithClientsSupportiveIndividualsValueSystem: 'Conflict with client\'s supportive individuals value system',
    PreoccupationWithEnergyOrNutrientContentOfFoods: 'Preoccupation with energy or nutrient content of foods',
    AvoidanceOfSpecificFoodTexturesOrConsistencies: 'Avoidance of specific food textures or consistencies',
    KnowledgeableAboutCurrentDietFads: 'Knowledgeable about current diet fads',
    FastingForLongPeriodsOfTimeDuringTypicalEatingHours: 'Fasting for long periods of time during typical eating hours',
    EstimatedIntakeOfLargerQuantityOfFoodInADefinedTimePeriodASenseOfLimitedControlOverEating: 'Estimated intake of larger quantity of food in a defined time period, a sense of limited control over eating',
    RitualizedEatingBehavior: 'Ritualized eating behavior',
    EatingMuchMoreRapidlyThanNormalUntilFeelingUncomfortablyFull: 'Eating much more rapidly than normal, until feeling uncomfortably full',
    ConsumingLargeAmountsOfFoodWhenNotFeelingPhysicallyHungry: 'Consuming large amounts of food when not feeling physically hungry',
    EatingMoreSlowlyThanUsualToDelayEating: 'Eating more slowly than usual to delay eating',
    HidingFood: 'Hiding food',
    DistortedPerceptionOfAppropriateAmountsToEat: 'Distorted perception of appropriate amounts to eat',
    EatingAloneBecauseOfEmbarrassment: 'Eating alone because of embarrassment',
    EatsInPrivate: 'Eats in private',
    FeelingUnpleasantEmotionsSuchAsGuiltDisgustShameAngerOrDepressionAfterEating: 'Feeling unpleasant emotions, such as, guilt, disgust, shame, anger, or depression after eating',
    PatternOfChronicDieting: 'Pattern of chronic dieting',
    PreviousFoodRestrictionIntentionalOrUnintentional: 'Previous food restriction (intentional or unintentional)',
    RecentChangeInFoodOrNutrientIntakePattern: 'Recent change in food or nutrient intake pattern',
    ExcessiveRelianceOnNutritionTermingIncludingPlacingLabelsOnFoodsThatRankTheSuperiorityOfOneFoodOverAnother: 'Excessive reliance on nutrition terming, including placing labels on foods that rank the superiority of one food over another',
    InflexibilityWithFoodSelection: 'Inflexibility with food selection',
    UseOfLaxativesEnemasDiureticsStimulantsMetabolicEnhancersMedicationsPerformanceEnhancingProducts: 'Use of laxatives, enemas, diuretics, stimulants, metabolic enhancers, medications, performance enhancing products',
    InClientsWithDiabetesPurposefulOmissionOfInsulin: 'In clients with diabetes, purposeful omission of insulin',
    NightEating: 'Night eating',
    PerceivedControlAroundNutritionIntakeThroughCalorieCountingMacronutrientMonitoringRecordKeeping: 'Perceived control around nutrition intake through calorie counting, macronutrient monitoring, record keeping',
    ChewingAndSpittingOfFood: 'Chewing and spitting of food',
    PersistentBehaviorThatInterferesWithWeightGain: 'Persistent behavior that interferes with weight gain',
    PersistentUseOfAMirror: 'Persistent use of a mirror',
    ExcessiveTimeSpentSourcingFood: 'Excessive time spent sourcing food',
    ExcessiveTimeSpentPreparingFood: 'Excessive time spent preparing food',
    AvoidanceOfFoodDeemedToBeTooProcessedOrUnhealthy: 'Avoidance of food deemed to be too processed or unhealthy',
    ExcessiveUseOfCondimentsAndFoodMixing: 'Excessive use of condiments and food mixing',
    DiagnosisEGAnorexiaNervosaBulimiaNervosaBingeEatingDisorderOtherSpecifiedFeedingOrEatingDisorder: 'Diagnosis (e.g., anorexia nervosa, bulimia nervosa, binge eating disorder, other specified feeding or eating disorder)',
    HistoryOfMentalHealthConditionDepressionAnxietyObsessiveCompulsiveDisorderOcdPersonalityDisordersSubstanceAbuseDisordersSelfInjury: 'History of mental health condition, depression, anxiety, obsessive/compulsive disorder (OCD), personality disorders, substance abuse disorders, self injury',
    FamilyHistoryOfMentalHealthConditionEatingDisorderDepressionOcdAnxietyDisorders: 'Family history of mental health condition, eating disorder, depression, OCD, anxiety disorders',
    OsteoporosisOsteopenia: 'Osteoporosis, osteopenia',
    SocialIsolation: 'Social isolation',
    SexualAbuse: 'Sexual abuse',
    PreviousTraumaticEventS: 'Previous traumatic event(s)',
    Infertility: 'Infertility',
    GallBladderDisease: 'Gall bladder disease',
    CompetitiveOrProfessionalAthlete: 'Competitive or professional athlete',
    BariatricSurgery: 'Bariatric surgery',
    CardiacArrhythmiasBradycardia: 'Cardiac arrhythmias, bradycardia',
    HyperglycemiaFastingBloodGlucose126MgDL: 'Hyperglycemia (Fasting blood glucose > 126 mg/dL)',
    HemoglobinA1C6: 'Hemoglobin A1C > 6%',
    OralGlucoseToleranceTest2HourPostLoadGlucose200MgDL: 'Oral glucose tolerance test (2-hour post load glucose > 200 mg/dL)',
    DentalCaries: 'Dental caries',
    CulturalOrReligiousPracticesThatDoNotSupportModificationOfDietaryCarbohydrateIntake: 'Cultural or religious practices that do not support modification of dietary carbohydrate intake',
    EstimatedCarbohydrateIntakeThatIsConsistentlyMoreThanRecommendedAmounts: 'Estimated carbohydrate intake that is consistently more than recommended amounts',
    ChronicUseOfMedicationsThatCauseHyperglycemia: 'Chronic use of medications that cause hyperglycemia',
    VerbalizesInaccurateOrIncompleteKnowledge: 'Verbalizes inaccurate or incomplete knowledge',
    PancreaticInsufficiencyResultingInReducedInsulinProduction: 'Pancreatic insufficiency resulting in reduced insulin production',
    EconomicConstraintsThatLimitAvailabilityOfAppropriateFoods: 'Economic constraints that limit availability of appropriate foods',
    TotalCarbohydrateEstimatedNeedsIn24Hours: 'Total carbohydrate estimated needs in 24 hours',
    CarbohydrateEstimatedNeedsPerKgOfBodyWeightIn24Hours: 'Carbohydrate estimated needs per kg of body weight in 24 hours',
    MethodForEstimatingTotal24HourCarbohydrateNeeds: 'Method for estimating total 24 hour carbohydrate needs',
    ProportionOfEnergyNeedsFromCarbohydrateIn24Hours: 'Proportion of energy needs from carbohydrate in 24 hours',
    InadequateFecalBulk: 'Inadequate fecal bulk',
    EstimatedIntakeOfFiberThatIsInsufficientWhenComparedToRecommendedAmounts38GDayForMenAnd25GDayForWomen: 'Estimated intake of fiber that is insufficient when compared to recommended amounts (38 g/day for men and 25 g/day for women)',
    ConditionsAssociatedWithADiagnosisOrTreatmentEGUlcerDiseaseIbd: 'Conditions associated with a diagnosis or treatment (e.g., ulcer disease,IBD)',
    TotalFiberEstimatedNeedsIn24Hours: 'Total fiber estimated needs in 24 hours',
    MethodForEstimatingTotal24HourFiberNeeds: 'Method for estimating total 24 hour fiber needs',
    Cholesterol200MgDL52MmolLLdlCholesterol100MgDL259MmolLHdlCholesterol40MgDL1036MmolLTriglycerides150MgDL1695MmolL: 'Cholesterol > 200 mg/dL (5.2 mmol/L), LDL cholesterol > 100 mg/dL (2.59 mmol/L), HDL cholesterol < 40 mg/dL (1.036 mmol/L), triglycerides > 150 mg/dL (1.695 mmol/L)',
    SerumAmylaseAndOrLipase: 'Serum amylase and/or lipase',
    LftsTBilirubin: 'LFTs, T. bilirubin',
    FecalFat7g24Hours: 'Fecal fat > 7g/24 hours',
    EvidenceOfXanthomas: 'Evidence of xanthomas',
    DiarrheaCrampingSteatorrheaEpigastricPain: 'Diarrhea, cramping, steatorrhea, epigastric pain',
    FrequentOrLargePortionsOfHighFatFoods: 'Frequent or large portions of high-fat foods',
    FrequentFoodPreparationWithAddedFat: 'Frequent food preparation with added fat',
    FrequentConsumptionOfHighRiskLipidsIESaturatedFatTransFatCholesterol: 'Frequent consumption of high-risk lipids (i.e., saturated fat, trans fat, cholesterol)',
    ReportOfFoodsContainingFatMoreThanDietPrescription: 'Report of foods containing fat more than diet prescription',
    MedicationEgPancreaticEnzymesCholesterolOrOtherLipidLoweringMedications: 'Medication, eg, pancreatic enzymes, cholesterol or other lipid-lowering medications',
    VerbalizesUnsupportedBeliefsAndAttitudes: 'Verbalizes unsupported beliefs and attitudes',
    ConditionsAssociatedWithADiagnosisOrTreatmentEGHyperlipidemia: 'Conditions associated with a diagnosis or treatment (e.g., hyperlipidemia)',
    FamilyHistoryOfHyperlipidemiaAtherosclerosisOrPancreatitis: 'Family history of hyperlipidemia, atherosclerosis, or pancreatitis',
    TotalFatEstimatedNeedsIn24Hours: 'Total fat estimated needs in 24 hours',
    FatEstimatedNeedsPerKgOfBodyWeightIn24Hours: 'Fat estimated needs per kg of body weight in 24 hours',
    MethodForEstimatingTotal24HourFatNeeds: 'Method for estimating total 24 hour fat needs',
    ProportionOfEnergyNeedsFromFatIn24Hours: 'Proportion of energy needs from fat in 24 hours',
    VitaminASerumRetinol10GDL035MolL: 'Vitamin A: Serum retinol < 10 µg/dL (0.35 µmol/L)',
    VitaminCPlasmaConcentrations02MgDL114MolL: 'Vitamin C: Plasma concentrations < 0.2 mg/dL (11.4 µmol/L)',
    VitaminD25Ohd50NmolLIonizedCalcium39MgDL098MmolLWithHighParathyroidHormoneNormalSerumCalciumAndLowSerumPhosphorus26MgDL084MmolL: 'Vitamin D: 25(OH)D <50 nmol/L, ionized calcium < 3.9 mg/dL (0.98 mmol/L) with high parathyroid hormone, normal serum calcium, and low serum phosphorus < 2.6 mg/dL (0.84 mmol/L)',
    VitaminEPlasmaAlphaTocopherol18MolG418MolL: 'Vitamin E: Plasma alpha-tocopherol < 18 µmol/g (41.8 µmol/L)',
    VitaminKProthrombinTimeAlteredInrWithoutAnticoagulationTherapy: 'Vitamin K: Prothrombin time; altered INR (without anticoagulation therapy)',
    ThiaminErythrocyteTransketolaseActivity120GMLH: 'Thiamin: Erythrocyte transketolase activity > 1.20 µg/mL/h',
    RiboflavinErythrocyteGlutathioneReductase12IuGHemoglobin: 'Riboflavin: Erythrocyte glutathione reductase > 1.2 IU/g hemoglobin',
    NiacinNmethylNicotinamideExcretion58MolDay: 'Niacin: N\'methyl-nicotinamide excretion < 5.8 µmol/day',
    VitaminB6PlasmaPryrdoxal5phosphate5NgML20NmolL: 'Vitamin B-6: Plasma pryrdoxal 5\'phosphate <5 ng/mL (20 nmol/L)',
    VitaminB12SerumConcentration244NgDL180PmolLHighHomocysteine: 'Vitamin B-12: Serum concentration < 24.4 ng/dL (180 pmol/L); high homocysteine',
    FolicAcidSerumConcentration03GDL7NmolLRedCellFolate315NmolL: 'Folic acid: Serum concentration < 0.3 µg/dL (7 nmol/L); red cell folate < 315 nmol/L',
    PantothenicAcidLowPlasma: 'Pantothenic acid: Low plasma',
    BiotinLowSerum: 'Biotin: Low serum',
    VitaminANightBlindnessBitotsSpotsXerophthalmiaFollicularHyperkeratosis: 'Vitamin A: night blindness, Bitot\'s spots, xerophthalmia, follicular hyperkeratosis',
    VitaminCFollicularHyperkeratosisPetechiaeEcchymosisCoiledHairsInflamedAndBleedingGumsPerifolicularHemorrhagesJointEffusionsArthralgiaAndImpairedWoundHealing: 'Vitamin C: follicular hyperkeratosis, petechiae, ecchymosis, coiled hairs, inflamed and bleeding gums, perifolicular hemorrhages, joint effusions, arthralgia, and impaired wound healing',
    VitaminDWideningAtEndsOfLongBones: 'Vitamin D: widening at ends of long bones',
    RiboflavinSoreThroatHyperemiaEdemaOfPharyngealAndOralMucousMembranesCheilosisAngularStomatitisGlossitisMagentaTongueSeborrheicDermatitisAndNormochromicNormocyticAnemiaWithPureErythrocyteCytoplasiaOfTheBoneMarrow: 'Riboflavin: sore throat, hyperemia, edema of pharyngeal and oral mucous membranes, cheilosis, angular stomatitis, glossitis, magenta tongue, seborrheic dermatitis, and normochromic, normocytic anemia with pure erythrocyte cytoplasia of the bone marrow',
    NiacinSymmetricalPigmentedRashOnAreasExposedToSunlightBrightRedTongue: 'Niacin: symmetrical, pigmented rash on areas exposed to sunlight; bright red tongue',
    VitaminB6SeborrheicDermatitisStomatitisCheilosisGlossitisConfusionDepression: 'Vitamin B-6: seborrheic dermatitis, stomatitis, cheilosis, glossitis, confusion, depression',
    VitaminB12TinglingAndNumbnessInExtremitiesDiminishedVibratoryAndPositionSenseMotorDisturbancesIncludingGaitDisturbances: 'Vitamin B-12: tingling and numbness in extremities, diminished vibratory and position sense, motor disturbances including gait disturbances',
    PantothenicAcidIrritabilityAndRestlessnessFatigueApathyMalaiseSleepDisturbancesNauseaVomitingAbdominalCrampsNumbnessMuscleCrampsHypoglycemiaSensitivityToInsulin: 'Pantothenic acid: irritability and restlessness, fatigue, apathy, malaise, sleep disturbances, nausea, vomiting, abdominal cramps, numbness, muscle cramps, hypoglycemia, sensitivity to insulin',
    BiotinDermatitisConjunctivitisAlopeciaDepressionLethargyHallucinationsAndParesthesiaHypotoniaDevelopmentalDelays: 'Biotin: dermatitis, conjunctivitis, alopecia, depression, lethargy, hallucinations and paresthesia, hypotonia, developmental delays',
    EstimatedIntakeOfFoodsContainingSpecificVitaminsLessThanRequirementsOrRecommendedLevel: 'Estimated intake of foods containing specific vitamins less than requirements or recommended level',
    IntakeOfFoodsThatDoNotContainAvailableVitaminsEGOverProcessedOvercookedOrImproperlyStoredFoods: 'Intake of foods that do not contain available vitamins (e.g., over processed, overcooked, or improperly stored foods)',
    ProlongedUseOfSubstancesKnownToIncreaseVitaminRequirementsOrReduceVitaminAbsorption: 'Prolonged use of substances known to increase vitamin requirements or reduce vitamin absorption',
    LackOfInterestInFoods: 'Lack of interest in foods',
    ConditionsAssociatedWithADiagnosisOrTreatmentEGMalabsorptionAsAResultOfCeliacDiseaseShortBowelSyndromeOrInflammatoryBowel: 'Conditions associated with a diagnosis or treatment (e.g., malabsorption as a result of celiac disease, short-bowel syndrome, or inflammatory bowel)',
    CertainEnvironmentalConditionsEgInfantsExclusivelyFedBreastmilkWithLimitedExposureToSunlightVitaminD: 'Certain environmental conditions, eg, infants exclusively fed breastmilk with limited exposure to sunlight (Vitamin D)',
    HistoryOfChronicKidneyDiseaseDecreasedConversionOf25Ohd: 'History of chronic kidney disease - decreased conversion of 25(OH)D',
    PrematureInfantExtremelyLowBirthWeightInfantVitaminD: 'Premature infant, extremely low-birth-weight infant (vitamin D)',
    RachiticRosaryInChildrenRicketsOsteomalacia: 'Rachitic rosary in children, rickets, osteomalacia',
    Pellagra: 'Pellagra',
    EstimatedVitaminANeedsIn24Hours: 'Estimated vitamin A needs in 24 hours',
    EstimatedVitaminCNeedsIn24Hours: 'Estimated vitamin C needs in 24 hours',
    EstimatedVitaminDNeedsIn24Hours: 'Estimated vitamin D needs in 24 hours',
    EstimatedVitaminENeedsIn24Hours: 'Estimated vitamin E needs in 24 hours',
    EstimatedVitaminKNeedsIn24Hours: 'Estimated vitamin K needs in 24 hours',
    EstimatedThiaminNeedsIn24Hours: 'Estimated thiamin needs in 24 hours',
    EstimatedRiboflavinNeedsIn24Hours: 'Estimated riboflavin needs in 24 hours',
    EstimatedNiacinNeedsIn24Hours: 'Estimated niacin needs in 24 hours',
    EstimatedFolateNeedsIn24Hours: 'Estimated folate needs in 24 hours',
    EstimatedVitaminB6NeedsIn24Hours: 'Estimated vitamin B6 needs in 24 hours',
    EstimatedVitaminB12NeedsIn24Hours: 'Estimated vitamin B12 needs in 24 hours',
    EstimatedPantothenicAcidNeedsIn24Hours: 'Estimated pantothenic acid needs in 24 hours',
    EstimatedBiotinNeedsIn24Hours: 'Estimated biotin needs in 24 hours',
    MethodForEstimating24HourVitaminNeeds: 'Method for estimating 24 hour vitamin needs',
    CalciumBoneMineralContentBmcLowerThanTheYoungAdultMeanHypocalciuriaSerum25Ohd32NgML: 'Calcium: bone mineral content (BMC) lower than the young adult mean. Hypocalciuria, serum 25(OH)D < 32 ng/mL',
    LowPhosphorus26MgDL084MmolL: 'Low Phosphorus < 2.6 mg/dL (0.84 mmol/L)',
    FerritinInClientWithALowMeanCorpuscularVolumeMcv: 'Ferritin in client with a low Mean Corpuscular Volume (MCV)',
    LowZincPlasma: 'Low Zinc, plasma',
    LowMagnesium18MgDL07MmolL: 'Low Magnesium <1.8 mg/dL (0.7 mmol/L)',
    IronLowHemoglobin13GL2MmolLMales12GL186MmolLFemales: 'Iron: low hemoglobin < 13 g/L (2 mmol/L) (males); < 12 g/L (1.86 mmol/L) (females)',
    IodineLowUrinaryExcretion100GL788NmolL: 'Iodine: low urinary excretion < 100 µg/L (788 nmol/L)',
    CopperLowSerumCopper64GDL10MolL: 'Copper: Low serum copper < 64 µg/dL (10 µmol/L)',
    LowSeleniumPlasma: 'Low Selenium, plasma',
    LowFluoridePlasma: 'Low Fluoride, plasma',
    LowManganeseSerum: 'Low Manganese, serum',
    LowMolybdenumSerum: 'Low Molybdenum, serum',
    LowBoronSerumOrPlasma: 'Low Boron, serum or plasma',
    ChangesInUrineLabsAssociatedWithKidneyStones: 'Changes in urine labs associated with kidney stones',
    CalciumBodyHeightLoss: 'Calcium: body height loss',
    IodineGrowthAbnormalities: 'Iodine: growth abnormalities',
    ChromiumUnintentionalBodyWeightLoss: 'Chromium: unintentional body weight loss',
    CalciumHypertensionAcuteHyperactiveReflexesTetanyMuscleSpasmIrregularHeartRhythm: 'Calcium: hypertension, acute - hyperactive reflexes, tetany, muscle spasm, irregular heart rhythm',
    IronPallorOfFaceMucosaPaleGumsTachycardiaFatigue: 'Iron: pallor of face, mucosa, pale gums, tachycardia, fatigue',
    PotassiumWeaknessConstipationHypoactiveReflexes: 'Potassium - weakness, constipation, hypoactive reflexes',
    PhosphorousFatigueMyalgiaAtaxiaConfusionParasthesias: 'Phosphorous: fatigue, myalgia, ataxia, confusion, parasthesias',
    ZincDysgeusiaPoorWoundHealingSkinLesionsButtocksPerianalAreaMouthNoseEyesAlopecia: 'Zinc: dysgeusia, poor wound healing, skin lesions (buttocks, perianal area, mouth, nose, eyes), alopecia',
    CopperDepigmentationOfHairAndSkinOsteoporosis: 'Copper: depigmentation of hair and skin, osteoporosis',
    SeleniumDepigmentationOfHairAndSkin: 'Selenium:depigmentation of hair and skin',
    IodineEnlargedThyroid: 'Iodine: enlarged thyroid',
    FluorideDentalCaries: 'Fluoride: dental caries',
    ManganeseDermatitis: 'Manganese: dermatitis',
    EstimatedMineralIntakeFromDietLessThanRecommendedIntake: 'Estimated mineral intake from diet less than recommended intake',
    FoodAvoidanceAndOrEliminationOfWholeFoodGroupSFromDiet: 'Food avoidance and/or elimination of whole food group(s) from diet',
    LackOfInterestInFood: 'Lack of interest in food',
    LessThanOptimalFoodChoicesAndOrChronicDietingBehavior: 'Less than optimal food choices and/or chronic dieting behavior',
    CulturalOrReligiousPracticesThatAffectIntake: 'Cultural or religious practices that affect intake',
    ConditionsAssociatedWithADiagnosisOrTreatmentEGMalabsorptionAsAResultOfCeliacDisease: 'Conditions associated with a diagnosis or treatment (e.g., malabsorption as a result of celiac disease)',
    PolycysticOvarySyndromePremenstrualSyndromeKidneyStonesColonPolyps: 'Polycystic ovary syndrome, premenstrual syndrome, kidney stones, colon polyps',
    OtherSignificantMedicalDiagnosesAndTherapies: 'Other significant medical diagnoses and therapies',
    GeographicLatitudeAndHistoryOfUltravioletBExposureUseOfSunscreen: 'Geographic latitude and history of Ultraviolet-B exposure/use of sunscreen',
    ChangeInLivingEnvironmentIndependence: 'Change in living environment/independence',
    CalciumObesity: 'Calcium: obesity',
    EstimatedCalciumNeedsIn24Hours: 'Estimated calcium needs in 24 hours',
    EstimatedChlorideNeedsIn24Hours: 'Estimated chloride needs in 24 hours',
    EstimatedIronNeedsIn24Hours: 'Estimated iron needs in 24 hours',
    EstimatedMagnesiumNeedsIn24Hours: 'Estimated magnesium needs in 24 hours',
    EstimatedPotassiumNeedsIn24Hours: 'Estimated potassium needs in 24 hours',
    EstimatedPhosphorusNeedsIn24Hours: 'Estimated phosphorus needs in 24 hours',
    EstimatedSodiumNeedsIn24Hours: 'Estimated sodium needs in 24 hours',
    EstimatedZincNeedsIn24Hours: 'Estimated zinc needs in 24 hours',
    EstimatedSulfateNeedsIn24Hours: 'Estimated sulfate needs in 24 hours',
    EstimatedFluorideNeedsIn24Hours: 'Estimated fluoride needs in 24 hours',
    EstimatedCopperNeedsIn24Hours: 'Estimated copper needs in 24 hours',
    EstimatedIodineNeedsIn24Hours: 'Estimated iodine needs in 24 hours',
    EstimatedSeleniumNeedsIn24Hours: 'Estimated selenium needs in 24 hours',
    EstimatedManganeseNeedsIn24Hours: 'Estimated manganese needs in 24 hours',
    EstimatedChromiumNeedsIn24Hours: 'Estimated chromium needs in 24 hours',
    EstimatedMolybdenumNeedsIn24Hours: 'Estimated molybdenum needs in 24 hours',
    EstimatedBoronNeedsIn24Hours: 'Estimated boron needs in 24 hours',
    EstimatedCobaltNeedsIn24Hours: 'Estimated cobalt needs in 24 hours',
    MethodForEstimating24HourMineralNeeds: 'Method for estimating 24 hour mineral needs'
} as const;

export type ProblemOptionLabelEnum = typeof ProblemOptionLabelEnum[keyof typeof ProblemOptionLabelEnum];

export interface ProductDetailsResponse {
    'product_id': string;
    'name': string;
    'description': string;
    'variants': Array<ProductVariantDetailsResponse>;
    'categories': Array<CategoryDetailsResponse>;
}
export interface ProductVariantDetailsResponse {
    'variant_id': string;
    'name': string;
    'price': string;
    'image_url': string;
    'options'?: { [key: string]: string; } | null;
    'stock': number;
}
export interface ProfileCuisine {
    /**
     * Unique identifier for this data point
     */
    'slug': string;
    /**
     * Display-friendly name
     */
    'name': string;
}
export interface ProfileDiet {
    /**
     * Unique identifier for this data point
     */
    'slug': string;
    /**
     * Display-friendly name
     */
    'name': string;
}
export interface ProfileIdentity {
    /**
     * Unique identifier for this data point
     */
    'slug': string;
    /**
     * Display-friendly name
     */
    'name': string;
}
export interface ProfileInsurance {
    /**
     * Unique identifier for this data point
     */
    'slug': string;
    /**
     * Display-friendly name
     */
    'name': string;
    /**
     * Internal name for the insurance company
     */
    'internal_name': InsuranceCompany;
}


export interface ProfileLanguage {
    /**
     * Unique identifier for this data point
     */
    'slug': string;
    /**
     * Display-friendly name
     */
    'name': string;
}
export interface ProfileModality {
    /**
     * Unique identifier for this data point
     */
    'slug': string;
    /**
     * Display-friendly name
     */
    'name': string;
    /**
     * Emoji to represent the modality
     */
    'emoji': string;
}
export interface ProfileSpecialty {
    /**
     * Unique identifier for this data point
     */
    'slug': string;
    /**
     * Display-friendly name
     */
    'name': string;
}
export interface ProgressResponse {
    'current_points': number;
    'max_points': number;
    'last_completed_at': string | null;
}
export interface ProviderAvailabilityScheduleResponse {
    'provider_id': string;
    'windows': Array<ProviderAvailabilityWindowResponse>;
}

export const ProviderAvailabilityType = {
    InPerson: 'in_person',
    Virtual: 'virtual'
} as const;

export type ProviderAvailabilityType = typeof ProviderAvailabilityType[keyof typeof ProviderAvailabilityType];


export interface ProviderAvailabilityWindowResponse {
    'provider_availability_window_id': string;
    'start_time': string;
    'end_time': string;
    'day_of_week': DayOfWeek;
    'timezone': string;
    'availability_type': ProviderAvailabilityType;
}


/**
 * Provider\'s business type for tax reporting purposes.
 */

export const ProviderBusinessType = {
    Individual: 'individual',
    Company: 'company'
} as const;

export type ProviderBusinessType = typeof ProviderBusinessType[keyof typeof ProviderBusinessType];


export interface ProviderConfigDetails {
    'provider_config_id': string;
    'provider_id': string;
    'offers_free_consultations': boolean;
    'fay_referrals_disabled': boolean;
    'enable_smart_replies': boolean;
    'audit_proofing_launch_override': string | null;
    'instant_bookings_enabled': boolean;
}
export interface ProviderConfirmationPayload {
    'new_password': string;
}
export interface ProviderConfirmationPreflightResponse {
    'email': string;
    'can_confirm': boolean;
    'cognito_id': string;
}
export interface ProviderDetailsBasicResponse {
    'provider_id': string;
    'full_name': string;
    'supported_booking_insurance_companies': Set<InsuranceCompany>;
    'settings': ProviderSettings;
    'supported_us_states': Array<USState>;
    'primary_practice_address'?: BaseAddress | null;
    'is_admin': boolean;
    'is_test': boolean;
}
export interface ProviderDetailsResponse {
    'provider_id': string;
    'cognito_id': string;
    'first_name': string;
    'last_name': string;
    'preferred_first_name': string;
    'full_name': string;
    'full_legal_name': string;
    'slug': string;
    'email': string;
    'npi': string;
    'timezone': string;
    'sex': Sex | null;
    'pronouns': string | null;
    'phone_number': string | null;
    'avatar_url': string | null;
    'is_admin': boolean;
    'is_churned': boolean;
    'has_ssn': boolean;
    'completed_onboarding_at': string | null;
    'supported_booking_insurance_companies': Set<InsuranceCompany>;
    'supported_billing_insurance_companies': Set<InsuranceCompany>;
    'supported_us_states': Array<USState>;
    'settings': ProviderSettings;
    'provider_config': ProviderConfigDetails;
    'web_presence': ProviderWebPresenceDetails;
    'roles'?: Array<UserRole>;
    'primary_practice_address'?: BaseAddress | null;
    'has_google_business_profile'?: boolean;
    'is_imported': boolean;
}


export interface ProviderFeedbackPayload {
    'comment': string;
    'rating'?: number | null;
}
export interface ProviderForPatientDetailsResponse {
    'provider_id': string;
    'cognito_id': string;
    'first_name': string;
    'last_name': string;
    'preferred_first_name': string;
    'full_name': string;
    'avatar_url': string | null;
    'slug': string;
    'email': string;
    'timezone': string;
    'sex': Sex | null;
    'pronouns': string | null;
    'current': boolean;
    'started_seeing_provider_at': string;
    'is_admin': boolean;
    'is_churned': boolean;
    'is_migrated': boolean;
}


export interface ProviderGoogleBusinessReviewLinkResponse {
    'review_link': string;
}
export interface ProviderId {
}
export interface ProviderId1 {
}
export interface ProviderIdentityDetailsResponse {
    'provider_id': string;
    'cognito_id': string;
    'status': CognitoUserStatus;
    'created_at': string;
}


export interface ProviderInfo {
    'provider_id': string;
    'provider_name': string;
}
export interface ProviderPayoutSettingsResponse {
    'business_type': ProviderBusinessType | null;
    'status': ProviderPayoutSettingsStatus;
    'group_practice_lead_provider_id': string | null;
}


/**
 * Status of provider\'s payout settings and Stripe Connect account.
 */

export const ProviderPayoutSettingsStatus = {
    NotOnboarded: 'not_onboarded',
    Active: 'active',
    RequiresAttention: 'requires_attention'
} as const;

export type ProviderPayoutSettingsStatus = typeof ProviderPayoutSettingsStatus[keyof typeof ProviderPayoutSettingsStatus];


export interface ProviderProfileResponse {
    /**
     * Unique identifier for the provider in the platform.
     */
    'provider_id': string;
    /**
     * The unique slug for this provider in the platform.
     */
    'slug': string;
    /**
     * The full name of the provider, including their trailing credentials. e.g. (John Smith, RD)
     */
    'full_name_and_credentials': string;
    /**
     * URL to the provider booking page
     */
    'booking_url': string;
    /**
     * URL to the provider\'s profile picture
     */
    'photo_url': string;
    /**
     * URL to the provider\'s profile page
     */
    'profile_url': string;
    /**
     * A set of US states that the provider provides care in. Sorted alphabetically.
     */
    'supported_us_states': Array<USState>;
    /**
     * A set of appointment availability types that the provider supports. Sorted alphabetically.
     */
    'availability_types': Array<ProviderAvailabilityType>;
    'address'?: BaseAddress | null;
    'background'?: string | null;
    'approach'?: string | null;
    /**
     * A set of specialties the provider specializes in. Sorted alphabetically.
     */
    'specialties': Array<ProfileSpecialty>;
    /**
     * A set of modalities the provider specializes in. Sorted alphabetically.
     */
    'modalities': Array<ProfileModality>;
    /**
     * A set of insurances the provider accepts. Sorted alphabetically.
     */
    'insurance_accepted': Array<ProfileInsurance>;
    /**
     * A set of identities the provider identifies with. Sorted alphabetically.
     */
    'identities': Array<ProfileIdentity>;
    /**
     * Whether the provider is currently available for instant bookings
     */
    'is_available_now': boolean;
}
/**
 * Enum for sorting provider profiles.
 */

export const ProviderProfileSortOrder = {
    Ranking: 'ranking',
    Availability: 'availability',
    Outcomes: 'outcomes'
} as const;

export type ProviderProfileSortOrder = typeof ProviderProfileSortOrder[keyof typeof ProviderProfileSortOrder];


export interface ProviderProfileValidateFieldRequest {
    /**
     * The profile field to validate.
     */
    'field': ProviderProfileValidateFieldRequestFieldEnum;
    /**
     * The content to validate
     */
    'content': string;
}

export const ProviderProfileValidateFieldRequestFieldEnum = {
    Background: 'background',
    Approach: 'approach'
} as const;

export type ProviderProfileValidateFieldRequestFieldEnum = typeof ProviderProfileValidateFieldRequestFieldEnum[keyof typeof ProviderProfileValidateFieldRequestFieldEnum];

export interface ProviderProfileValidationImageRequest {
    /**
     * The profile image field to validate.
     */
    'field': ProviderProfileValidationImageRequestFieldEnum;
    /**
     * The S3 URI of the image to validate, e.g., \'s3://bucket/key\'
     */
    'uri': string;
}

export const ProviderProfileValidationImageRequestFieldEnum = {
    ProfilePhoto: 'profile_photo'
} as const;

export type ProviderProfileValidationImageRequestFieldEnum = typeof ProviderProfileValidationImageRequestFieldEnum[keyof typeof ProviderProfileValidationImageRequestFieldEnum];

export interface ProviderProfileValidationResponse {
    /**
     * Whether validation succeeded
     */
    'success': boolean;
    'validation_token'?: string | null;
}
export interface ProviderProfilesResponse {
    /**
     * List of provider profiles
     */
    'items'?: Array<ProviderProfileResponse>;
    /**
     * Total number of provider profiles matching the query
     */
    'total': number;
    'next_page'?: number | null;
    'previous_page'?: number | null;
}
/**
 * Public-facing provider rating information.
 */
export interface ProviderPublicRatingResponse {
    'rating': RatingBreakdownResponse | null;
}
/**
 * Public-facing provider reputation information.
 */
export interface ProviderPublicReputationResponse {
    'rating': RatingBreakdownResponse | null;
    /**
     * Public reviews
     */
    'reviews': Array<ProviderReviewResponse>;
    'review_summary': string | null;
}
/**
 * All inputs needed for provider ranking calculation
 */
export interface ProviderRankingAlgorithmInputs {
    'availability_slots': number;
    'occurred_appointments_count': number;
    'occurred_appointments_in_last_30_days': number;
    'practice_optimization_score'?: number | null;
    'weekly_retention'?: number | null;
    'initial_consultation_occurrence_rate'?: number | null;
    'initial_consultation_bookings': number;
    'is_eating_disorder_specialist': boolean;
    'offers_free_consultations': boolean;
    'ranking_score_override'?: number | null;
    'should_boost': boolean;
}
/**
 * Response model containing a provider\'s current ranking factors and computed score
 */
export interface ProviderRankingFactorsResponse {
    'provider_id': string;
    'provider_name': string;
    'algorithm_inputs': ProviderRankingAlgorithmInputs;
}
export interface ProviderRateDetail {
    'payer': InsuranceCompany;
    'hourly_rate': string;
    'is_eligible': boolean;
}


export interface ProviderRatesResponse {
    'rates': { [key: string]: ProviderRateDetail; };
    'is_any_fay_referral_plan_available': boolean;
}
export interface ProviderReferenceDataResponse {
    /**
     * List of primary concerns and their secondary concerns.
     */
    'primary_concerns'?: Array<PrimaryConcern>;
    /**
     * List of provider specialties
     */
    'specialties'?: Array<ProfileSpecialty>;
    /**
     * List of provider modalities
     */
    'modalities'?: Array<ProfileModality>;
    /**
     * List of insurance companies
     */
    'insurances'?: Array<ProfileInsurance>;
    /**
     * List of identities
     */
    'identities'?: Array<ProfileIdentity>;
    /**
     * List of diet types
     */
    'diets'?: Array<ProfileDiet>;
    /**
     * List of cuisine types
     */
    'cuisines'?: Array<ProfileCuisine>;
    /**
     * List of languages
     */
    'languages'?: Array<ProfileLanguage>;
}
export interface ProviderReputationResponse {
    'average_rating': string | null;
    'rating': RatingBreakdownResponse | null;
    'reviews'?: Array<ProviderReviewResponse>;
    'review_summary': string | null;
    'has_google_business_profile'?: boolean;
}
export interface ProviderReviewResponse {
    /**
     * Name of the reviewer
     */
    'reviewer_name': string;
    'reviewer_avatar_url': string | null;
    /**
     * Content of the review
     */
    'content': string;
    'star_rating': number | null;
    /**
     * Date when the review was created
     */
    'date_created': string;
}
export interface ProviderSenderResponse {
    'display_name': string;
    'preferred_first_name': string;
    'last_name': string;
    'avatar_url': string | null;
    'cognito_id': string;
    'type'?: ProviderSenderResponseTypeEnum;
    'provider_id': string;
    'slug': string;
}

export const ProviderSenderResponseTypeEnum = {
    Provider: 'provider'
} as const;

export type ProviderSenderResponseTypeEnum = typeof ProviderSenderResponseTypeEnum[keyof typeof ProviderSenderResponseTypeEnum];

export interface ProviderSettings {
    'minimum_advance_schedule_time'?: number;
    'max_days_in_future'?: number;
}
export interface ProviderWebPresenceDetails {
    'instagram': Instagram;
    'tiktok': Tiktok;
    'website': Website;
    'google_business_location_id': GoogleBusinessLocationId;
    'google_business_place_id': GoogleBusinessPlaceId;
}
export interface RankingCalculationConfig {
    /**
     * Maximum number of appointments in the last 30 days to consider for ranking
     */
    'thirty_day_max_appointment_count': number;
    /**
     * Minimum initial consultation occurrence rate to consider for ranking. If the initial consultation occurrence rate is below this value, the provider will be deprioritized.
     */
    'initial_consultation_occurrence_rate_minimum': number;
    /**
     * Threshold for low retention. If the weekly retention is below this value, the provider will be considered low retention.
     */
    'low_retention_threshold': number;
    /**
     * Threshold for low retention for eating disorder specialists. If the weekly retention is below this value, the provider will be considered low retention.
     */
    'low_retention_ed_threshold': number;
    /**
     * If the provider has fewer appointments than this threshold, they will be boosted to the top of the rankings.
     */
    'boost_appointment_threshold': number;
    /**
     * Adjustment to the score for eating disorder specialists. This is added to the base score if the provider is an eating disorder specialist.
     */
    'ed_specialist_adjustment': number;
    /**
     * Threshold for medium availability. If the provider has more than this number of availability slots, they are considered to have medium availability.
     */
    'medium_availability_threshold': number;
    /**
     * Threshold for high availability. If the provider has more than this number of availability slots, they are considered to have high availability.
     */
    'high_availability_threshold': number;
    /**
     * Minimum new client bookings before using initial consultation occurrence rate for deranking.
     */
    'min_new_client_bookings_for_initial_consultation_check'?: number;
}
/**
 * Features that can be toggled during ranking calculations
 */
export interface RankingCalculationFeatures {
    /**
     * Activate behavior that models the uncertainty around the score. The lower the appointment count, the more uncertain the algorithm is about the \'true\' base score.
     */
    'use_exploratory_model'?: boolean;
    /**
     * Randomize the scores of boosted providers to shuffle them within the boosted group.
     */
    'shuffle_boosted_providers'?: boolean;
    /**
     * If True, deprioritized providers will be set to the minimum score of their group. If False, they will be set to the deprioritization threshold.
     */
    'set_deprioritized_to_group_minimum'?: boolean;
    /**
     * Override the composite score to be on top of the rankings if the provider is under 2 appointments
     */
    'boost_under_appointment_threshold'?: boolean;
    /**
     * If True, providers with high appointment counts and low retention will be deprioritized.
     */
    'deprioritize_high_volume_providers'?: boolean;
}
/**
 * Response model containing current live ranking configuration
 */
export interface RankingConfigurationResponse {
    /**
     * Current dynamic configuration values
     */
    'dynamic_config': RankingCalculationConfig;
    /**
     * Current feature flag values for ranking
     */
    'feature_flags': RankingCalculationFeatures;
}
/**
 * Request model for testing ranking calculations with custom parameters
 */
export interface RankingExperimentRequest {
    'algorithm_inputs': ProviderRankingAlgorithmInputs;
    /**
     * Configuration values (e.g., \'thirty_day_max_appointment_count\': 15)
     */
    'config': RankingCalculationConfig;
    /**
     * Feature flags (e.g., \'use_exploratory_model\': True)
     */
    'features': RankingCalculationFeatures;
    /**
     * Number of samples for distribution
     */
    'sample_size'?: number;
}
/**
 * Response model containing ranking calculation results and distribution analysis
 */
export interface RankingExperimentResponse {
    /**
     * Single computed score for the given inputs (non-randomized)
     */
    'single_score': number;
    /**
     * Array of sampled scores showing distribution
     */
    'sample_scores': Array<number>;
    /**
     * Statistical summary of the distribution
     */
    'statistics': { [key: string]: number; };
    /**
     * Histogram data for visualization
     */
    'histogram_buckets': Array<{ [key: string]: RankingExperimentResponseHistogramBucketsInnerValue; }>;
    /**
     * Final configuration values used in calculation
     */
    'config_used': { [key: string]: ConfigUsedValue; };
    /**
     * Final feature flags used in calculation
     */
    'features_used': { [key: string]: boolean; };
}
export interface RankingExperimentResponseHistogramBucketsInnerValue {
}
/**
 * Breakdown of ratings by star level.
 */
export interface RatingBreakdownResponse {
    /**
     * Average rating
     */
    'average': string;
    /**
     * Number of 1-star ratings
     */
    'one_star': number;
    /**
     * Number of 2-star ratings
     */
    'two_star': number;
    /**
     * Number of 3-star ratings
     */
    'three_star': number;
    /**
     * Number of 4-star ratings
     */
    'four_star': number;
    /**
     * Number of 5-star ratings
     */
    'five_star': number;
    /**
     * Total number of ratings submitted
     */
    'total_submissions': number;
}
export interface RecipeResponse {
    /**
     * The name of the recipe
     */
    'name': string;
    /**
     * The ingredients of the recipe
     */
    'ingredients': Array<string>;
    /**
     * The steps of the recipe
     */
    'steps': Array<string>;
    'image_url': string | null;
}
export interface Recipient {
    'recipient_type': RecipientType;
    'recipient_id': string;
}



export const RecipientType = {
    Patient: 'patient',
    Provider: 'provider',
    Email: 'email',
    Phone: 'phone',
    ExternalProvider: 'external_provider',
    Employer: 'employer'
} as const;

export type RecipientType = typeof RecipientType[keyof typeof RecipientType];



export const RecurrenceType = {
    Weekly: 'Weekly',
    Monthly: 'Monthly',
    BiWeekly: 'Bi-weekly'
} as const;

export type RecurrenceType = typeof RecurrenceType[keyof typeof RecurrenceType];


export interface RecurringDonationResponse {
    'amount': string;
    'status': DonationStatusResponse;
    'next_billing_date'?: string | null;
}


export interface ReferralCapabilities {
    'max_tier_share_count'?: number;
}
export interface ReferralSource {
    'source_type': ReferralSourceType;
    'source_id': SourceId;
}



export const ReferralSourceType = {
    Fay: 'fay',
    Provider: 'provider',
    Partner: 'partner',
    ShareASaleAffiliate: 'share_a_sale_affiliate',
    AmazonHbcReferral: 'amazon_hbc_referral',
    WithingsReferral: 'withings_referral'
} as const;

export type ReferralSourceType = typeof ReferralSourceType[keyof typeof ReferralSourceType];


export interface RegisterPatientPayload {
    'first_name': string;
    'last_name': string;
    'email': string;
    'sex'?: Sex | null;
    'date_of_birth'?: string | null;
    'phone_number'?: string | null;
    'timezone': string;
    'height'?: HeightFieldInput | null;
    'weight'?: WeightFieldInput | null;
    'enrollment_reason'?: string | null;
    'enrollment_tags'?: Set<EnrollmentTags> | null;
    'discovery_source'?: PatientDiscoverySource | null;
}



export const RegisterPatientReferralType = {
    ProviderClientReferralImpressionToken: 'provider_client_referral_impression_token',
    LevelsReferralToken: 'levels_referral_token',
    ShareASaleAffiliateReferralId: 'share_a_sale_affiliate_referral_id',
    AmazonHbcReferralCustomerId: 'amazon_hbc_referral_customer_id',
    WithingsReferralWithingsUserId: 'withings_referral_withings_user_id'
} as const;

export type RegisterPatientReferralType = typeof RegisterPatientReferralType[keyof typeof RegisterPatientReferralType];


export interface RegisterProviderPayload {
    'provider_id'?: string | null;
    'cognito_id'?: string | null;
    'first_name': string;
    'last_name': string;
    'slug'?: string | null;
    'email': string;
    'npi': string;
    'timezone': string;
    /**
     * Is the provider a Fay Staff admin?
     */
    'is_admin'?: boolean;
    /**
     * Is the provider a test provider?
     */
    'is_test'?: boolean;
}
export interface RejectMRRSubmissionsPayload {
    'medical_record_request_submission_ids'?: Array<string>;
    'rejection_reason': string;
}
export interface RejectMRRSubmissionsResponse {
    'success': boolean;
    'failed_submissions'?: Array<FailedSubmission>;
}
export interface ReleaseOfInformationPayload {
    'authorized': boolean;
    'release_form_preview_url'?: string | null;
    'version'?: number | null;
}
/**
 * Payload for reserving an appointment slot.
 */
export interface ReserveSlotPayload {
    'email': string;
    'provider_id': string;
    'start_time': string;
    'end_time': string;
}
/**
 * Response returned when a slot is successfully reserved.
 */
export interface ReserveSlotResponse {
    'reservation_id': string;
    'reservation_jwt': string;
    'expires_at': string;
    'start_time': string;
    'end_time': string;
}
export interface ResetPasswordResponse {
    'challenge_id': string;
    'expires_at': string;
    'cooldown_expires_at': string;
    'password_changed'?: boolean;
    'username'?: string | null;
}

export const ResubmissionCode = {
    NUMBER_1: 1,
    NUMBER_7: 7,
    NUMBER_8: 8,
    NUMBER_9: 9
} as const;

export type ResubmissionCode = typeof ResubmissionCode[keyof typeof ResubmissionCode];


export interface ResubmitClaimsFromSpecificationsPayload {
    'claims': Array<APIClaimSpecificationInput>;
}
export interface ResubmitClaimsResponse {
    'resubmitted_claim_ids': Array<string>;
}
export interface RewardResponse {
    'reward_id': string;
    /**
     * Type of reward, e.g., DIAMOND_PERIWINKLE
     */
    'reward_type': RewardType;
    'is_claimed': boolean;
    'source_type': RewardSourceType;
    'source_id': string;
    'granted_at': string;
    'is_spent': boolean;
}



export const RewardSourceType = {
    Appointment: 'appointment',
    Progress: 'progress',
    Challenge: 'challenge',
    SharedContent: 'shared_content',
    NewPatient: 'new_patient'
} as const;

export type RewardSourceType = typeof RewardSourceType[keyof typeof RewardSourceType];



export const RewardType = {
    DiamondBlack: 'DIAMOND_BLACK',
    DiamondBubblegum: 'DIAMOND_BUBBLEGUM',
    DiamondCanary: 'DIAMOND_CANARY',
    DiamondEmerald: 'DIAMOND_EMERALD',
    DiamondFire: 'DIAMOND_FIRE',
    DiamondGolden: 'DIAMOND_GOLDEN',
    DiamondIce: 'DIAMOND_ICE',
    DiamondPeriwinkle: 'DIAMOND_PERIWINKLE',
    StarEmerald: 'STAR_EMERALD',
    StarFire: 'STAR_FIRE',
    StarGolden: 'STAR_GOLDEN',
    StarPeriwinkle: 'STAR_PERIWINKLE'
} as const;

export type RewardType = typeof RewardType[keyof typeof RewardType];



export const Role = {
    User: 'user',
    Assistant: 'assistant'
} as const;

export type Role = typeof Role[keyof typeof Role];


export interface ScribeResponse {
    'in_progress': boolean;
    'note': string | null;
}
export interface SecondaryConcern {
    'primary_concern_slug': PrimaryConcernSlug;
    'slug': string;
    'name': string;
    'extra_specialties'?: Array<string> | null;
    'include_primary_concern_specialties'?: boolean;
    'show_primary_as_provider_match'?: boolean;
}


export interface SeenAnnouncementPayload {
    'announcement_type': AnnouncementType;
}


export interface SendChatMessagePayload {
    'content': string;
    'content_type': ChatMessageContentTypeResponse;
    'attachments'?: Array<ChatMessageAttachmentPayload>;
    'chat_completion_id'?: string | null;
}


export interface SendClientReferralSMSPayload {
    'phone_number': string;
}
export interface SendMRRSubmissionsResponse {
    'init_success': boolean;
    'failed_submissions'?: Array<FailedSubmission>;
}
export interface SetupPatientAndBookAppointmentAddressDetails {
    'line1': string;
    'line2'?: string | null;
    'city': string;
    'state': string;
    'postal_code': string;
}
export interface SetupPatientAndBookAppointmentAnalyticsDetails {
    'utm_parameters'?: Array<UTMParameter>;
}
export interface SetupPatientAndBookAppointmentAppointmentDetails {
    'start': string;
    'enrollment_reason'?: string | null;
    'tags'?: Set<EnrollmentTags> | null;
    'location_type'?: AppointmentLocationType;
}


export interface SetupPatientAndBookAppointmentInsuranceDetails {
    'payer': InsuranceCompany;
    'policy_number': string;
}


export interface SetupPatientAndBookAppointmentPayload {
    'personal': SetupPatientAndBookAppointmentPersonalDetails;
    'appointment': SetupPatientAndBookAppointmentAppointmentDetails;
    'provider': SetupPatientAndBookAppointmentProviderDetails;
    'payment'?: SetupPatientAndBookAppointmentPaymentDetails | null;
    'insurance'?: SetupPatientAndBookAppointmentInsuranceDetails | null;
    'address'?: SetupPatientAndBookAppointmentAddressDetails | null;
    'analytics'?: SetupPatientAndBookAppointmentAnalyticsDetails | null;
    'referral'?: SetupPatientAndBookAppointmentReferralDetails | null;
    'quiz_flow_data'?: object | null;
}
export interface SetupPatientAndBookAppointmentPaymentDetails {
    'stripe_customer_id'?: string | null;
    'stripe_payment_method_id'?: string | null;
}
export interface SetupPatientAndBookAppointmentPersonalDetails {
    'new_account': boolean;
    'email': string;
    'timezone': string;
    'weight'?: Weight | null;
    'height'?: Height | null;
    'first_name'?: string | null;
    'last_name'?: string | null;
    'date_of_birth'?: string | null;
    'sex'?: Sex | null;
    'phone_number'?: string | null;
    'discovery_source'?: PatientDiscoverySource | null;
    'booking_code_id'?: string | null;
}


export interface SetupPatientAndBookAppointmentProviderDetails {
    'provider_id': string;
}
export interface SetupPatientAndBookAppointmentReferralDetails {
    'referral_code': string;
    'referral_type': RegisterPatientReferralType;
}


export interface SetupPatientAndBookAppointmentResponse {
    'appointment_id': string;
    'zoom_join_url': string | null;
    'start_time': string;
    'end_time': string;
    'appointment_description': string;
    'location_type': AppointmentLocationType;
    'location': string | null;
    'ics_data': string;
    'add_to_google_calendar_url': string;
    'add_to_outlook_url': string;
    'patient_id': string;
    'new_account': boolean;
}


export interface SetupPaymentInfo {
    'email': string;
    'first_name': string;
    'last_name': string;
}
export interface SetupPaymentMethodPayload {
    'setup_info'?: SetupPaymentInfo | null;
}
export interface SetupPaymentMethodResponse {
    'stripe_customer_id': string;
    'client_secret': string;
}

export const Sex = {
    Male: 'Male',
    Female: 'Female',
    Other: 'Other',
    PreferNotToSay: 'Prefer not to say'
} as const;

export type Sex = typeof Sex[keyof typeof Sex];



export const SharedContentDestination = {
    Instagram: 'Instagram',
    TikTok: 'TikTok',
    Sms: 'SMS'
} as const;

export type SharedContentDestination = typeof SharedContentDestination[keyof typeof SharedContentDestination];



export const SharedContentEventType = {
    Prize: 'Prize',
    StreakEntry: 'StreakEntry',
    AppointmentBooked: 'AppointmentBooked',
    AppointmentRescheduled: 'AppointmentRescheduled',
    JournalEntrySubmitted: 'JournalEntrySubmitted',
    DiamondEarnedGoal: 'DiamondEarnedGoal',
    DiamondEarnedChallenge: 'DiamondEarnedChallenge',
    ChallengeProgress: 'ChallengeProgress',
    DiamondEarnedShareBonus: 'DiamondEarnedShareBonus'
} as const;

export type SharedContentEventType = typeof SharedContentEventType[keyof typeof SharedContentEventType];


export interface SharedContentPayload {
    'destination': SharedContentDestination;
    'event_type': SharedContentEventType;
    'event_id': string;
}


export interface SharedReferralPayload {
    'destination': SharedContentDestination;
    'event_type': SharedContentEventType;
    'referral_capabilities': ReferralCapabilities;
}


export interface SharedReferralResponse {
    'updated_patient_referrer_profile': PatientReferrerProfileResponse;
    'has_new_tier': boolean;
}
export interface ShippingAddress {
    'line1': string;
    'line2'?: string | null;
    'city': string;
    'state': USState;
    'postal_code': string;
    'country'?: string;
    'first_name': string;
    'last_name': string;
    'phone_number': string;
    'email': string;
}


export interface SignatureResponse {
    'signed_at': string;
    'signer_name': string;
    'signer_initials': string;
}
export interface SolicitProviderReviewPayload {
    'patient_id'?: string | null;
    'phone_number'?: string | null;
    'message_content': string;
}

export const SortOrdering = {
    Ascending: 'ASCENDING',
    Descending: 'DESCENDING'
} as const;

export type SortOrdering = typeof SortOrdering[keyof typeof SortOrdering];


export interface SourceId {
    'name': PartnerName;
    'code': string;
}


export interface StartDate {
}
export interface StreakSummaryResponse {
    /**
     * Total number of journal entries in the consecutive day streak.
     */
    'streak_count': number;
    /**
     * Consecutive days of journaling. Resets to 0if the patient has not journaled today or yesterday.
     */
    'consecutive_days': number;
    'start_date': string | null;
    /**
     * The weekly streak display ([M ✅ , T ✅ , W...]). If there is no streak, an array starting with today in the patient\'s timezone will be returned.
     */
    'weekly_streak_display': Array<WeeklyStreakDisplayResponse>;
    /**
     * Total points accumulated in the current streak.
     */
    'total_points': number;
}
export interface StripePaymentDetails {
    'payment_type': CardSource;
    'stripe_code': string;
}


export interface Subject {
    'subject_type': SubjectType;
    'subject_id': string;
}



export const SubjectType = {
    Appointment: 'appointment',
    ChatChannel: 'chat_channel',
    ChatChannelFay: 'chat_channel_fay',
    PatientCharge: 'patient_charge',
    Patient: 'patient',
    PartnerBooking: 'partner_booking',
    Provider: 'provider',
    ProviderInvite: 'provider_invite',
    RecurringDonationCharge: 'recurring_donation_charge',
    RecurringDonation: 'recurring_donation',
    MealPlan: 'meal_plan',
    EmployerEligibilityFile: 'employer_eligibility_file',
    Challenge: 'challenge',
    Claim: 'claim',
    Prize: 'prize',
    ProviderImport: 'provider_import',
    PatientImport: 'patient_import'
} as const;

export type SubjectType = typeof SubjectType[keyof typeof SubjectType];


export interface SuggestChatResponsePayload {
    'patient_id': string;
}
export interface SuggestChatResponseResponse {
    'response': string;
    'appointment_id_to_reschedule'?: string | null;
    'chat_completion_id': string;
}
export interface SweepstakesExpirationResponse {
    'expiration_date': string | null;
}
export interface SyncProviderDetailsRequest {
    'business_type'?: ProviderBusinessType | null;
}


export interface SyncedCalendarEventDetailsResponse {
    'synced_calendar_event_id': string;
    'synced_calendar_id': string;
    'ical_uid': string;
    'source_calendar_event_id': string;
    'source': SyncedCalendarSource;
    'synced_event_url': string | null;
    'is_busy': boolean;
    'is_cancelled': boolean;
}



export const SyncedCalendarSource = {
    Google: 'google'
} as const;

export type SyncedCalendarSource = typeof SyncedCalendarSource[keyof typeof SyncedCalendarSource];


export interface Tiktok {
}
export interface Tiktok1 {
}
export interface TotalCalories {
}
export interface TotalFluids {
}
export interface TotalProtein {
}

export const USState = {
    Al: 'AL',
    Ak: 'AK',
    Az: 'AZ',
    Ar: 'AR',
    Ca: 'CA',
    Co: 'CO',
    Ct: 'CT',
    De: 'DE',
    Fl: 'FL',
    Ga: 'GA',
    Hi: 'HI',
    Id: 'ID',
    Il: 'IL',
    In: 'IN',
    Ia: 'IA',
    Ks: 'KS',
    Ky: 'KY',
    La: 'LA',
    Me: 'ME',
    Md: 'MD',
    Ma: 'MA',
    Mi: 'MI',
    Mn: 'MN',
    Ms: 'MS',
    Mo: 'MO',
    Mt: 'MT',
    Ne: 'NE',
    Nv: 'NV',
    Nh: 'NH',
    Nj: 'NJ',
    Nm: 'NM',
    Ny: 'NY',
    Nc: 'NC',
    Nd: 'ND',
    Oh: 'OH',
    Ok: 'OK',
    Or: 'OR',
    Pa: 'PA',
    Ri: 'RI',
    Sc: 'SC',
    Sd: 'SD',
    Tn: 'TN',
    Tx: 'TX',
    Ut: 'UT',
    Vt: 'VT',
    Va: 'VA',
    Wa: 'WA',
    Wv: 'WV',
    Wi: 'WI',
    Wy: 'WY',
    As: 'AS',
    Dc: 'DC',
    Gu: 'GU',
    Mp: 'MP',
    Pr: 'PR',
    Vi: 'VI',
    Aa: 'AA',
    Ae: 'AE',
    Ap: 'AP'
} as const;

export type USState = typeof USState[keyof typeof USState];


export interface UTMParameter {
    'parameter_name': string;
    'parameter_value': string;
}
export interface UpcomingAppointmentSummary {
    'appointment_id': string;
    'patient_id': string;
    'provider_id': string;
    'start_time': string;
    'end_time': string;
    'recurrence_type'?: RecurrenceType | null;
    'duration': number;
}


export interface UpdateAddressPayload {
    'line1': string;
    'line2'?: string | null;
    'city': string;
    'state': string;
    'postal_code': string;
    'country': string;
}
export interface UpdateAppointmentPayload {
    'status'?: APIAppointmentStatus | null;
    'start'?: string | null;
    'duration_in_minutes'?: number | null;
    'appointment_type'?: APIAppointmentType | null;
    'location_type'?: AppointmentLocationType;
}


export interface UpdateBookingCodePayload {
    'description'?: string | null;
    'is_active'?: boolean | null;
}
export interface UpdateCalendarEventPayload {
    'title'?: string | null;
    'start'?: string | null;
    'end'?: string | null;
}
export interface UpdateCartItemPayload {
    'quantity': number;
}
export interface UpdateChartNoteClinicalFormPayload {
    'patient_usual_body_weight'?: PatientUsualBodyWeight | null;
    'patient_ideal_body_weight'?: PatientIdealBodyWeight | null;
    'patient_weight_increased': boolean;
    'patient_weight_decreased': boolean;
    'patient_weight_change_notes'?: string | null;
    'patient_24_hour_recall'?: string | null;
    'patient_appetite'?: string | null;
    'patient_food_allergies'?: string | null;
    'patient_food_preferences'?: string | null;
    'patient_adaptive_devices'?: string | null;
    'patient_difficulty_chewing_swallowing'?: string | null;
    'patient_feeding_assistance'?: string | null;
    'patient_medical_conditions'?: string | null;
    'patient_lab_results'?: string | null;
    'patient_medications'?: string | null;
    'orbital_fat_assessment': ClinicalFormFatAssessment;
    'triceps_fat_assessment': ClinicalFormFatAssessment;
    'overlying_ribs_fat_assessment': ClinicalFormFatAssessment;
    'temple_mass_assessment': ClinicalFormMassAssessment;
    'pectoralis_mass_assessment': ClinicalFormMassAssessment;
    'shoulder_mass_assessment': ClinicalFormMassAssessment;
    'back_mass_assessment': ClinicalFormMassAssessment;
    'hand_mass_assessment': ClinicalFormMassAssessment;
    'thigh_mass_assessment': ClinicalFormMassAssessment;
    'patient_physical_appearance'?: string | null;
    'patient_hydration_status'?: string | null;
    'patient_malnutrition_status'?: string | null;
    'total_calories'?: TotalCalories | null;
    'total_calories_estimation_method'?: string | null;
    'total_protein'?: TotalProtein | null;
    'total_protein_estimation_method'?: string | null;
    'total_fluids'?: TotalFluids | null;
    'total_fluids_estimation_method'?: string | null;
    'current_intake_meets_estimated_needs'?: boolean | null;
    'estimated_nutrition_needs_notes'?: string | null;
    'nutrition_diagnosis_problem'?: ClinicalFormNutritionDiagnosisProblem | null;
    'nutrition_diagnosis_problem_etiology'?: Array<ClinicalFormNutritionDiagnosisEtiology> | null;
    'nutrition_diagnosis_symptoms'?: Array<ClinicalFormNutritionDiagnosisSymptom> | null;
    'smart_goals'?: Array<string> | null;
    'care_plan_updated_for_nutrition_goals': boolean;
    'interventions'?: Array<ClinicalFormNutritionIntervention> | null;
    'additional_interventions'?: string | null;
    'metrics_to_monitor'?: string | null;
    'follow_up_appointment_id'?: string | null;
}


export interface UpdateChartNotePayload {
    'note'?: string | null;
    'clinical_form'?: UpdateChartNoteClinicalFormPayload | null;
    'is_attempting_signing'?: boolean;
}
export interface UpdateChatCompletionFeedbackPayload {
    'binary_feedback'?: boolean | null;
    'feedback_text'?: string | null;
}
export interface UpdateClientDetailsPayload {
    'billable_units': number;
    'summary': string;
}
export interface UpdateGoalPayload {
    'title': string;
}
export interface UpdateIdentityResponse {
    'challenge_id': string;
    'expires_at': string;
    'cooldown_expires_at': string;
    'updated_login'?: boolean;
}
export interface UpdateInsurancePolicyPayload {
    'policy_number': string;
    'payer': InsuranceCompany;
}


export interface UpdateIntakePayload {
    'intake_form_answers'?: IntakeFormAnswerList | null;
    'intake_form_version'?: IntakeFormVersion;
    'external_providers'?: ExternalProviderList | null;
    'gender'?: Gender | null;
    'pronouns'?: string | null;
    'profession'?: string | null;
    'work_email'?: string | null;
    'student_email'?: string | null;
}


export interface UpdateJournalEntryFilePayload {
    'file_key': string;
}
export interface UpdateJournalEntryPayload {
    'content'?: string | null;
    'files'?: Array<UpdateJournalEntryFilePayload> | null;
    'occurred_at'?: string | null;
    'current_timezone'?: string | null;
    'is_private'?: boolean | null;
}
export interface UpdateMealPayload {
    /**
     * The updated recipe details
     */
    'recipe': UpdateRecipePayload;
}
export interface UpdatePatientPayload {
    'first_name'?: string | null;
    'last_name'?: string | null;
    'preferred_first_name'?: string | null;
    'email'?: string | null;
    'date_of_birth'?: string | null;
    'phone_number'?: string | null;
    'sex'?: Sex | null;
    'pronouns'?: string | null;
    'height'?: HeightFieldInput | null;
    'weight'?: WeightFieldInput | null;
    'avatar_url'?: string | null;
    'timezone'?: string | null;
    'enrollment_reason'?: string | null;
    'insurance_policy'?: UpdateInsurancePolicyPayload | null;
    'mailing_address'?: UpdateAddressPayload | null;
    'disallow_eligible_override'?: boolean | null;
}


export interface UpdateProviderAvailabilitySchedulePayload {
    'windows': Array<UpdateProviderAvailabilityScheduleWindowPayload>;
}
export interface UpdateProviderAvailabilityScheduleWindowPayload {
    'day_of_week': DayOfWeek;
    'start_time': string;
    'end_time': string;
    'availability_type'?: ProviderAvailabilityType;
}


export interface UpdateProviderAvailabilityTypesPayload {
    'updates': Array<AvailabilityTypeUpdatePayload>;
}
export interface UpdateProviderConfigPayload {
    'offers_free_consultations'?: boolean | null;
    'fay_referrals_disabled'?: boolean | null;
    'enable_smart_replies'?: boolean | null;
    'instant_bookings_enabled'?: boolean | null;
}
export interface UpdateProviderPayload {
    'preferred_first_name'?: string | null;
    'first_name'?: string | null;
    'last_name'?: string | null;
    'email'?: string | null;
    'sex'?: Sex | null;
    'pronouns'?: string | null;
    'phone_number'?: string | null;
    'timezone'?: string | null;
    'ssn'?: string | null;
    'provider_config'?: UpdateProviderConfigPayload | null;
    'web_presence'?: UpdateWebPresencePayload | null;
}


export interface UpdateProviderPayoutSettingsRequest {
    'group_practice_lead_provider_id'?: string | null;
}
/**
 * Payload for creating or replacing a provider\'s profile.
 */
export interface UpdateProviderProfilePayload {
    /**
     * Provider\'s background
     */
    'background': ValidatedTextFieldPayload;
    /**
     * Provider\'s approach
     */
    'approach': ValidatedTextFieldPayload;
    /**
     * List of specialty slugs (minimum 5 required)
     */
    'specialties': Array<string>;
    /**
     * List of modality slugs (minimum 5 required)
     */
    'modalities': Array<string>;
    /**
     * List of diet slugs
     */
    'diets'?: Array<string>;
    /**
     * List of cuisine slugs
     */
    'cuisines'?: Array<string>;
    /**
     * List of identity slugs
     */
    'identities'?: Array<string>;
    /**
     * List of language slugs
     */
    'languages'?: Array<string>;
    /**
     * List of availability types (in_person, virtual)
     */
    'availability_types': Array<ProviderAvailabilityType>;
}
/**
 * Response for provider profile update.
 */
export interface UpdateProviderProfileResponse {
    'provider_id': string;
    'message'?: string;
}
export interface UpdateRecipePayload {
    /**
     * The name of the recipe
     */
    'name': string;
    /**
     * The ingredients of the recipe
     */
    'ingredients': Array<string>;
    /**
     * The steps of the recipe
     */
    'steps': Array<string>;
}
export interface UpdateRecurringDonationPayload {
    'amount': Amount;
}
export interface UpdateSettingPayload {
    'is_enabled': boolean;
}
export interface UpdateSettingResponse {
    'is_enabled': boolean;
}
export interface UpdateWebPresencePayload {
    'instagram'?: Instagram1 | null;
    'tiktok'?: Tiktok1 | null;
    'website'?: Website1 | null;
}
export interface UploadPatientLabPayload {
    'document_s3_key': string;
    'intended_provider_id': string;
}
/**
 * Defines the roles that a user can have in order to determine their permissions.  For now, we only have roles for admin providers, but we are likely to add additional roles as the system evolves. As we migrate towards role-based permissions, note that permissions may be implicitly granted (by default) to admin users.
 */

export const UserRole = {
    BillingOperations: 'billing_operations'
} as const;

export type UserRole = typeof UserRole[keyof typeof UserRole];



export const UserType = {
    Provider: 'provider',
    Patient: 'patient',
    Machine: 'machine'
} as const;

export type UserType = typeof UserType[keyof typeof UserType];


export interface ValidateAmazonSessionPayload {
    'session_id': string;
    'b64_customer_id': string;
}
export interface ValidateAmazonSessionResponse {
    'valid': boolean;
    'customer_jwt'?: string | null;
}
/**
 * A text field bundled with its validation token.
 */
export interface ValidatedTextFieldPayload {
    /**
     * The text content
     */
    'value': string;
    /**
     * JWT validation token for the field
     */
    'token': string;
}
export interface ValidationError {
    'loc': Array<ValidationErrorLocInner>;
    'msg': string;
    'type': string;
}
export interface ValidationErrorItem {
    'input': string;
    'loc': Array<string>;
    'msg': string;
    'type': string;
}
export interface ValidationErrorLocInner {
}
export interface ValidationErrorResponse {
    'detail': Array<ValidationErrorItem>;
}
export interface Value {
}
export interface VerifyPaymentMethodPayload {
    'stripe_token': string;
    'card_source': CardSource;
    'first_name': string;
    'last_name': string;
    'email': string;
    'stripe_customer_id'?: string | null;
}


export interface VerifyPaymentMethodResponse {
    'stripe_customer_id': string;
    'payment_method_id': string | null;
    'error'?: string | null;
}
export interface VerifyTokenPayload {
    'token': string;
}
export interface VerifyTokenResponse {
    'is_valid': boolean;
}
export interface VoucherResponse {
    'voucher_id': string;
    'value_amount': string;
    'voucher_link'?: string | null;
    'redemption_code'?: string | null;
    'created_at': string;
    'assigned_at'?: string | null;
    'prize_id'?: string | null;
}
export interface Website {
}
export interface Website1 {
}
export interface WeeklyStreakDisplayResponse {
    /**
     * The day of the week for this streak display item.
     */
    'label': string;
    /**
     * Indicates whether this day is part of the current streak.
     */
    'filled': boolean;
    /**
     * Indicates whether this day should be animated when displayed.
     */
    'animate_in': boolean;
}
export interface Weight {
}
export interface WeightFieldInput {
    'unit': WeightUnits;
    'value': Value;
}


export interface WeightFieldOutput {
    'unit': WeightUnits;
    'value': string;
}



export const WeightUnits = {
    Pounds: 'pounds',
    Kilograms: 'kilograms'
} as const;

export type WeightUnits = typeof WeightUnits[keyof typeof WeightUnits];


export interface WithingsReferralImpressionPayload {
    'withings_token': string;
    'has_withings_plus': boolean;
}
export interface WithingsReferralPrefillResponse {
    'withings_user_id'?: string | null;
    'has_withings_plus'?: boolean | null;
    'first_name'?: string | null;
    'last_name'?: string | null;
    'email_address'?: string | null;
    'phone'?: string | null;
    'date_of_birth'?: string | null;
    'height'?: HeightFieldOutput | null;
    'weight'?: WeightFieldOutput | null;
}
export interface ZocdocAppointment {
    'appointment_id': string;
    'patient_id': string;
    'provider_id': string;
    'start_time': string;
    'duration': number;
    'visit_reason_id': ZocdocAppointmentType;
    'location_id': string;
    'appointment_status_id': string;
}


export interface ZocdocAppointmentCancelResponse {
    'successful': boolean;
    'message': string;
}
export interface ZocdocAppointmentIdPayload {
    'appointment_id': string;
}
export interface ZocdocAppointmentStatus {
    'id': string;
    'name': string;
}

export const ZocdocAppointmentType = {
    _148145: '148145'
} as const;

export type ZocdocAppointmentType = typeof ZocdocAppointmentType[keyof typeof ZocdocAppointmentType];


export interface ZocdocAvailabilitySlot {
    'start_time': string;
    'end_time': string;
    'name'?: string;
    'location_id'?: string;
    'available_slot_types'?: Array<any>;
}
export interface ZocdocCreateAppointmentPayload {
    'provider_id': string;
    'patient_id': string;
    'start_time': string;
    'notes'?: string | null;
    'patient_address1'?: string | null;
    'patient_address2'?: string | null;
    'patient_city'?: string | null;
    'patient_state'?: string | null;
    'patient_zip'?: string | null;
    'insurance_carrier'?: string | null;
    'insurance_plan'?: string | null;
    'insurance_member_id'?: string | null;
}
export interface ZocdocCreateAppointmentResponse {
    'appointment_id': string | null;
    'successful': boolean;
}
export interface ZocdocCreatePatientPayload {
    'first_name': string;
    'last_name': string;
    'date_of_birth': string;
    'email_address': string;
    'phone_number': string;
    'provider_id'?: string | null;
    'gender': ZocdocGender;
    'insurance_carrier'?: string | null;
    'insurance_plan'?: string | null;
    'insurance_member_id'?: string | null;
}


export interface ZocdocCreatePatientResponse {
    'patient_id': string | null;
    'provider_id': string | null;
}
/**
 * This is a reductive and incorrect representation of gender but it\'s what the spec requires.
 */

export const ZocdocGender = {
    M: 'M',
    F: 'F'
} as const;

export type ZocdocGender = typeof ZocdocGender[keyof typeof ZocdocGender];


export interface ZocdocPatient {
    'patient_id': string;
    'provider_id': string | null;
    'first_name': string;
    'last_name': string;
    'date_of_birth': string;
    'email_address': string;
    'phone_number': string | null;
    'gender'?: ZocdocGender | null;
}


export interface ZocdocPatientSearchPayload {
    'email_address': string;
    'phone_number'?: string | null;
}
export interface ZocdocProvider {
    'id': string;
    'name': string;
}
export interface ZocdocVisitReason {
    'id': ZocdocAppointmentType;
    'name': string;
}



/**
 * AIFeedbackApi - axios parameter creator
 */
export const AIFeedbackApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Update Chat Completion Feedback
         * @param {string} chatCompletionId 
         * @param {UpdateChatCompletionFeedbackPayload} updateChatCompletionFeedbackPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateChatCompletionFeedbackAiFeedbackChatCompletionChatCompletionIdPut: async (chatCompletionId: string, updateChatCompletionFeedbackPayload: UpdateChatCompletionFeedbackPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatCompletionId' is not null or undefined
            assertParamExists('updateChatCompletionFeedbackAiFeedbackChatCompletionChatCompletionIdPut', 'chatCompletionId', chatCompletionId)
            // verify required parameter 'updateChatCompletionFeedbackPayload' is not null or undefined
            assertParamExists('updateChatCompletionFeedbackAiFeedbackChatCompletionChatCompletionIdPut', 'updateChatCompletionFeedbackPayload', updateChatCompletionFeedbackPayload)
            const localVarPath = `/ai-feedback/chat-completion/{chat_completion_id}`
                .replace(`{${"chat_completion_id"}}`, encodeURIComponent(String(chatCompletionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateChatCompletionFeedbackPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AIFeedbackApi - functional programming interface
 */
export const AIFeedbackApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AIFeedbackApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Update Chat Completion Feedback
         * @param {string} chatCompletionId 
         * @param {UpdateChatCompletionFeedbackPayload} updateChatCompletionFeedbackPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateChatCompletionFeedbackAiFeedbackChatCompletionChatCompletionIdPut(chatCompletionId: string, updateChatCompletionFeedbackPayload: UpdateChatCompletionFeedbackPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateChatCompletionFeedbackAiFeedbackChatCompletionChatCompletionIdPut(chatCompletionId, updateChatCompletionFeedbackPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AIFeedbackApi.updateChatCompletionFeedbackAiFeedbackChatCompletionChatCompletionIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AIFeedbackApi - factory interface
 */
export const AIFeedbackApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AIFeedbackApiFp(configuration)
    return {
        /**
         * 
         * @summary Update Chat Completion Feedback
         * @param {string} chatCompletionId 
         * @param {UpdateChatCompletionFeedbackPayload} updateChatCompletionFeedbackPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateChatCompletionFeedbackAiFeedbackChatCompletionChatCompletionIdPut(chatCompletionId: string, updateChatCompletionFeedbackPayload: UpdateChatCompletionFeedbackPayload, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateChatCompletionFeedbackAiFeedbackChatCompletionChatCompletionIdPut(chatCompletionId, updateChatCompletionFeedbackPayload, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AIFeedbackApi - object-oriented interface
 */
export class AIFeedbackApi extends BaseAPI {
    /**
     * 
     * @summary Update Chat Completion Feedback
     * @param {string} chatCompletionId 
     * @param {UpdateChatCompletionFeedbackPayload} updateChatCompletionFeedbackPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateChatCompletionFeedbackAiFeedbackChatCompletionChatCompletionIdPut(chatCompletionId: string, updateChatCompletionFeedbackPayload: UpdateChatCompletionFeedbackPayload, options?: RawAxiosRequestConfig) {
        return AIFeedbackApiFp(this.configuration).updateChatCompletionFeedbackAiFeedbackChatCompletionChatCompletionIdPut(chatCompletionId, updateChatCompletionFeedbackPayload, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AmazonHBCApi - axios parameter creator
 */
export const AmazonHBCApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Prefill Referral Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrefillReferralDataPublicAmazonHbcPrefillGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public/amazon-hbc/prefill`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint to validate the Amazon session. This is used to ensure that the Amazon HBC client is properly configured and can communicate with Amazon.  The session_id is a token that Amazon provides as a query parameter in the redirect URL.  The customer_id_hash is a hash of the Amazon customer ID, which is required to validate the session with Amazon\'s API.
         * @summary Validate Amazon Session
         * @param {ValidateAmazonSessionPayload} validateAmazonSessionPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAmazonSessionPublicAmazonHbcValidateSessionPost: async (validateAmazonSessionPayload: ValidateAmazonSessionPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'validateAmazonSessionPayload' is not null or undefined
            assertParamExists('validateAmazonSessionPublicAmazonHbcValidateSessionPost', 'validateAmazonSessionPayload', validateAmazonSessionPayload)
            const localVarPath = `/public/amazon-hbc/validate-session`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validateAmazonSessionPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AmazonHBCApi - functional programming interface
 */
export const AmazonHBCApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AmazonHBCApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Prefill Referral Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrefillReferralDataPublicAmazonHbcPrefillGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AmazonHBCReferralPrefillResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrefillReferralDataPublicAmazonHbcPrefillGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AmazonHBCApi.getPrefillReferralDataPublicAmazonHbcPrefillGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Endpoint to validate the Amazon session. This is used to ensure that the Amazon HBC client is properly configured and can communicate with Amazon.  The session_id is a token that Amazon provides as a query parameter in the redirect URL.  The customer_id_hash is a hash of the Amazon customer ID, which is required to validate the session with Amazon\'s API.
         * @summary Validate Amazon Session
         * @param {ValidateAmazonSessionPayload} validateAmazonSessionPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateAmazonSessionPublicAmazonHbcValidateSessionPost(validateAmazonSessionPayload: ValidateAmazonSessionPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateAmazonSessionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateAmazonSessionPublicAmazonHbcValidateSessionPost(validateAmazonSessionPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AmazonHBCApi.validateAmazonSessionPublicAmazonHbcValidateSessionPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AmazonHBCApi - factory interface
 */
export const AmazonHBCApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AmazonHBCApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Prefill Referral Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrefillReferralDataPublicAmazonHbcPrefillGet(options?: RawAxiosRequestConfig): AxiosPromise<AmazonHBCReferralPrefillResponse> {
            return localVarFp.getPrefillReferralDataPublicAmazonHbcPrefillGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint to validate the Amazon session. This is used to ensure that the Amazon HBC client is properly configured and can communicate with Amazon.  The session_id is a token that Amazon provides as a query parameter in the redirect URL.  The customer_id_hash is a hash of the Amazon customer ID, which is required to validate the session with Amazon\'s API.
         * @summary Validate Amazon Session
         * @param {ValidateAmazonSessionPayload} validateAmazonSessionPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAmazonSessionPublicAmazonHbcValidateSessionPost(validateAmazonSessionPayload: ValidateAmazonSessionPayload, options?: RawAxiosRequestConfig): AxiosPromise<ValidateAmazonSessionResponse> {
            return localVarFp.validateAmazonSessionPublicAmazonHbcValidateSessionPost(validateAmazonSessionPayload, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AmazonHBCApi - object-oriented interface
 */
export class AmazonHBCApi extends BaseAPI {
    /**
     * 
     * @summary Get Prefill Referral Data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPrefillReferralDataPublicAmazonHbcPrefillGet(options?: RawAxiosRequestConfig) {
        return AmazonHBCApiFp(this.configuration).getPrefillReferralDataPublicAmazonHbcPrefillGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint to validate the Amazon session. This is used to ensure that the Amazon HBC client is properly configured and can communicate with Amazon.  The session_id is a token that Amazon provides as a query parameter in the redirect URL.  The customer_id_hash is a hash of the Amazon customer ID, which is required to validate the session with Amazon\'s API.
     * @summary Validate Amazon Session
     * @param {ValidateAmazonSessionPayload} validateAmazonSessionPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateAmazonSessionPublicAmazonHbcValidateSessionPost(validateAmazonSessionPayload: ValidateAmazonSessionPayload, options?: RawAxiosRequestConfig) {
        return AmazonHBCApiFp(this.configuration).validateAmazonSessionPublicAmazonHbcValidateSessionPost(validateAmazonSessionPayload, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AnnouncementsApi - axios parameter creator
 */
export const AnnouncementsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add Provider Seen Announcement
         * @param {SeenAnnouncementPayload} seenAnnouncementPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProviderSeenAnnouncementAnnouncementsSeenPost: async (seenAnnouncementPayload: SeenAnnouncementPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seenAnnouncementPayload' is not null or undefined
            assertParamExists('addProviderSeenAnnouncementAnnouncementsSeenPost', 'seenAnnouncementPayload', seenAnnouncementPayload)
            const localVarPath = `/announcements/seen`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(seenAnnouncementPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Announcements To Show By Provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnnouncementsToShowByProviderAnnouncementsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/announcements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AnnouncementsApi - functional programming interface
 */
export const AnnouncementsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AnnouncementsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add Provider Seen Announcement
         * @param {SeenAnnouncementPayload} seenAnnouncementPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addProviderSeenAnnouncementAnnouncementsSeenPost(seenAnnouncementPayload: SeenAnnouncementPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnnouncementsToShowResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addProviderSeenAnnouncementAnnouncementsSeenPost(seenAnnouncementPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnnouncementsApi.addProviderSeenAnnouncementAnnouncementsSeenPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Announcements To Show By Provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAnnouncementsToShowByProviderAnnouncementsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnnouncementsToShowResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAnnouncementsToShowByProviderAnnouncementsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnnouncementsApi.getAnnouncementsToShowByProviderAnnouncementsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AnnouncementsApi - factory interface
 */
export const AnnouncementsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AnnouncementsApiFp(configuration)
    return {
        /**
         * 
         * @summary Add Provider Seen Announcement
         * @param {SeenAnnouncementPayload} seenAnnouncementPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProviderSeenAnnouncementAnnouncementsSeenPost(seenAnnouncementPayload: SeenAnnouncementPayload, options?: RawAxiosRequestConfig): AxiosPromise<AnnouncementsToShowResponse> {
            return localVarFp.addProviderSeenAnnouncementAnnouncementsSeenPost(seenAnnouncementPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Announcements To Show By Provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnnouncementsToShowByProviderAnnouncementsGet(options?: RawAxiosRequestConfig): AxiosPromise<AnnouncementsToShowResponse> {
            return localVarFp.getAnnouncementsToShowByProviderAnnouncementsGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AnnouncementsApi - object-oriented interface
 */
export class AnnouncementsApi extends BaseAPI {
    /**
     * 
     * @summary Add Provider Seen Announcement
     * @param {SeenAnnouncementPayload} seenAnnouncementPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addProviderSeenAnnouncementAnnouncementsSeenPost(seenAnnouncementPayload: SeenAnnouncementPayload, options?: RawAxiosRequestConfig) {
        return AnnouncementsApiFp(this.configuration).addProviderSeenAnnouncementAnnouncementsSeenPost(seenAnnouncementPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Announcements To Show By Provider
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAnnouncementsToShowByProviderAnnouncementsGet(options?: RawAxiosRequestConfig) {
        return AnnouncementsApiFp(this.configuration).getAnnouncementsToShowByProviderAnnouncementsGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AppReviewApi - axios parameter creator
 */
export const AppReviewApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Post Review
         * @param {AppReviewPayload} appReviewPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postReviewAppReviewPost: async (appReviewPayload: AppReviewPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appReviewPayload' is not null or undefined
            assertParamExists('postReviewAppReviewPost', 'appReviewPayload', appReviewPayload)
            const localVarPath = `/app-review`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(appReviewPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AppReviewApi - functional programming interface
 */
export const AppReviewApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AppReviewApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Post Review
         * @param {AppReviewPayload} appReviewPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postReviewAppReviewPost(appReviewPayload: AppReviewPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppReviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postReviewAppReviewPost(appReviewPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppReviewApi.postReviewAppReviewPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AppReviewApi - factory interface
 */
export const AppReviewApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AppReviewApiFp(configuration)
    return {
        /**
         * 
         * @summary Post Review
         * @param {AppReviewPayload} appReviewPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postReviewAppReviewPost(appReviewPayload: AppReviewPayload, options?: RawAxiosRequestConfig): AxiosPromise<AppReviewResponse> {
            return localVarFp.postReviewAppReviewPost(appReviewPayload, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AppReviewApi - object-oriented interface
 */
export class AppReviewApi extends BaseAPI {
    /**
     * 
     * @summary Post Review
     * @param {AppReviewPayload} appReviewPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postReviewAppReviewPost(appReviewPayload: AppReviewPayload, options?: RawAxiosRequestConfig) {
        return AppReviewApiFp(this.configuration).postReviewAppReviewPost(appReviewPayload, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AppointmentApi - axios parameter creator
 */
export const AppointmentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Book Appointment
         * @param {BookAppointmentPayload} bookAppointmentPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookAppointmentAppointmentsPost: async (bookAppointmentPayload: BookAppointmentPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookAppointmentPayload' is not null or undefined
            assertParamExists('bookAppointmentAppointmentsPost', 'bookAppointmentPayload', bookAppointmentPayload)
            const localVarPath = `/appointments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bookAppointmentPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cancel a specific AI prefill fieldset for the appointment\'s chart note.
         * @summary Cancel Ai Clinical Notes Prefill
         * @param {string} appointmentId 
         * @param {string} aiPrefillFieldsetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelAiClinicalNotesPrefillAppointmentsAppointmentIdChartNotePrefillAiPrefillFieldsetIdDelete: async (appointmentId: string, aiPrefillFieldsetId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentId' is not null or undefined
            assertParamExists('cancelAiClinicalNotesPrefillAppointmentsAppointmentIdChartNotePrefillAiPrefillFieldsetIdDelete', 'appointmentId', appointmentId)
            // verify required parameter 'aiPrefillFieldsetId' is not null or undefined
            assertParamExists('cancelAiClinicalNotesPrefillAppointmentsAppointmentIdChartNotePrefillAiPrefillFieldsetIdDelete', 'aiPrefillFieldsetId', aiPrefillFieldsetId)
            const localVarPath = `/appointments/{appointment_id}/chart-note/prefill/{ai_prefill_fieldset_id}`
                .replace(`{${"appointment_id"}}`, encodeURIComponent(String(appointmentId)))
                .replace(`{${"ai_prefill_fieldset_id"}}`, encodeURIComponent(String(aiPrefillFieldsetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Cancel Appointment
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelAppointmentAppointmentAppointmentIdCancelPost: async (appointmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentId' is not null or undefined
            assertParamExists('cancelAppointmentAppointmentAppointmentIdCancelPost', 'appointmentId', appointmentId)
            const localVarPath = `/appointment/{appointment_id}/cancel`
                .replace(`{${"appointment_id"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Calendar Block
         * @param {CreateCalendarBlockPayload} createCalendarBlockPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCalendarBlockCalendarEventsBlocksPost: async (createCalendarBlockPayload: CreateCalendarBlockPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCalendarBlockPayload' is not null or undefined
            assertParamExists('createCalendarBlockCalendarEventsBlocksPost', 'createCalendarBlockPayload', createCalendarBlockPayload)
            const localVarPath = `/calendar-events/blocks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCalendarBlockPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deprecated Get Chart Note For Appointment
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dEPRECATEDGetChartNoteForAppointmentAppointmentAppointmentIdChartNoteGet: async (appointmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentId' is not null or undefined
            assertParamExists('dEPRECATEDGetChartNoteForAppointmentAppointmentAppointmentIdChartNoteGet', 'appointmentId', appointmentId)
            const localVarPath = `/appointment/{appointment_id}/chart-note`
                .replace(`{${"appointment_id"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deprecated Update Chart Note For Appointment
         * @param {string} appointmentId 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dEPRECATEDUpdateChartNoteForAppointmentAppointmentAppointmentIdChartNotePut: async (appointmentId: string, body: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentId' is not null or undefined
            assertParamExists('dEPRECATEDUpdateChartNoteForAppointmentAppointmentAppointmentIdChartNotePut', 'appointmentId', appointmentId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('dEPRECATEDUpdateChartNoteForAppointmentAppointmentAppointmentIdChartNotePut', 'body', body)
            const localVarPath = `/appointment/{appointment_id}/chart-note`
                .replace(`{${"appointment_id"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Calendar Event
         * @param {string} calendarEventId 
         * @param {boolean} withSubsequentEventsInRecurrenceSeries If true, all events after this event in the recurrence series will also be deleted. When false, only this event is deleted.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCalendarEventCalendarEventsCalendarEventIdDelete: async (calendarEventId: string, withSubsequentEventsInRecurrenceSeries: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calendarEventId' is not null or undefined
            assertParamExists('deleteCalendarEventCalendarEventsCalendarEventIdDelete', 'calendarEventId', calendarEventId)
            // verify required parameter 'withSubsequentEventsInRecurrenceSeries' is not null or undefined
            assertParamExists('deleteCalendarEventCalendarEventsCalendarEventIdDelete', 'withSubsequentEventsInRecurrenceSeries', withSubsequentEventsInRecurrenceSeries)
            const localVarPath = `/calendar-events/{calendar_event_id}`
                .replace(`{${"calendar_event_id"}}`, encodeURIComponent(String(calendarEventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (withSubsequentEventsInRecurrenceSeries !== undefined) {
                localVarQueryParameter['with_subsequent_events_in_recurrence_series'] = withSubsequentEventsInRecurrenceSeries;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Ai Clinical Notes Prefill Status
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAiClinicalNotesPrefillStatusAppointmentsAppointmentIdChartNotePrefillGet: async (appointmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentId' is not null or undefined
            assertParamExists('getAiClinicalNotesPrefillStatusAppointmentsAppointmentIdChartNotePrefillGet', 'appointmentId', appointmentId)
            const localVarPath = `/appointments/{appointment_id}/chart-note/prefill`
                .replace(`{${"appointment_id"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint is authenticated by either an appointment-based JWT token or a Cognito user.
         * @summary Get Appointment Add To Calendar Details
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentAddToCalendarDetailsAppointmentsAppointmentIdCalendarDetailsGet: async (appointmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentId' is not null or undefined
            assertParamExists('getAppointmentAddToCalendarDetailsAppointmentsAppointmentIdCalendarDetailsGet', 'appointmentId', appointmentId)
            const localVarPath = `/appointments/{appointment_id}/calendar-details`
                .replace(`{${"appointment_id"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Appointment
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentAppointmentsAppointmentIdGet: async (appointmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentId' is not null or undefined
            assertParamExists('getAppointmentAppointmentsAppointmentIdGet', 'appointmentId', appointmentId)
            const localVarPath = `/appointments/{appointment_id}`
                .replace(`{${"appointment_id"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Appointments
         * @param {string | null} [providerId] 
         * @param {string | null} [patientId] 
         * @param {string | null} [before] 
         * @param {string | null} [after] 
         * @param {string | null} [startBefore] 
         * @param {string | null} [startAfter] 
         * @param {string | null} [endBefore] 
         * @param {string | null} [endAfter] 
         * @param {AllowedSortParam | null} [sort] 
         * @param {Array<AppointmentStatus> | null} [statuses] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentsAppointmentsGet: async (providerId?: string | null, patientId?: string | null, before?: string | null, after?: string | null, startBefore?: string | null, startAfter?: string | null, endBefore?: string | null, endAfter?: string | null, sort?: AllowedSortParam | null, statuses?: Array<AppointmentStatus> | null, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/appointments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (providerId !== undefined) {
                localVarQueryParameter['provider_id'] = providerId;
            }

            if (patientId !== undefined) {
                localVarQueryParameter['patient_id'] = patientId;
            }

            if (before !== undefined) {
                localVarQueryParameter['before'] = (before as any instanceof Date) ?
                    (before as any).toISOString() :
                    before;
            }

            if (after !== undefined) {
                localVarQueryParameter['after'] = (after as any instanceof Date) ?
                    (after as any).toISOString() :
                    after;
            }

            if (startBefore !== undefined) {
                localVarQueryParameter['start_before'] = (startBefore as any instanceof Date) ?
                    (startBefore as any).toISOString() :
                    startBefore;
            }

            if (startAfter !== undefined) {
                localVarQueryParameter['start_after'] = (startAfter as any instanceof Date) ?
                    (startAfter as any).toISOString() :
                    startAfter;
            }

            if (endBefore !== undefined) {
                localVarQueryParameter['end_before'] = (endBefore as any instanceof Date) ?
                    (endBefore as any).toISOString() :
                    endBefore;
            }

            if (endAfter !== undefined) {
                localVarQueryParameter['end_after'] = (endAfter as any instanceof Date) ?
                    (endAfter as any).toISOString() :
                    endAfter;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (statuses) {
                localVarQueryParameter['statuses'] = statuses;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Calendar Event
         * @param {string} calendarEventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalendarEventCalendarEventsCalendarEventIdGet: async (calendarEventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calendarEventId' is not null or undefined
            assertParamExists('getCalendarEventCalendarEventsCalendarEventIdGet', 'calendarEventId', calendarEventId)
            const localVarPath = `/calendar-events/{calendar_event_id}`
                .replace(`{${"calendar_event_id"}}`, encodeURIComponent(String(calendarEventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Calendar Events
         * @param {string} startTime 
         * @param {string} endTime 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalendarEventsCalendarEventsGet: async (startTime: string, endTime: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('getCalendarEventsCalendarEventsGet', 'startTime', startTime)
            // verify required parameter 'endTime' is not null or undefined
            assertParamExists('getCalendarEventsCalendarEventsGet', 'endTime', endTime)
            const localVarPath = `/calendar-events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['start_time'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['end_time'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * check_provider_can_access_appointment implicitly checks that the appointment  exists (and that the provider is allowed to access it) so we don\'t need  to do it redundantly here.
         * @summary Get Chart Note For Appointment
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChartNoteForAppointmentAppointmentsAppointmentIdChartNoteGet: async (appointmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentId' is not null or undefined
            assertParamExists('getChartNoteForAppointmentAppointmentsAppointmentIdChartNoteGet', 'appointmentId', appointmentId)
            const localVarPath = `/appointments/{appointment_id}/chart-note`
                .replace(`{${"appointment_id"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the PES options for the clinical form nutrition diagnosis.
         * @summary Get Pes Options
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPesOptionsPesOptionsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/pes-options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Provider Availability Schedule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderAvailabilityScheduleAvailabilityScheduleGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/availability-schedule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of available slots for the given provider between the given start and end times. The slots returned are the start times of the available slots in 15 minute increments.
         * @summary Get Provider Available Slots
         * @param {string} startTime 
         * @param {string} endTime 
         * @param {number} appointmentDurationInMinutes 
         * @param {string} providerId 
         * @param {string | null} [reschedulingToken] 
         * @param {string | null} [appointmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderAvailableSlotsAvailabilitySlotsGet: async (startTime: string, endTime: string, appointmentDurationInMinutes: number, providerId: string, reschedulingToken?: string | null, appointmentId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('getProviderAvailableSlotsAvailabilitySlotsGet', 'startTime', startTime)
            // verify required parameter 'endTime' is not null or undefined
            assertParamExists('getProviderAvailableSlotsAvailabilitySlotsGet', 'endTime', endTime)
            // verify required parameter 'appointmentDurationInMinutes' is not null or undefined
            assertParamExists('getProviderAvailableSlotsAvailabilitySlotsGet', 'appointmentDurationInMinutes', appointmentDurationInMinutes)
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('getProviderAvailableSlotsAvailabilitySlotsGet', 'providerId', providerId)
            const localVarPath = `/availability-slots`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['start_time'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['end_time'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }

            if (appointmentDurationInMinutes !== undefined) {
                localVarQueryParameter['appointment_duration_in_minutes'] = appointmentDurationInMinutes;
            }

            if (providerId !== undefined) {
                localVarQueryParameter['provider_id'] = providerId;
            }

            if (reschedulingToken !== undefined) {
                localVarQueryParameter['rescheduling_token'] = reschedulingToken;
            }

            if (appointmentId !== undefined) {
                localVarQueryParameter['appointment_id'] = appointmentId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Triggers AI prefill for the appointment\'s chart note and returns the latest prefill fieldset snapshot for client polling/UI state.
         * @summary Initialize Ai Clinical Notes Prefill
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initializeAiClinicalNotesPrefillAppointmentsAppointmentIdChartNotePrefillPost: async (appointmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentId' is not null or undefined
            assertParamExists('initializeAiClinicalNotesPrefillAppointmentsAppointmentIdChartNotePrefillPost', 'appointmentId', appointmentId)
            const localVarPath = `/appointments/{appointment_id}/chart-note/prefill`
                .replace(`{${"appointment_id"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reserve an appointment slot for a temporary period (default 15 minutes).  Returns a JWT token that can be used when booking the appointment to guarantee the slot is available.
         * @summary Reserve Appointment Slot
         * @param {ReserveSlotPayload} reserveSlotPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reserveAppointmentSlotAppointmentsReservePost: async (reserveSlotPayload: ReserveSlotPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reserveSlotPayload' is not null or undefined
            assertParamExists('reserveAppointmentSlotAppointmentsReservePost', 'reserveSlotPayload', reserveSlotPayload)
            const localVarPath = `/appointments/reserve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reserveSlotPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set Provider Availability Schedule
         * @param {UpdateProviderAvailabilitySchedulePayload} updateProviderAvailabilitySchedulePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setProviderAvailabilityScheduleAvailabilitySchedulePost: async (updateProviderAvailabilitySchedulePayload: UpdateProviderAvailabilitySchedulePayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateProviderAvailabilitySchedulePayload' is not null or undefined
            assertParamExists('setProviderAvailabilityScheduleAvailabilitySchedulePost', 'updateProviderAvailabilitySchedulePayload', updateProviderAvailabilitySchedulePayload)
            const localVarPath = `/availability-schedule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProviderAvailabilitySchedulePayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Setup Patient And Book Appointment
         * @param {SetupPatientAndBookAppointmentPayload} setupPatientAndBookAppointmentPayload 
         * @param {string | null} [fayBookingReservationToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setupPatientAndBookAppointmentAppointmentsSetupPatientPost: async (setupPatientAndBookAppointmentPayload: SetupPatientAndBookAppointmentPayload, fayBookingReservationToken?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'setupPatientAndBookAppointmentPayload' is not null or undefined
            assertParamExists('setupPatientAndBookAppointmentAppointmentsSetupPatientPost', 'setupPatientAndBookAppointmentPayload', setupPatientAndBookAppointmentPayload)
            const localVarPath = `/appointments/setup-patient`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            if (fayBookingReservationToken != null) {
                localVarHeaderParameter['Fay-Booking-Reservation-Token'] = String(fayBookingReservationToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setupPatientAndBookAppointmentPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sign Chart Note For Appointment
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signChartNoteForAppointmentAppointmentsAppointmentIdChartNoteSignPut: async (appointmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentId' is not null or undefined
            assertParamExists('signChartNoteForAppointmentAppointmentsAppointmentIdChartNoteSignPut', 'appointmentId', appointmentId)
            const localVarPath = `/appointments/{appointment_id}/chart-note/sign`
                .replace(`{${"appointment_id"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Appointment
         * @param {string} appointmentId 
         * @param {UpdateAppointmentPayload} updateAppointmentPayload 
         * @param {string | null} [reschedulingToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAppointmentAppointmentsAppointmentIdPatch: async (appointmentId: string, updateAppointmentPayload: UpdateAppointmentPayload, reschedulingToken?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentId' is not null or undefined
            assertParamExists('updateAppointmentAppointmentsAppointmentIdPatch', 'appointmentId', appointmentId)
            // verify required parameter 'updateAppointmentPayload' is not null or undefined
            assertParamExists('updateAppointmentAppointmentsAppointmentIdPatch', 'updateAppointmentPayload', updateAppointmentPayload)
            const localVarPath = `/appointments/{appointment_id}`
                .replace(`{${"appointment_id"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (reschedulingToken !== undefined) {
                localVarQueryParameter['rescheduling_token'] = reschedulingToken;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAppointmentPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Calendar Event
         * @param {string} calendarEventId 
         * @param {UpdateCalendarEventPayload} updateCalendarEventPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCalendarEventCalendarEventsCalendarEventIdPut: async (calendarEventId: string, updateCalendarEventPayload: UpdateCalendarEventPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calendarEventId' is not null or undefined
            assertParamExists('updateCalendarEventCalendarEventsCalendarEventIdPut', 'calendarEventId', calendarEventId)
            // verify required parameter 'updateCalendarEventPayload' is not null or undefined
            assertParamExists('updateCalendarEventCalendarEventsCalendarEventIdPut', 'updateCalendarEventPayload', updateCalendarEventPayload)
            const localVarPath = `/calendar-events/{calendar_event_id}`
                .replace(`{${"calendar_event_id"}}`, encodeURIComponent(String(calendarEventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCalendarEventPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Chart Note For Appointment
         * @param {string} appointmentId 
         * @param {UpdateChartNotePayload} updateChartNotePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateChartNoteForAppointmentAppointmentsAppointmentIdChartNotePatch: async (appointmentId: string, updateChartNotePayload: UpdateChartNotePayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentId' is not null or undefined
            assertParamExists('updateChartNoteForAppointmentAppointmentsAppointmentIdChartNotePatch', 'appointmentId', appointmentId)
            // verify required parameter 'updateChartNotePayload' is not null or undefined
            assertParamExists('updateChartNoteForAppointmentAppointmentsAppointmentIdChartNotePatch', 'updateChartNotePayload', updateChartNotePayload)
            const localVarPath = `/appointments/{appointment_id}/chart-note`
                .replace(`{${"appointment_id"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateChartNotePayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Provider Availability Types
         * @param {UpdateProviderAvailabilityTypesPayload} updateProviderAvailabilityTypesPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProviderAvailabilityTypesAvailabilityScheduleAvailabilityTypesPut: async (updateProviderAvailabilityTypesPayload: UpdateProviderAvailabilityTypesPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateProviderAvailabilityTypesPayload' is not null or undefined
            assertParamExists('updateProviderAvailabilityTypesAvailabilityScheduleAvailabilityTypesPut', 'updateProviderAvailabilityTypesPayload', updateProviderAvailabilityTypesPayload)
            const localVarPath = `/availability-schedule/availability-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProviderAvailabilityTypesPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AppointmentApi - functional programming interface
 */
export const AppointmentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AppointmentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Book Appointment
         * @param {BookAppointmentPayload} bookAppointmentPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bookAppointmentAppointmentsPost(bookAppointmentPayload: BookAppointmentPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookAppointmentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bookAppointmentAppointmentsPost(bookAppointmentPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentApi.bookAppointmentAppointmentsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Cancel a specific AI prefill fieldset for the appointment\'s chart note.
         * @summary Cancel Ai Clinical Notes Prefill
         * @param {string} appointmentId 
         * @param {string} aiPrefillFieldsetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelAiClinicalNotesPrefillAppointmentsAppointmentIdChartNotePrefillAiPrefillFieldsetIdDelete(appointmentId: string, aiPrefillFieldsetId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelAiClinicalNotesPrefillAppointmentsAppointmentIdChartNotePrefillAiPrefillFieldsetIdDelete(appointmentId, aiPrefillFieldsetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentApi.cancelAiClinicalNotesPrefillAppointmentsAppointmentIdChartNotePrefillAiPrefillFieldsetIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Cancel Appointment
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelAppointmentAppointmentAppointmentIdCancelPost(appointmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppointmentCanceledResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelAppointmentAppointmentAppointmentIdCancelPost(appointmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentApi.cancelAppointmentAppointmentAppointmentIdCancelPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Calendar Block
         * @param {CreateCalendarBlockPayload} createCalendarBlockPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCalendarBlockCalendarEventsBlocksPost(createCalendarBlockPayload: CreateCalendarBlockPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarEventResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCalendarBlockCalendarEventsBlocksPost(createCalendarBlockPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentApi.createCalendarBlockCalendarEventsBlocksPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Deprecated Get Chart Note For Appointment
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dEPRECATEDGetChartNoteForAppointmentAppointmentAppointmentIdChartNoteGet(appointmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChartNoteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dEPRECATEDGetChartNoteForAppointmentAppointmentAppointmentIdChartNoteGet(appointmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentApi.dEPRECATEDGetChartNoteForAppointmentAppointmentAppointmentIdChartNoteGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Deprecated Update Chart Note For Appointment
         * @param {string} appointmentId 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dEPRECATEDUpdateChartNoteForAppointmentAppointmentAppointmentIdChartNotePut(appointmentId: string, body: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChartNoteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dEPRECATEDUpdateChartNoteForAppointmentAppointmentAppointmentIdChartNotePut(appointmentId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentApi.dEPRECATEDUpdateChartNoteForAppointmentAppointmentAppointmentIdChartNotePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Calendar Event
         * @param {string} calendarEventId 
         * @param {boolean} withSubsequentEventsInRecurrenceSeries If true, all events after this event in the recurrence series will also be deleted. When false, only this event is deleted.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCalendarEventCalendarEventsCalendarEventIdDelete(calendarEventId: string, withSubsequentEventsInRecurrenceSeries: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCalendarEventCalendarEventsCalendarEventIdDelete(calendarEventId, withSubsequentEventsInRecurrenceSeries, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentApi.deleteCalendarEventCalendarEventsCalendarEventIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Ai Clinical Notes Prefill Status
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAiClinicalNotesPrefillStatusAppointmentsAppointmentIdChartNotePrefillGet(appointmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AIPrefillFieldsetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAiClinicalNotesPrefillStatusAppointmentsAppointmentIdChartNotePrefillGet(appointmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentApi.getAiClinicalNotesPrefillStatusAppointmentsAppointmentIdChartNotePrefillGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint is authenticated by either an appointment-based JWT token or a Cognito user.
         * @summary Get Appointment Add To Calendar Details
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppointmentAddToCalendarDetailsAppointmentsAppointmentIdCalendarDetailsGet(appointmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppointmentAddToCalendarDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppointmentAddToCalendarDetailsAppointmentsAppointmentIdCalendarDetailsGet(appointmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentApi.getAppointmentAddToCalendarDetailsAppointmentsAppointmentIdCalendarDetailsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Appointment
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppointmentAppointmentsAppointmentIdGet(appointmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppointmentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppointmentAppointmentsAppointmentIdGet(appointmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentApi.getAppointmentAppointmentsAppointmentIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Appointments
         * @param {string | null} [providerId] 
         * @param {string | null} [patientId] 
         * @param {string | null} [before] 
         * @param {string | null} [after] 
         * @param {string | null} [startBefore] 
         * @param {string | null} [startAfter] 
         * @param {string | null} [endBefore] 
         * @param {string | null} [endAfter] 
         * @param {AllowedSortParam | null} [sort] 
         * @param {Array<AppointmentStatus> | null} [statuses] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppointmentsAppointmentsGet(providerId?: string | null, patientId?: string | null, before?: string | null, after?: string | null, startBefore?: string | null, startAfter?: string | null, endBefore?: string | null, endAfter?: string | null, sort?: AllowedSortParam | null, statuses?: Array<AppointmentStatus> | null, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AppointmentResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppointmentsAppointmentsGet(providerId, patientId, before, after, startBefore, startAfter, endBefore, endAfter, sort, statuses, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentApi.getAppointmentsAppointmentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Calendar Event
         * @param {string} calendarEventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCalendarEventCalendarEventsCalendarEventIdGet(calendarEventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarEventResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCalendarEventCalendarEventsCalendarEventIdGet(calendarEventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentApi.getCalendarEventCalendarEventsCalendarEventIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Calendar Events
         * @param {string} startTime 
         * @param {string} endTime 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCalendarEventsCalendarEventsGet(startTime: string, endTime: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarEventsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCalendarEventsCalendarEventsGet(startTime, endTime, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentApi.getCalendarEventsCalendarEventsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * check_provider_can_access_appointment implicitly checks that the appointment  exists (and that the provider is allowed to access it) so we don\'t need  to do it redundantly here.
         * @summary Get Chart Note For Appointment
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChartNoteForAppointmentAppointmentsAppointmentIdChartNoteGet(appointmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChartNoteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChartNoteForAppointmentAppointmentsAppointmentIdChartNoteGet(appointmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentApi.getChartNoteForAppointmentAppointmentsAppointmentIdChartNoteGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the PES options for the clinical form nutrition diagnosis.
         * @summary Get Pes Options
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPesOptionsPesOptionsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PESOptionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPesOptionsPesOptionsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentApi.getPesOptionsPesOptionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Provider Availability Schedule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProviderAvailabilityScheduleAvailabilityScheduleGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProviderAvailabilityScheduleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProviderAvailabilityScheduleAvailabilityScheduleGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentApi.getProviderAvailabilityScheduleAvailabilityScheduleGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a list of available slots for the given provider between the given start and end times. The slots returned are the start times of the available slots in 15 minute increments.
         * @summary Get Provider Available Slots
         * @param {string} startTime 
         * @param {string} endTime 
         * @param {number} appointmentDurationInMinutes 
         * @param {string} providerId 
         * @param {string | null} [reschedulingToken] 
         * @param {string | null} [appointmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProviderAvailableSlotsAvailabilitySlotsGet(startTime: string, endTime: string, appointmentDurationInMinutes: number, providerId: string, reschedulingToken?: string | null, appointmentId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AvailabilitySlotsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProviderAvailableSlotsAvailabilitySlotsGet(startTime, endTime, appointmentDurationInMinutes, providerId, reschedulingToken, appointmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentApi.getProviderAvailableSlotsAvailabilitySlotsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Triggers AI prefill for the appointment\'s chart note and returns the latest prefill fieldset snapshot for client polling/UI state.
         * @summary Initialize Ai Clinical Notes Prefill
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initializeAiClinicalNotesPrefillAppointmentsAppointmentIdChartNotePrefillPost(appointmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AIPrefillFieldsetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initializeAiClinicalNotesPrefillAppointmentsAppointmentIdChartNotePrefillPost(appointmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentApi.initializeAiClinicalNotesPrefillAppointmentsAppointmentIdChartNotePrefillPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reserve an appointment slot for a temporary period (default 15 minutes).  Returns a JWT token that can be used when booking the appointment to guarantee the slot is available.
         * @summary Reserve Appointment Slot
         * @param {ReserveSlotPayload} reserveSlotPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reserveAppointmentSlotAppointmentsReservePost(reserveSlotPayload: ReserveSlotPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReserveSlotResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reserveAppointmentSlotAppointmentsReservePost(reserveSlotPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentApi.reserveAppointmentSlotAppointmentsReservePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Set Provider Availability Schedule
         * @param {UpdateProviderAvailabilitySchedulePayload} updateProviderAvailabilitySchedulePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setProviderAvailabilityScheduleAvailabilitySchedulePost(updateProviderAvailabilitySchedulePayload: UpdateProviderAvailabilitySchedulePayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProviderAvailabilityScheduleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setProviderAvailabilityScheduleAvailabilitySchedulePost(updateProviderAvailabilitySchedulePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentApi.setProviderAvailabilityScheduleAvailabilitySchedulePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Setup Patient And Book Appointment
         * @param {SetupPatientAndBookAppointmentPayload} setupPatientAndBookAppointmentPayload 
         * @param {string | null} [fayBookingReservationToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setupPatientAndBookAppointmentAppointmentsSetupPatientPost(setupPatientAndBookAppointmentPayload: SetupPatientAndBookAppointmentPayload, fayBookingReservationToken?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SetupPatientAndBookAppointmentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setupPatientAndBookAppointmentAppointmentsSetupPatientPost(setupPatientAndBookAppointmentPayload, fayBookingReservationToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentApi.setupPatientAndBookAppointmentAppointmentsSetupPatientPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Sign Chart Note For Appointment
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signChartNoteForAppointmentAppointmentsAppointmentIdChartNoteSignPut(appointmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChartNoteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signChartNoteForAppointmentAppointmentsAppointmentIdChartNoteSignPut(appointmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentApi.signChartNoteForAppointmentAppointmentsAppointmentIdChartNoteSignPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Appointment
         * @param {string} appointmentId 
         * @param {UpdateAppointmentPayload} updateAppointmentPayload 
         * @param {string | null} [reschedulingToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAppointmentAppointmentsAppointmentIdPatch(appointmentId: string, updateAppointmentPayload: UpdateAppointmentPayload, reschedulingToken?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppointmentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAppointmentAppointmentsAppointmentIdPatch(appointmentId, updateAppointmentPayload, reschedulingToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentApi.updateAppointmentAppointmentsAppointmentIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Calendar Event
         * @param {string} calendarEventId 
         * @param {UpdateCalendarEventPayload} updateCalendarEventPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCalendarEventCalendarEventsCalendarEventIdPut(calendarEventId: string, updateCalendarEventPayload: UpdateCalendarEventPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarEventResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCalendarEventCalendarEventsCalendarEventIdPut(calendarEventId, updateCalendarEventPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentApi.updateCalendarEventCalendarEventsCalendarEventIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Chart Note For Appointment
         * @param {string} appointmentId 
         * @param {UpdateChartNotePayload} updateChartNotePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateChartNoteForAppointmentAppointmentsAppointmentIdChartNotePatch(appointmentId: string, updateChartNotePayload: UpdateChartNotePayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChartNoteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateChartNoteForAppointmentAppointmentsAppointmentIdChartNotePatch(appointmentId, updateChartNotePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentApi.updateChartNoteForAppointmentAppointmentsAppointmentIdChartNotePatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Provider Availability Types
         * @param {UpdateProviderAvailabilityTypesPayload} updateProviderAvailabilityTypesPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProviderAvailabilityTypesAvailabilityScheduleAvailabilityTypesPut(updateProviderAvailabilityTypesPayload: UpdateProviderAvailabilityTypesPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProviderAvailabilityTypesAvailabilityScheduleAvailabilityTypesPut(updateProviderAvailabilityTypesPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppointmentApi.updateProviderAvailabilityTypesAvailabilityScheduleAvailabilityTypesPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AppointmentApi - factory interface
 */
export const AppointmentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AppointmentApiFp(configuration)
    return {
        /**
         * 
         * @summary Book Appointment
         * @param {BookAppointmentPayload} bookAppointmentPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookAppointmentAppointmentsPost(bookAppointmentPayload: BookAppointmentPayload, options?: RawAxiosRequestConfig): AxiosPromise<BookAppointmentResponse> {
            return localVarFp.bookAppointmentAppointmentsPost(bookAppointmentPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Cancel a specific AI prefill fieldset for the appointment\'s chart note.
         * @summary Cancel Ai Clinical Notes Prefill
         * @param {string} appointmentId 
         * @param {string} aiPrefillFieldsetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelAiClinicalNotesPrefillAppointmentsAppointmentIdChartNotePrefillAiPrefillFieldsetIdDelete(appointmentId: string, aiPrefillFieldsetId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.cancelAiClinicalNotesPrefillAppointmentsAppointmentIdChartNotePrefillAiPrefillFieldsetIdDelete(appointmentId, aiPrefillFieldsetId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cancel Appointment
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelAppointmentAppointmentAppointmentIdCancelPost(appointmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<AppointmentCanceledResponse> {
            return localVarFp.cancelAppointmentAppointmentAppointmentIdCancelPost(appointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Calendar Block
         * @param {CreateCalendarBlockPayload} createCalendarBlockPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCalendarBlockCalendarEventsBlocksPost(createCalendarBlockPayload: CreateCalendarBlockPayload, options?: RawAxiosRequestConfig): AxiosPromise<CalendarEventResponse> {
            return localVarFp.createCalendarBlockCalendarEventsBlocksPost(createCalendarBlockPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deprecated Get Chart Note For Appointment
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dEPRECATEDGetChartNoteForAppointmentAppointmentAppointmentIdChartNoteGet(appointmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<ChartNoteResponse> {
            return localVarFp.dEPRECATEDGetChartNoteForAppointmentAppointmentAppointmentIdChartNoteGet(appointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deprecated Update Chart Note For Appointment
         * @param {string} appointmentId 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dEPRECATEDUpdateChartNoteForAppointmentAppointmentAppointmentIdChartNotePut(appointmentId: string, body: string, options?: RawAxiosRequestConfig): AxiosPromise<ChartNoteResponse> {
            return localVarFp.dEPRECATEDUpdateChartNoteForAppointmentAppointmentAppointmentIdChartNotePut(appointmentId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Calendar Event
         * @param {string} calendarEventId 
         * @param {boolean} withSubsequentEventsInRecurrenceSeries If true, all events after this event in the recurrence series will also be deleted. When false, only this event is deleted.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCalendarEventCalendarEventsCalendarEventIdDelete(calendarEventId: string, withSubsequentEventsInRecurrenceSeries: boolean, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCalendarEventCalendarEventsCalendarEventIdDelete(calendarEventId, withSubsequentEventsInRecurrenceSeries, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Ai Clinical Notes Prefill Status
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAiClinicalNotesPrefillStatusAppointmentsAppointmentIdChartNotePrefillGet(appointmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<AIPrefillFieldsetResponse> {
            return localVarFp.getAiClinicalNotesPrefillStatusAppointmentsAppointmentIdChartNotePrefillGet(appointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is authenticated by either an appointment-based JWT token or a Cognito user.
         * @summary Get Appointment Add To Calendar Details
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentAddToCalendarDetailsAppointmentsAppointmentIdCalendarDetailsGet(appointmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<AppointmentAddToCalendarDetailsResponse> {
            return localVarFp.getAppointmentAddToCalendarDetailsAppointmentsAppointmentIdCalendarDetailsGet(appointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Appointment
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentAppointmentsAppointmentIdGet(appointmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<AppointmentResponse> {
            return localVarFp.getAppointmentAppointmentsAppointmentIdGet(appointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Appointments
         * @param {string | null} [providerId] 
         * @param {string | null} [patientId] 
         * @param {string | null} [before] 
         * @param {string | null} [after] 
         * @param {string | null} [startBefore] 
         * @param {string | null} [startAfter] 
         * @param {string | null} [endBefore] 
         * @param {string | null} [endAfter] 
         * @param {AllowedSortParam | null} [sort] 
         * @param {Array<AppointmentStatus> | null} [statuses] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentsAppointmentsGet(providerId?: string | null, patientId?: string | null, before?: string | null, after?: string | null, startBefore?: string | null, startAfter?: string | null, endBefore?: string | null, endAfter?: string | null, sort?: AllowedSortParam | null, statuses?: Array<AppointmentStatus> | null, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<AppointmentResponse>> {
            return localVarFp.getAppointmentsAppointmentsGet(providerId, patientId, before, after, startBefore, startAfter, endBefore, endAfter, sort, statuses, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Calendar Event
         * @param {string} calendarEventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalendarEventCalendarEventsCalendarEventIdGet(calendarEventId: string, options?: RawAxiosRequestConfig): AxiosPromise<CalendarEventResponse> {
            return localVarFp.getCalendarEventCalendarEventsCalendarEventIdGet(calendarEventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Calendar Events
         * @param {string} startTime 
         * @param {string} endTime 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalendarEventsCalendarEventsGet(startTime: string, endTime: string, options?: RawAxiosRequestConfig): AxiosPromise<CalendarEventsResponse> {
            return localVarFp.getCalendarEventsCalendarEventsGet(startTime, endTime, options).then((request) => request(axios, basePath));
        },
        /**
         * check_provider_can_access_appointment implicitly checks that the appointment  exists (and that the provider is allowed to access it) so we don\'t need  to do it redundantly here.
         * @summary Get Chart Note For Appointment
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChartNoteForAppointmentAppointmentsAppointmentIdChartNoteGet(appointmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<ChartNoteResponse> {
            return localVarFp.getChartNoteForAppointmentAppointmentsAppointmentIdChartNoteGet(appointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the PES options for the clinical form nutrition diagnosis.
         * @summary Get Pes Options
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPesOptionsPesOptionsGet(options?: RawAxiosRequestConfig): AxiosPromise<PESOptionsResponse> {
            return localVarFp.getPesOptionsPesOptionsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Provider Availability Schedule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderAvailabilityScheduleAvailabilityScheduleGet(options?: RawAxiosRequestConfig): AxiosPromise<ProviderAvailabilityScheduleResponse> {
            return localVarFp.getProviderAvailabilityScheduleAvailabilityScheduleGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list of available slots for the given provider between the given start and end times. The slots returned are the start times of the available slots in 15 minute increments.
         * @summary Get Provider Available Slots
         * @param {string} startTime 
         * @param {string} endTime 
         * @param {number} appointmentDurationInMinutes 
         * @param {string} providerId 
         * @param {string | null} [reschedulingToken] 
         * @param {string | null} [appointmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderAvailableSlotsAvailabilitySlotsGet(startTime: string, endTime: string, appointmentDurationInMinutes: number, providerId: string, reschedulingToken?: string | null, appointmentId?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<AvailabilitySlotsResponse> {
            return localVarFp.getProviderAvailableSlotsAvailabilitySlotsGet(startTime, endTime, appointmentDurationInMinutes, providerId, reschedulingToken, appointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Triggers AI prefill for the appointment\'s chart note and returns the latest prefill fieldset snapshot for client polling/UI state.
         * @summary Initialize Ai Clinical Notes Prefill
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initializeAiClinicalNotesPrefillAppointmentsAppointmentIdChartNotePrefillPost(appointmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<AIPrefillFieldsetResponse> {
            return localVarFp.initializeAiClinicalNotesPrefillAppointmentsAppointmentIdChartNotePrefillPost(appointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Reserve an appointment slot for a temporary period (default 15 minutes).  Returns a JWT token that can be used when booking the appointment to guarantee the slot is available.
         * @summary Reserve Appointment Slot
         * @param {ReserveSlotPayload} reserveSlotPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reserveAppointmentSlotAppointmentsReservePost(reserveSlotPayload: ReserveSlotPayload, options?: RawAxiosRequestConfig): AxiosPromise<ReserveSlotResponse> {
            return localVarFp.reserveAppointmentSlotAppointmentsReservePost(reserveSlotPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set Provider Availability Schedule
         * @param {UpdateProviderAvailabilitySchedulePayload} updateProviderAvailabilitySchedulePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setProviderAvailabilityScheduleAvailabilitySchedulePost(updateProviderAvailabilitySchedulePayload: UpdateProviderAvailabilitySchedulePayload, options?: RawAxiosRequestConfig): AxiosPromise<ProviderAvailabilityScheduleResponse> {
            return localVarFp.setProviderAvailabilityScheduleAvailabilitySchedulePost(updateProviderAvailabilitySchedulePayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Setup Patient And Book Appointment
         * @param {SetupPatientAndBookAppointmentPayload} setupPatientAndBookAppointmentPayload 
         * @param {string | null} [fayBookingReservationToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setupPatientAndBookAppointmentAppointmentsSetupPatientPost(setupPatientAndBookAppointmentPayload: SetupPatientAndBookAppointmentPayload, fayBookingReservationToken?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<SetupPatientAndBookAppointmentResponse> {
            return localVarFp.setupPatientAndBookAppointmentAppointmentsSetupPatientPost(setupPatientAndBookAppointmentPayload, fayBookingReservationToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sign Chart Note For Appointment
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signChartNoteForAppointmentAppointmentsAppointmentIdChartNoteSignPut(appointmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<ChartNoteResponse> {
            return localVarFp.signChartNoteForAppointmentAppointmentsAppointmentIdChartNoteSignPut(appointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Appointment
         * @param {string} appointmentId 
         * @param {UpdateAppointmentPayload} updateAppointmentPayload 
         * @param {string | null} [reschedulingToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAppointmentAppointmentsAppointmentIdPatch(appointmentId: string, updateAppointmentPayload: UpdateAppointmentPayload, reschedulingToken?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<AppointmentResponse> {
            return localVarFp.updateAppointmentAppointmentsAppointmentIdPatch(appointmentId, updateAppointmentPayload, reschedulingToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Calendar Event
         * @param {string} calendarEventId 
         * @param {UpdateCalendarEventPayload} updateCalendarEventPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCalendarEventCalendarEventsCalendarEventIdPut(calendarEventId: string, updateCalendarEventPayload: UpdateCalendarEventPayload, options?: RawAxiosRequestConfig): AxiosPromise<CalendarEventResponse> {
            return localVarFp.updateCalendarEventCalendarEventsCalendarEventIdPut(calendarEventId, updateCalendarEventPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Chart Note For Appointment
         * @param {string} appointmentId 
         * @param {UpdateChartNotePayload} updateChartNotePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateChartNoteForAppointmentAppointmentsAppointmentIdChartNotePatch(appointmentId: string, updateChartNotePayload: UpdateChartNotePayload, options?: RawAxiosRequestConfig): AxiosPromise<ChartNoteResponse> {
            return localVarFp.updateChartNoteForAppointmentAppointmentsAppointmentIdChartNotePatch(appointmentId, updateChartNotePayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Provider Availability Types
         * @param {UpdateProviderAvailabilityTypesPayload} updateProviderAvailabilityTypesPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProviderAvailabilityTypesAvailabilityScheduleAvailabilityTypesPut(updateProviderAvailabilityTypesPayload: UpdateProviderAvailabilityTypesPayload, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.updateProviderAvailabilityTypesAvailabilityScheduleAvailabilityTypesPut(updateProviderAvailabilityTypesPayload, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AppointmentApi - object-oriented interface
 */
export class AppointmentApi extends BaseAPI {
    /**
     * 
     * @summary Book Appointment
     * @param {BookAppointmentPayload} bookAppointmentPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public bookAppointmentAppointmentsPost(bookAppointmentPayload: BookAppointmentPayload, options?: RawAxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).bookAppointmentAppointmentsPost(bookAppointmentPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Cancel a specific AI prefill fieldset for the appointment\'s chart note.
     * @summary Cancel Ai Clinical Notes Prefill
     * @param {string} appointmentId 
     * @param {string} aiPrefillFieldsetId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public cancelAiClinicalNotesPrefillAppointmentsAppointmentIdChartNotePrefillAiPrefillFieldsetIdDelete(appointmentId: string, aiPrefillFieldsetId: string, options?: RawAxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).cancelAiClinicalNotesPrefillAppointmentsAppointmentIdChartNotePrefillAiPrefillFieldsetIdDelete(appointmentId, aiPrefillFieldsetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cancel Appointment
     * @param {string} appointmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public cancelAppointmentAppointmentAppointmentIdCancelPost(appointmentId: string, options?: RawAxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).cancelAppointmentAppointmentAppointmentIdCancelPost(appointmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Calendar Block
     * @param {CreateCalendarBlockPayload} createCalendarBlockPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createCalendarBlockCalendarEventsBlocksPost(createCalendarBlockPayload: CreateCalendarBlockPayload, options?: RawAxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).createCalendarBlockCalendarEventsBlocksPost(createCalendarBlockPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deprecated Get Chart Note For Appointment
     * @param {string} appointmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public dEPRECATEDGetChartNoteForAppointmentAppointmentAppointmentIdChartNoteGet(appointmentId: string, options?: RawAxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).dEPRECATEDGetChartNoteForAppointmentAppointmentAppointmentIdChartNoteGet(appointmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deprecated Update Chart Note For Appointment
     * @param {string} appointmentId 
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public dEPRECATEDUpdateChartNoteForAppointmentAppointmentAppointmentIdChartNotePut(appointmentId: string, body: string, options?: RawAxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).dEPRECATEDUpdateChartNoteForAppointmentAppointmentAppointmentIdChartNotePut(appointmentId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Calendar Event
     * @param {string} calendarEventId 
     * @param {boolean} withSubsequentEventsInRecurrenceSeries If true, all events after this event in the recurrence series will also be deleted. When false, only this event is deleted.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteCalendarEventCalendarEventsCalendarEventIdDelete(calendarEventId: string, withSubsequentEventsInRecurrenceSeries: boolean, options?: RawAxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).deleteCalendarEventCalendarEventsCalendarEventIdDelete(calendarEventId, withSubsequentEventsInRecurrenceSeries, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Ai Clinical Notes Prefill Status
     * @param {string} appointmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAiClinicalNotesPrefillStatusAppointmentsAppointmentIdChartNotePrefillGet(appointmentId: string, options?: RawAxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).getAiClinicalNotesPrefillStatusAppointmentsAppointmentIdChartNotePrefillGet(appointmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint is authenticated by either an appointment-based JWT token or a Cognito user.
     * @summary Get Appointment Add To Calendar Details
     * @param {string} appointmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAppointmentAddToCalendarDetailsAppointmentsAppointmentIdCalendarDetailsGet(appointmentId: string, options?: RawAxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).getAppointmentAddToCalendarDetailsAppointmentsAppointmentIdCalendarDetailsGet(appointmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Appointment
     * @param {string} appointmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAppointmentAppointmentsAppointmentIdGet(appointmentId: string, options?: RawAxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).getAppointmentAppointmentsAppointmentIdGet(appointmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Appointments
     * @param {string | null} [providerId] 
     * @param {string | null} [patientId] 
     * @param {string | null} [before] 
     * @param {string | null} [after] 
     * @param {string | null} [startBefore] 
     * @param {string | null} [startAfter] 
     * @param {string | null} [endBefore] 
     * @param {string | null} [endAfter] 
     * @param {AllowedSortParam | null} [sort] 
     * @param {Array<AppointmentStatus> | null} [statuses] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAppointmentsAppointmentsGet(providerId?: string | null, patientId?: string | null, before?: string | null, after?: string | null, startBefore?: string | null, startAfter?: string | null, endBefore?: string | null, endAfter?: string | null, sort?: AllowedSortParam | null, statuses?: Array<AppointmentStatus> | null, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).getAppointmentsAppointmentsGet(providerId, patientId, before, after, startBefore, startAfter, endBefore, endAfter, sort, statuses, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Calendar Event
     * @param {string} calendarEventId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCalendarEventCalendarEventsCalendarEventIdGet(calendarEventId: string, options?: RawAxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).getCalendarEventCalendarEventsCalendarEventIdGet(calendarEventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Calendar Events
     * @param {string} startTime 
     * @param {string} endTime 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCalendarEventsCalendarEventsGet(startTime: string, endTime: string, options?: RawAxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).getCalendarEventsCalendarEventsGet(startTime, endTime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * check_provider_can_access_appointment implicitly checks that the appointment  exists (and that the provider is allowed to access it) so we don\'t need  to do it redundantly here.
     * @summary Get Chart Note For Appointment
     * @param {string} appointmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getChartNoteForAppointmentAppointmentsAppointmentIdChartNoteGet(appointmentId: string, options?: RawAxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).getChartNoteForAppointmentAppointmentsAppointmentIdChartNoteGet(appointmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the PES options for the clinical form nutrition diagnosis.
     * @summary Get Pes Options
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPesOptionsPesOptionsGet(options?: RawAxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).getPesOptionsPesOptionsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Provider Availability Schedule
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProviderAvailabilityScheduleAvailabilityScheduleGet(options?: RawAxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).getProviderAvailabilityScheduleAvailabilityScheduleGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list of available slots for the given provider between the given start and end times. The slots returned are the start times of the available slots in 15 minute increments.
     * @summary Get Provider Available Slots
     * @param {string} startTime 
     * @param {string} endTime 
     * @param {number} appointmentDurationInMinutes 
     * @param {string} providerId 
     * @param {string | null} [reschedulingToken] 
     * @param {string | null} [appointmentId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProviderAvailableSlotsAvailabilitySlotsGet(startTime: string, endTime: string, appointmentDurationInMinutes: number, providerId: string, reschedulingToken?: string | null, appointmentId?: string | null, options?: RawAxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).getProviderAvailableSlotsAvailabilitySlotsGet(startTime, endTime, appointmentDurationInMinutes, providerId, reschedulingToken, appointmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Triggers AI prefill for the appointment\'s chart note and returns the latest prefill fieldset snapshot for client polling/UI state.
     * @summary Initialize Ai Clinical Notes Prefill
     * @param {string} appointmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public initializeAiClinicalNotesPrefillAppointmentsAppointmentIdChartNotePrefillPost(appointmentId: string, options?: RawAxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).initializeAiClinicalNotesPrefillAppointmentsAppointmentIdChartNotePrefillPost(appointmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reserve an appointment slot for a temporary period (default 15 minutes).  Returns a JWT token that can be used when booking the appointment to guarantee the slot is available.
     * @summary Reserve Appointment Slot
     * @param {ReserveSlotPayload} reserveSlotPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reserveAppointmentSlotAppointmentsReservePost(reserveSlotPayload: ReserveSlotPayload, options?: RawAxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).reserveAppointmentSlotAppointmentsReservePost(reserveSlotPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set Provider Availability Schedule
     * @param {UpdateProviderAvailabilitySchedulePayload} updateProviderAvailabilitySchedulePayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public setProviderAvailabilityScheduleAvailabilitySchedulePost(updateProviderAvailabilitySchedulePayload: UpdateProviderAvailabilitySchedulePayload, options?: RawAxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).setProviderAvailabilityScheduleAvailabilitySchedulePost(updateProviderAvailabilitySchedulePayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Setup Patient And Book Appointment
     * @param {SetupPatientAndBookAppointmentPayload} setupPatientAndBookAppointmentPayload 
     * @param {string | null} [fayBookingReservationToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public setupPatientAndBookAppointmentAppointmentsSetupPatientPost(setupPatientAndBookAppointmentPayload: SetupPatientAndBookAppointmentPayload, fayBookingReservationToken?: string | null, options?: RawAxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).setupPatientAndBookAppointmentAppointmentsSetupPatientPost(setupPatientAndBookAppointmentPayload, fayBookingReservationToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sign Chart Note For Appointment
     * @param {string} appointmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public signChartNoteForAppointmentAppointmentsAppointmentIdChartNoteSignPut(appointmentId: string, options?: RawAxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).signChartNoteForAppointmentAppointmentsAppointmentIdChartNoteSignPut(appointmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Appointment
     * @param {string} appointmentId 
     * @param {UpdateAppointmentPayload} updateAppointmentPayload 
     * @param {string | null} [reschedulingToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateAppointmentAppointmentsAppointmentIdPatch(appointmentId: string, updateAppointmentPayload: UpdateAppointmentPayload, reschedulingToken?: string | null, options?: RawAxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).updateAppointmentAppointmentsAppointmentIdPatch(appointmentId, updateAppointmentPayload, reschedulingToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Calendar Event
     * @param {string} calendarEventId 
     * @param {UpdateCalendarEventPayload} updateCalendarEventPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateCalendarEventCalendarEventsCalendarEventIdPut(calendarEventId: string, updateCalendarEventPayload: UpdateCalendarEventPayload, options?: RawAxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).updateCalendarEventCalendarEventsCalendarEventIdPut(calendarEventId, updateCalendarEventPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Chart Note For Appointment
     * @param {string} appointmentId 
     * @param {UpdateChartNotePayload} updateChartNotePayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateChartNoteForAppointmentAppointmentsAppointmentIdChartNotePatch(appointmentId: string, updateChartNotePayload: UpdateChartNotePayload, options?: RawAxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).updateChartNoteForAppointmentAppointmentsAppointmentIdChartNotePatch(appointmentId, updateChartNotePayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Provider Availability Types
     * @param {UpdateProviderAvailabilityTypesPayload} updateProviderAvailabilityTypesPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateProviderAvailabilityTypesAvailabilityScheduleAvailabilityTypesPut(updateProviderAvailabilityTypesPayload: UpdateProviderAvailabilityTypesPayload, options?: RawAxiosRequestConfig) {
        return AppointmentApiFp(this.configuration).updateProviderAvailabilityTypesAvailabilityScheduleAvailabilityTypesPut(updateProviderAvailabilityTypesPayload, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuthApi - axios parameter creator
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Begin Update Identity
         * @param {InitiateUpdateIdentityPayload} initiateUpdateIdentityPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        beginUpdateIdentityAuthUpdateIdentityPost: async (initiateUpdateIdentityPayload: InitiateUpdateIdentityPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'initiateUpdateIdentityPayload' is not null or undefined
            assertParamExists('beginUpdateIdentityAuthUpdateIdentityPost', 'initiateUpdateIdentityPayload', initiateUpdateIdentityPayload)
            const localVarPath = `/auth/update-identity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(initiateUpdateIdentityPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Can Patient Verify Phone Number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        canPatientVerifyPhoneNumberAuthIdentityCanVerifyPhoneNumberGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/identity/can-verify-phone-number`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Complete Login
         * @param {CompleteLoginChallengePayload} completeLoginChallengePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeLoginAuthLoginCompletePost: async (completeLoginChallengePayload: CompleteLoginChallengePayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'completeLoginChallengePayload' is not null or undefined
            assertParamExists('completeLoginAuthLoginCompletePost', 'completeLoginChallengePayload', completeLoginChallengePayload)
            const localVarPath = `/auth/login/complete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeLoginChallengePayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Complete Reset Password
         * @param {CompleteResetPasswordPayload} completeResetPasswordPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeResetPasswordAuthResetPasswordCompletePost: async (completeResetPasswordPayload: CompleteResetPasswordPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'completeResetPasswordPayload' is not null or undefined
            assertParamExists('completeResetPasswordAuthResetPasswordCompletePost', 'completeResetPasswordPayload', completeResetPasswordPayload)
            const localVarPath = `/auth/reset-password/complete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeResetPasswordPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Complete Update Identity
         * @param {CompleteLoginChallengePayload} completeLoginChallengePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeUpdateIdentityAuthUpdateIdentityCompletePost: async (completeLoginChallengePayload: CompleteLoginChallengePayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'completeLoginChallengePayload' is not null or undefined
            assertParamExists('completeUpdateIdentityAuthUpdateIdentityCompletePost', 'completeLoginChallengePayload', completeLoginChallengePayload)
            const localVarPath = `/auth/update-identity/complete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeLoginChallengePayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Login
         * @param {BeginPhoneLoginChallengePayload} beginPhoneLoginChallengePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAuthLoginPost: async (beginPhoneLoginChallengePayload: BeginPhoneLoginChallengePayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'beginPhoneLoginChallengePayload' is not null or undefined
            assertParamExists('loginAuthLoginPost', 'beginPhoneLoginChallengePayload', beginPhoneLoginChallengePayload)
            const localVarPath = `/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(beginPhoneLoginChallengePayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reset Password
         * @param {BeginResetPasswordPayload} beginResetPasswordPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPasswordAuthResetPasswordPost: async (beginResetPasswordPayload: BeginResetPasswordPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'beginResetPasswordPayload' is not null or undefined
            assertParamExists('resetPasswordAuthResetPasswordPost', 'beginResetPasswordPayload', beginResetPasswordPayload)
            const localVarPath = `/auth/reset-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(beginResetPasswordPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 */
export const AuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Begin Update Identity
         * @param {InitiateUpdateIdentityPayload} initiateUpdateIdentityPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async beginUpdateIdentityAuthUpdateIdentityPost(initiateUpdateIdentityPayload: InitiateUpdateIdentityPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateIdentityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.beginUpdateIdentityAuthUpdateIdentityPost(initiateUpdateIdentityPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.beginUpdateIdentityAuthUpdateIdentityPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Can Patient Verify Phone Number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async canPatientVerifyPhoneNumberAuthIdentityCanVerifyPhoneNumberGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.canPatientVerifyPhoneNumberAuthIdentityCanVerifyPhoneNumberGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.canPatientVerifyPhoneNumberAuthIdentityCanVerifyPhoneNumberGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Complete Login
         * @param {CompleteLoginChallengePayload} completeLoginChallengePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeLoginAuthLoginCompletePost(completeLoginChallengePayload: CompleteLoginChallengePayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completeLoginAuthLoginCompletePost(completeLoginChallengePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.completeLoginAuthLoginCompletePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Complete Reset Password
         * @param {CompleteResetPasswordPayload} completeResetPasswordPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeResetPasswordAuthResetPasswordCompletePost(completeResetPasswordPayload: CompleteResetPasswordPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResetPasswordResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completeResetPasswordAuthResetPasswordCompletePost(completeResetPasswordPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.completeResetPasswordAuthResetPasswordCompletePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Complete Update Identity
         * @param {CompleteLoginChallengePayload} completeLoginChallengePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeUpdateIdentityAuthUpdateIdentityCompletePost(completeLoginChallengePayload: CompleteLoginChallengePayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateIdentityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completeUpdateIdentityAuthUpdateIdentityCompletePost(completeLoginChallengePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.completeUpdateIdentityAuthUpdateIdentityCompletePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Login
         * @param {BeginPhoneLoginChallengePayload} beginPhoneLoginChallengePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginAuthLoginPost(beginPhoneLoginChallengePayload: BeginPhoneLoginChallengePayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginAuthLoginPost(beginPhoneLoginChallengePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.loginAuthLoginPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reset Password
         * @param {BeginResetPasswordPayload} beginResetPasswordPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetPasswordAuthResetPasswordPost(beginResetPasswordPayload: BeginResetPasswordPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResetPasswordResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetPasswordAuthResetPasswordPost(beginResetPasswordPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.resetPasswordAuthResetPasswordPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthApi - factory interface
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthApiFp(configuration)
    return {
        /**
         * 
         * @summary Begin Update Identity
         * @param {InitiateUpdateIdentityPayload} initiateUpdateIdentityPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        beginUpdateIdentityAuthUpdateIdentityPost(initiateUpdateIdentityPayload: InitiateUpdateIdentityPayload, options?: RawAxiosRequestConfig): AxiosPromise<UpdateIdentityResponse> {
            return localVarFp.beginUpdateIdentityAuthUpdateIdentityPost(initiateUpdateIdentityPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Can Patient Verify Phone Number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        canPatientVerifyPhoneNumberAuthIdentityCanVerifyPhoneNumberGet(options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.canPatientVerifyPhoneNumberAuthIdentityCanVerifyPhoneNumberGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Complete Login
         * @param {CompleteLoginChallengePayload} completeLoginChallengePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeLoginAuthLoginCompletePost(completeLoginChallengePayload: CompleteLoginChallengePayload, options?: RawAxiosRequestConfig): AxiosPromise<LoginResponse> {
            return localVarFp.completeLoginAuthLoginCompletePost(completeLoginChallengePayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Complete Reset Password
         * @param {CompleteResetPasswordPayload} completeResetPasswordPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeResetPasswordAuthResetPasswordCompletePost(completeResetPasswordPayload: CompleteResetPasswordPayload, options?: RawAxiosRequestConfig): AxiosPromise<ResetPasswordResponse> {
            return localVarFp.completeResetPasswordAuthResetPasswordCompletePost(completeResetPasswordPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Complete Update Identity
         * @param {CompleteLoginChallengePayload} completeLoginChallengePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeUpdateIdentityAuthUpdateIdentityCompletePost(completeLoginChallengePayload: CompleteLoginChallengePayload, options?: RawAxiosRequestConfig): AxiosPromise<UpdateIdentityResponse> {
            return localVarFp.completeUpdateIdentityAuthUpdateIdentityCompletePost(completeLoginChallengePayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Login
         * @param {BeginPhoneLoginChallengePayload} beginPhoneLoginChallengePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAuthLoginPost(beginPhoneLoginChallengePayload: BeginPhoneLoginChallengePayload, options?: RawAxiosRequestConfig): AxiosPromise<LoginResponse> {
            return localVarFp.loginAuthLoginPost(beginPhoneLoginChallengePayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reset Password
         * @param {BeginResetPasswordPayload} beginResetPasswordPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPasswordAuthResetPasswordPost(beginResetPasswordPayload: BeginResetPasswordPayload, options?: RawAxiosRequestConfig): AxiosPromise<ResetPasswordResponse> {
            return localVarFp.resetPasswordAuthResetPasswordPost(beginResetPasswordPayload, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthApi - object-oriented interface
 */
export class AuthApi extends BaseAPI {
    /**
     * 
     * @summary Begin Update Identity
     * @param {InitiateUpdateIdentityPayload} initiateUpdateIdentityPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public beginUpdateIdentityAuthUpdateIdentityPost(initiateUpdateIdentityPayload: InitiateUpdateIdentityPayload, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).beginUpdateIdentityAuthUpdateIdentityPost(initiateUpdateIdentityPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Can Patient Verify Phone Number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public canPatientVerifyPhoneNumberAuthIdentityCanVerifyPhoneNumberGet(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).canPatientVerifyPhoneNumberAuthIdentityCanVerifyPhoneNumberGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Complete Login
     * @param {CompleteLoginChallengePayload} completeLoginChallengePayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public completeLoginAuthLoginCompletePost(completeLoginChallengePayload: CompleteLoginChallengePayload, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).completeLoginAuthLoginCompletePost(completeLoginChallengePayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Complete Reset Password
     * @param {CompleteResetPasswordPayload} completeResetPasswordPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public completeResetPasswordAuthResetPasswordCompletePost(completeResetPasswordPayload: CompleteResetPasswordPayload, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).completeResetPasswordAuthResetPasswordCompletePost(completeResetPasswordPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Complete Update Identity
     * @param {CompleteLoginChallengePayload} completeLoginChallengePayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public completeUpdateIdentityAuthUpdateIdentityCompletePost(completeLoginChallengePayload: CompleteLoginChallengePayload, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).completeUpdateIdentityAuthUpdateIdentityCompletePost(completeLoginChallengePayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Login
     * @param {BeginPhoneLoginChallengePayload} beginPhoneLoginChallengePayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public loginAuthLoginPost(beginPhoneLoginChallengePayload: BeginPhoneLoginChallengePayload, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).loginAuthLoginPost(beginPhoneLoginChallengePayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reset Password
     * @param {BeginResetPasswordPayload} beginResetPasswordPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public resetPasswordAuthResetPasswordPost(beginResetPasswordPayload: BeginResetPasswordPayload, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).resetPasswordAuthResetPasswordPost(beginResetPasswordPayload, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ChatApi - axios parameter creator
 */
export const ChatApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Fetches a chat channel for the current user.
         * @summary Get Chat Channel
         * @param {string} chatChannelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatChannelChatChannelsChatChannelIdGet: async (chatChannelId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatChannelId' is not null or undefined
            assertParamExists('getChatChannelChatChannelsChatChannelIdGet', 'chatChannelId', chatChannelId)
            const localVarPath = `/chat/channels/{chat_channel_id}`
                .replace(`{${"chat_channel_id"}}`, encodeURIComponent(String(chatChannelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sorted by sent_at descending (most recent first). If sent_after is provided, fetch messages sent after the provided time. If sent_before is provided, fetch messages sent before the provided time.  The earliest and latest sent_at times are returned for pagination.
         * @summary Get Chat Channel Messages
         * @param {string} chatChannelId 
         * @param {string | null} [updatedAfter] 
         * @param {string | null} [sentAfter] 
         * @param {string | null} [sentBefore] 
         * @param {number} [limit] 
         * @param {SortOrdering} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatChannelMessagesChatChannelsChatChannelIdMessagesGet: async (chatChannelId: string, updatedAfter?: string | null, sentAfter?: string | null, sentBefore?: string | null, limit?: number, order?: SortOrdering, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatChannelId' is not null or undefined
            assertParamExists('getChatChannelMessagesChatChannelsChatChannelIdMessagesGet', 'chatChannelId', chatChannelId)
            const localVarPath = `/chat/channels/{chat_channel_id}/messages`
                .replace(`{${"chat_channel_id"}}`, encodeURIComponent(String(chatChannelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (updatedAfter !== undefined) {
                localVarQueryParameter['updated_after'] = (updatedAfter as any instanceof Date) ?
                    (updatedAfter as any).toISOString() :
                    updatedAfter;
            }

            if (sentAfter !== undefined) {
                localVarQueryParameter['sent_after'] = (sentAfter as any instanceof Date) ?
                    (sentAfter as any).toISOString() :
                    sentAfter;
            }

            if (sentBefore !== undefined) {
                localVarQueryParameter['sent_before'] = (sentBefore as any instanceof Date) ?
                    (sentBefore as any).toISOString() :
                    sentBefore;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetches a list of chat channels for the current user.  It is ordered by last activity time first (e.g. message sent), created at second. NOTE: this is not a stable ordering. An acceptable design tradeoff.  If provider_id is provided, filter the channels for a matching provider in the conversation participants. If patient_id is provided, filter the channels for a matching patient in the conversation participants. If updated_after is provided, fetch channels updated after the provided time. If updated_before is provided, fetch channels updated before the provided time.  If more results than the limit are available, the response provides a cursor to be used for pagination. - `latest_updated_at` is returned if no `updated_` or `updated_after` was set. - `earliest_updated_at` is returned if `updated_before` was set.
         * @summary Get Chat Channels
         * @param {string | null} [providerId] 
         * @param {string | null} [patientId] 
         * @param {string | null} [updatedAfter] 
         * @param {string | null} [updatedBefore] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatChannelsChatChannelsGet: async (providerId?: string | null, patientId?: string | null, updatedAfter?: string | null, updatedBefore?: string | null, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/chat/channels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (providerId !== undefined) {
                localVarQueryParameter['provider_id'] = providerId;
            }

            if (patientId !== undefined) {
                localVarQueryParameter['patient_id'] = patientId;
            }

            if (updatedAfter !== undefined) {
                localVarQueryParameter['updated_after'] = (updatedAfter as any instanceof Date) ?
                    (updatedAfter as any).toISOString() :
                    updatedAfter;
            }

            if (updatedBefore !== undefined) {
                localVarQueryParameter['updated_before'] = (updatedBefore as any instanceof Date) ?
                    (updatedBefore as any).toISOString() :
                    updatedBefore;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Chat Message Attachment
         * @param {string} channelId 
         * @param {string} messageId 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatMessageAttachmentChatChannelsChannelIdMessagesMessageIdAttachmentsAttachmentIdGet: async (channelId: string, messageId: string, attachmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'channelId' is not null or undefined
            assertParamExists('getChatMessageAttachmentChatChannelsChannelIdMessagesMessageIdAttachmentsAttachmentIdGet', 'channelId', channelId)
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('getChatMessageAttachmentChatChannelsChannelIdMessagesMessageIdAttachmentsAttachmentIdGet', 'messageId', messageId)
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('getChatMessageAttachmentChatChannelsChannelIdMessagesMessageIdAttachmentsAttachmentIdGet', 'attachmentId', attachmentId)
            const localVarPath = `/chat/channels/{channel_id}/messages/{message_id}/attachments/{attachment_id}`
                .replace(`{${"channel_id"}}`, encodeURIComponent(String(channelId)))
                .replace(`{${"message_id"}}`, encodeURIComponent(String(messageId)))
                .replace(`{${"attachment_id"}}`, encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetches a single chat message by its ID from the specified channel.
         * @summary Get Chat Message
         * @param {string} channelId 
         * @param {string} messageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatMessageChatChannelsChannelIdMessagesMessageIdGet: async (channelId: string, messageId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'channelId' is not null or undefined
            assertParamExists('getChatMessageChatChannelsChannelIdMessagesMessageIdGet', 'channelId', channelId)
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('getChatMessageChatChannelsChannelIdMessagesMessageIdGet', 'messageId', messageId)
            const localVarPath = `/chat/channels/{channel_id}/messages/{message_id}`
                .replace(`{${"channel_id"}}`, encodeURIComponent(String(channelId)))
                .replace(`{${"message_id"}}`, encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetches the count of unread chat channels for the current user.
         * @summary Get Chat Metadata Channels Unread
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatMetadataChannelsUnreadChatMetadataChannelsUnreadGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/chat/metadata/channels/unread`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Post Chat Channel Message
         * @param {string} chatChannelId 
         * @param {SendChatMessagePayload} sendChatMessagePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postChatChannelMessageChatChannelsChatChannelIdMessagesPost: async (chatChannelId: string, sendChatMessagePayload: SendChatMessagePayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatChannelId' is not null or undefined
            assertParamExists('postChatChannelMessageChatChannelsChatChannelIdMessagesPost', 'chatChannelId', chatChannelId)
            // verify required parameter 'sendChatMessagePayload' is not null or undefined
            assertParamExists('postChatChannelMessageChatChannelsChatChannelIdMessagesPost', 'sendChatMessagePayload', sendChatMessagePayload)
            const localVarPath = `/chat/channels/{chat_channel_id}/messages`
                .replace(`{${"chat_channel_id"}}`, encodeURIComponent(String(chatChannelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendChatMessagePayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Marks all messages in the `chat_channel` read before `read_sent_at`.  Only marks messages for which the user was not the sender.
         * @summary Post Chat Channel Read
         * @param {string} chatChannelId 
         * @param {string} readSentAt 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postChatChannelReadChatChannelsChatChannelIdReadPost: async (chatChannelId: string, readSentAt: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatChannelId' is not null or undefined
            assertParamExists('postChatChannelReadChatChannelsChatChannelIdReadPost', 'chatChannelId', chatChannelId)
            // verify required parameter 'readSentAt' is not null or undefined
            assertParamExists('postChatChannelReadChatChannelsChatChannelIdReadPost', 'readSentAt', readSentAt)
            const localVarPath = `/chat/channels/{chat_channel_id}/read`
                .replace(`{${"chat_channel_id"}}`, encodeURIComponent(String(chatChannelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (readSentAt !== undefined) {
                localVarQueryParameter['read_sent_at'] = (readSentAt as any instanceof Date) ?
                    (readSentAt as any).toISOString() :
                    readSentAt;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Store Messages From Chime
         * @param {ChimeBridgePayload} chimeBridgePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeMessagesFromChimeChatChimeBridgePost: async (chimeBridgePayload: ChimeBridgePayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chimeBridgePayload' is not null or undefined
            assertParamExists('storeMessagesFromChimeChatChimeBridgePost', 'chimeBridgePayload', chimeBridgePayload)
            const localVarPath = `/chat/chime-bridge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chimeBridgePayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Suggest Chat Response
         * @param {SuggestChatResponsePayload} suggestChatResponsePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestChatResponseChatSuggestionPost: async (suggestChatResponsePayload: SuggestChatResponsePayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'suggestChatResponsePayload' is not null or undefined
            assertParamExists('suggestChatResponseChatSuggestionPost', 'suggestChatResponsePayload', suggestChatResponsePayload)
            const localVarPath = `/chat/suggestion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(suggestChatResponsePayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChatApi - functional programming interface
 */
export const ChatApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChatApiAxiosParamCreator(configuration)
    return {
        /**
         * Fetches a chat channel for the current user.
         * @summary Get Chat Channel
         * @param {string} chatChannelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChatChannelChatChannelsChatChannelIdGet(chatChannelId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatChannelResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChatChannelChatChannelsChatChannelIdGet(chatChannelId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.getChatChannelChatChannelsChatChannelIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sorted by sent_at descending (most recent first). If sent_after is provided, fetch messages sent after the provided time. If sent_before is provided, fetch messages sent before the provided time.  The earliest and latest sent_at times are returned for pagination.
         * @summary Get Chat Channel Messages
         * @param {string} chatChannelId 
         * @param {string | null} [updatedAfter] 
         * @param {string | null} [sentAfter] 
         * @param {string | null} [sentBefore] 
         * @param {number} [limit] 
         * @param {SortOrdering} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChatChannelMessagesChatChannelsChatChannelIdMessagesGet(chatChannelId: string, updatedAfter?: string | null, sentAfter?: string | null, sentBefore?: string | null, limit?: number, order?: SortOrdering, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatMessagesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChatChannelMessagesChatChannelsChatChannelIdMessagesGet(chatChannelId, updatedAfter, sentAfter, sentBefore, limit, order, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.getChatChannelMessagesChatChannelsChatChannelIdMessagesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetches a list of chat channels for the current user.  It is ordered by last activity time first (e.g. message sent), created at second. NOTE: this is not a stable ordering. An acceptable design tradeoff.  If provider_id is provided, filter the channels for a matching provider in the conversation participants. If patient_id is provided, filter the channels for a matching patient in the conversation participants. If updated_after is provided, fetch channels updated after the provided time. If updated_before is provided, fetch channels updated before the provided time.  If more results than the limit are available, the response provides a cursor to be used for pagination. - `latest_updated_at` is returned if no `updated_` or `updated_after` was set. - `earliest_updated_at` is returned if `updated_before` was set.
         * @summary Get Chat Channels
         * @param {string | null} [providerId] 
         * @param {string | null} [patientId] 
         * @param {string | null} [updatedAfter] 
         * @param {string | null} [updatedBefore] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChatChannelsChatChannelsGet(providerId?: string | null, patientId?: string | null, updatedAfter?: string | null, updatedBefore?: string | null, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatChannelsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChatChannelsChatChannelsGet(providerId, patientId, updatedAfter, updatedBefore, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.getChatChannelsChatChannelsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Chat Message Attachment
         * @param {string} channelId 
         * @param {string} messageId 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChatMessageAttachmentChatChannelsChannelIdMessagesMessageIdAttachmentsAttachmentIdGet(channelId: string, messageId: string, attachmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatMessageAttachmentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChatMessageAttachmentChatChannelsChannelIdMessagesMessageIdAttachmentsAttachmentIdGet(channelId, messageId, attachmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.getChatMessageAttachmentChatChannelsChannelIdMessagesMessageIdAttachmentsAttachmentIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetches a single chat message by its ID from the specified channel.
         * @summary Get Chat Message
         * @param {string} channelId 
         * @param {string} messageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChatMessageChatChannelsChannelIdMessagesMessageIdGet(channelId: string, messageId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatMessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChatMessageChatChannelsChannelIdMessagesMessageIdGet(channelId, messageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.getChatMessageChatChannelsChannelIdMessagesMessageIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetches the count of unread chat channels for the current user.
         * @summary Get Chat Metadata Channels Unread
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChatMetadataChannelsUnreadChatMetadataChannelsUnreadGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatChannelsUnreadCountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChatMetadataChannelsUnreadChatMetadataChannelsUnreadGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.getChatMetadataChannelsUnreadChatMetadataChannelsUnreadGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Post Chat Channel Message
         * @param {string} chatChannelId 
         * @param {SendChatMessagePayload} sendChatMessagePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postChatChannelMessageChatChannelsChatChannelIdMessagesPost(chatChannelId: string, sendChatMessagePayload: SendChatMessagePayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatMessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postChatChannelMessageChatChannelsChatChannelIdMessagesPost(chatChannelId, sendChatMessagePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.postChatChannelMessageChatChannelsChatChannelIdMessagesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Marks all messages in the `chat_channel` read before `read_sent_at`.  Only marks messages for which the user was not the sender.
         * @summary Post Chat Channel Read
         * @param {string} chatChannelId 
         * @param {string} readSentAt 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postChatChannelReadChatChannelsChatChannelIdReadPost(chatChannelId: string, readSentAt: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postChatChannelReadChatChannelsChatChannelIdReadPost(chatChannelId, readSentAt, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.postChatChannelReadChatChannelsChatChannelIdReadPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Store Messages From Chime
         * @param {ChimeBridgePayload} chimeBridgePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storeMessagesFromChimeChatChimeBridgePost(chimeBridgePayload: ChimeBridgePayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: boolean; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storeMessagesFromChimeChatChimeBridgePost(chimeBridgePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.storeMessagesFromChimeChatChimeBridgePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Suggest Chat Response
         * @param {SuggestChatResponsePayload} suggestChatResponsePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async suggestChatResponseChatSuggestionPost(suggestChatResponsePayload: SuggestChatResponsePayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuggestChatResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.suggestChatResponseChatSuggestionPost(suggestChatResponsePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.suggestChatResponseChatSuggestionPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ChatApi - factory interface
 */
export const ChatApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChatApiFp(configuration)
    return {
        /**
         * Fetches a chat channel for the current user.
         * @summary Get Chat Channel
         * @param {string} chatChannelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatChannelChatChannelsChatChannelIdGet(chatChannelId: string, options?: RawAxiosRequestConfig): AxiosPromise<ChatChannelResponse> {
            return localVarFp.getChatChannelChatChannelsChatChannelIdGet(chatChannelId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sorted by sent_at descending (most recent first). If sent_after is provided, fetch messages sent after the provided time. If sent_before is provided, fetch messages sent before the provided time.  The earliest and latest sent_at times are returned for pagination.
         * @summary Get Chat Channel Messages
         * @param {string} chatChannelId 
         * @param {string | null} [updatedAfter] 
         * @param {string | null} [sentAfter] 
         * @param {string | null} [sentBefore] 
         * @param {number} [limit] 
         * @param {SortOrdering} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatChannelMessagesChatChannelsChatChannelIdMessagesGet(chatChannelId: string, updatedAfter?: string | null, sentAfter?: string | null, sentBefore?: string | null, limit?: number, order?: SortOrdering, options?: RawAxiosRequestConfig): AxiosPromise<ChatMessagesResponse> {
            return localVarFp.getChatChannelMessagesChatChannelsChatChannelIdMessagesGet(chatChannelId, updatedAfter, sentAfter, sentBefore, limit, order, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetches a list of chat channels for the current user.  It is ordered by last activity time first (e.g. message sent), created at second. NOTE: this is not a stable ordering. An acceptable design tradeoff.  If provider_id is provided, filter the channels for a matching provider in the conversation participants. If patient_id is provided, filter the channels for a matching patient in the conversation participants. If updated_after is provided, fetch channels updated after the provided time. If updated_before is provided, fetch channels updated before the provided time.  If more results than the limit are available, the response provides a cursor to be used for pagination. - `latest_updated_at` is returned if no `updated_` or `updated_after` was set. - `earliest_updated_at` is returned if `updated_before` was set.
         * @summary Get Chat Channels
         * @param {string | null} [providerId] 
         * @param {string | null} [patientId] 
         * @param {string | null} [updatedAfter] 
         * @param {string | null} [updatedBefore] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatChannelsChatChannelsGet(providerId?: string | null, patientId?: string | null, updatedAfter?: string | null, updatedBefore?: string | null, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<ChatChannelsResponse> {
            return localVarFp.getChatChannelsChatChannelsGet(providerId, patientId, updatedAfter, updatedBefore, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Chat Message Attachment
         * @param {string} channelId 
         * @param {string} messageId 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatMessageAttachmentChatChannelsChannelIdMessagesMessageIdAttachmentsAttachmentIdGet(channelId: string, messageId: string, attachmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<ChatMessageAttachmentResponse> {
            return localVarFp.getChatMessageAttachmentChatChannelsChannelIdMessagesMessageIdAttachmentsAttachmentIdGet(channelId, messageId, attachmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetches a single chat message by its ID from the specified channel.
         * @summary Get Chat Message
         * @param {string} channelId 
         * @param {string} messageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatMessageChatChannelsChannelIdMessagesMessageIdGet(channelId: string, messageId: string, options?: RawAxiosRequestConfig): AxiosPromise<ChatMessageResponse> {
            return localVarFp.getChatMessageChatChannelsChannelIdMessagesMessageIdGet(channelId, messageId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetches the count of unread chat channels for the current user.
         * @summary Get Chat Metadata Channels Unread
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatMetadataChannelsUnreadChatMetadataChannelsUnreadGet(options?: RawAxiosRequestConfig): AxiosPromise<ChatChannelsUnreadCountResponse> {
            return localVarFp.getChatMetadataChannelsUnreadChatMetadataChannelsUnreadGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Post Chat Channel Message
         * @param {string} chatChannelId 
         * @param {SendChatMessagePayload} sendChatMessagePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postChatChannelMessageChatChannelsChatChannelIdMessagesPost(chatChannelId: string, sendChatMessagePayload: SendChatMessagePayload, options?: RawAxiosRequestConfig): AxiosPromise<ChatMessageResponse> {
            return localVarFp.postChatChannelMessageChatChannelsChatChannelIdMessagesPost(chatChannelId, sendChatMessagePayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Marks all messages in the `chat_channel` read before `read_sent_at`.  Only marks messages for which the user was not the sender.
         * @summary Post Chat Channel Read
         * @param {string} chatChannelId 
         * @param {string} readSentAt 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postChatChannelReadChatChannelsChatChannelIdReadPost(chatChannelId: string, readSentAt: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.postChatChannelReadChatChannelsChatChannelIdReadPost(chatChannelId, readSentAt, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Store Messages From Chime
         * @param {ChimeBridgePayload} chimeBridgePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeMessagesFromChimeChatChimeBridgePost(chimeBridgePayload: ChimeBridgePayload, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: boolean; }> {
            return localVarFp.storeMessagesFromChimeChatChimeBridgePost(chimeBridgePayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Suggest Chat Response
         * @param {SuggestChatResponsePayload} suggestChatResponsePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestChatResponseChatSuggestionPost(suggestChatResponsePayload: SuggestChatResponsePayload, options?: RawAxiosRequestConfig): AxiosPromise<SuggestChatResponseResponse> {
            return localVarFp.suggestChatResponseChatSuggestionPost(suggestChatResponsePayload, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ChatApi - object-oriented interface
 */
export class ChatApi extends BaseAPI {
    /**
     * Fetches a chat channel for the current user.
     * @summary Get Chat Channel
     * @param {string} chatChannelId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getChatChannelChatChannelsChatChannelIdGet(chatChannelId: string, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).getChatChannelChatChannelsChatChannelIdGet(chatChannelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sorted by sent_at descending (most recent first). If sent_after is provided, fetch messages sent after the provided time. If sent_before is provided, fetch messages sent before the provided time.  The earliest and latest sent_at times are returned for pagination.
     * @summary Get Chat Channel Messages
     * @param {string} chatChannelId 
     * @param {string | null} [updatedAfter] 
     * @param {string | null} [sentAfter] 
     * @param {string | null} [sentBefore] 
     * @param {number} [limit] 
     * @param {SortOrdering} [order] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getChatChannelMessagesChatChannelsChatChannelIdMessagesGet(chatChannelId: string, updatedAfter?: string | null, sentAfter?: string | null, sentBefore?: string | null, limit?: number, order?: SortOrdering, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).getChatChannelMessagesChatChannelsChatChannelIdMessagesGet(chatChannelId, updatedAfter, sentAfter, sentBefore, limit, order, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetches a list of chat channels for the current user.  It is ordered by last activity time first (e.g. message sent), created at second. NOTE: this is not a stable ordering. An acceptable design tradeoff.  If provider_id is provided, filter the channels for a matching provider in the conversation participants. If patient_id is provided, filter the channels for a matching patient in the conversation participants. If updated_after is provided, fetch channels updated after the provided time. If updated_before is provided, fetch channels updated before the provided time.  If more results than the limit are available, the response provides a cursor to be used for pagination. - `latest_updated_at` is returned if no `updated_` or `updated_after` was set. - `earliest_updated_at` is returned if `updated_before` was set.
     * @summary Get Chat Channels
     * @param {string | null} [providerId] 
     * @param {string | null} [patientId] 
     * @param {string | null} [updatedAfter] 
     * @param {string | null} [updatedBefore] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getChatChannelsChatChannelsGet(providerId?: string | null, patientId?: string | null, updatedAfter?: string | null, updatedBefore?: string | null, limit?: number, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).getChatChannelsChatChannelsGet(providerId, patientId, updatedAfter, updatedBefore, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Chat Message Attachment
     * @param {string} channelId 
     * @param {string} messageId 
     * @param {string} attachmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getChatMessageAttachmentChatChannelsChannelIdMessagesMessageIdAttachmentsAttachmentIdGet(channelId: string, messageId: string, attachmentId: string, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).getChatMessageAttachmentChatChannelsChannelIdMessagesMessageIdAttachmentsAttachmentIdGet(channelId, messageId, attachmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetches a single chat message by its ID from the specified channel.
     * @summary Get Chat Message
     * @param {string} channelId 
     * @param {string} messageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getChatMessageChatChannelsChannelIdMessagesMessageIdGet(channelId: string, messageId: string, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).getChatMessageChatChannelsChannelIdMessagesMessageIdGet(channelId, messageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetches the count of unread chat channels for the current user.
     * @summary Get Chat Metadata Channels Unread
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getChatMetadataChannelsUnreadChatMetadataChannelsUnreadGet(options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).getChatMetadataChannelsUnreadChatMetadataChannelsUnreadGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Post Chat Channel Message
     * @param {string} chatChannelId 
     * @param {SendChatMessagePayload} sendChatMessagePayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postChatChannelMessageChatChannelsChatChannelIdMessagesPost(chatChannelId: string, sendChatMessagePayload: SendChatMessagePayload, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).postChatChannelMessageChatChannelsChatChannelIdMessagesPost(chatChannelId, sendChatMessagePayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Marks all messages in the `chat_channel` read before `read_sent_at`.  Only marks messages for which the user was not the sender.
     * @summary Post Chat Channel Read
     * @param {string} chatChannelId 
     * @param {string} readSentAt 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postChatChannelReadChatChannelsChatChannelIdReadPost(chatChannelId: string, readSentAt: string, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).postChatChannelReadChatChannelsChatChannelIdReadPost(chatChannelId, readSentAt, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Store Messages From Chime
     * @param {ChimeBridgePayload} chimeBridgePayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public storeMessagesFromChimeChatChimeBridgePost(chimeBridgePayload: ChimeBridgePayload, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).storeMessagesFromChimeChatChimeBridgePost(chimeBridgePayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Suggest Chat Response
     * @param {SuggestChatResponsePayload} suggestChatResponsePayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public suggestChatResponseChatSuggestionPost(suggestChatResponsePayload: SuggestChatResponsePayload, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).suggestChatResponseChatSuggestionPost(suggestChatResponsePayload, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClaimsApi - axios parameter creator
 */
export const ClaimsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add Claim Prefixes
         * @param {AddClaimPrefixesPayload} addClaimPrefixesPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addClaimPrefixesAdminClaimsAddPrefixesPost: async (addClaimPrefixesPayload: AddClaimPrefixesPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addClaimPrefixesPayload' is not null or undefined
            assertParamExists('addClaimPrefixesAdminClaimsAddPrefixesPost', 'addClaimPrefixesPayload', addClaimPrefixesPayload)
            const localVarPath = `/admin/claims/add-prefixes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addClaimPrefixesPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Cancel Client Care
         * @param {string} careId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelClientCareMyClientCareCareIdCancelPost: async (careId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'careId' is not null or undefined
            assertParamExists('cancelClientCareMyClientCareCareIdCancelPost', 'careId', careId)
            const localVarPath = `/my-client-care/{care_id}/cancel`
                .replace(`{${"care_id"}}`, encodeURIComponent(String(careId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Claim
         * @param {CreateClaimPayload} createClaimPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClaimClaimsPost: async (createClaimPayload: CreateClaimPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createClaimPayload' is not null or undefined
            assertParamExists('createClaimClaimsPost', 'createClaimPayload', createClaimPayload)
            const localVarPath = `/claims`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createClaimPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Claims From Specifications
         * @param {CreateClaimsFromSpecificationsPayload} createClaimsFromSpecificationsPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClaimsFromSpecificationsAdminClaimsCreateFromSpecificationsPost: async (createClaimsFromSpecificationsPayload: CreateClaimsFromSpecificationsPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createClaimsFromSpecificationsPayload' is not null or undefined
            assertParamExists('createClaimsFromSpecificationsAdminClaimsCreateFromSpecificationsPost', 'createClaimsFromSpecificationsPayload', createClaimsFromSpecificationsPayload)
            const localVarPath = `/admin/claims/create-from-specifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createClaimsFromSpecificationsPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get New Encounters Since Time
         * @param {string} since 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewEncountersSinceTimeClientEngagementRewardGet: async (since: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'since' is not null or undefined
            assertParamExists('getNewEncountersSinceTimeClientEngagementRewardGet', 'since', since)
            const localVarPath = `/client-engagement-reward`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (since !== undefined) {
                localVarQueryParameter['since'] = (since as any instanceof Date) ?
                    (since as any).toISOString() :
                    since;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary My Client Care Details
         * @param {string} careId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        myClientCareDetailsMyClientCareCareIdGet: async (careId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'careId' is not null or undefined
            assertParamExists('myClientCareDetailsMyClientCareCareIdGet', 'careId', careId)
            const localVarPath = `/my-client-care/{care_id}`
                .replace(`{${"care_id"}}`, encodeURIComponent(String(careId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary My Client Care
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        myClientCareMyClientCareGet: async (page?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/my-client-care`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Preview Claims From Appointments
         * @param {ClaimPreviewPayload} claimPreviewPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewClaimsFromAppointmentsAdminClaimPreviewsFromAppointmentsPost: async (claimPreviewPayload: ClaimPreviewPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'claimPreviewPayload' is not null or undefined
            assertParamExists('previewClaimsFromAppointmentsAdminClaimPreviewsFromAppointmentsPost', 'claimPreviewPayload', claimPreviewPayload)
            const localVarPath = `/admin/claim-previews/from-appointments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(claimPreviewPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Preview Claims From Claims
         * @param {ClaimPreviewFromClaimsPayload} claimPreviewFromClaimsPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewClaimsFromClaimsAdminClaimPreviewsFromClaimsPost: async (claimPreviewFromClaimsPayload: ClaimPreviewFromClaimsPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'claimPreviewFromClaimsPayload' is not null or undefined
            assertParamExists('previewClaimsFromClaimsAdminClaimPreviewsFromClaimsPost', 'claimPreviewFromClaimsPayload', claimPreviewFromClaimsPayload)
            const localVarPath = `/admin/claim-previews/from-claims`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(claimPreviewFromClaimsPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resubmit Claims From Specifications
         * @param {ResubmitClaimsFromSpecificationsPayload} resubmitClaimsFromSpecificationsPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resubmitClaimsFromSpecificationsAdminClaimsResubmitFromSpecificationsPost: async (resubmitClaimsFromSpecificationsPayload: ResubmitClaimsFromSpecificationsPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resubmitClaimsFromSpecificationsPayload' is not null or undefined
            assertParamExists('resubmitClaimsFromSpecificationsAdminClaimsResubmitFromSpecificationsPost', 'resubmitClaimsFromSpecificationsPayload', resubmitClaimsFromSpecificationsPayload)
            const localVarPath = `/admin/claims/resubmit-from-specifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resubmitClaimsFromSpecificationsPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update My Client Care
         * @param {string} careId 
         * @param {UpdateClientDetailsPayload} updateClientDetailsPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyClientCareMyClientCareCareIdPatch: async (careId: string, updateClientDetailsPayload: UpdateClientDetailsPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'careId' is not null or undefined
            assertParamExists('updateMyClientCareMyClientCareCareIdPatch', 'careId', careId)
            // verify required parameter 'updateClientDetailsPayload' is not null or undefined
            assertParamExists('updateMyClientCareMyClientCareCareIdPatch', 'updateClientDetailsPayload', updateClientDetailsPayload)
            const localVarPath = `/my-client-care/{care_id}`
                .replace(`{${"care_id"}}`, encodeURIComponent(String(careId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateClientDetailsPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClaimsApi - functional programming interface
 */
export const ClaimsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClaimsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add Claim Prefixes
         * @param {AddClaimPrefixesPayload} addClaimPrefixesPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addClaimPrefixesAdminClaimsAddPrefixesPost(addClaimPrefixesPayload: AddClaimPrefixesPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddPrefixesResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addClaimPrefixesAdminClaimsAddPrefixesPost(addClaimPrefixesPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClaimsApi.addClaimPrefixesAdminClaimsAddPrefixesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Cancel Client Care
         * @param {string} careId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelClientCareMyClientCareCareIdCancelPost(careId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientCareDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelClientCareMyClientCareCareIdCancelPost(careId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClaimsApi.cancelClientCareMyClientCareCareIdCancelPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Claim
         * @param {CreateClaimPayload} createClaimPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createClaimClaimsPost(createClaimPayload: CreateClaimPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateClaimResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createClaimClaimsPost(createClaimPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClaimsApi.createClaimClaimsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Claims From Specifications
         * @param {CreateClaimsFromSpecificationsPayload} createClaimsFromSpecificationsPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createClaimsFromSpecificationsAdminClaimsCreateFromSpecificationsPost(createClaimsFromSpecificationsPayload: CreateClaimsFromSpecificationsPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateClaimsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createClaimsFromSpecificationsAdminClaimsCreateFromSpecificationsPost(createClaimsFromSpecificationsPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClaimsApi.createClaimsFromSpecificationsAdminClaimsCreateFromSpecificationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get New Encounters Since Time
         * @param {string} since 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNewEncountersSinceTimeClientEngagementRewardGet(since: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientEngagementRewardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNewEncountersSinceTimeClientEngagementRewardGet(since, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClaimsApi.getNewEncountersSinceTimeClientEngagementRewardGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary My Client Care Details
         * @param {string} careId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async myClientCareDetailsMyClientCareCareIdGet(careId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientCareDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.myClientCareDetailsMyClientCareCareIdGet(careId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClaimsApi.myClientCareDetailsMyClientCareCareIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary My Client Care
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async myClientCareMyClientCareGet(page?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DateRangePaginatedClientCareResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.myClientCareMyClientCareGet(page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClaimsApi.myClientCareMyClientCareGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Preview Claims From Appointments
         * @param {ClaimPreviewPayload} claimPreviewPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewClaimsFromAppointmentsAdminClaimPreviewsFromAppointmentsPost(claimPreviewPayload: ClaimPreviewPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimSpecificationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewClaimsFromAppointmentsAdminClaimPreviewsFromAppointmentsPost(claimPreviewPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClaimsApi.previewClaimsFromAppointmentsAdminClaimPreviewsFromAppointmentsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Preview Claims From Claims
         * @param {ClaimPreviewFromClaimsPayload} claimPreviewFromClaimsPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewClaimsFromClaimsAdminClaimPreviewsFromClaimsPost(claimPreviewFromClaimsPayload: ClaimPreviewFromClaimsPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimSpecificationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewClaimsFromClaimsAdminClaimPreviewsFromClaimsPost(claimPreviewFromClaimsPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClaimsApi.previewClaimsFromClaimsAdminClaimPreviewsFromClaimsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Resubmit Claims From Specifications
         * @param {ResubmitClaimsFromSpecificationsPayload} resubmitClaimsFromSpecificationsPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resubmitClaimsFromSpecificationsAdminClaimsResubmitFromSpecificationsPost(resubmitClaimsFromSpecificationsPayload: ResubmitClaimsFromSpecificationsPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResubmitClaimsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resubmitClaimsFromSpecificationsAdminClaimsResubmitFromSpecificationsPost(resubmitClaimsFromSpecificationsPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClaimsApi.resubmitClaimsFromSpecificationsAdminClaimsResubmitFromSpecificationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update My Client Care
         * @param {string} careId 
         * @param {UpdateClientDetailsPayload} updateClientDetailsPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMyClientCareMyClientCareCareIdPatch(careId: string, updateClientDetailsPayload: UpdateClientDetailsPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientCareDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMyClientCareMyClientCareCareIdPatch(careId, updateClientDetailsPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClaimsApi.updateMyClientCareMyClientCareCareIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClaimsApi - factory interface
 */
export const ClaimsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClaimsApiFp(configuration)
    return {
        /**
         * 
         * @summary Add Claim Prefixes
         * @param {AddClaimPrefixesPayload} addClaimPrefixesPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addClaimPrefixesAdminClaimsAddPrefixesPost(addClaimPrefixesPayload: AddClaimPrefixesPayload, options?: RawAxiosRequestConfig): AxiosPromise<AddPrefixesResult> {
            return localVarFp.addClaimPrefixesAdminClaimsAddPrefixesPost(addClaimPrefixesPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cancel Client Care
         * @param {string} careId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelClientCareMyClientCareCareIdCancelPost(careId: string, options?: RawAxiosRequestConfig): AxiosPromise<ClientCareDetailsResponse> {
            return localVarFp.cancelClientCareMyClientCareCareIdCancelPost(careId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Claim
         * @param {CreateClaimPayload} createClaimPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClaimClaimsPost(createClaimPayload: CreateClaimPayload, options?: RawAxiosRequestConfig): AxiosPromise<CreateClaimResponse> {
            return localVarFp.createClaimClaimsPost(createClaimPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Claims From Specifications
         * @param {CreateClaimsFromSpecificationsPayload} createClaimsFromSpecificationsPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClaimsFromSpecificationsAdminClaimsCreateFromSpecificationsPost(createClaimsFromSpecificationsPayload: CreateClaimsFromSpecificationsPayload, options?: RawAxiosRequestConfig): AxiosPromise<CreateClaimsResponse> {
            return localVarFp.createClaimsFromSpecificationsAdminClaimsCreateFromSpecificationsPost(createClaimsFromSpecificationsPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get New Encounters Since Time
         * @param {string} since 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewEncountersSinceTimeClientEngagementRewardGet(since: string, options?: RawAxiosRequestConfig): AxiosPromise<ClientEngagementRewardResponse> {
            return localVarFp.getNewEncountersSinceTimeClientEngagementRewardGet(since, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary My Client Care Details
         * @param {string} careId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        myClientCareDetailsMyClientCareCareIdGet(careId: string, options?: RawAxiosRequestConfig): AxiosPromise<ClientCareDetailsResponse> {
            return localVarFp.myClientCareDetailsMyClientCareCareIdGet(careId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary My Client Care
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        myClientCareMyClientCareGet(page?: number, options?: RawAxiosRequestConfig): AxiosPromise<DateRangePaginatedClientCareResponse> {
            return localVarFp.myClientCareMyClientCareGet(page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Preview Claims From Appointments
         * @param {ClaimPreviewPayload} claimPreviewPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewClaimsFromAppointmentsAdminClaimPreviewsFromAppointmentsPost(claimPreviewPayload: ClaimPreviewPayload, options?: RawAxiosRequestConfig): AxiosPromise<ClaimSpecificationsResponse> {
            return localVarFp.previewClaimsFromAppointmentsAdminClaimPreviewsFromAppointmentsPost(claimPreviewPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Preview Claims From Claims
         * @param {ClaimPreviewFromClaimsPayload} claimPreviewFromClaimsPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewClaimsFromClaimsAdminClaimPreviewsFromClaimsPost(claimPreviewFromClaimsPayload: ClaimPreviewFromClaimsPayload, options?: RawAxiosRequestConfig): AxiosPromise<ClaimSpecificationsResponse> {
            return localVarFp.previewClaimsFromClaimsAdminClaimPreviewsFromClaimsPost(claimPreviewFromClaimsPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resubmit Claims From Specifications
         * @param {ResubmitClaimsFromSpecificationsPayload} resubmitClaimsFromSpecificationsPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resubmitClaimsFromSpecificationsAdminClaimsResubmitFromSpecificationsPost(resubmitClaimsFromSpecificationsPayload: ResubmitClaimsFromSpecificationsPayload, options?: RawAxiosRequestConfig): AxiosPromise<ResubmitClaimsResponse> {
            return localVarFp.resubmitClaimsFromSpecificationsAdminClaimsResubmitFromSpecificationsPost(resubmitClaimsFromSpecificationsPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update My Client Care
         * @param {string} careId 
         * @param {UpdateClientDetailsPayload} updateClientDetailsPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyClientCareMyClientCareCareIdPatch(careId: string, updateClientDetailsPayload: UpdateClientDetailsPayload, options?: RawAxiosRequestConfig): AxiosPromise<ClientCareDetailsResponse> {
            return localVarFp.updateMyClientCareMyClientCareCareIdPatch(careId, updateClientDetailsPayload, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClaimsApi - object-oriented interface
 */
export class ClaimsApi extends BaseAPI {
    /**
     * 
     * @summary Add Claim Prefixes
     * @param {AddClaimPrefixesPayload} addClaimPrefixesPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addClaimPrefixesAdminClaimsAddPrefixesPost(addClaimPrefixesPayload: AddClaimPrefixesPayload, options?: RawAxiosRequestConfig) {
        return ClaimsApiFp(this.configuration).addClaimPrefixesAdminClaimsAddPrefixesPost(addClaimPrefixesPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cancel Client Care
     * @param {string} careId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public cancelClientCareMyClientCareCareIdCancelPost(careId: string, options?: RawAxiosRequestConfig) {
        return ClaimsApiFp(this.configuration).cancelClientCareMyClientCareCareIdCancelPost(careId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Claim
     * @param {CreateClaimPayload} createClaimPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createClaimClaimsPost(createClaimPayload: CreateClaimPayload, options?: RawAxiosRequestConfig) {
        return ClaimsApiFp(this.configuration).createClaimClaimsPost(createClaimPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Claims From Specifications
     * @param {CreateClaimsFromSpecificationsPayload} createClaimsFromSpecificationsPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createClaimsFromSpecificationsAdminClaimsCreateFromSpecificationsPost(createClaimsFromSpecificationsPayload: CreateClaimsFromSpecificationsPayload, options?: RawAxiosRequestConfig) {
        return ClaimsApiFp(this.configuration).createClaimsFromSpecificationsAdminClaimsCreateFromSpecificationsPost(createClaimsFromSpecificationsPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get New Encounters Since Time
     * @param {string} since 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getNewEncountersSinceTimeClientEngagementRewardGet(since: string, options?: RawAxiosRequestConfig) {
        return ClaimsApiFp(this.configuration).getNewEncountersSinceTimeClientEngagementRewardGet(since, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary My Client Care Details
     * @param {string} careId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public myClientCareDetailsMyClientCareCareIdGet(careId: string, options?: RawAxiosRequestConfig) {
        return ClaimsApiFp(this.configuration).myClientCareDetailsMyClientCareCareIdGet(careId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary My Client Care
     * @param {number} [page] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public myClientCareMyClientCareGet(page?: number, options?: RawAxiosRequestConfig) {
        return ClaimsApiFp(this.configuration).myClientCareMyClientCareGet(page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Preview Claims From Appointments
     * @param {ClaimPreviewPayload} claimPreviewPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public previewClaimsFromAppointmentsAdminClaimPreviewsFromAppointmentsPost(claimPreviewPayload: ClaimPreviewPayload, options?: RawAxiosRequestConfig) {
        return ClaimsApiFp(this.configuration).previewClaimsFromAppointmentsAdminClaimPreviewsFromAppointmentsPost(claimPreviewPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Preview Claims From Claims
     * @param {ClaimPreviewFromClaimsPayload} claimPreviewFromClaimsPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public previewClaimsFromClaimsAdminClaimPreviewsFromClaimsPost(claimPreviewFromClaimsPayload: ClaimPreviewFromClaimsPayload, options?: RawAxiosRequestConfig) {
        return ClaimsApiFp(this.configuration).previewClaimsFromClaimsAdminClaimPreviewsFromClaimsPost(claimPreviewFromClaimsPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resubmit Claims From Specifications
     * @param {ResubmitClaimsFromSpecificationsPayload} resubmitClaimsFromSpecificationsPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public resubmitClaimsFromSpecificationsAdminClaimsResubmitFromSpecificationsPost(resubmitClaimsFromSpecificationsPayload: ResubmitClaimsFromSpecificationsPayload, options?: RawAxiosRequestConfig) {
        return ClaimsApiFp(this.configuration).resubmitClaimsFromSpecificationsAdminClaimsResubmitFromSpecificationsPost(resubmitClaimsFromSpecificationsPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update My Client Care
     * @param {string} careId 
     * @param {UpdateClientDetailsPayload} updateClientDetailsPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateMyClientCareMyClientCareCareIdPatch(careId: string, updateClientDetailsPayload: UpdateClientDetailsPayload, options?: RawAxiosRequestConfig) {
        return ClaimsApiFp(this.configuration).updateMyClientCareMyClientCareCareIdPatch(careId, updateClientDetailsPayload, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CommerceApi - axios parameter creator
 */
export const CommerceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add To Cart
         * @param {AddToCartPayload} addToCartPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addToCartCommerceCartPost: async (addToCartPayload: AddToCartPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addToCartPayload' is not null or undefined
            assertParamExists('addToCartCommerceCartPost', 'addToCartPayload', addToCartPayload)
            const localVarPath = `/commerce/cart`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addToCartPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Checkout
         * @param {CheckoutPayload} checkoutPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkoutCommerceCheckoutPost: async (checkoutPayload: CheckoutPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checkoutPayload' is not null or undefined
            assertParamExists('checkoutCommerceCheckoutPost', 'checkoutPayload', checkoutPayload)
            const localVarPath = `/commerce/checkout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkoutPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Cart
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCartCommerceCartGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/commerce/cart`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the catalog of products.
         * @summary Get Catalog
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {CatalogSortOptions} [sort] 
         * @param {string | null} [category] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogCommerceCatalogGet: async (page?: number, limit?: number, sort?: CatalogSortOptions, category?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/commerce/catalog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the list of product categories.
         * @summary Get Categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoriesCommerceCategoriesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/commerce/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Checkout Details
         * @param {string} postalCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCheckoutDetailsCommerceCheckoutGet: async (postalCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postalCode' is not null or undefined
            assertParamExists('getCheckoutDetailsCommerceCheckoutGet', 'postalCode', postalCode)
            const localVarPath = `/commerce/checkout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (postalCode !== undefined) {
                localVarQueryParameter['postal_code'] = postalCode;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Order
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderCommerceOrdersOrderIdGet: async (orderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getOrderCommerceOrdersOrderIdGet', 'orderId', orderId)
            const localVarPath = `/commerce/orders/{order_id}`
                .replace(`{${"order_id"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get product details by product ID.
         * @summary Get Product
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductCommerceCatalogProductIdGet: async (productId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getProductCommerceCatalogProductIdGet', 'productId', productId)
            const localVarPath = `/commerce/catalog/{product_id}`
                .replace(`{${"product_id"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Orders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrdersCommerceOrdersGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/commerce/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove From Cart
         * @param {string} cartItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFromCartCommerceCartCartItemIdDelete: async (cartItemId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cartItemId' is not null or undefined
            assertParamExists('removeFromCartCommerceCartCartItemIdDelete', 'cartItemId', cartItemId)
            const localVarPath = `/commerce/cart/{cart_item_id}`
                .replace(`{${"cart_item_id"}}`, encodeURIComponent(String(cartItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Cart
         * @param {string} cartItemId 
         * @param {UpdateCartItemPayload} updateCartItemPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCartCommerceCartCartItemIdPatch: async (cartItemId: string, updateCartItemPayload: UpdateCartItemPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cartItemId' is not null or undefined
            assertParamExists('updateCartCommerceCartCartItemIdPatch', 'cartItemId', cartItemId)
            // verify required parameter 'updateCartItemPayload' is not null or undefined
            assertParamExists('updateCartCommerceCartCartItemIdPatch', 'updateCartItemPayload', updateCartItemPayload)
            const localVarPath = `/commerce/cart/{cart_item_id}`
                .replace(`{${"cart_item_id"}}`, encodeURIComponent(String(cartItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCartItemPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CommerceApi - functional programming interface
 */
export const CommerceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CommerceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add To Cart
         * @param {AddToCartPayload} addToCartPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addToCartCommerceCartPost(addToCartPayload: AddToCartPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CartDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addToCartCommerceCartPost(addToCartPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommerceApi.addToCartCommerceCartPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Checkout
         * @param {CheckoutPayload} checkoutPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkoutCommerceCheckoutPost(checkoutPayload: CheckoutPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkoutCommerceCheckoutPost(checkoutPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommerceApi.checkoutCommerceCheckoutPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Cart
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCartCommerceCartGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CartDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCartCommerceCartGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommerceApi.getCartCommerceCartGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the catalog of products.
         * @summary Get Catalog
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {CatalogSortOptions} [sort] 
         * @param {string | null} [category] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCatalogCommerceCatalogGet(page?: number, limit?: number, sort?: CatalogSortOptions, category?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CatalogResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCatalogCommerceCatalogGet(page, limit, sort, category, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommerceApi.getCatalogCommerceCatalogGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the list of product categories.
         * @summary Get Categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCategoriesCommerceCategoriesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CategoryDetailsResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCategoriesCommerceCategoriesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommerceApi.getCategoriesCommerceCategoriesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Checkout Details
         * @param {string} postalCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCheckoutDetailsCommerceCheckoutGet(postalCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckoutTotalDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCheckoutDetailsCommerceCheckoutGet(postalCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommerceApi.getCheckoutDetailsCommerceCheckoutGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Order
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderCommerceOrdersOrderIdGet(orderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderCommerceOrdersOrderIdGet(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommerceApi.getOrderCommerceOrdersOrderIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get product details by product ID.
         * @summary Get Product
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductCommerceCatalogProductIdGet(productId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductCommerceCatalogProductIdGet(productId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommerceApi.getProductCommerceCatalogProductIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Orders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listOrdersCommerceOrdersGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrderDetailsResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listOrdersCommerceOrdersGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommerceApi.listOrdersCommerceOrdersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove From Cart
         * @param {string} cartItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeFromCartCommerceCartCartItemIdDelete(cartItemId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CartDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeFromCartCommerceCartCartItemIdDelete(cartItemId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommerceApi.removeFromCartCommerceCartCartItemIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Cart
         * @param {string} cartItemId 
         * @param {UpdateCartItemPayload} updateCartItemPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCartCommerceCartCartItemIdPatch(cartItemId: string, updateCartItemPayload: UpdateCartItemPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CartDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCartCommerceCartCartItemIdPatch(cartItemId, updateCartItemPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommerceApi.updateCartCommerceCartCartItemIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CommerceApi - factory interface
 */
export const CommerceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CommerceApiFp(configuration)
    return {
        /**
         * 
         * @summary Add To Cart
         * @param {AddToCartPayload} addToCartPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addToCartCommerceCartPost(addToCartPayload: AddToCartPayload, options?: RawAxiosRequestConfig): AxiosPromise<CartDetailsResponse> {
            return localVarFp.addToCartCommerceCartPost(addToCartPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Checkout
         * @param {CheckoutPayload} checkoutPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkoutCommerceCheckoutPost(checkoutPayload: CheckoutPayload, options?: RawAxiosRequestConfig): AxiosPromise<OrderDetailsResponse> {
            return localVarFp.checkoutCommerceCheckoutPost(checkoutPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Cart
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCartCommerceCartGet(options?: RawAxiosRequestConfig): AxiosPromise<CartDetailsResponse> {
            return localVarFp.getCartCommerceCartGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Get the catalog of products.
         * @summary Get Catalog
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {CatalogSortOptions} [sort] 
         * @param {string | null} [category] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogCommerceCatalogGet(page?: number, limit?: number, sort?: CatalogSortOptions, category?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<CatalogResponse> {
            return localVarFp.getCatalogCommerceCatalogGet(page, limit, sort, category, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the list of product categories.
         * @summary Get Categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoriesCommerceCategoriesGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<CategoryDetailsResponse>> {
            return localVarFp.getCategoriesCommerceCategoriesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Checkout Details
         * @param {string} postalCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCheckoutDetailsCommerceCheckoutGet(postalCode: string, options?: RawAxiosRequestConfig): AxiosPromise<CheckoutTotalDetailsResponse> {
            return localVarFp.getCheckoutDetailsCommerceCheckoutGet(postalCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Order
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderCommerceOrdersOrderIdGet(orderId: string, options?: RawAxiosRequestConfig): AxiosPromise<OrderDetailsResponse> {
            return localVarFp.getOrderCommerceOrdersOrderIdGet(orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get product details by product ID.
         * @summary Get Product
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductCommerceCatalogProductIdGet(productId: string, options?: RawAxiosRequestConfig): AxiosPromise<ProductDetailsResponse> {
            return localVarFp.getProductCommerceCatalogProductIdGet(productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Orders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrdersCommerceOrdersGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<OrderDetailsResponse>> {
            return localVarFp.listOrdersCommerceOrdersGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove From Cart
         * @param {string} cartItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFromCartCommerceCartCartItemIdDelete(cartItemId: string, options?: RawAxiosRequestConfig): AxiosPromise<CartDetailsResponse> {
            return localVarFp.removeFromCartCommerceCartCartItemIdDelete(cartItemId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Cart
         * @param {string} cartItemId 
         * @param {UpdateCartItemPayload} updateCartItemPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCartCommerceCartCartItemIdPatch(cartItemId: string, updateCartItemPayload: UpdateCartItemPayload, options?: RawAxiosRequestConfig): AxiosPromise<CartDetailsResponse> {
            return localVarFp.updateCartCommerceCartCartItemIdPatch(cartItemId, updateCartItemPayload, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CommerceApi - object-oriented interface
 */
export class CommerceApi extends BaseAPI {
    /**
     * 
     * @summary Add To Cart
     * @param {AddToCartPayload} addToCartPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addToCartCommerceCartPost(addToCartPayload: AddToCartPayload, options?: RawAxiosRequestConfig) {
        return CommerceApiFp(this.configuration).addToCartCommerceCartPost(addToCartPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Checkout
     * @param {CheckoutPayload} checkoutPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public checkoutCommerceCheckoutPost(checkoutPayload: CheckoutPayload, options?: RawAxiosRequestConfig) {
        return CommerceApiFp(this.configuration).checkoutCommerceCheckoutPost(checkoutPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Cart
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCartCommerceCartGet(options?: RawAxiosRequestConfig) {
        return CommerceApiFp(this.configuration).getCartCommerceCartGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the catalog of products.
     * @summary Get Catalog
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {CatalogSortOptions} [sort] 
     * @param {string | null} [category] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCatalogCommerceCatalogGet(page?: number, limit?: number, sort?: CatalogSortOptions, category?: string | null, options?: RawAxiosRequestConfig) {
        return CommerceApiFp(this.configuration).getCatalogCommerceCatalogGet(page, limit, sort, category, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the list of product categories.
     * @summary Get Categories
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCategoriesCommerceCategoriesGet(options?: RawAxiosRequestConfig) {
        return CommerceApiFp(this.configuration).getCategoriesCommerceCategoriesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Checkout Details
     * @param {string} postalCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCheckoutDetailsCommerceCheckoutGet(postalCode: string, options?: RawAxiosRequestConfig) {
        return CommerceApiFp(this.configuration).getCheckoutDetailsCommerceCheckoutGet(postalCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Order
     * @param {string} orderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOrderCommerceOrdersOrderIdGet(orderId: string, options?: RawAxiosRequestConfig) {
        return CommerceApiFp(this.configuration).getOrderCommerceOrdersOrderIdGet(orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get product details by product ID.
     * @summary Get Product
     * @param {string} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProductCommerceCatalogProductIdGet(productId: string, options?: RawAxiosRequestConfig) {
        return CommerceApiFp(this.configuration).getProductCommerceCatalogProductIdGet(productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Orders
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listOrdersCommerceOrdersGet(options?: RawAxiosRequestConfig) {
        return CommerceApiFp(this.configuration).listOrdersCommerceOrdersGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove From Cart
     * @param {string} cartItemId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public removeFromCartCommerceCartCartItemIdDelete(cartItemId: string, options?: RawAxiosRequestConfig) {
        return CommerceApiFp(this.configuration).removeFromCartCommerceCartCartItemIdDelete(cartItemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Cart
     * @param {string} cartItemId 
     * @param {UpdateCartItemPayload} updateCartItemPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateCartCommerceCartCartItemIdPatch(cartItemId: string, updateCartItemPayload: UpdateCartItemPayload, options?: RawAxiosRequestConfig) {
        return CommerceApiFp(this.configuration).updateCartCommerceCartCartItemIdPatch(cartItemId, updateCartItemPayload, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DefaultApi - axios parameter creator
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns a list of all the event and command types that are currently being handled by the bus.
         * @summary Admin Get Bus Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetBusTypesAdminBusGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/bus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used to resubmit Events and/or Commands to EventBridge for payloads that didn\'t make it to EventBridge due to PutEvents errors in Datadog.
         * @summary Admin Resubmit Event Or Command To Bus
         * @param {BusResubmissionPayload} busResubmissionPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminResubmitEventOrCommandToBusAdminBusPost: async (busResubmissionPayload: BusResubmissionPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'busResubmissionPayload' is not null or undefined
            assertParamExists('adminResubmitEventOrCommandToBusAdminBusPost', 'busResubmissionPayload', busResubmissionPayload)
            const localVarPath = `/admin/bus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(busResubmissionPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary App Update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appUpdateAppUpdateGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/app-update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Background Jobs Handler
         * @param {BackgroundJobPayload} backgroundJobPayload 
         * @param {string | null} [xApiKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        backgroundJobsHandlerBackgroundJobsPost: async (backgroundJobPayload: BackgroundJobPayload, xApiKey?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'backgroundJobPayload' is not null or undefined
            assertParamExists('backgroundJobsHandlerBackgroundJobsPost', 'backgroundJobPayload', backgroundJobPayload)
            const localVarPath = `/background-jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            if (xApiKey != null) {
                localVarHeaderParameter['x-api-key'] = String(xApiKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(backgroundJobPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Commands
         * @param {object} body 
         * @param {string | null} [xApiKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commandsCommandsPost: async (body: object, xApiKey?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('commandsCommandsPost', 'body', body)
            const localVarPath = `/commands`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            if (xApiKey != null) {
                localVarHeaderParameter['x-api-key'] = String(xApiKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Events
         * @param {object} body 
         * @param {string | null} [xApiKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsEventsPost: async (body: object, xApiKey?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('eventsEventsPost', 'body', body)
            const localVarPath = `/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            if (xApiKey != null) {
                localVarHeaderParameter['x-api-key'] = String(xApiKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Check if the server is up and the database is reachable: e.g. it can serve traffic.
         * @summary Healthcheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthcheckHealthGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Check if the server is up: e.g. ECS can call it started.
         * @summary Ping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pingPingGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ping`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Report Csp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportCspReportCspPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/_report_csp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search Npi Database
         * @param {string} query 
         * @param {number} limit 
         * @param {USState | null} [state] 
         * @param {ExternalProviderType | null} [providerType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchNpiDatabaseNpiGet: async (query: string, limit: number, state?: USState | null, providerType?: ExternalProviderType | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'query' is not null or undefined
            assertParamExists('searchNpiDatabaseNpiGet', 'query', query)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('searchNpiDatabaseNpiGet', 'limit', limit)
            const localVarPath = `/npi`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (providerType !== undefined) {
                localVarQueryParameter['provider_type'] = providerType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Test Cache
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testCacheTestCacheGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/_test_cache`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns a list of all the event and command types that are currently being handled by the bus.
         * @summary Admin Get Bus Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetBusTypesAdminBusGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommandsAndEventsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetBusTypesAdminBusGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.adminGetBusTypesAdminBusGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Used to resubmit Events and/or Commands to EventBridge for payloads that didn\'t make it to EventBridge due to PutEvents errors in Datadog.
         * @summary Admin Resubmit Event Or Command To Bus
         * @param {BusResubmissionPayload} busResubmissionPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminResubmitEventOrCommandToBusAdminBusPost(busResubmissionPayload: BusResubmissionPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BusResubmissionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminResubmitEventOrCommandToBusAdminBusPost(busResubmissionPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.adminResubmitEventOrCommandToBusAdminBusPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary App Update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appUpdateAppUpdateGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppUpdateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appUpdateAppUpdateGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.appUpdateAppUpdateGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Background Jobs Handler
         * @param {BackgroundJobPayload} backgroundJobPayload 
         * @param {string | null} [xApiKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async backgroundJobsHandlerBackgroundJobsPost(backgroundJobPayload: BackgroundJobPayload, xApiKey?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.backgroundJobsHandlerBackgroundJobsPost(backgroundJobPayload, xApiKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.backgroundJobsHandlerBackgroundJobsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Commands
         * @param {object} body 
         * @param {string | null} [xApiKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commandsCommandsPost(body: object, xApiKey?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commandsCommandsPost(body, xApiKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.commandsCommandsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Events
         * @param {object} body 
         * @param {string | null} [xApiKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async eventsEventsPost(body: object, xApiKey?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.eventsEventsPost(body, xApiKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.eventsEventsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Check if the server is up and the database is reachable: e.g. it can serve traffic.
         * @summary Healthcheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthcheckHealthGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthcheckHealthGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.healthcheckHealthGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Check if the server is up: e.g. ECS can call it started.
         * @summary Ping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pingPingGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pingPingGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.pingPingGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Report Csp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportCspReportCspPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportCspReportCspPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.reportCspReportCspPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Search Npi Database
         * @param {string} query 
         * @param {number} limit 
         * @param {USState | null} [state] 
         * @param {ExternalProviderType | null} [providerType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchNpiDatabaseNpiGet(query: string, limit: number, state?: USState | null, providerType?: ExternalProviderType | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NPIProviderResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchNpiDatabaseNpiGet(query, limit, state, providerType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.searchNpiDatabaseNpiGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Test Cache
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testCacheTestCacheGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string | null>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testCacheTestCacheGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.testCacheTestCacheGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * Returns a list of all the event and command types that are currently being handled by the bus.
         * @summary Admin Get Bus Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetBusTypesAdminBusGet(options?: RawAxiosRequestConfig): AxiosPromise<CommandsAndEventsResponse> {
            return localVarFp.adminGetBusTypesAdminBusGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Used to resubmit Events and/or Commands to EventBridge for payloads that didn\'t make it to EventBridge due to PutEvents errors in Datadog.
         * @summary Admin Resubmit Event Or Command To Bus
         * @param {BusResubmissionPayload} busResubmissionPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminResubmitEventOrCommandToBusAdminBusPost(busResubmissionPayload: BusResubmissionPayload, options?: RawAxiosRequestConfig): AxiosPromise<BusResubmissionResponse> {
            return localVarFp.adminResubmitEventOrCommandToBusAdminBusPost(busResubmissionPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary App Update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appUpdateAppUpdateGet(options?: RawAxiosRequestConfig): AxiosPromise<AppUpdateResponse> {
            return localVarFp.appUpdateAppUpdateGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Background Jobs Handler
         * @param {BackgroundJobPayload} backgroundJobPayload 
         * @param {string | null} [xApiKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        backgroundJobsHandlerBackgroundJobsPost(backgroundJobPayload: BackgroundJobPayload, xApiKey?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.backgroundJobsHandlerBackgroundJobsPost(backgroundJobPayload, xApiKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Commands
         * @param {object} body 
         * @param {string | null} [xApiKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commandsCommandsPost(body: object, xApiKey?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.commandsCommandsPost(body, xApiKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Events
         * @param {object} body 
         * @param {string | null} [xApiKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsEventsPost(body: object, xApiKey?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.eventsEventsPost(body, xApiKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Check if the server is up and the database is reachable: e.g. it can serve traffic.
         * @summary Healthcheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthcheckHealthGet(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.healthcheckHealthGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Check if the server is up: e.g. ECS can call it started.
         * @summary Ping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pingPingGet(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.pingPingGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Report Csp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportCspReportCspPost(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.reportCspReportCspPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search Npi Database
         * @param {string} query 
         * @param {number} limit 
         * @param {USState | null} [state] 
         * @param {ExternalProviderType | null} [providerType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchNpiDatabaseNpiGet(query: string, limit: number, state?: USState | null, providerType?: ExternalProviderType | null, options?: RawAxiosRequestConfig): AxiosPromise<Array<NPIProviderResponse>> {
            return localVarFp.searchNpiDatabaseNpiGet(query, limit, state, providerType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Test Cache
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testCacheTestCacheGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<string | null>> {
            return localVarFp.testCacheTestCacheGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 */
export class DefaultApi extends BaseAPI {
    /**
     * Returns a list of all the event and command types that are currently being handled by the bus.
     * @summary Admin Get Bus Types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminGetBusTypesAdminBusGet(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).adminGetBusTypesAdminBusGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used to resubmit Events and/or Commands to EventBridge for payloads that didn\'t make it to EventBridge due to PutEvents errors in Datadog.
     * @summary Admin Resubmit Event Or Command To Bus
     * @param {BusResubmissionPayload} busResubmissionPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminResubmitEventOrCommandToBusAdminBusPost(busResubmissionPayload: BusResubmissionPayload, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).adminResubmitEventOrCommandToBusAdminBusPost(busResubmissionPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary App Update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public appUpdateAppUpdateGet(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).appUpdateAppUpdateGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Background Jobs Handler
     * @param {BackgroundJobPayload} backgroundJobPayload 
     * @param {string | null} [xApiKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public backgroundJobsHandlerBackgroundJobsPost(backgroundJobPayload: BackgroundJobPayload, xApiKey?: string | null, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).backgroundJobsHandlerBackgroundJobsPost(backgroundJobPayload, xApiKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Commands
     * @param {object} body 
     * @param {string | null} [xApiKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public commandsCommandsPost(body: object, xApiKey?: string | null, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).commandsCommandsPost(body, xApiKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Events
     * @param {object} body 
     * @param {string | null} [xApiKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public eventsEventsPost(body: object, xApiKey?: string | null, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).eventsEventsPost(body, xApiKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Check if the server is up and the database is reachable: e.g. it can serve traffic.
     * @summary Healthcheck
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public healthcheckHealthGet(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).healthcheckHealthGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Check if the server is up: e.g. ECS can call it started.
     * @summary Ping
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public pingPingGet(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).pingPingGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Report Csp
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reportCspReportCspPost(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).reportCspReportCspPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search Npi Database
     * @param {string} query 
     * @param {number} limit 
     * @param {USState | null} [state] 
     * @param {ExternalProviderType | null} [providerType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchNpiDatabaseNpiGet(query: string, limit: number, state?: USState | null, providerType?: ExternalProviderType | null, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchNpiDatabaseNpiGet(query, limit, state, providerType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Test Cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public testCacheTestCacheGet(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).testCacheTestCacheGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DeferralRulesApi - axios parameter creator
 */
export const DeferralRulesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new deferral rule.
         * @summary Create Deferral Rule
         * @param {CreateDeferralRulePayload} createDeferralRulePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDeferralRuleAdminClaimsDeferralRulesPost: async (createDeferralRulePayload: CreateDeferralRulePayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createDeferralRulePayload' is not null or undefined
            assertParamExists('createDeferralRuleAdminClaimsDeferralRulesPost', 'createDeferralRulePayload', createDeferralRulePayload)
            const localVarPath = `/admin/claims/deferral-rules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDeferralRulePayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Soft-delete a deferral rule.
         * @summary Delete Deferral Rule
         * @param {string} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDeferralRuleAdminClaimsDeferralRulesRuleIdDelete: async (ruleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('deleteDeferralRuleAdminClaimsDeferralRulesRuleIdDelete', 'ruleId', ruleId)
            const localVarPath = `/admin/claims/deferral-rules/{rule_id}`
                .replace(`{${"rule_id"}}`, encodeURIComponent(String(ruleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all non-deleted deferral rules.
         * @summary List Deferral Rules
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDeferralRulesAdminClaimsDeferralRulesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/claims/deferral-rules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DeferralRulesApi - functional programming interface
 */
export const DeferralRulesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DeferralRulesApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new deferral rule.
         * @summary Create Deferral Rule
         * @param {CreateDeferralRulePayload} createDeferralRulePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDeferralRuleAdminClaimsDeferralRulesPost(createDeferralRulePayload: CreateDeferralRulePayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeferralRuleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDeferralRuleAdminClaimsDeferralRulesPost(createDeferralRulePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeferralRulesApi.createDeferralRuleAdminClaimsDeferralRulesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Soft-delete a deferral rule.
         * @summary Delete Deferral Rule
         * @param {string} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDeferralRuleAdminClaimsDeferralRulesRuleIdDelete(ruleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDeferralRuleAdminClaimsDeferralRulesRuleIdDelete(ruleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeferralRulesApi.deleteDeferralRuleAdminClaimsDeferralRulesRuleIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all non-deleted deferral rules.
         * @summary List Deferral Rules
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDeferralRulesAdminClaimsDeferralRulesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeferralRulesListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDeferralRulesAdminClaimsDeferralRulesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeferralRulesApi.listDeferralRulesAdminClaimsDeferralRulesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DeferralRulesApi - factory interface
 */
export const DeferralRulesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DeferralRulesApiFp(configuration)
    return {
        /**
         * Create a new deferral rule.
         * @summary Create Deferral Rule
         * @param {CreateDeferralRulePayload} createDeferralRulePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDeferralRuleAdminClaimsDeferralRulesPost(createDeferralRulePayload: CreateDeferralRulePayload, options?: RawAxiosRequestConfig): AxiosPromise<DeferralRuleResponse> {
            return localVarFp.createDeferralRuleAdminClaimsDeferralRulesPost(createDeferralRulePayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Soft-delete a deferral rule.
         * @summary Delete Deferral Rule
         * @param {string} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDeferralRuleAdminClaimsDeferralRulesRuleIdDelete(ruleId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteDeferralRuleAdminClaimsDeferralRulesRuleIdDelete(ruleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all non-deleted deferral rules.
         * @summary List Deferral Rules
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDeferralRulesAdminClaimsDeferralRulesGet(options?: RawAxiosRequestConfig): AxiosPromise<DeferralRulesListResponse> {
            return localVarFp.listDeferralRulesAdminClaimsDeferralRulesGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DeferralRulesApi - object-oriented interface
 */
export class DeferralRulesApi extends BaseAPI {
    /**
     * Create a new deferral rule.
     * @summary Create Deferral Rule
     * @param {CreateDeferralRulePayload} createDeferralRulePayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createDeferralRuleAdminClaimsDeferralRulesPost(createDeferralRulePayload: CreateDeferralRulePayload, options?: RawAxiosRequestConfig) {
        return DeferralRulesApiFp(this.configuration).createDeferralRuleAdminClaimsDeferralRulesPost(createDeferralRulePayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Soft-delete a deferral rule.
     * @summary Delete Deferral Rule
     * @param {string} ruleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteDeferralRuleAdminClaimsDeferralRulesRuleIdDelete(ruleId: string, options?: RawAxiosRequestConfig) {
        return DeferralRulesApiFp(this.configuration).deleteDeferralRuleAdminClaimsDeferralRulesRuleIdDelete(ruleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all non-deleted deferral rules.
     * @summary List Deferral Rules
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listDeferralRulesAdminClaimsDeferralRulesGet(options?: RawAxiosRequestConfig) {
        return DeferralRulesApiFp(this.configuration).listDeferralRulesAdminClaimsDeferralRulesGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DonationsApi - axios parameter creator
 */
export const DonationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Cancel Donation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelDonationDonationDelete: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/donation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Donation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDonationDonationGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/donation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Donation
         * @param {UpdateRecurringDonationPayload} updateRecurringDonationPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDonationDonationPut: async (updateRecurringDonationPayload: UpdateRecurringDonationPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateRecurringDonationPayload' is not null or undefined
            assertParamExists('updateDonationDonationPut', 'updateRecurringDonationPayload', updateRecurringDonationPayload)
            const localVarPath = `/donation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRecurringDonationPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DonationsApi - functional programming interface
 */
export const DonationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DonationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Cancel Donation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelDonationDonationDelete(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelDonationDonationDelete(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DonationsApi.cancelDonationDonationDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Donation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDonationDonationGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecurringDonationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDonationDonationGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DonationsApi.getDonationDonationGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Donation
         * @param {UpdateRecurringDonationPayload} updateRecurringDonationPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDonationDonationPut(updateRecurringDonationPayload: UpdateRecurringDonationPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecurringDonationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDonationDonationPut(updateRecurringDonationPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DonationsApi.updateDonationDonationPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DonationsApi - factory interface
 */
export const DonationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DonationsApiFp(configuration)
    return {
        /**
         * 
         * @summary Cancel Donation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelDonationDonationDelete(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.cancelDonationDonationDelete(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Donation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDonationDonationGet(options?: RawAxiosRequestConfig): AxiosPromise<RecurringDonationResponse> {
            return localVarFp.getDonationDonationGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Donation
         * @param {UpdateRecurringDonationPayload} updateRecurringDonationPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDonationDonationPut(updateRecurringDonationPayload: UpdateRecurringDonationPayload, options?: RawAxiosRequestConfig): AxiosPromise<RecurringDonationResponse> {
            return localVarFp.updateDonationDonationPut(updateRecurringDonationPayload, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DonationsApi - object-oriented interface
 */
export class DonationsApi extends BaseAPI {
    /**
     * 
     * @summary Cancel Donation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public cancelDonationDonationDelete(options?: RawAxiosRequestConfig) {
        return DonationsApiFp(this.configuration).cancelDonationDonationDelete(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Donation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDonationDonationGet(options?: RawAxiosRequestConfig) {
        return DonationsApiFp(this.configuration).getDonationDonationGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Donation
     * @param {UpdateRecurringDonationPayload} updateRecurringDonationPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateDonationDonationPut(updateRecurringDonationPayload: UpdateRecurringDonationPayload, options?: RawAxiosRequestConfig) {
        return DonationsApiFp(this.configuration).updateDonationDonationPut(updateRecurringDonationPayload, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EmployerApi - axios parameter creator
 */
export const EmployerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Eligibility File
         * @param {CreateEligibilityFilePayload} createEligibilityFilePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEligibilityFileEmployerEligibilityFilesPost: async (createEligibilityFilePayload: CreateEligibilityFilePayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createEligibilityFilePayload' is not null or undefined
            assertParamExists('createEligibilityFileEmployerEligibilityFilesPost', 'createEligibilityFilePayload', createEligibilityFilePayload)
            const localVarPath = `/employer-eligibility-files`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEligibilityFilePayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmployerApi - functional programming interface
 */
export const EmployerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmployerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Eligibility File
         * @param {CreateEligibilityFilePayload} createEligibilityFilePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEligibilityFileEmployerEligibilityFilesPost(createEligibilityFilePayload: CreateEligibilityFilePayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EligibilityFileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEligibilityFileEmployerEligibilityFilesPost(createEligibilityFilePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployerApi.createEligibilityFileEmployerEligibilityFilesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EmployerApi - factory interface
 */
export const EmployerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmployerApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Eligibility File
         * @param {CreateEligibilityFilePayload} createEligibilityFilePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEligibilityFileEmployerEligibilityFilesPost(createEligibilityFilePayload: CreateEligibilityFilePayload, options?: RawAxiosRequestConfig): AxiosPromise<EligibilityFileResponse> {
            return localVarFp.createEligibilityFileEmployerEligibilityFilesPost(createEligibilityFilePayload, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmployerApi - object-oriented interface
 */
export class EmployerApi extends BaseAPI {
    /**
     * 
     * @summary Create Eligibility File
     * @param {CreateEligibilityFilePayload} createEligibilityFilePayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createEligibilityFileEmployerEligibilityFilesPost(createEligibilityFilePayload: CreateEligibilityFilePayload, options?: RawAxiosRequestConfig) {
        return EmployerApiFp(this.configuration).createEligibilityFileEmployerEligibilityFilesPost(createEligibilityFilePayload, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FeedbackApi - axios parameter creator
 */
export const FeedbackApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Capture a follow-up note for appointment feedback.  Requires a JWT token with feedback permission in the Authorization header. Finds the existing feedback entry for the appointment and adds the note.
         * @summary Capture Feedback Note
         * @param {CaptureFeedbackNoteRequest} captureFeedbackNoteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        captureFeedbackNoteFeedbackNotePut: async (captureFeedbackNoteRequest: CaptureFeedbackNoteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'captureFeedbackNoteRequest' is not null or undefined
            assertParamExists('captureFeedbackNoteFeedbackNotePut', 'captureFeedbackNoteRequest', captureFeedbackNoteRequest)
            const localVarPath = `/feedback/note`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(captureFeedbackNoteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Capture patient feedback rating for an appointment.  Requires a JWT token with feedback permission in the Authorization header. Returns the next action (either \'note\' for ratings < 5 or a Trustpilot URL for 5-star ratings).
         * @summary Capture Feedback Rating
         * @param {CaptureFeedbackRatingRequest} captureFeedbackRatingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        captureFeedbackRatingFeedbackRatingPut: async (captureFeedbackRatingRequest: CaptureFeedbackRatingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'captureFeedbackRatingRequest' is not null or undefined
            assertParamExists('captureFeedbackRatingFeedbackRatingPut', 'captureFeedbackRatingRequest', captureFeedbackRatingRequest)
            const localVarPath = `/feedback/rating`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(captureFeedbackRatingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FeedbackApi - functional programming interface
 */
export const FeedbackApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FeedbackApiAxiosParamCreator(configuration)
    return {
        /**
         * Capture a follow-up note for appointment feedback.  Requires a JWT token with feedback permission in the Authorization header. Finds the existing feedback entry for the appointment and adds the note.
         * @summary Capture Feedback Note
         * @param {CaptureFeedbackNoteRequest} captureFeedbackNoteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async captureFeedbackNoteFeedbackNotePut(captureFeedbackNoteRequest: CaptureFeedbackNoteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.captureFeedbackNoteFeedbackNotePut(captureFeedbackNoteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeedbackApi.captureFeedbackNoteFeedbackNotePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Capture patient feedback rating for an appointment.  Requires a JWT token with feedback permission in the Authorization header. Returns the next action (either \'note\' for ratings < 5 or a Trustpilot URL for 5-star ratings).
         * @summary Capture Feedback Rating
         * @param {CaptureFeedbackRatingRequest} captureFeedbackRatingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async captureFeedbackRatingFeedbackRatingPut(captureFeedbackRatingRequest: CaptureFeedbackRatingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CaptureFeedbackRatingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.captureFeedbackRatingFeedbackRatingPut(captureFeedbackRatingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeedbackApi.captureFeedbackRatingFeedbackRatingPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FeedbackApi - factory interface
 */
export const FeedbackApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FeedbackApiFp(configuration)
    return {
        /**
         * Capture a follow-up note for appointment feedback.  Requires a JWT token with feedback permission in the Authorization header. Finds the existing feedback entry for the appointment and adds the note.
         * @summary Capture Feedback Note
         * @param {CaptureFeedbackNoteRequest} captureFeedbackNoteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        captureFeedbackNoteFeedbackNotePut(captureFeedbackNoteRequest: CaptureFeedbackNoteRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.captureFeedbackNoteFeedbackNotePut(captureFeedbackNoteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Capture patient feedback rating for an appointment.  Requires a JWT token with feedback permission in the Authorization header. Returns the next action (either \'note\' for ratings < 5 or a Trustpilot URL for 5-star ratings).
         * @summary Capture Feedback Rating
         * @param {CaptureFeedbackRatingRequest} captureFeedbackRatingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        captureFeedbackRatingFeedbackRatingPut(captureFeedbackRatingRequest: CaptureFeedbackRatingRequest, options?: RawAxiosRequestConfig): AxiosPromise<CaptureFeedbackRatingResponse> {
            return localVarFp.captureFeedbackRatingFeedbackRatingPut(captureFeedbackRatingRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FeedbackApi - object-oriented interface
 */
export class FeedbackApi extends BaseAPI {
    /**
     * Capture a follow-up note for appointment feedback.  Requires a JWT token with feedback permission in the Authorization header. Finds the existing feedback entry for the appointment and adds the note.
     * @summary Capture Feedback Note
     * @param {CaptureFeedbackNoteRequest} captureFeedbackNoteRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public captureFeedbackNoteFeedbackNotePut(captureFeedbackNoteRequest: CaptureFeedbackNoteRequest, options?: RawAxiosRequestConfig) {
        return FeedbackApiFp(this.configuration).captureFeedbackNoteFeedbackNotePut(captureFeedbackNoteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Capture patient feedback rating for an appointment.  Requires a JWT token with feedback permission in the Authorization header. Returns the next action (either \'note\' for ratings < 5 or a Trustpilot URL for 5-star ratings).
     * @summary Capture Feedback Rating
     * @param {CaptureFeedbackRatingRequest} captureFeedbackRatingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public captureFeedbackRatingFeedbackRatingPut(captureFeedbackRatingRequest: CaptureFeedbackRatingRequest, options?: RawAxiosRequestConfig) {
        return FeedbackApiFp(this.configuration).captureFeedbackRatingFeedbackRatingPut(captureFeedbackRatingRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InsuranceCheckingApi - axios parameter creator
 */
export const InsuranceCheckingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Estimate Price
         * @param {PricePayload} pricePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        estimatePriceInsuranceCheckingEstimatePricePost: async (pricePayload: PricePayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pricePayload' is not null or undefined
            assertParamExists('estimatePriceInsuranceCheckingEstimatePricePost', 'pricePayload', pricePayload)
            const localVarPath = `/insurance-checking/estimate-price`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pricePayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate Insurance
         * @param {InsuranceValidationPayload} insuranceValidationPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateInsuranceInsuranceCheckingValidateInsurancePost: async (insuranceValidationPayload: InsuranceValidationPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'insuranceValidationPayload' is not null or undefined
            assertParamExists('validateInsuranceInsuranceCheckingValidateInsurancePost', 'insuranceValidationPayload', insuranceValidationPayload)
            const localVarPath = `/insurance-checking/validate-insurance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(insuranceValidationPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InsuranceCheckingApi - functional programming interface
 */
export const InsuranceCheckingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InsuranceCheckingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Estimate Price
         * @param {PricePayload} pricePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async estimatePriceInsuranceCheckingEstimatePricePost(pricePayload: PricePayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PriceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.estimatePriceInsuranceCheckingEstimatePricePost(pricePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InsuranceCheckingApi.estimatePriceInsuranceCheckingEstimatePricePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Validate Insurance
         * @param {InsuranceValidationPayload} insuranceValidationPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateInsuranceInsuranceCheckingValidateInsurancePost(insuranceValidationPayload: InsuranceValidationPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InsuranceValidationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateInsuranceInsuranceCheckingValidateInsurancePost(insuranceValidationPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InsuranceCheckingApi.validateInsuranceInsuranceCheckingValidateInsurancePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InsuranceCheckingApi - factory interface
 */
export const InsuranceCheckingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InsuranceCheckingApiFp(configuration)
    return {
        /**
         * 
         * @summary Estimate Price
         * @param {PricePayload} pricePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        estimatePriceInsuranceCheckingEstimatePricePost(pricePayload: PricePayload, options?: RawAxiosRequestConfig): AxiosPromise<PriceResponse> {
            return localVarFp.estimatePriceInsuranceCheckingEstimatePricePost(pricePayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Validate Insurance
         * @param {InsuranceValidationPayload} insuranceValidationPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateInsuranceInsuranceCheckingValidateInsurancePost(insuranceValidationPayload: InsuranceValidationPayload, options?: RawAxiosRequestConfig): AxiosPromise<InsuranceValidationResponse> {
            return localVarFp.validateInsuranceInsuranceCheckingValidateInsurancePost(insuranceValidationPayload, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InsuranceCheckingApi - object-oriented interface
 */
export class InsuranceCheckingApi extends BaseAPI {
    /**
     * 
     * @summary Estimate Price
     * @param {PricePayload} pricePayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public estimatePriceInsuranceCheckingEstimatePricePost(pricePayload: PricePayload, options?: RawAxiosRequestConfig) {
        return InsuranceCheckingApiFp(this.configuration).estimatePriceInsuranceCheckingEstimatePricePost(pricePayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Validate Insurance
     * @param {InsuranceValidationPayload} insuranceValidationPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateInsuranceInsuranceCheckingValidateInsurancePost(insuranceValidationPayload: InsuranceValidationPayload, options?: RawAxiosRequestConfig) {
        return InsuranceCheckingApiFp(this.configuration).validateInsuranceInsuranceCheckingValidateInsurancePost(insuranceValidationPayload, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MealPlanningApi - axios parameter creator
 */
export const MealPlanningApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Generate Meal Plan
         * @param {GenerateMealPlanPayload} generateMealPlanPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateMealPlanMealPlanPost: async (generateMealPlanPayload: GenerateMealPlanPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generateMealPlanPayload' is not null or undefined
            assertParamExists('generateMealPlanMealPlanPost', 'generateMealPlanPayload', generateMealPlanPayload)
            const localVarPath = `/meal-plan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateMealPlanPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Meal Plan
         * @param {string} mealPlanId The ID of the meal plan to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMealPlanMealPlanMealPlanIdGet: async (mealPlanId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mealPlanId' is not null or undefined
            assertParamExists('getMealPlanMealPlanMealPlanIdGet', 'mealPlanId', mealPlanId)
            const localVarPath = `/meal-plan/{meal_plan_id}`
                .replace(`{${"meal_plan_id"}}`, encodeURIComponent(String(mealPlanId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send Meal Plan
         * @param {string} mealPlanId The ID of the meal plan to send
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMealPlanMealPlanMealPlanIdSendPost: async (mealPlanId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mealPlanId' is not null or undefined
            assertParamExists('sendMealPlanMealPlanMealPlanIdSendPost', 'mealPlanId', mealPlanId)
            const localVarPath = `/meal-plan/{meal_plan_id}/send`
                .replace(`{${"meal_plan_id"}}`, encodeURIComponent(String(mealPlanId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Meal
         * @param {string} mealPlanId The ID of the meal plan to update
         * @param {string} mealId The ID of the meal to update
         * @param {UpdateMealPayload} updateMealPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMealMealPlanMealPlanIdMealsMealIdPut: async (mealPlanId: string, mealId: string, updateMealPayload: UpdateMealPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mealPlanId' is not null or undefined
            assertParamExists('updateMealMealPlanMealPlanIdMealsMealIdPut', 'mealPlanId', mealPlanId)
            // verify required parameter 'mealId' is not null or undefined
            assertParamExists('updateMealMealPlanMealPlanIdMealsMealIdPut', 'mealId', mealId)
            // verify required parameter 'updateMealPayload' is not null or undefined
            assertParamExists('updateMealMealPlanMealPlanIdMealsMealIdPut', 'updateMealPayload', updateMealPayload)
            const localVarPath = `/meal-plan/{meal_plan_id}/meals/{meal_id}`
                .replace(`{${"meal_plan_id"}}`, encodeURIComponent(String(mealPlanId)))
                .replace(`{${"meal_id"}}`, encodeURIComponent(String(mealId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMealPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MealPlanningApi - functional programming interface
 */
export const MealPlanningApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MealPlanningApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Generate Meal Plan
         * @param {GenerateMealPlanPayload} generateMealPlanPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateMealPlanMealPlanPost(generateMealPlanPayload: GenerateMealPlanPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MealPlanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateMealPlanMealPlanPost(generateMealPlanPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MealPlanningApi.generateMealPlanMealPlanPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Meal Plan
         * @param {string} mealPlanId The ID of the meal plan to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMealPlanMealPlanMealPlanIdGet(mealPlanId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MealPlanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMealPlanMealPlanMealPlanIdGet(mealPlanId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MealPlanningApi.getMealPlanMealPlanMealPlanIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Send Meal Plan
         * @param {string} mealPlanId The ID of the meal plan to send
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendMealPlanMealPlanMealPlanIdSendPost(mealPlanId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MealPlanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendMealPlanMealPlanMealPlanIdSendPost(mealPlanId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MealPlanningApi.sendMealPlanMealPlanMealPlanIdSendPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Meal
         * @param {string} mealPlanId The ID of the meal plan to update
         * @param {string} mealId The ID of the meal to update
         * @param {UpdateMealPayload} updateMealPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMealMealPlanMealPlanIdMealsMealIdPut(mealPlanId: string, mealId: string, updateMealPayload: UpdateMealPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MealPlanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMealMealPlanMealPlanIdMealsMealIdPut(mealPlanId, mealId, updateMealPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MealPlanningApi.updateMealMealPlanMealPlanIdMealsMealIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MealPlanningApi - factory interface
 */
export const MealPlanningApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MealPlanningApiFp(configuration)
    return {
        /**
         * 
         * @summary Generate Meal Plan
         * @param {GenerateMealPlanPayload} generateMealPlanPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateMealPlanMealPlanPost(generateMealPlanPayload: GenerateMealPlanPayload, options?: RawAxiosRequestConfig): AxiosPromise<MealPlanResponse> {
            return localVarFp.generateMealPlanMealPlanPost(generateMealPlanPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Meal Plan
         * @param {string} mealPlanId The ID of the meal plan to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMealPlanMealPlanMealPlanIdGet(mealPlanId: string, options?: RawAxiosRequestConfig): AxiosPromise<MealPlanResponse> {
            return localVarFp.getMealPlanMealPlanMealPlanIdGet(mealPlanId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send Meal Plan
         * @param {string} mealPlanId The ID of the meal plan to send
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMealPlanMealPlanMealPlanIdSendPost(mealPlanId: string, options?: RawAxiosRequestConfig): AxiosPromise<MealPlanResponse> {
            return localVarFp.sendMealPlanMealPlanMealPlanIdSendPost(mealPlanId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Meal
         * @param {string} mealPlanId The ID of the meal plan to update
         * @param {string} mealId The ID of the meal to update
         * @param {UpdateMealPayload} updateMealPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMealMealPlanMealPlanIdMealsMealIdPut(mealPlanId: string, mealId: string, updateMealPayload: UpdateMealPayload, options?: RawAxiosRequestConfig): AxiosPromise<MealPlanResponse> {
            return localVarFp.updateMealMealPlanMealPlanIdMealsMealIdPut(mealPlanId, mealId, updateMealPayload, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MealPlanningApi - object-oriented interface
 */
export class MealPlanningApi extends BaseAPI {
    /**
     * 
     * @summary Generate Meal Plan
     * @param {GenerateMealPlanPayload} generateMealPlanPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generateMealPlanMealPlanPost(generateMealPlanPayload: GenerateMealPlanPayload, options?: RawAxiosRequestConfig) {
        return MealPlanningApiFp(this.configuration).generateMealPlanMealPlanPost(generateMealPlanPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Meal Plan
     * @param {string} mealPlanId The ID of the meal plan to retrieve
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMealPlanMealPlanMealPlanIdGet(mealPlanId: string, options?: RawAxiosRequestConfig) {
        return MealPlanningApiFp(this.configuration).getMealPlanMealPlanMealPlanIdGet(mealPlanId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send Meal Plan
     * @param {string} mealPlanId The ID of the meal plan to send
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sendMealPlanMealPlanMealPlanIdSendPost(mealPlanId: string, options?: RawAxiosRequestConfig) {
        return MealPlanningApiFp(this.configuration).sendMealPlanMealPlanMealPlanIdSendPost(mealPlanId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Meal
     * @param {string} mealPlanId The ID of the meal plan to update
     * @param {string} mealId The ID of the meal to update
     * @param {UpdateMealPayload} updateMealPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateMealMealPlanMealPlanIdMealsMealIdPut(mealPlanId: string, mealId: string, updateMealPayload: UpdateMealPayload, options?: RawAxiosRequestConfig) {
        return MealPlanningApiFp(this.configuration).updateMealMealPlanMealPlanIdMealsMealIdPut(mealPlanId, mealId, updateMealPayload, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MedicalRecordRequestsApi - axios parameter creator
 */
export const MedicalRecordRequestsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create an admin medical record request for a patient.  This endpoint allows admins to request medical records for any patient. The records are generated asynchronously and can be retrieved once completed.  Validation rules: - Only admin users (with provider_id) can access this endpoint - Admin users can request records for any patient  Args:     payload: The request payload containing patient_id and CCNs     application: Injected application service     user: Authenticated admin user  Returns:     CreateMedicalRecordRequestResponse with the group ID  Raises:     HTTPException: 403 if not admin, 400 if validation fails, 500 if creation fails
         * @summary Create Medical Record Request
         * @param {CreateMedicalRecordRequestPayload} createMedicalRecordRequestPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMedicalRecordRequestClaimMedicalRecordRequestsAdminPost: async (createMedicalRecordRequestPayload: CreateMedicalRecordRequestPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createMedicalRecordRequestPayload' is not null or undefined
            assertParamExists('createMedicalRecordRequestClaimMedicalRecordRequestsAdminPost', 'createMedicalRecordRequestPayload', createMedicalRecordRequestPayload)
            const localVarPath = `/claim/medical-record-requests/admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createMedicalRecordRequestPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download all medical record exports for a group as a zip file.  This endpoint allows admins to download all completed medical record exports for a given group ID. The files are packaged as a zip file.  Authorization: Only admin users can download medical records.  Args:     group_id: The medical record request group ID     application: Injected application service     storage: Injected storage service for fetching PDFs from S3     user: Authenticated admin user  Raises:     HTTPException: 403 if not admin or access denied, 400 if exports not ready, 500 if download fails
         * @summary Download Medical Record Requests
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadMedicalRecordRequestsClaimMedicalRecordRequestsGroupIdDownloadGet: async (groupId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('downloadMedicalRecordRequestsClaimMedicalRecordRequestsGroupIdDownloadGet', 'groupId', groupId)
            const localVarPath = `/claim/medical-record-requests/{group_id}/download`
                .replace(`{${"group_id"}}`, encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download MRR submissions as a zip file.  This endpoint allows admins to download multiple MRR submissions that have been generated. The files are packaged as a zip file.  Authorization: Only admin users can download MRR submissions.  Args:     payload: The request payload containing submission IDs to download.     application: Injected application service     storage: Injected storage service for fetching PDFs from S3     user: Authenticated admin user  Returns:     Response with zip file containing the MRR submissions  Raises:     HTTPException: 403 if not admin, 400 if no valid submissions, 500 if download fails
         * @summary Download Mrr Submissions
         * @param {BulkMRRSubmissionsPayload} bulkMRRSubmissionsPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadMrrSubmissionsClaimMedicalRecordRequestsSubmissionsDownloadPost: async (bulkMRRSubmissionsPayload: BulkMRRSubmissionsPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkMRRSubmissionsPayload' is not null or undefined
            assertParamExists('downloadMrrSubmissionsClaimMedicalRecordRequestsSubmissionsDownloadPost', 'bulkMRRSubmissionsPayload', bulkMRRSubmissionsPayload)
            const localVarPath = `/claim/medical-record-requests/submissions/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkMRRSubmissionsPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the status of a medical record request group.  Returns the overall status of a medical record request group: - \"in_progress\": At least one request is still processing - \"completed\": At least one completed, none in progress - \"failed\": All requests failed  Authorization: User must be the requester who created the group (patient or admin).  Args:     group_id: The medical record request group ID     application: Injected application service     user: Authenticated user (patient or admin)  Returns:     GetMedicalRecordRequestStatusResponse with the status  Raises:     HTTPException: 403 if group not found or requester mismatch, 500 if status check fails
         * @summary Get Medical Record Request Status
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMedicalRecordRequestStatusClaimMedicalRecordRequestsGroupIdStatusGet: async (groupId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('getMedicalRecordRequestStatusClaimMedicalRecordRequestsGroupIdStatusGet', 'groupId', groupId)
            const localVarPath = `/claim/medical-record-requests/{group_id}/status`
                .replace(`{${"group_id"}}`, encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List MRR submissions with optional filters. Returns paginated list.  Args:     status: Required status filter     payer_id: Optional payer ID filter     claim_carrier_control_number: Optional claim carrier control number filter     medical_record_request_group_id: Optional group ID filter     page: Page number (default: 1)     limit: Items per page (default: 20, max: 100)     query_service: Injected query service     user: Authenticated admin user  Returns:     ListMRRSubmissionsResponse with paginated results  Raises:     HTTPException: 403 if not admin, 500 if query fails
         * @summary List Mrr Submissions
         * @param {MedicalRecordRequestSubmissionStatus} status Filter by submission status (required)
         * @param {PayerId | null} [payerId] 
         * @param {string | null} [claimCarrierControlNumber] 
         * @param {string | null} [medicalRecordRequestGroupId] 
         * @param {number} [page] Page number (1-based)
         * @param {number} [limit] Items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMrrSubmissionsClaimMedicalRecordRequestsSubmissionsGet: async (status: MedicalRecordRequestSubmissionStatus, payerId?: PayerId | null, claimCarrierControlNumber?: string | null, medicalRecordRequestGroupId?: string | null, page?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'status' is not null or undefined
            assertParamExists('listMrrSubmissionsClaimMedicalRecordRequestsSubmissionsGet', 'status', status)
            const localVarPath = `/claim/medical-record-requests/submissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (payerId !== undefined) {
                localVarQueryParameter['payer_id'] = payerId;
            }

            if (claimCarrierControlNumber !== undefined) {
                localVarQueryParameter['claim_carrier_control_number'] = claimCarrierControlNumber;
            }

            if (medicalRecordRequestGroupId !== undefined) {
                localVarQueryParameter['medical_record_request_group_id'] = medicalRecordRequestGroupId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Preview Medical Record Request
         * @param {Array<string> | null} [claimCarrierControlNumbers] 
         * @param {string | null} [patientId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewMedicalRecordRequestClaimMedicalRecordRequestsPreviewGet: async (claimCarrierControlNumbers?: Array<string> | null, patientId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/claim/medical-record-requests/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (claimCarrierControlNumbers) {
                localVarQueryParameter['claim_carrier_control_numbers'] = claimCarrierControlNumbers;
            }

            if (patientId !== undefined) {
                localVarQueryParameter['patient_id'] = patientId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reject MRR submissions that are in NO_REQUEST_LETTER, NOT_SUBMITTED, or SUBMIT_FAILED status.  Submissions in other statuses will be skipped and included in the failed list.  Returns:     RejectMRRSubmissionsResponse with success status and list of failed IDs  Raises:     HTTPException: 403 if not admin, 500 if rejection fails
         * @summary Reject Mrr Submissions
         * @param {RejectMRRSubmissionsPayload} rejectMRRSubmissionsPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectMrrSubmissionsClaimMedicalRecordRequestsSubmissionsRejectPost: async (rejectMRRSubmissionsPayload: RejectMRRSubmissionsPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rejectMRRSubmissionsPayload' is not null or undefined
            assertParamExists('rejectMrrSubmissionsClaimMedicalRecordRequestsSubmissionsRejectPost', 'rejectMRRSubmissionsPayload', rejectMRRSubmissionsPayload)
            const localVarPath = `/claim/medical-record-requests/submissions/reject`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rejectMRRSubmissionsPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sends MRR submissions that are in NOT_SUBMITTED status. Submissions in other statuses will be skipped and included in the failed list.  Returns:     SendMRRSubmissionsResponse with success status and list of failed IDs  Raises:     HTTPException: 403 if not admin, 500 if sending fails
         * @summary Send Mrr Submissions
         * @param {BulkMRRSubmissionsPayload} bulkMRRSubmissionsPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMrrSubmissionsClaimMedicalRecordRequestsSubmissionsSendPost: async (bulkMRRSubmissionsPayload: BulkMRRSubmissionsPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkMRRSubmissionsPayload' is not null or undefined
            assertParamExists('sendMrrSubmissionsClaimMedicalRecordRequestsSubmissionsSendPost', 'bulkMRRSubmissionsPayload', bulkMRRSubmissionsPayload)
            const localVarPath = `/claim/medical-record-requests/submissions/send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkMRRSubmissionsPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MedicalRecordRequestsApi - functional programming interface
 */
export const MedicalRecordRequestsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MedicalRecordRequestsApiAxiosParamCreator(configuration)
    return {
        /**
         * Create an admin medical record request for a patient.  This endpoint allows admins to request medical records for any patient. The records are generated asynchronously and can be retrieved once completed.  Validation rules: - Only admin users (with provider_id) can access this endpoint - Admin users can request records for any patient  Args:     payload: The request payload containing patient_id and CCNs     application: Injected application service     user: Authenticated admin user  Returns:     CreateMedicalRecordRequestResponse with the group ID  Raises:     HTTPException: 403 if not admin, 400 if validation fails, 500 if creation fails
         * @summary Create Medical Record Request
         * @param {CreateMedicalRecordRequestPayload} createMedicalRecordRequestPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMedicalRecordRequestClaimMedicalRecordRequestsAdminPost(createMedicalRecordRequestPayload: CreateMedicalRecordRequestPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateMedicalRecordRequestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMedicalRecordRequestClaimMedicalRecordRequestsAdminPost(createMedicalRecordRequestPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalRecordRequestsApi.createMedicalRecordRequestClaimMedicalRecordRequestsAdminPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Download all medical record exports for a group as a zip file.  This endpoint allows admins to download all completed medical record exports for a given group ID. The files are packaged as a zip file.  Authorization: Only admin users can download medical records.  Args:     group_id: The medical record request group ID     application: Injected application service     storage: Injected storage service for fetching PDFs from S3     user: Authenticated admin user  Raises:     HTTPException: 403 if not admin or access denied, 400 if exports not ready, 500 if download fails
         * @summary Download Medical Record Requests
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadMedicalRecordRequestsClaimMedicalRecordRequestsGroupIdDownloadGet(groupId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadMedicalRecordRequestsClaimMedicalRecordRequestsGroupIdDownloadGet(groupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalRecordRequestsApi.downloadMedicalRecordRequestsClaimMedicalRecordRequestsGroupIdDownloadGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Download MRR submissions as a zip file.  This endpoint allows admins to download multiple MRR submissions that have been generated. The files are packaged as a zip file.  Authorization: Only admin users can download MRR submissions.  Args:     payload: The request payload containing submission IDs to download.     application: Injected application service     storage: Injected storage service for fetching PDFs from S3     user: Authenticated admin user  Returns:     Response with zip file containing the MRR submissions  Raises:     HTTPException: 403 if not admin, 400 if no valid submissions, 500 if download fails
         * @summary Download Mrr Submissions
         * @param {BulkMRRSubmissionsPayload} bulkMRRSubmissionsPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadMrrSubmissionsClaimMedicalRecordRequestsSubmissionsDownloadPost(bulkMRRSubmissionsPayload: BulkMRRSubmissionsPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadMrrSubmissionsClaimMedicalRecordRequestsSubmissionsDownloadPost(bulkMRRSubmissionsPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalRecordRequestsApi.downloadMrrSubmissionsClaimMedicalRecordRequestsSubmissionsDownloadPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the status of a medical record request group.  Returns the overall status of a medical record request group: - \"in_progress\": At least one request is still processing - \"completed\": At least one completed, none in progress - \"failed\": All requests failed  Authorization: User must be the requester who created the group (patient or admin).  Args:     group_id: The medical record request group ID     application: Injected application service     user: Authenticated user (patient or admin)  Returns:     GetMedicalRecordRequestStatusResponse with the status  Raises:     HTTPException: 403 if group not found or requester mismatch, 500 if status check fails
         * @summary Get Medical Record Request Status
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMedicalRecordRequestStatusClaimMedicalRecordRequestsGroupIdStatusGet(groupId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMedicalRecordRequestStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMedicalRecordRequestStatusClaimMedicalRecordRequestsGroupIdStatusGet(groupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalRecordRequestsApi.getMedicalRecordRequestStatusClaimMedicalRecordRequestsGroupIdStatusGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List MRR submissions with optional filters. Returns paginated list.  Args:     status: Required status filter     payer_id: Optional payer ID filter     claim_carrier_control_number: Optional claim carrier control number filter     medical_record_request_group_id: Optional group ID filter     page: Page number (default: 1)     limit: Items per page (default: 20, max: 100)     query_service: Injected query service     user: Authenticated admin user  Returns:     ListMRRSubmissionsResponse with paginated results  Raises:     HTTPException: 403 if not admin, 500 if query fails
         * @summary List Mrr Submissions
         * @param {MedicalRecordRequestSubmissionStatus} status Filter by submission status (required)
         * @param {PayerId | null} [payerId] 
         * @param {string | null} [claimCarrierControlNumber] 
         * @param {string | null} [medicalRecordRequestGroupId] 
         * @param {number} [page] Page number (1-based)
         * @param {number} [limit] Items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMrrSubmissionsClaimMedicalRecordRequestsSubmissionsGet(status: MedicalRecordRequestSubmissionStatus, payerId?: PayerId | null, claimCarrierControlNumber?: string | null, medicalRecordRequestGroupId?: string | null, page?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListMRRSubmissionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMrrSubmissionsClaimMedicalRecordRequestsSubmissionsGet(status, payerId, claimCarrierControlNumber, medicalRecordRequestGroupId, page, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalRecordRequestsApi.listMrrSubmissionsClaimMedicalRecordRequestsSubmissionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Preview Medical Record Request
         * @param {Array<string> | null} [claimCarrierControlNumbers] 
         * @param {string | null} [patientId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewMedicalRecordRequestClaimMedicalRecordRequestsPreviewGet(claimCarrierControlNumbers?: Array<string> | null, patientId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PreviewMedicalRecordRequestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewMedicalRecordRequestClaimMedicalRecordRequestsPreviewGet(claimCarrierControlNumbers, patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalRecordRequestsApi.previewMedicalRecordRequestClaimMedicalRecordRequestsPreviewGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reject MRR submissions that are in NO_REQUEST_LETTER, NOT_SUBMITTED, or SUBMIT_FAILED status.  Submissions in other statuses will be skipped and included in the failed list.  Returns:     RejectMRRSubmissionsResponse with success status and list of failed IDs  Raises:     HTTPException: 403 if not admin, 500 if rejection fails
         * @summary Reject Mrr Submissions
         * @param {RejectMRRSubmissionsPayload} rejectMRRSubmissionsPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectMrrSubmissionsClaimMedicalRecordRequestsSubmissionsRejectPost(rejectMRRSubmissionsPayload: RejectMRRSubmissionsPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RejectMRRSubmissionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectMrrSubmissionsClaimMedicalRecordRequestsSubmissionsRejectPost(rejectMRRSubmissionsPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalRecordRequestsApi.rejectMrrSubmissionsClaimMedicalRecordRequestsSubmissionsRejectPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sends MRR submissions that are in NOT_SUBMITTED status. Submissions in other statuses will be skipped and included in the failed list.  Returns:     SendMRRSubmissionsResponse with success status and list of failed IDs  Raises:     HTTPException: 403 if not admin, 500 if sending fails
         * @summary Send Mrr Submissions
         * @param {BulkMRRSubmissionsPayload} bulkMRRSubmissionsPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendMrrSubmissionsClaimMedicalRecordRequestsSubmissionsSendPost(bulkMRRSubmissionsPayload: BulkMRRSubmissionsPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendMRRSubmissionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendMrrSubmissionsClaimMedicalRecordRequestsSubmissionsSendPost(bulkMRRSubmissionsPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MedicalRecordRequestsApi.sendMrrSubmissionsClaimMedicalRecordRequestsSubmissionsSendPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MedicalRecordRequestsApi - factory interface
 */
export const MedicalRecordRequestsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MedicalRecordRequestsApiFp(configuration)
    return {
        /**
         * Create an admin medical record request for a patient.  This endpoint allows admins to request medical records for any patient. The records are generated asynchronously and can be retrieved once completed.  Validation rules: - Only admin users (with provider_id) can access this endpoint - Admin users can request records for any patient  Args:     payload: The request payload containing patient_id and CCNs     application: Injected application service     user: Authenticated admin user  Returns:     CreateMedicalRecordRequestResponse with the group ID  Raises:     HTTPException: 403 if not admin, 400 if validation fails, 500 if creation fails
         * @summary Create Medical Record Request
         * @param {CreateMedicalRecordRequestPayload} createMedicalRecordRequestPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMedicalRecordRequestClaimMedicalRecordRequestsAdminPost(createMedicalRecordRequestPayload: CreateMedicalRecordRequestPayload, options?: RawAxiosRequestConfig): AxiosPromise<CreateMedicalRecordRequestResponse> {
            return localVarFp.createMedicalRecordRequestClaimMedicalRecordRequestsAdminPost(createMedicalRecordRequestPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Download all medical record exports for a group as a zip file.  This endpoint allows admins to download all completed medical record exports for a given group ID. The files are packaged as a zip file.  Authorization: Only admin users can download medical records.  Args:     group_id: The medical record request group ID     application: Injected application service     storage: Injected storage service for fetching PDFs from S3     user: Authenticated admin user  Raises:     HTTPException: 403 if not admin or access denied, 400 if exports not ready, 500 if download fails
         * @summary Download Medical Record Requests
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadMedicalRecordRequestsClaimMedicalRecordRequestsGroupIdDownloadGet(groupId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.downloadMedicalRecordRequestsClaimMedicalRecordRequestsGroupIdDownloadGet(groupId, options).then((request) => request(axios, basePath));
        },
        /**
         * Download MRR submissions as a zip file.  This endpoint allows admins to download multiple MRR submissions that have been generated. The files are packaged as a zip file.  Authorization: Only admin users can download MRR submissions.  Args:     payload: The request payload containing submission IDs to download.     application: Injected application service     storage: Injected storage service for fetching PDFs from S3     user: Authenticated admin user  Returns:     Response with zip file containing the MRR submissions  Raises:     HTTPException: 403 if not admin, 400 if no valid submissions, 500 if download fails
         * @summary Download Mrr Submissions
         * @param {BulkMRRSubmissionsPayload} bulkMRRSubmissionsPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadMrrSubmissionsClaimMedicalRecordRequestsSubmissionsDownloadPost(bulkMRRSubmissionsPayload: BulkMRRSubmissionsPayload, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.downloadMrrSubmissionsClaimMedicalRecordRequestsSubmissionsDownloadPost(bulkMRRSubmissionsPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the status of a medical record request group.  Returns the overall status of a medical record request group: - \"in_progress\": At least one request is still processing - \"completed\": At least one completed, none in progress - \"failed\": All requests failed  Authorization: User must be the requester who created the group (patient or admin).  Args:     group_id: The medical record request group ID     application: Injected application service     user: Authenticated user (patient or admin)  Returns:     GetMedicalRecordRequestStatusResponse with the status  Raises:     HTTPException: 403 if group not found or requester mismatch, 500 if status check fails
         * @summary Get Medical Record Request Status
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMedicalRecordRequestStatusClaimMedicalRecordRequestsGroupIdStatusGet(groupId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetMedicalRecordRequestStatusResponse> {
            return localVarFp.getMedicalRecordRequestStatusClaimMedicalRecordRequestsGroupIdStatusGet(groupId, options).then((request) => request(axios, basePath));
        },
        /**
         * List MRR submissions with optional filters. Returns paginated list.  Args:     status: Required status filter     payer_id: Optional payer ID filter     claim_carrier_control_number: Optional claim carrier control number filter     medical_record_request_group_id: Optional group ID filter     page: Page number (default: 1)     limit: Items per page (default: 20, max: 100)     query_service: Injected query service     user: Authenticated admin user  Returns:     ListMRRSubmissionsResponse with paginated results  Raises:     HTTPException: 403 if not admin, 500 if query fails
         * @summary List Mrr Submissions
         * @param {MedicalRecordRequestSubmissionStatus} status Filter by submission status (required)
         * @param {PayerId | null} [payerId] 
         * @param {string | null} [claimCarrierControlNumber] 
         * @param {string | null} [medicalRecordRequestGroupId] 
         * @param {number} [page] Page number (1-based)
         * @param {number} [limit] Items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMrrSubmissionsClaimMedicalRecordRequestsSubmissionsGet(status: MedicalRecordRequestSubmissionStatus, payerId?: PayerId | null, claimCarrierControlNumber?: string | null, medicalRecordRequestGroupId?: string | null, page?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<ListMRRSubmissionsResponse> {
            return localVarFp.listMrrSubmissionsClaimMedicalRecordRequestsSubmissionsGet(status, payerId, claimCarrierControlNumber, medicalRecordRequestGroupId, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Preview Medical Record Request
         * @param {Array<string> | null} [claimCarrierControlNumbers] 
         * @param {string | null} [patientId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewMedicalRecordRequestClaimMedicalRecordRequestsPreviewGet(claimCarrierControlNumbers?: Array<string> | null, patientId?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<PreviewMedicalRecordRequestResponse> {
            return localVarFp.previewMedicalRecordRequestClaimMedicalRecordRequestsPreviewGet(claimCarrierControlNumbers, patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Reject MRR submissions that are in NO_REQUEST_LETTER, NOT_SUBMITTED, or SUBMIT_FAILED status.  Submissions in other statuses will be skipped and included in the failed list.  Returns:     RejectMRRSubmissionsResponse with success status and list of failed IDs  Raises:     HTTPException: 403 if not admin, 500 if rejection fails
         * @summary Reject Mrr Submissions
         * @param {RejectMRRSubmissionsPayload} rejectMRRSubmissionsPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectMrrSubmissionsClaimMedicalRecordRequestsSubmissionsRejectPost(rejectMRRSubmissionsPayload: RejectMRRSubmissionsPayload, options?: RawAxiosRequestConfig): AxiosPromise<RejectMRRSubmissionsResponse> {
            return localVarFp.rejectMrrSubmissionsClaimMedicalRecordRequestsSubmissionsRejectPost(rejectMRRSubmissionsPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Sends MRR submissions that are in NOT_SUBMITTED status. Submissions in other statuses will be skipped and included in the failed list.  Returns:     SendMRRSubmissionsResponse with success status and list of failed IDs  Raises:     HTTPException: 403 if not admin, 500 if sending fails
         * @summary Send Mrr Submissions
         * @param {BulkMRRSubmissionsPayload} bulkMRRSubmissionsPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMrrSubmissionsClaimMedicalRecordRequestsSubmissionsSendPost(bulkMRRSubmissionsPayload: BulkMRRSubmissionsPayload, options?: RawAxiosRequestConfig): AxiosPromise<SendMRRSubmissionsResponse> {
            return localVarFp.sendMrrSubmissionsClaimMedicalRecordRequestsSubmissionsSendPost(bulkMRRSubmissionsPayload, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MedicalRecordRequestsApi - object-oriented interface
 */
export class MedicalRecordRequestsApi extends BaseAPI {
    /**
     * Create an admin medical record request for a patient.  This endpoint allows admins to request medical records for any patient. The records are generated asynchronously and can be retrieved once completed.  Validation rules: - Only admin users (with provider_id) can access this endpoint - Admin users can request records for any patient  Args:     payload: The request payload containing patient_id and CCNs     application: Injected application service     user: Authenticated admin user  Returns:     CreateMedicalRecordRequestResponse with the group ID  Raises:     HTTPException: 403 if not admin, 400 if validation fails, 500 if creation fails
     * @summary Create Medical Record Request
     * @param {CreateMedicalRecordRequestPayload} createMedicalRecordRequestPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createMedicalRecordRequestClaimMedicalRecordRequestsAdminPost(createMedicalRecordRequestPayload: CreateMedicalRecordRequestPayload, options?: RawAxiosRequestConfig) {
        return MedicalRecordRequestsApiFp(this.configuration).createMedicalRecordRequestClaimMedicalRecordRequestsAdminPost(createMedicalRecordRequestPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download all medical record exports for a group as a zip file.  This endpoint allows admins to download all completed medical record exports for a given group ID. The files are packaged as a zip file.  Authorization: Only admin users can download medical records.  Args:     group_id: The medical record request group ID     application: Injected application service     storage: Injected storage service for fetching PDFs from S3     user: Authenticated admin user  Raises:     HTTPException: 403 if not admin or access denied, 400 if exports not ready, 500 if download fails
     * @summary Download Medical Record Requests
     * @param {string} groupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadMedicalRecordRequestsClaimMedicalRecordRequestsGroupIdDownloadGet(groupId: string, options?: RawAxiosRequestConfig) {
        return MedicalRecordRequestsApiFp(this.configuration).downloadMedicalRecordRequestsClaimMedicalRecordRequestsGroupIdDownloadGet(groupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download MRR submissions as a zip file.  This endpoint allows admins to download multiple MRR submissions that have been generated. The files are packaged as a zip file.  Authorization: Only admin users can download MRR submissions.  Args:     payload: The request payload containing submission IDs to download.     application: Injected application service     storage: Injected storage service for fetching PDFs from S3     user: Authenticated admin user  Returns:     Response with zip file containing the MRR submissions  Raises:     HTTPException: 403 if not admin, 400 if no valid submissions, 500 if download fails
     * @summary Download Mrr Submissions
     * @param {BulkMRRSubmissionsPayload} bulkMRRSubmissionsPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadMrrSubmissionsClaimMedicalRecordRequestsSubmissionsDownloadPost(bulkMRRSubmissionsPayload: BulkMRRSubmissionsPayload, options?: RawAxiosRequestConfig) {
        return MedicalRecordRequestsApiFp(this.configuration).downloadMrrSubmissionsClaimMedicalRecordRequestsSubmissionsDownloadPost(bulkMRRSubmissionsPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the status of a medical record request group.  Returns the overall status of a medical record request group: - \"in_progress\": At least one request is still processing - \"completed\": At least one completed, none in progress - \"failed\": All requests failed  Authorization: User must be the requester who created the group (patient or admin).  Args:     group_id: The medical record request group ID     application: Injected application service     user: Authenticated user (patient or admin)  Returns:     GetMedicalRecordRequestStatusResponse with the status  Raises:     HTTPException: 403 if group not found or requester mismatch, 500 if status check fails
     * @summary Get Medical Record Request Status
     * @param {string} groupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMedicalRecordRequestStatusClaimMedicalRecordRequestsGroupIdStatusGet(groupId: string, options?: RawAxiosRequestConfig) {
        return MedicalRecordRequestsApiFp(this.configuration).getMedicalRecordRequestStatusClaimMedicalRecordRequestsGroupIdStatusGet(groupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List MRR submissions with optional filters. Returns paginated list.  Args:     status: Required status filter     payer_id: Optional payer ID filter     claim_carrier_control_number: Optional claim carrier control number filter     medical_record_request_group_id: Optional group ID filter     page: Page number (default: 1)     limit: Items per page (default: 20, max: 100)     query_service: Injected query service     user: Authenticated admin user  Returns:     ListMRRSubmissionsResponse with paginated results  Raises:     HTTPException: 403 if not admin, 500 if query fails
     * @summary List Mrr Submissions
     * @param {MedicalRecordRequestSubmissionStatus} status Filter by submission status (required)
     * @param {PayerId | null} [payerId] 
     * @param {string | null} [claimCarrierControlNumber] 
     * @param {string | null} [medicalRecordRequestGroupId] 
     * @param {number} [page] Page number (1-based)
     * @param {number} [limit] Items per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listMrrSubmissionsClaimMedicalRecordRequestsSubmissionsGet(status: MedicalRecordRequestSubmissionStatus, payerId?: PayerId | null, claimCarrierControlNumber?: string | null, medicalRecordRequestGroupId?: string | null, page?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return MedicalRecordRequestsApiFp(this.configuration).listMrrSubmissionsClaimMedicalRecordRequestsSubmissionsGet(status, payerId, claimCarrierControlNumber, medicalRecordRequestGroupId, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Preview Medical Record Request
     * @param {Array<string> | null} [claimCarrierControlNumbers] 
     * @param {string | null} [patientId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public previewMedicalRecordRequestClaimMedicalRecordRequestsPreviewGet(claimCarrierControlNumbers?: Array<string> | null, patientId?: string | null, options?: RawAxiosRequestConfig) {
        return MedicalRecordRequestsApiFp(this.configuration).previewMedicalRecordRequestClaimMedicalRecordRequestsPreviewGet(claimCarrierControlNumbers, patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reject MRR submissions that are in NO_REQUEST_LETTER, NOT_SUBMITTED, or SUBMIT_FAILED status.  Submissions in other statuses will be skipped and included in the failed list.  Returns:     RejectMRRSubmissionsResponse with success status and list of failed IDs  Raises:     HTTPException: 403 if not admin, 500 if rejection fails
     * @summary Reject Mrr Submissions
     * @param {RejectMRRSubmissionsPayload} rejectMRRSubmissionsPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public rejectMrrSubmissionsClaimMedicalRecordRequestsSubmissionsRejectPost(rejectMRRSubmissionsPayload: RejectMRRSubmissionsPayload, options?: RawAxiosRequestConfig) {
        return MedicalRecordRequestsApiFp(this.configuration).rejectMrrSubmissionsClaimMedicalRecordRequestsSubmissionsRejectPost(rejectMRRSubmissionsPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sends MRR submissions that are in NOT_SUBMITTED status. Submissions in other statuses will be skipped and included in the failed list.  Returns:     SendMRRSubmissionsResponse with success status and list of failed IDs  Raises:     HTTPException: 403 if not admin, 500 if sending fails
     * @summary Send Mrr Submissions
     * @param {BulkMRRSubmissionsPayload} bulkMRRSubmissionsPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sendMrrSubmissionsClaimMedicalRecordRequestsSubmissionsSendPost(bulkMRRSubmissionsPayload: BulkMRRSubmissionsPayload, options?: RawAxiosRequestConfig) {
        return MedicalRecordRequestsApiFp(this.configuration).sendMrrSubmissionsClaimMedicalRecordRequestsSubmissionsSendPost(bulkMRRSubmissionsPayload, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NotificationApi - axios parameter creator
 */
export const NotificationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete Fcm Token
         * @param {string} token 
         * @param {PatientId} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFcmTokenPatientsPatientIdPushNotificationsRegistrationsTokenDelete: async (token: string, patientId: PatientId, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('deleteFcmTokenPatientsPatientIdPushNotificationsRegistrationsTokenDelete', 'token', token)
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('deleteFcmTokenPatientsPatientIdPushNotificationsRegistrationsTokenDelete', 'patientId', patientId)
            const localVarPath = `/patients/{patient_id}/push-notifications/registrations/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)))
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get All Notification Group Settings
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNotificationGroupSettingsPatientsPatientIdNotificationSettingsGet: async (patientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getAllNotificationGroupSettingsPatientsPatientIdNotificationSettingsGet', 'patientId', patientId)
            const localVarPath = `/patients/{patient_id}/notification-settings`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Notifications For Recipient
         * @param {string | null} [patientId] 
         * @param {string | null} [providerId] 
         * @param {number} [offset] Number of items to skip
         * @param {number} [limit] Maximum number of items to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationsForRecipientAdminNotificationsGet: async (patientId?: string | null, providerId?: string | null, offset?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (patientId !== undefined) {
                localVarQueryParameter['patient_id'] = patientId;
            }

            if (providerId !== undefined) {
                localVarQueryParameter['provider_id'] = providerId;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Register Fcm Token
         * @param {PatientId} patientId 
         * @param {FCMRegistrationRequest} fCMRegistrationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerFcmTokenPatientsPatientIdPushNotificationsRegistrationsPost: async (patientId: PatientId, fCMRegistrationRequest: FCMRegistrationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('registerFcmTokenPatientsPatientIdPushNotificationsRegistrationsPost', 'patientId', patientId)
            // verify required parameter 'fCMRegistrationRequest' is not null or undefined
            assertParamExists('registerFcmTokenPatientsPatientIdPushNotificationsRegistrationsPost', 'fCMRegistrationRequest', fCMRegistrationRequest)
            const localVarPath = `/patients/{patient_id}/push-notifications/registrations`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fCMRegistrationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Twilio Inbound Sms Webhook
         * @param {string} from 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        twilioInboundSmsWebhookWebhooksTwilioInboundSmsPost: async (from: string, body: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'from' is not null or undefined
            assertParamExists('twilioInboundSmsWebhookWebhooksTwilioInboundSmsPost', 'from', from)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('twilioInboundSmsWebhookWebhooksTwilioInboundSmsPost', 'body', body)
            const localVarPath = `/webhooks/twilio/inbound_sms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();


            if (from !== undefined) { 
                localVarFormParams.set('from_', from as any);
            }

            if (body !== undefined) { 
                localVarFormParams.set('body', body as any);
            }
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Notification Group Setting
         * @param {string} patientId 
         * @param {string} groupSlug 
         * @param {UpdateSettingPayload} updateSettingPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotificationGroupSettingPatientsPatientIdNotificationSettingsGroupSlugPut: async (patientId: string, groupSlug: string, updateSettingPayload: UpdateSettingPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('updateNotificationGroupSettingPatientsPatientIdNotificationSettingsGroupSlugPut', 'patientId', patientId)
            // verify required parameter 'groupSlug' is not null or undefined
            assertParamExists('updateNotificationGroupSettingPatientsPatientIdNotificationSettingsGroupSlugPut', 'groupSlug', groupSlug)
            // verify required parameter 'updateSettingPayload' is not null or undefined
            assertParamExists('updateNotificationGroupSettingPatientsPatientIdNotificationSettingsGroupSlugPut', 'updateSettingPayload', updateSettingPayload)
            const localVarPath = `/patients/{patient_id}/notification-settings/{group_slug}`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)))
                .replace(`{${"group_slug"}}`, encodeURIComponent(String(groupSlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSettingPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationApi - functional programming interface
 */
export const NotificationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete Fcm Token
         * @param {string} token 
         * @param {PatientId} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFcmTokenPatientsPatientIdPushNotificationsRegistrationsTokenDelete(token: string, patientId: PatientId, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFcmTokenPatientsPatientIdPushNotificationsRegistrationsTokenDelete(token, patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.deleteFcmTokenPatientsPatientIdPushNotificationsRegistrationsTokenDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get All Notification Group Settings
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllNotificationGroupSettingsPatientsPatientIdNotificationSettingsGet(patientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AllSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllNotificationGroupSettingsPatientsPatientIdNotificationSettingsGet(patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.getAllNotificationGroupSettingsPatientsPatientIdNotificationSettingsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Notifications For Recipient
         * @param {string | null} [patientId] 
         * @param {string | null} [providerId] 
         * @param {number} [offset] Number of items to skip
         * @param {number} [limit] Maximum number of items to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotificationsForRecipientAdminNotificationsGet(patientId?: string | null, providerId?: string | null, offset?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AllNotificationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotificationsForRecipientAdminNotificationsGet(patientId, providerId, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.getNotificationsForRecipientAdminNotificationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Register Fcm Token
         * @param {PatientId} patientId 
         * @param {FCMRegistrationRequest} fCMRegistrationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerFcmTokenPatientsPatientIdPushNotificationsRegistrationsPost(patientId: PatientId, fCMRegistrationRequest: FCMRegistrationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FCMRegistrationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerFcmTokenPatientsPatientIdPushNotificationsRegistrationsPost(patientId, fCMRegistrationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.registerFcmTokenPatientsPatientIdPushNotificationsRegistrationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Twilio Inbound Sms Webhook
         * @param {string} from 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async twilioInboundSmsWebhookWebhooksTwilioInboundSmsPost(from: string, body: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.twilioInboundSmsWebhookWebhooksTwilioInboundSmsPost(from, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.twilioInboundSmsWebhookWebhooksTwilioInboundSmsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Notification Group Setting
         * @param {string} patientId 
         * @param {string} groupSlug 
         * @param {UpdateSettingPayload} updateSettingPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateNotificationGroupSettingPatientsPatientIdNotificationSettingsGroupSlugPut(patientId: string, groupSlug: string, updateSettingPayload: UpdateSettingPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateSettingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateNotificationGroupSettingPatientsPatientIdNotificationSettingsGroupSlugPut(patientId, groupSlug, updateSettingPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.updateNotificationGroupSettingPatientsPatientIdNotificationSettingsGroupSlugPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NotificationApi - factory interface
 */
export const NotificationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete Fcm Token
         * @param {string} token 
         * @param {PatientId} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFcmTokenPatientsPatientIdPushNotificationsRegistrationsTokenDelete(token: string, patientId: PatientId, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteFcmTokenPatientsPatientIdPushNotificationsRegistrationsTokenDelete(token, patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get All Notification Group Settings
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNotificationGroupSettingsPatientsPatientIdNotificationSettingsGet(patientId: string, options?: RawAxiosRequestConfig): AxiosPromise<AllSettingsResponse> {
            return localVarFp.getAllNotificationGroupSettingsPatientsPatientIdNotificationSettingsGet(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Notifications For Recipient
         * @param {string | null} [patientId] 
         * @param {string | null} [providerId] 
         * @param {number} [offset] Number of items to skip
         * @param {number} [limit] Maximum number of items to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationsForRecipientAdminNotificationsGet(patientId?: string | null, providerId?: string | null, offset?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<AllNotificationsResponse> {
            return localVarFp.getNotificationsForRecipientAdminNotificationsGet(patientId, providerId, offset, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Register Fcm Token
         * @param {PatientId} patientId 
         * @param {FCMRegistrationRequest} fCMRegistrationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerFcmTokenPatientsPatientIdPushNotificationsRegistrationsPost(patientId: PatientId, fCMRegistrationRequest: FCMRegistrationRequest, options?: RawAxiosRequestConfig): AxiosPromise<FCMRegistrationResponse> {
            return localVarFp.registerFcmTokenPatientsPatientIdPushNotificationsRegistrationsPost(patientId, fCMRegistrationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Twilio Inbound Sms Webhook
         * @param {string} from 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        twilioInboundSmsWebhookWebhooksTwilioInboundSmsPost(from: string, body: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.twilioInboundSmsWebhookWebhooksTwilioInboundSmsPost(from, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Notification Group Setting
         * @param {string} patientId 
         * @param {string} groupSlug 
         * @param {UpdateSettingPayload} updateSettingPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotificationGroupSettingPatientsPatientIdNotificationSettingsGroupSlugPut(patientId: string, groupSlug: string, updateSettingPayload: UpdateSettingPayload, options?: RawAxiosRequestConfig): AxiosPromise<UpdateSettingResponse> {
            return localVarFp.updateNotificationGroupSettingPatientsPatientIdNotificationSettingsGroupSlugPut(patientId, groupSlug, updateSettingPayload, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationApi - object-oriented interface
 */
export class NotificationApi extends BaseAPI {
    /**
     * 
     * @summary Delete Fcm Token
     * @param {string} token 
     * @param {PatientId} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteFcmTokenPatientsPatientIdPushNotificationsRegistrationsTokenDelete(token: string, patientId: PatientId, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).deleteFcmTokenPatientsPatientIdPushNotificationsRegistrationsTokenDelete(token, patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get All Notification Group Settings
     * @param {string} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllNotificationGroupSettingsPatientsPatientIdNotificationSettingsGet(patientId: string, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).getAllNotificationGroupSettingsPatientsPatientIdNotificationSettingsGet(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Notifications For Recipient
     * @param {string | null} [patientId] 
     * @param {string | null} [providerId] 
     * @param {number} [offset] Number of items to skip
     * @param {number} [limit] Maximum number of items to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getNotificationsForRecipientAdminNotificationsGet(patientId?: string | null, providerId?: string | null, offset?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).getNotificationsForRecipientAdminNotificationsGet(patientId, providerId, offset, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Register Fcm Token
     * @param {PatientId} patientId 
     * @param {FCMRegistrationRequest} fCMRegistrationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public registerFcmTokenPatientsPatientIdPushNotificationsRegistrationsPost(patientId: PatientId, fCMRegistrationRequest: FCMRegistrationRequest, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).registerFcmTokenPatientsPatientIdPushNotificationsRegistrationsPost(patientId, fCMRegistrationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Twilio Inbound Sms Webhook
     * @param {string} from 
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public twilioInboundSmsWebhookWebhooksTwilioInboundSmsPost(from: string, body: string, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).twilioInboundSmsWebhookWebhooksTwilioInboundSmsPost(from, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Notification Group Setting
     * @param {string} patientId 
     * @param {string} groupSlug 
     * @param {UpdateSettingPayload} updateSettingPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateNotificationGroupSettingPatientsPatientIdNotificationSettingsGroupSlugPut(patientId: string, groupSlug: string, updateSettingPayload: UpdateSettingPayload, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).updateNotificationGroupSettingPatientsPatientIdNotificationSettingsGroupSlugPut(patientId, groupSlug, updateSettingPayload, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NutritionResearchApi - axios parameter creator
 */
export const NutritionResearchApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Nutrition Research Thread
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNutritionResearchThreadNutritionResearchThreadsPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/nutrition-research/threads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Nutrition Research Thread Messages
         * @param {string} threadId 
         * @param {number} [pageSize] The number of messages to return
         * @param {number} [offset] The offset or cursor used in pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNutritionResearchThreadMessagesNutritionResearchThreadsThreadIdMessagesGet: async (threadId: string, pageSize?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'threadId' is not null or undefined
            assertParamExists('getNutritionResearchThreadMessagesNutritionResearchThreadsThreadIdMessagesGet', 'threadId', threadId)
            const localVarPath = `/nutrition-research/threads/{thread_id}/messages`
                .replace(`{${"thread_id"}}`, encodeURIComponent(String(threadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Nutrition Research Thread
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNutritionResearchThreadNutritionResearchThreadsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/nutrition-research/threads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Nutrition Research Feedback
         * @param {NutritionResearchFeedbackPayload} nutritionResearchFeedbackPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nutritionResearchFeedbackNutritionResearchFeedbackPost: async (nutritionResearchFeedbackPayload: NutritionResearchFeedbackPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nutritionResearchFeedbackPayload' is not null or undefined
            assertParamExists('nutritionResearchFeedbackNutritionResearchFeedbackPost', 'nutritionResearchFeedbackPayload', nutritionResearchFeedbackPayload)
            const localVarPath = `/nutrition-research/feedback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(nutritionResearchFeedbackPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Run Nutrition Research Thread
         * @param {string} threadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runNutritionResearchThreadNutritionResearchThreadsRunThreadIdPost: async (threadId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'threadId' is not null or undefined
            assertParamExists('runNutritionResearchThreadNutritionResearchThreadsRunThreadIdPost', 'threadId', threadId)
            const localVarPath = `/nutrition-research/threads/run/{thread_id}`
                .replace(`{${"thread_id"}}`, encodeURIComponent(String(threadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send Nutrition Research Message
         * @param {NutritionResearchSendMessagePayload} nutritionResearchSendMessagePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendNutritionResearchMessageNutritionResearchMessagePost: async (nutritionResearchSendMessagePayload: NutritionResearchSendMessagePayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nutritionResearchSendMessagePayload' is not null or undefined
            assertParamExists('sendNutritionResearchMessageNutritionResearchMessagePost', 'nutritionResearchSendMessagePayload', nutritionResearchSendMessagePayload)
            const localVarPath = `/nutrition-research/message`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(nutritionResearchSendMessagePayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Stream Nutrition Research Thread
         * @param {string} threadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        streamNutritionResearchThreadNutritionResearchThreadsStreamThreadIdPost: async (threadId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'threadId' is not null or undefined
            assertParamExists('streamNutritionResearchThreadNutritionResearchThreadsStreamThreadIdPost', 'threadId', threadId)
            const localVarPath = `/nutrition-research/threads/stream/{thread_id}`
                .replace(`{${"thread_id"}}`, encodeURIComponent(String(threadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NutritionResearchApi - functional programming interface
 */
export const NutritionResearchApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NutritionResearchApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Nutrition Research Thread
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNutritionResearchThreadNutritionResearchThreadsPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateNutritionResearchThreadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNutritionResearchThreadNutritionResearchThreadsPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NutritionResearchApi.createNutritionResearchThreadNutritionResearchThreadsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Nutrition Research Thread Messages
         * @param {string} threadId 
         * @param {number} [pageSize] The number of messages to return
         * @param {number} [offset] The offset or cursor used in pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNutritionResearchThreadMessagesNutritionResearchThreadsThreadIdMessagesGet(threadId: string, pageSize?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetNutritionResearchThreadMessagesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNutritionResearchThreadMessagesNutritionResearchThreadsThreadIdMessagesGet(threadId, pageSize, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NutritionResearchApi.getNutritionResearchThreadMessagesNutritionResearchThreadsThreadIdMessagesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Nutrition Research Thread
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNutritionResearchThreadNutritionResearchThreadsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetNutritionResearchThreadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNutritionResearchThreadNutritionResearchThreadsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NutritionResearchApi.getNutritionResearchThreadNutritionResearchThreadsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Nutrition Research Feedback
         * @param {NutritionResearchFeedbackPayload} nutritionResearchFeedbackPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async nutritionResearchFeedbackNutritionResearchFeedbackPost(nutritionResearchFeedbackPayload: NutritionResearchFeedbackPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.nutritionResearchFeedbackNutritionResearchFeedbackPost(nutritionResearchFeedbackPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NutritionResearchApi.nutritionResearchFeedbackNutritionResearchFeedbackPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Run Nutrition Research Thread
         * @param {string} threadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runNutritionResearchThreadNutritionResearchThreadsRunThreadIdPost(threadId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NutritionResearchRunThreadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runNutritionResearchThreadNutritionResearchThreadsRunThreadIdPost(threadId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NutritionResearchApi.runNutritionResearchThreadNutritionResearchThreadsRunThreadIdPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Send Nutrition Research Message
         * @param {NutritionResearchSendMessagePayload} nutritionResearchSendMessagePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendNutritionResearchMessageNutritionResearchMessagePost(nutritionResearchSendMessagePayload: NutritionResearchSendMessagePayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendNutritionResearchMessageNutritionResearchMessagePost(nutritionResearchSendMessagePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NutritionResearchApi.sendNutritionResearchMessageNutritionResearchMessagePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Stream Nutrition Research Thread
         * @param {string} threadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async streamNutritionResearchThreadNutritionResearchThreadsStreamThreadIdPost(threadId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.streamNutritionResearchThreadNutritionResearchThreadsStreamThreadIdPost(threadId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NutritionResearchApi.streamNutritionResearchThreadNutritionResearchThreadsStreamThreadIdPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NutritionResearchApi - factory interface
 */
export const NutritionResearchApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NutritionResearchApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Nutrition Research Thread
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNutritionResearchThreadNutritionResearchThreadsPost(options?: RawAxiosRequestConfig): AxiosPromise<CreateNutritionResearchThreadResponse> {
            return localVarFp.createNutritionResearchThreadNutritionResearchThreadsPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Nutrition Research Thread Messages
         * @param {string} threadId 
         * @param {number} [pageSize] The number of messages to return
         * @param {number} [offset] The offset or cursor used in pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNutritionResearchThreadMessagesNutritionResearchThreadsThreadIdMessagesGet(threadId: string, pageSize?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<GetNutritionResearchThreadMessagesResponse> {
            return localVarFp.getNutritionResearchThreadMessagesNutritionResearchThreadsThreadIdMessagesGet(threadId, pageSize, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Nutrition Research Thread
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNutritionResearchThreadNutritionResearchThreadsGet(options?: RawAxiosRequestConfig): AxiosPromise<GetNutritionResearchThreadResponse> {
            return localVarFp.getNutritionResearchThreadNutritionResearchThreadsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Nutrition Research Feedback
         * @param {NutritionResearchFeedbackPayload} nutritionResearchFeedbackPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nutritionResearchFeedbackNutritionResearchFeedbackPost(nutritionResearchFeedbackPayload: NutritionResearchFeedbackPayload, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.nutritionResearchFeedbackNutritionResearchFeedbackPost(nutritionResearchFeedbackPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Run Nutrition Research Thread
         * @param {string} threadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runNutritionResearchThreadNutritionResearchThreadsRunThreadIdPost(threadId: string, options?: RawAxiosRequestConfig): AxiosPromise<NutritionResearchRunThreadResponse> {
            return localVarFp.runNutritionResearchThreadNutritionResearchThreadsRunThreadIdPost(threadId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send Nutrition Research Message
         * @param {NutritionResearchSendMessagePayload} nutritionResearchSendMessagePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendNutritionResearchMessageNutritionResearchMessagePost(nutritionResearchSendMessagePayload: NutritionResearchSendMessagePayload, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.sendNutritionResearchMessageNutritionResearchMessagePost(nutritionResearchSendMessagePayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Stream Nutrition Research Thread
         * @param {string} threadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        streamNutritionResearchThreadNutritionResearchThreadsStreamThreadIdPost(threadId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.streamNutritionResearchThreadNutritionResearchThreadsStreamThreadIdPost(threadId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NutritionResearchApi - object-oriented interface
 */
export class NutritionResearchApi extends BaseAPI {
    /**
     * 
     * @summary Create Nutrition Research Thread
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createNutritionResearchThreadNutritionResearchThreadsPost(options?: RawAxiosRequestConfig) {
        return NutritionResearchApiFp(this.configuration).createNutritionResearchThreadNutritionResearchThreadsPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Nutrition Research Thread Messages
     * @param {string} threadId 
     * @param {number} [pageSize] The number of messages to return
     * @param {number} [offset] The offset or cursor used in pagination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getNutritionResearchThreadMessagesNutritionResearchThreadsThreadIdMessagesGet(threadId: string, pageSize?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return NutritionResearchApiFp(this.configuration).getNutritionResearchThreadMessagesNutritionResearchThreadsThreadIdMessagesGet(threadId, pageSize, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Nutrition Research Thread
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getNutritionResearchThreadNutritionResearchThreadsGet(options?: RawAxiosRequestConfig) {
        return NutritionResearchApiFp(this.configuration).getNutritionResearchThreadNutritionResearchThreadsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Nutrition Research Feedback
     * @param {NutritionResearchFeedbackPayload} nutritionResearchFeedbackPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public nutritionResearchFeedbackNutritionResearchFeedbackPost(nutritionResearchFeedbackPayload: NutritionResearchFeedbackPayload, options?: RawAxiosRequestConfig) {
        return NutritionResearchApiFp(this.configuration).nutritionResearchFeedbackNutritionResearchFeedbackPost(nutritionResearchFeedbackPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Run Nutrition Research Thread
     * @param {string} threadId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public runNutritionResearchThreadNutritionResearchThreadsRunThreadIdPost(threadId: string, options?: RawAxiosRequestConfig) {
        return NutritionResearchApiFp(this.configuration).runNutritionResearchThreadNutritionResearchThreadsRunThreadIdPost(threadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send Nutrition Research Message
     * @param {NutritionResearchSendMessagePayload} nutritionResearchSendMessagePayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sendNutritionResearchMessageNutritionResearchMessagePost(nutritionResearchSendMessagePayload: NutritionResearchSendMessagePayload, options?: RawAxiosRequestConfig) {
        return NutritionResearchApiFp(this.configuration).sendNutritionResearchMessageNutritionResearchMessagePost(nutritionResearchSendMessagePayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Stream Nutrition Research Thread
     * @param {string} threadId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public streamNutritionResearchThreadNutritionResearchThreadsStreamThreadIdPost(threadId: string, options?: RawAxiosRequestConfig) {
        return NutritionResearchApiFp(this.configuration).streamNutritionResearchThreadNutritionResearchThreadsStreamThreadIdPost(threadId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PartnerBookingApi - axios parameter creator
 */
export const PartnerBookingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Complete Partner Booking
         * @param {string} bookingCode 
         * @param {CompletePartnerBookingPayload} completePartnerBookingPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completePartnerBookingPartnersBookingBookingCodePost: async (bookingCode: string, completePartnerBookingPayload: CompletePartnerBookingPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingCode' is not null or undefined
            assertParamExists('completePartnerBookingPartnersBookingBookingCodePost', 'bookingCode', bookingCode)
            // verify required parameter 'completePartnerBookingPayload' is not null or undefined
            assertParamExists('completePartnerBookingPartnersBookingBookingCodePost', 'completePartnerBookingPayload', completePartnerBookingPayload)
            const localVarPath = `/partners/booking/{booking_code}`
                .replace(`{${"booking_code"}}`, encodeURIComponent(String(bookingCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completePartnerBookingPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Partner Booking Info
         * @param {string} bookingCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerBookingInfoPartnersBookingBookingCodeGet: async (bookingCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingCode' is not null or undefined
            assertParamExists('getPartnerBookingInfoPartnersBookingBookingCodeGet', 'bookingCode', bookingCode)
            const localVarPath = `/partners/booking/{booking_code}`
                .replace(`{${"booking_code"}}`, encodeURIComponent(String(bookingCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PartnerBookingApi - functional programming interface
 */
export const PartnerBookingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PartnerBookingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Complete Partner Booking
         * @param {string} bookingCode 
         * @param {CompletePartnerBookingPayload} completePartnerBookingPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completePartnerBookingPartnersBookingBookingCodePost(bookingCode: string, completePartnerBookingPayload: CompletePartnerBookingPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompletePartnerBookingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completePartnerBookingPartnersBookingBookingCodePost(bookingCode, completePartnerBookingPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartnerBookingApi.completePartnerBookingPartnersBookingBookingCodePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Partner Booking Info
         * @param {string} bookingCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPartnerBookingInfoPartnersBookingBookingCodeGet(bookingCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPartnerBookingInfoPartnersBookingBookingCodeGet(bookingCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartnerBookingApi.getPartnerBookingInfoPartnersBookingBookingCodeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PartnerBookingApi - factory interface
 */
export const PartnerBookingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PartnerBookingApiFp(configuration)
    return {
        /**
         * 
         * @summary Complete Partner Booking
         * @param {string} bookingCode 
         * @param {CompletePartnerBookingPayload} completePartnerBookingPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completePartnerBookingPartnersBookingBookingCodePost(bookingCode: string, completePartnerBookingPayload: CompletePartnerBookingPayload, options?: RawAxiosRequestConfig): AxiosPromise<CompletePartnerBookingResponse> {
            return localVarFp.completePartnerBookingPartnersBookingBookingCodePost(bookingCode, completePartnerBookingPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Partner Booking Info
         * @param {string} bookingCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerBookingInfoPartnersBookingBookingCodeGet(bookingCode: string, options?: RawAxiosRequestConfig): AxiosPromise<BookingInfoResponse> {
            return localVarFp.getPartnerBookingInfoPartnersBookingBookingCodeGet(bookingCode, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PartnerBookingApi - object-oriented interface
 */
export class PartnerBookingApi extends BaseAPI {
    /**
     * 
     * @summary Complete Partner Booking
     * @param {string} bookingCode 
     * @param {CompletePartnerBookingPayload} completePartnerBookingPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public completePartnerBookingPartnersBookingBookingCodePost(bookingCode: string, completePartnerBookingPayload: CompletePartnerBookingPayload, options?: RawAxiosRequestConfig) {
        return PartnerBookingApiFp(this.configuration).completePartnerBookingPartnersBookingBookingCodePost(bookingCode, completePartnerBookingPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Partner Booking Info
     * @param {string} bookingCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPartnerBookingInfoPartnersBookingBookingCodeGet(bookingCode: string, options?: RawAxiosRequestConfig) {
        return PartnerBookingApiFp(this.configuration).getPartnerBookingInfoPartnersBookingBookingCodeGet(bookingCode, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PatientApi - axios parameter creator
 */
export const PatientApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add Patient Lab Feedback
         * @param {string} labId 
         * @param {PatientId} patientId 
         * @param {AddPatientLabFeedbackPayload} addPatientLabFeedbackPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPatientLabFeedbackPatientPatientIdLabsLabIdFeedbackPost: async (labId: string, patientId: PatientId, addPatientLabFeedbackPayload: AddPatientLabFeedbackPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'labId' is not null or undefined
            assertParamExists('addPatientLabFeedbackPatientPatientIdLabsLabIdFeedbackPost', 'labId', labId)
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('addPatientLabFeedbackPatientPatientIdLabsLabIdFeedbackPost', 'patientId', patientId)
            // verify required parameter 'addPatientLabFeedbackPayload' is not null or undefined
            assertParamExists('addPatientLabFeedbackPatientPatientIdLabsLabIdFeedbackPost', 'addPatientLabFeedbackPayload', addPatientLabFeedbackPayload)
            const localVarPath = `/patient/{patient_id}/labs/{lab_id}/feedback`
                .replace(`{${"lab_id"}}`, encodeURIComponent(String(labId)))
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addPatientLabFeedbackPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Public endpoint to check if a phone number is available for registration.  This endpoint is restricted to requests from signup.faynutrition.com domains and is rate-limited to prevent enumeration attacks.  Returns:     PhoneAvailabilityResponse: Object with \'available\' boolean field
         * @summary Check Phone Availability
         * @param {string} phoneNumber Phone number to check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkPhoneAvailabilityPatientsPhoneAvailabilityGet: async (phoneNumber: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'phoneNumber' is not null or undefined
            assertParamExists('checkPhoneAvailabilityPatientsPhoneAvailabilityGet', 'phoneNumber', phoneNumber)
            const localVarPath = `/patients/phone-availability`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (phoneNumber !== undefined) {
                localVarQueryParameter['phone_number'] = phoneNumber;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new booking code. Only accessible by admin users.
         * @summary Create Booking Code
         * @param {CreateBookingCodePayload} createBookingCodePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBookingCodeBookingCodesPost: async (createBookingCodePayload: CreateBookingCodePayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createBookingCodePayload' is not null or undefined
            assertParamExists('createBookingCodeBookingCodesPost', 'createBookingCodePayload', createBookingCodePayload)
            const localVarPath = `/booking-codes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBookingCodePayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Journal Entry
         * @param {CreateJournalEntryPayload} createJournalEntryPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJournalEntryPatientJournalEntriesPost: async (createJournalEntryPayload: CreateJournalEntryPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createJournalEntryPayload' is not null or undefined
            assertParamExists('createJournalEntryPatientJournalEntriesPost', 'createJournalEntryPayload', createJournalEntryPayload)
            const localVarPath = `/patient/journal/entries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createJournalEntryPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an existing booking code. Only accessible by admin users.
         * @summary Delete Booking Code
         * @param {string} bookingCodeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBookingCodeBookingCodesBookingCodeIdDelete: async (bookingCodeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingCodeId' is not null or undefined
            assertParamExists('deleteBookingCodeBookingCodesBookingCodeIdDelete', 'bookingCodeId', bookingCodeId)
            const localVarPath = `/booking-codes/{booking_code_id}`
                .replace(`{${"booking_code_id"}}`, encodeURIComponent(String(bookingCodeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Journal Entry
         * @param {string} journalEntryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteJournalEntryPatientJournalEntriesJournalEntryIdDelete: async (journalEntryId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'journalEntryId' is not null or undefined
            assertParamExists('deleteJournalEntryPatientJournalEntriesJournalEntryIdDelete', 'journalEntryId', journalEntryId)
            const localVarPath = `/patient/journal/entries/{journal_entry_id}`
                .replace(`{${"journal_entry_id"}}`, encodeURIComponent(String(journalEntryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Soft deletes a patient\'s account upon request of the patient.  Note: this does not delete the patient from our system - just marks them as deleted and triggers patient data cleanup.
         * @summary Delete Patient Account
         * @param {PatientId} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePatientAccountPatientsPatientIdDelete: async (patientId: PatientId, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('deletePatientAccountPatientsPatientIdDelete', 'patientId', patientId)
            const localVarPath = `/patients/{patient_id}`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary External Facing Details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalFacingDetailsPatientExternalFacingDetailsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/patient/external_facing_details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a booking code by its ID.
         * @summary Get Booking Code
         * @param {string} bookingCodeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookingCodeBookingCodesBookingCodeIdGet: async (bookingCodeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingCodeId' is not null or undefined
            assertParamExists('getBookingCodeBookingCodesBookingCodeIdGet', 'bookingCodeId', bookingCodeId)
            const localVarPath = `/booking-codes/{booking_code_id}`
                .replace(`{${"booking_code_id"}}`, encodeURIComponent(String(bookingCodeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unauthenticated, retrieve a booking code by its code.
         * @summary Get Booking Code By Code
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookingCodeByCodeBookingCodesCodeCodeGet: async (code: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('getBookingCodeByCodeBookingCodesCodeCodeGet', 'code', code)
            const localVarPath = `/booking-codes/code/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the current booking code for a patient.
         * @summary Get Booking Code For Patient
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookingCodeForPatientPatientsBookingCodeConfigGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/patients/booking-code-config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve all booking codes. Only accessible by admin users.  Args:     booking_code_types: Optional list of booking code types to filter by.                        If not provided, defaults to all types except patient_referral.     booking_code_application: The application service to retrieve booking codes.
         * @summary Get Booking Codes
         * @param {Array<BookingCodeType> | null} [bookingCodeTypes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookingCodesBookingCodesGet: async (bookingCodeTypes?: Array<BookingCodeType> | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/booking-codes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (bookingCodeTypes) {
                localVarQueryParameter['booking_code_types'] = bookingCodeTypes;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Journal Entry
         * @param {string} journalEntryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJournalEntryPatientJournalEntriesJournalEntryIdGet: async (journalEntryId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'journalEntryId' is not null or undefined
            assertParamExists('getJournalEntryPatientJournalEntriesJournalEntryIdGet', 'journalEntryId', journalEntryId)
            const localVarPath = `/patient/journal/entries/{journal_entry_id}`
                .replace(`{${"journal_entry_id"}}`, encodeURIComponent(String(journalEntryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Journal Streak
         * @param {string | null} [timezone] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJournalStreakPatientJournalStreakGet: async (timezone?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/patient/journal/streak`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (timezone !== undefined) {
                localVarQueryParameter['timezone'] = timezone;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Patient Confirmation Status By Onboarding Code
         * @param {string} onboardingCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientConfirmationStatusByOnboardingCodePatientConfirmCodeOnboardingCodeGet: async (onboardingCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'onboardingCode' is not null or undefined
            assertParamExists('getPatientConfirmationStatusByOnboardingCodePatientConfirmCodeOnboardingCodeGet', 'onboardingCode', onboardingCode)
            const localVarPath = `/patient/confirm/code/{onboarding_code}`
                .replace(`{${"onboarding_code"}}`, encodeURIComponent(String(onboardingCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Patient Confirmation Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientConfirmationStatusPatientConfirmGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/patient/confirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Patient Details By Email
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientDetailsByEmailAdminPatientsByEmailGet: async (email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('getPatientDetailsByEmailAdminPatientsByEmailGet', 'email', email)
            const localVarPath = `/admin/patients/by-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Patient Details
         * @param {PatientId} patientId 
         * @param {Array<PatientDetailsInclusions> | null} [include] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientDetailsPatientsPatientIdGet: async (patientId: PatientId, include?: Array<PatientDetailsInclusions> | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getPatientDetailsPatientsPatientIdGet', 'patientId', patientId)
            const localVarPath = `/patients/{patient_id}`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (include) {
                localVarQueryParameter['include'] = include;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Patient Intake Form Answers
         * @param {PatientId} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientIntakeFormAnswersPatientsPatientIdIntakeGet: async (patientId: PatientId, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getPatientIntakeFormAnswersPatientsPatientIdIntakeGet', 'patientId', patientId)
            const localVarPath = `/patients/{patient_id}/intake`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve paginated journal entries for the specified patient.  The entries are returned in descending order based on their creation date, with the most recent entries appearing first.  Args:     patient_id (PatientIdAllowingMe): The ID of the patient or \'me\' for the current user.     cursor (str | None): Pagination cursor for fetching the next set of results.     limit (int): Number of entries to return per page (default: 20, max: 100).     application: Application service used to fetch journal entries.     patient_application: Application service for retrieving patient details.     journal_entry_files_service: Service for accessing journal entry files.     user: The authenticated user making the request.  Returns:     CursorPaginatedJournalEntriesResponse: A paginated list of journal entries     and the next pagination cursor.
         * @summary Get Patient Journal Entries
         * @param {PatientId} patientId 
         * @param {string | null} [cursor] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientJournalEntriesPatientPatientIdJournalEntriesGet: async (patientId: PatientId, cursor?: string | null, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getPatientJournalEntriesPatientPatientIdJournalEntriesGet', 'patientId', patientId)
            const localVarPath = `/patient/{patient_id}/journal/entries`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Patient Lab
         * @param {string} labId 
         * @param {PatientId} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientLabPatientPatientIdLabsLabIdGet: async (labId: string, patientId: PatientId, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'labId' is not null or undefined
            assertParamExists('getPatientLabPatientPatientIdLabsLabIdGet', 'labId', labId)
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getPatientLabPatientPatientIdLabsLabIdGet', 'patientId', patientId)
            const localVarPath = `/patient/{patient_id}/labs/{lab_id}`
                .replace(`{${"lab_id"}}`, encodeURIComponent(String(labId)))
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Patient Labs
         * @param {PatientId} patientId 
         * @param {string | null} [beforeDatetime] Only return labs created before this datetime
         * @param {string | null} [afterDatetime] Only return labs created after this datetime
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientLabsPatientPatientIdLabsGet: async (patientId: PatientId, beforeDatetime?: string | null, afterDatetime?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getPatientLabsPatientPatientIdLabsGet', 'patientId', patientId)
            const localVarPath = `/patient/{patient_id}/labs`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (beforeDatetime !== undefined) {
                localVarQueryParameter['before_datetime'] = (beforeDatetime as any instanceof Date) ?
                    (beforeDatetime as any).toISOString() :
                    beforeDatetime;
            }

            if (afterDatetime !== undefined) {
                localVarQueryParameter['after_datetime'] = (afterDatetime as any instanceof Date) ?
                    (afterDatetime as any).toISOString() :
                    afterDatetime;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Patients For Provider
         * @param {Array<PatientDetailsInclusions> | null} [include] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientsForProviderPatientsGet: async (include?: Array<PatientDetailsInclusions> | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/patients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (include) {
                localVarQueryParameter['include'] = include;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Release Form
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReleaseFormPatientsPatientIdReleaseFormPdfGet: async (patientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getReleaseFormPatientsPatientIdReleaseFormPdfGet', 'patientId', patientId)
            const localVarPath = `/patients/{patient_id}/release_form.pdf`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/pdf,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Release Form Preview Url
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReleaseFormPreviewUrlPatientsFilesReleaseFormPreviewUrlGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/patients/files/release_form_preview_url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Patient Confirmation By Code
         * @param {PatientConfirmationByCodePayload} patientConfirmationByCodePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientConfirmationByCodePatientConfirmCodePost: async (patientConfirmationByCodePayload: PatientConfirmationByCodePayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientConfirmationByCodePayload' is not null or undefined
            assertParamExists('patientConfirmationByCodePatientConfirmCodePost', 'patientConfirmationByCodePayload', patientConfirmationByCodePayload)
            const localVarPath = `/patient/confirm/code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientConfirmationByCodePayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Patient Confirmation
         * @param {PatientConfirmationPayload} patientConfirmationPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientConfirmationPatientConfirmPost: async (patientConfirmationPayload: PatientConfirmationPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientConfirmationPayload' is not null or undefined
            assertParamExists('patientConfirmationPatientConfirmPost', 'patientConfirmationPayload', patientConfirmationPayload)
            const localVarPath = `/patient/confirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientConfirmationPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Register Patient
         * @param {RegisterPatientPayload} registerPatientPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerPatientAdminPatientsPost: async (registerPatientPayload: RegisterPatientPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registerPatientPayload' is not null or undefined
            assertParamExists('registerPatientAdminPatientsPost', 'registerPatientPayload', registerPatientPayload)
            const localVarPath = `/admin/patients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerPatientPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set Patient Intake Form
         * @param {PatientId} patientId 
         * @param {UpdateIntakePayload} updateIntakePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPatientIntakeFormPatientsPatientIdIntakePost: async (patientId: PatientId, updateIntakePayload: UpdateIntakePayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('setPatientIntakeFormPatientsPatientIdIntakePost', 'patientId', patientId)
            // verify required parameter 'updateIntakePayload' is not null or undefined
            assertParamExists('setPatientIntakeFormPatientsPatientIdIntakePost', 'updateIntakePayload', updateIntakePayload)
            const localVarPath = `/patients/{patient_id}/intake`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateIntakePayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Submit Booking Email
         * @param {PatientBookingSubmitEmailPayload} patientBookingSubmitEmailPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitBookingEmailPatientsBookingSubmitEmailPost: async (patientBookingSubmitEmailPayload: PatientBookingSubmitEmailPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientBookingSubmitEmailPayload' is not null or undefined
            assertParamExists('submitBookingEmailPatientsBookingSubmitEmailPost', 'patientBookingSubmitEmailPayload', patientBookingSubmitEmailPayload)
            const localVarPath = `/patients/booking-submit-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientBookingSubmitEmailPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing booking code description or set activity level. Only accessible by admin users.
         * @summary Update Booking Code
         * @param {string} bookingCodeId 
         * @param {UpdateBookingCodePayload} updateBookingCodePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBookingCodeBookingCodesBookingCodeIdPatch: async (bookingCodeId: string, updateBookingCodePayload: UpdateBookingCodePayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingCodeId' is not null or undefined
            assertParamExists('updateBookingCodeBookingCodesBookingCodeIdPatch', 'bookingCodeId', bookingCodeId)
            // verify required parameter 'updateBookingCodePayload' is not null or undefined
            assertParamExists('updateBookingCodeBookingCodesBookingCodeIdPatch', 'updateBookingCodePayload', updateBookingCodePayload)
            const localVarPath = `/booking-codes/{booking_code_id}`
                .replace(`{${"booking_code_id"}}`, encodeURIComponent(String(bookingCodeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateBookingCodePayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Journal Entry
         * @param {string} journalEntryId 
         * @param {UpdateJournalEntryPayload} updateJournalEntryPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateJournalEntryPatientJournalEntriesJournalEntryIdPatch: async (journalEntryId: string, updateJournalEntryPayload: UpdateJournalEntryPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'journalEntryId' is not null or undefined
            assertParamExists('updateJournalEntryPatientJournalEntriesJournalEntryIdPatch', 'journalEntryId', journalEntryId)
            // verify required parameter 'updateJournalEntryPayload' is not null or undefined
            assertParamExists('updateJournalEntryPatientJournalEntriesJournalEntryIdPatch', 'updateJournalEntryPayload', updateJournalEntryPayload)
            const localVarPath = `/patient/journal/entries/{journal_entry_id}`
                .replace(`{${"journal_entry_id"}}`, encodeURIComponent(String(journalEntryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateJournalEntryPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Patient
         * @param {PatientId} patientId 
         * @param {UpdatePatientPayload} updatePatientPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientPatientsPatientIdPatch: async (patientId: PatientId, updatePatientPayload: UpdatePatientPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('updatePatientPatientsPatientIdPatch', 'patientId', patientId)
            // verify required parameter 'updatePatientPayload' is not null or undefined
            assertParamExists('updatePatientPatientsPatientIdPatch', 'updatePatientPayload', updatePatientPayload)
            const localVarPath = `/patients/{patient_id}`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePatientPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Release Of Information
         * @param {PatientId} patientId 
         * @param {ReleaseOfInformationPayload} releaseOfInformationPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReleaseOfInformationPatientsPatientIdReleaseOfInformationPost: async (patientId: PatientId, releaseOfInformationPayload: ReleaseOfInformationPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('updateReleaseOfInformationPatientsPatientIdReleaseOfInformationPost', 'patientId', patientId)
            // verify required parameter 'releaseOfInformationPayload' is not null or undefined
            assertParamExists('updateReleaseOfInformationPatientsPatientIdReleaseOfInformationPost', 'releaseOfInformationPayload', releaseOfInformationPayload)
            const localVarPath = `/patients/{patient_id}/release_of_information`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(releaseOfInformationPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload Patient Lab
         * @param {PatientId} patientId 
         * @param {UploadPatientLabPayload} uploadPatientLabPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPatientLabPatientPatientIdLabsPost: async (patientId: PatientId, uploadPatientLabPayload: UploadPatientLabPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('uploadPatientLabPatientPatientIdLabsPost', 'patientId', patientId)
            // verify required parameter 'uploadPatientLabPayload' is not null or undefined
            assertParamExists('uploadPatientLabPatientPatientIdLabsPost', 'uploadPatientLabPayload', uploadPatientLabPayload)
            const localVarPath = `/patient/{patient_id}/labs`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uploadPatientLabPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PatientApi - functional programming interface
 */
export const PatientApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PatientApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add Patient Lab Feedback
         * @param {string} labId 
         * @param {PatientId} patientId 
         * @param {AddPatientLabFeedbackPayload} addPatientLabFeedbackPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addPatientLabFeedbackPatientPatientIdLabsLabIdFeedbackPost(labId: string, patientId: PatientId, addPatientLabFeedbackPayload: AddPatientLabFeedbackPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientLabResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addPatientLabFeedbackPatientPatientIdLabsLabIdFeedbackPost(labId, patientId, addPatientLabFeedbackPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientApi.addPatientLabFeedbackPatientPatientIdLabsLabIdFeedbackPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Public endpoint to check if a phone number is available for registration.  This endpoint is restricted to requests from signup.faynutrition.com domains and is rate-limited to prevent enumeration attacks.  Returns:     PhoneAvailabilityResponse: Object with \'available\' boolean field
         * @summary Check Phone Availability
         * @param {string} phoneNumber Phone number to check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkPhoneAvailabilityPatientsPhoneAvailabilityGet(phoneNumber: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PhoneAvailabilityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkPhoneAvailabilityPatientsPhoneAvailabilityGet(phoneNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientApi.checkPhoneAvailabilityPatientsPhoneAvailabilityGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new booking code. Only accessible by admin users.
         * @summary Create Booking Code
         * @param {CreateBookingCodePayload} createBookingCodePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBookingCodeBookingCodesPost(createBookingCodePayload: CreateBookingCodePayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingCodeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBookingCodeBookingCodesPost(createBookingCodePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientApi.createBookingCodeBookingCodesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Journal Entry
         * @param {CreateJournalEntryPayload} createJournalEntryPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createJournalEntryPatientJournalEntriesPost(createJournalEntryPayload: CreateJournalEntryPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JournalEntryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createJournalEntryPatientJournalEntriesPost(createJournalEntryPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientApi.createJournalEntryPatientJournalEntriesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete an existing booking code. Only accessible by admin users.
         * @summary Delete Booking Code
         * @param {string} bookingCodeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteBookingCodeBookingCodesBookingCodeIdDelete(bookingCodeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBookingCodeBookingCodesBookingCodeIdDelete(bookingCodeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientApi.deleteBookingCodeBookingCodesBookingCodeIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Journal Entry
         * @param {string} journalEntryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteJournalEntryPatientJournalEntriesJournalEntryIdDelete(journalEntryId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteJournalEntryPatientJournalEntriesJournalEntryIdDelete(journalEntryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientApi.deleteJournalEntryPatientJournalEntriesJournalEntryIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Soft deletes a patient\'s account upon request of the patient.  Note: this does not delete the patient from our system - just marks them as deleted and triggers patient data cleanup.
         * @summary Delete Patient Account
         * @param {PatientId} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePatientAccountPatientsPatientIdDelete(patientId: PatientId, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePatientAccountPatientsPatientIdDelete(patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientApi.deletePatientAccountPatientsPatientIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary External Facing Details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalFacingDetailsPatientExternalFacingDetailsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientExternalFacingDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.externalFacingDetailsPatientExternalFacingDetailsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientApi.externalFacingDetailsPatientExternalFacingDetailsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a booking code by its ID.
         * @summary Get Booking Code
         * @param {string} bookingCodeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBookingCodeBookingCodesBookingCodeIdGet(bookingCodeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingCodeResponseWithConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBookingCodeBookingCodesBookingCodeIdGet(bookingCodeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientApi.getBookingCodeBookingCodesBookingCodeIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Unauthenticated, retrieve a booking code by its code.
         * @summary Get Booking Code By Code
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBookingCodeByCodeBookingCodesCodeCodeGet(code: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingCodeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBookingCodeByCodeBookingCodesCodeCodeGet(code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientApi.getBookingCodeByCodeBookingCodesCodeCodeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve the current booking code for a patient.
         * @summary Get Booking Code For Patient
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBookingCodeForPatientPatientsBookingCodeConfigGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingCodeResponseWithConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBookingCodeForPatientPatientsBookingCodeConfigGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientApi.getBookingCodeForPatientPatientsBookingCodeConfigGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve all booking codes. Only accessible by admin users.  Args:     booking_code_types: Optional list of booking code types to filter by.                        If not provided, defaults to all types except patient_referral.     booking_code_application: The application service to retrieve booking codes.
         * @summary Get Booking Codes
         * @param {Array<BookingCodeType> | null} [bookingCodeTypes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBookingCodesBookingCodesGet(bookingCodeTypes?: Array<BookingCodeType> | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingCodesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBookingCodesBookingCodesGet(bookingCodeTypes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientApi.getBookingCodesBookingCodesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Journal Entry
         * @param {string} journalEntryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJournalEntryPatientJournalEntriesJournalEntryIdGet(journalEntryId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JournalEntryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJournalEntryPatientJournalEntriesJournalEntryIdGet(journalEntryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientApi.getJournalEntryPatientJournalEntriesJournalEntryIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Journal Streak
         * @param {string | null} [timezone] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJournalStreakPatientJournalStreakGet(timezone?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JournalStreakResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJournalStreakPatientJournalStreakGet(timezone, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientApi.getJournalStreakPatientJournalStreakGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Patient Confirmation Status By Onboarding Code
         * @param {string} onboardingCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientConfirmationStatusByOnboardingCodePatientConfirmCodeOnboardingCodeGet(onboardingCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientConfirmationPreflightResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientConfirmationStatusByOnboardingCodePatientConfirmCodeOnboardingCodeGet(onboardingCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientApi.getPatientConfirmationStatusByOnboardingCodePatientConfirmCodeOnboardingCodeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Patient Confirmation Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientConfirmationStatusPatientConfirmGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientConfirmationPreflightResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientConfirmationStatusPatientConfirmGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientApi.getPatientConfirmationStatusPatientConfirmGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Patient Details By Email
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientDetailsByEmailAdminPatientsByEmailGet(email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientDetailsByEmailAdminPatientsByEmailGet(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientApi.getPatientDetailsByEmailAdminPatientsByEmailGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Patient Details
         * @param {PatientId} patientId 
         * @param {Array<PatientDetailsInclusions> | null} [include] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientDetailsPatientsPatientIdGet(patientId: PatientId, include?: Array<PatientDetailsInclusions> | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientDetailsPatientsPatientIdGet(patientId, include, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientApi.getPatientDetailsPatientsPatientIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Patient Intake Form Answers
         * @param {PatientId} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientIntakeFormAnswersPatientsPatientIdIntakeGet(patientId: PatientId, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IntakeFormResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientIntakeFormAnswersPatientsPatientIdIntakeGet(patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientApi.getPatientIntakeFormAnswersPatientsPatientIdIntakeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve paginated journal entries for the specified patient.  The entries are returned in descending order based on their creation date, with the most recent entries appearing first.  Args:     patient_id (PatientIdAllowingMe): The ID of the patient or \'me\' for the current user.     cursor (str | None): Pagination cursor for fetching the next set of results.     limit (int): Number of entries to return per page (default: 20, max: 100).     application: Application service used to fetch journal entries.     patient_application: Application service for retrieving patient details.     journal_entry_files_service: Service for accessing journal entry files.     user: The authenticated user making the request.  Returns:     CursorPaginatedJournalEntriesResponse: A paginated list of journal entries     and the next pagination cursor.
         * @summary Get Patient Journal Entries
         * @param {PatientId} patientId 
         * @param {string | null} [cursor] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientJournalEntriesPatientPatientIdJournalEntriesGet(patientId: PatientId, cursor?: string | null, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CursorPaginatedJournalEntriesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientJournalEntriesPatientPatientIdJournalEntriesGet(patientId, cursor, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientApi.getPatientJournalEntriesPatientPatientIdJournalEntriesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Patient Lab
         * @param {string} labId 
         * @param {PatientId} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientLabPatientPatientIdLabsLabIdGet(labId: string, patientId: PatientId, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientLabResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientLabPatientPatientIdLabsLabIdGet(labId, patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientApi.getPatientLabPatientPatientIdLabsLabIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Patient Labs
         * @param {PatientId} patientId 
         * @param {string | null} [beforeDatetime] Only return labs created before this datetime
         * @param {string | null} [afterDatetime] Only return labs created after this datetime
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientLabsPatientPatientIdLabsGet(patientId: PatientId, beforeDatetime?: string | null, afterDatetime?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientLabsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientLabsPatientPatientIdLabsGet(patientId, beforeDatetime, afterDatetime, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientApi.getPatientLabsPatientPatientIdLabsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Patients For Provider
         * @param {Array<PatientDetailsInclusions> | null} [include] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientsForProviderPatientsGet(include?: Array<PatientDetailsInclusions> | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientDetailsListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientsForProviderPatientsGet(include, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientApi.getPatientsForProviderPatientsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Release Form
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReleaseFormPatientsPatientIdReleaseFormPdfGet(patientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReleaseFormPatientsPatientIdReleaseFormPdfGet(patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientApi.getReleaseFormPatientsPatientIdReleaseFormPdfGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Release Form Preview Url
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReleaseFormPreviewUrlPatientsFilesReleaseFormPreviewUrlGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientReleaseFormPreviewUrlResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReleaseFormPreviewUrlPatientsFilesReleaseFormPreviewUrlGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientApi.getReleaseFormPreviewUrlPatientsFilesReleaseFormPreviewUrlGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Patient Confirmation By Code
         * @param {PatientConfirmationByCodePayload} patientConfirmationByCodePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patientConfirmationByCodePatientConfirmCodePost(patientConfirmationByCodePayload: PatientConfirmationByCodePayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patientConfirmationByCodePatientConfirmCodePost(patientConfirmationByCodePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientApi.patientConfirmationByCodePatientConfirmCodePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Patient Confirmation
         * @param {PatientConfirmationPayload} patientConfirmationPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patientConfirmationPatientConfirmPost(patientConfirmationPayload: PatientConfirmationPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patientConfirmationPatientConfirmPost(patientConfirmationPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientApi.patientConfirmationPatientConfirmPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Register Patient
         * @param {RegisterPatientPayload} registerPatientPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerPatientAdminPatientsPost(registerPatientPayload: RegisterPatientPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerPatientAdminPatientsPost(registerPatientPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientApi.registerPatientAdminPatientsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Set Patient Intake Form
         * @param {PatientId} patientId 
         * @param {UpdateIntakePayload} updateIntakePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setPatientIntakeFormPatientsPatientIdIntakePost(patientId: PatientId, updateIntakePayload: UpdateIntakePayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IntakeFormResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setPatientIntakeFormPatientsPatientIdIntakePost(patientId, updateIntakePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientApi.setPatientIntakeFormPatientsPatientIdIntakePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Submit Booking Email
         * @param {PatientBookingSubmitEmailPayload} patientBookingSubmitEmailPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitBookingEmailPatientsBookingSubmitEmailPost(patientBookingSubmitEmailPayload: PatientBookingSubmitEmailPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientBookingSubmitEmailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitBookingEmailPatientsBookingSubmitEmailPost(patientBookingSubmitEmailPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientApi.submitBookingEmailPatientsBookingSubmitEmailPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing booking code description or set activity level. Only accessible by admin users.
         * @summary Update Booking Code
         * @param {string} bookingCodeId 
         * @param {UpdateBookingCodePayload} updateBookingCodePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBookingCodeBookingCodesBookingCodeIdPatch(bookingCodeId: string, updateBookingCodePayload: UpdateBookingCodePayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingCodeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBookingCodeBookingCodesBookingCodeIdPatch(bookingCodeId, updateBookingCodePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientApi.updateBookingCodeBookingCodesBookingCodeIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Journal Entry
         * @param {string} journalEntryId 
         * @param {UpdateJournalEntryPayload} updateJournalEntryPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateJournalEntryPatientJournalEntriesJournalEntryIdPatch(journalEntryId: string, updateJournalEntryPayload: UpdateJournalEntryPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JournalEntryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateJournalEntryPatientJournalEntriesJournalEntryIdPatch(journalEntryId, updateJournalEntryPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientApi.updateJournalEntryPatientJournalEntriesJournalEntryIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Patient
         * @param {PatientId} patientId 
         * @param {UpdatePatientPayload} updatePatientPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientPatientsPatientIdPatch(patientId: PatientId, updatePatientPayload: UpdatePatientPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientPatientsPatientIdPatch(patientId, updatePatientPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientApi.updatePatientPatientsPatientIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Release Of Information
         * @param {PatientId} patientId 
         * @param {ReleaseOfInformationPayload} releaseOfInformationPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateReleaseOfInformationPatientsPatientIdReleaseOfInformationPost(patientId: PatientId, releaseOfInformationPayload: ReleaseOfInformationPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateReleaseOfInformationPatientsPatientIdReleaseOfInformationPost(patientId, releaseOfInformationPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientApi.updateReleaseOfInformationPatientsPatientIdReleaseOfInformationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload Patient Lab
         * @param {PatientId} patientId 
         * @param {UploadPatientLabPayload} uploadPatientLabPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadPatientLabPatientPatientIdLabsPost(patientId: PatientId, uploadPatientLabPayload: UploadPatientLabPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientLabResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadPatientLabPatientPatientIdLabsPost(patientId, uploadPatientLabPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientApi.uploadPatientLabPatientPatientIdLabsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PatientApi - factory interface
 */
export const PatientApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PatientApiFp(configuration)
    return {
        /**
         * 
         * @summary Add Patient Lab Feedback
         * @param {string} labId 
         * @param {PatientId} patientId 
         * @param {AddPatientLabFeedbackPayload} addPatientLabFeedbackPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPatientLabFeedbackPatientPatientIdLabsLabIdFeedbackPost(labId: string, patientId: PatientId, addPatientLabFeedbackPayload: AddPatientLabFeedbackPayload, options?: RawAxiosRequestConfig): AxiosPromise<PatientLabResponse> {
            return localVarFp.addPatientLabFeedbackPatientPatientIdLabsLabIdFeedbackPost(labId, patientId, addPatientLabFeedbackPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Public endpoint to check if a phone number is available for registration.  This endpoint is restricted to requests from signup.faynutrition.com domains and is rate-limited to prevent enumeration attacks.  Returns:     PhoneAvailabilityResponse: Object with \'available\' boolean field
         * @summary Check Phone Availability
         * @param {string} phoneNumber Phone number to check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkPhoneAvailabilityPatientsPhoneAvailabilityGet(phoneNumber: string, options?: RawAxiosRequestConfig): AxiosPromise<PhoneAvailabilityResponse> {
            return localVarFp.checkPhoneAvailabilityPatientsPhoneAvailabilityGet(phoneNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new booking code. Only accessible by admin users.
         * @summary Create Booking Code
         * @param {CreateBookingCodePayload} createBookingCodePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBookingCodeBookingCodesPost(createBookingCodePayload: CreateBookingCodePayload, options?: RawAxiosRequestConfig): AxiosPromise<BookingCodeResponse> {
            return localVarFp.createBookingCodeBookingCodesPost(createBookingCodePayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Journal Entry
         * @param {CreateJournalEntryPayload} createJournalEntryPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJournalEntryPatientJournalEntriesPost(createJournalEntryPayload: CreateJournalEntryPayload, options?: RawAxiosRequestConfig): AxiosPromise<JournalEntryResponse> {
            return localVarFp.createJournalEntryPatientJournalEntriesPost(createJournalEntryPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete an existing booking code. Only accessible by admin users.
         * @summary Delete Booking Code
         * @param {string} bookingCodeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBookingCodeBookingCodesBookingCodeIdDelete(bookingCodeId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteBookingCodeBookingCodesBookingCodeIdDelete(bookingCodeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Journal Entry
         * @param {string} journalEntryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteJournalEntryPatientJournalEntriesJournalEntryIdDelete(journalEntryId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteJournalEntryPatientJournalEntriesJournalEntryIdDelete(journalEntryId, options).then((request) => request(axios, basePath));
        },
        /**
         * Soft deletes a patient\'s account upon request of the patient.  Note: this does not delete the patient from our system - just marks them as deleted and triggers patient data cleanup.
         * @summary Delete Patient Account
         * @param {PatientId} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePatientAccountPatientsPatientIdDelete(patientId: PatientId, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePatientAccountPatientsPatientIdDelete(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary External Facing Details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalFacingDetailsPatientExternalFacingDetailsGet(options?: RawAxiosRequestConfig): AxiosPromise<PatientExternalFacingDetailsResponse> {
            return localVarFp.externalFacingDetailsPatientExternalFacingDetailsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a booking code by its ID.
         * @summary Get Booking Code
         * @param {string} bookingCodeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookingCodeBookingCodesBookingCodeIdGet(bookingCodeId: string, options?: RawAxiosRequestConfig): AxiosPromise<BookingCodeResponseWithConfig> {
            return localVarFp.getBookingCodeBookingCodesBookingCodeIdGet(bookingCodeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Unauthenticated, retrieve a booking code by its code.
         * @summary Get Booking Code By Code
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookingCodeByCodeBookingCodesCodeCodeGet(code: string, options?: RawAxiosRequestConfig): AxiosPromise<BookingCodeResponse> {
            return localVarFp.getBookingCodeByCodeBookingCodesCodeCodeGet(code, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the current booking code for a patient.
         * @summary Get Booking Code For Patient
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookingCodeForPatientPatientsBookingCodeConfigGet(options?: RawAxiosRequestConfig): AxiosPromise<BookingCodeResponseWithConfig> {
            return localVarFp.getBookingCodeForPatientPatientsBookingCodeConfigGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve all booking codes. Only accessible by admin users.  Args:     booking_code_types: Optional list of booking code types to filter by.                        If not provided, defaults to all types except patient_referral.     booking_code_application: The application service to retrieve booking codes.
         * @summary Get Booking Codes
         * @param {Array<BookingCodeType> | null} [bookingCodeTypes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookingCodesBookingCodesGet(bookingCodeTypes?: Array<BookingCodeType> | null, options?: RawAxiosRequestConfig): AxiosPromise<BookingCodesResponse> {
            return localVarFp.getBookingCodesBookingCodesGet(bookingCodeTypes, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Journal Entry
         * @param {string} journalEntryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJournalEntryPatientJournalEntriesJournalEntryIdGet(journalEntryId: string, options?: RawAxiosRequestConfig): AxiosPromise<JournalEntryResponse> {
            return localVarFp.getJournalEntryPatientJournalEntriesJournalEntryIdGet(journalEntryId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Journal Streak
         * @param {string | null} [timezone] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJournalStreakPatientJournalStreakGet(timezone?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<JournalStreakResponse> {
            return localVarFp.getJournalStreakPatientJournalStreakGet(timezone, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Patient Confirmation Status By Onboarding Code
         * @param {string} onboardingCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientConfirmationStatusByOnboardingCodePatientConfirmCodeOnboardingCodeGet(onboardingCode: string, options?: RawAxiosRequestConfig): AxiosPromise<PatientConfirmationPreflightResponse> {
            return localVarFp.getPatientConfirmationStatusByOnboardingCodePatientConfirmCodeOnboardingCodeGet(onboardingCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Patient Confirmation Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientConfirmationStatusPatientConfirmGet(options?: RawAxiosRequestConfig): AxiosPromise<PatientConfirmationPreflightResponse> {
            return localVarFp.getPatientConfirmationStatusPatientConfirmGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Patient Details By Email
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientDetailsByEmailAdminPatientsByEmailGet(email: string, options?: RawAxiosRequestConfig): AxiosPromise<PatientDetailsResponse> {
            return localVarFp.getPatientDetailsByEmailAdminPatientsByEmailGet(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Patient Details
         * @param {PatientId} patientId 
         * @param {Array<PatientDetailsInclusions> | null} [include] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientDetailsPatientsPatientIdGet(patientId: PatientId, include?: Array<PatientDetailsInclusions> | null, options?: RawAxiosRequestConfig): AxiosPromise<PatientDetailsResponse> {
            return localVarFp.getPatientDetailsPatientsPatientIdGet(patientId, include, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Patient Intake Form Answers
         * @param {PatientId} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientIntakeFormAnswersPatientsPatientIdIntakeGet(patientId: PatientId, options?: RawAxiosRequestConfig): AxiosPromise<IntakeFormResponse> {
            return localVarFp.getPatientIntakeFormAnswersPatientsPatientIdIntakeGet(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve paginated journal entries for the specified patient.  The entries are returned in descending order based on their creation date, with the most recent entries appearing first.  Args:     patient_id (PatientIdAllowingMe): The ID of the patient or \'me\' for the current user.     cursor (str | None): Pagination cursor for fetching the next set of results.     limit (int): Number of entries to return per page (default: 20, max: 100).     application: Application service used to fetch journal entries.     patient_application: Application service for retrieving patient details.     journal_entry_files_service: Service for accessing journal entry files.     user: The authenticated user making the request.  Returns:     CursorPaginatedJournalEntriesResponse: A paginated list of journal entries     and the next pagination cursor.
         * @summary Get Patient Journal Entries
         * @param {PatientId} patientId 
         * @param {string | null} [cursor] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientJournalEntriesPatientPatientIdJournalEntriesGet(patientId: PatientId, cursor?: string | null, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<CursorPaginatedJournalEntriesResponse> {
            return localVarFp.getPatientJournalEntriesPatientPatientIdJournalEntriesGet(patientId, cursor, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Patient Lab
         * @param {string} labId 
         * @param {PatientId} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientLabPatientPatientIdLabsLabIdGet(labId: string, patientId: PatientId, options?: RawAxiosRequestConfig): AxiosPromise<PatientLabResponse> {
            return localVarFp.getPatientLabPatientPatientIdLabsLabIdGet(labId, patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Patient Labs
         * @param {PatientId} patientId 
         * @param {string | null} [beforeDatetime] Only return labs created before this datetime
         * @param {string | null} [afterDatetime] Only return labs created after this datetime
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientLabsPatientPatientIdLabsGet(patientId: PatientId, beforeDatetime?: string | null, afterDatetime?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<PatientLabsResponse> {
            return localVarFp.getPatientLabsPatientPatientIdLabsGet(patientId, beforeDatetime, afterDatetime, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Patients For Provider
         * @param {Array<PatientDetailsInclusions> | null} [include] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientsForProviderPatientsGet(include?: Array<PatientDetailsInclusions> | null, options?: RawAxiosRequestConfig): AxiosPromise<PatientDetailsListResponse> {
            return localVarFp.getPatientsForProviderPatientsGet(include, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Release Form
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReleaseFormPatientsPatientIdReleaseFormPdfGet(patientId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getReleaseFormPatientsPatientIdReleaseFormPdfGet(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Release Form Preview Url
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReleaseFormPreviewUrlPatientsFilesReleaseFormPreviewUrlGet(options?: RawAxiosRequestConfig): AxiosPromise<PatientReleaseFormPreviewUrlResponse> {
            return localVarFp.getReleaseFormPreviewUrlPatientsFilesReleaseFormPreviewUrlGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Patient Confirmation By Code
         * @param {PatientConfirmationByCodePayload} patientConfirmationByCodePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientConfirmationByCodePatientConfirmCodePost(patientConfirmationByCodePayload: PatientConfirmationByCodePayload, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.patientConfirmationByCodePatientConfirmCodePost(patientConfirmationByCodePayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Patient Confirmation
         * @param {PatientConfirmationPayload} patientConfirmationPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientConfirmationPatientConfirmPost(patientConfirmationPayload: PatientConfirmationPayload, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.patientConfirmationPatientConfirmPost(patientConfirmationPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Register Patient
         * @param {RegisterPatientPayload} registerPatientPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerPatientAdminPatientsPost(registerPatientPayload: RegisterPatientPayload, options?: RawAxiosRequestConfig): AxiosPromise<PatientDetailsResponse> {
            return localVarFp.registerPatientAdminPatientsPost(registerPatientPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set Patient Intake Form
         * @param {PatientId} patientId 
         * @param {UpdateIntakePayload} updateIntakePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPatientIntakeFormPatientsPatientIdIntakePost(patientId: PatientId, updateIntakePayload: UpdateIntakePayload, options?: RawAxiosRequestConfig): AxiosPromise<IntakeFormResponse> {
            return localVarFp.setPatientIntakeFormPatientsPatientIdIntakePost(patientId, updateIntakePayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Submit Booking Email
         * @param {PatientBookingSubmitEmailPayload} patientBookingSubmitEmailPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitBookingEmailPatientsBookingSubmitEmailPost(patientBookingSubmitEmailPayload: PatientBookingSubmitEmailPayload, options?: RawAxiosRequestConfig): AxiosPromise<PatientBookingSubmitEmailResponse> {
            return localVarFp.submitBookingEmailPatientsBookingSubmitEmailPost(patientBookingSubmitEmailPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing booking code description or set activity level. Only accessible by admin users.
         * @summary Update Booking Code
         * @param {string} bookingCodeId 
         * @param {UpdateBookingCodePayload} updateBookingCodePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBookingCodeBookingCodesBookingCodeIdPatch(bookingCodeId: string, updateBookingCodePayload: UpdateBookingCodePayload, options?: RawAxiosRequestConfig): AxiosPromise<BookingCodeResponse> {
            return localVarFp.updateBookingCodeBookingCodesBookingCodeIdPatch(bookingCodeId, updateBookingCodePayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Journal Entry
         * @param {string} journalEntryId 
         * @param {UpdateJournalEntryPayload} updateJournalEntryPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateJournalEntryPatientJournalEntriesJournalEntryIdPatch(journalEntryId: string, updateJournalEntryPayload: UpdateJournalEntryPayload, options?: RawAxiosRequestConfig): AxiosPromise<JournalEntryResponse> {
            return localVarFp.updateJournalEntryPatientJournalEntriesJournalEntryIdPatch(journalEntryId, updateJournalEntryPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Patient
         * @param {PatientId} patientId 
         * @param {UpdatePatientPayload} updatePatientPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientPatientsPatientIdPatch(patientId: PatientId, updatePatientPayload: UpdatePatientPayload, options?: RawAxiosRequestConfig): AxiosPromise<PatientDetailsResponse> {
            return localVarFp.updatePatientPatientsPatientIdPatch(patientId, updatePatientPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Release Of Information
         * @param {PatientId} patientId 
         * @param {ReleaseOfInformationPayload} releaseOfInformationPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReleaseOfInformationPatientsPatientIdReleaseOfInformationPost(patientId: PatientId, releaseOfInformationPayload: ReleaseOfInformationPayload, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.updateReleaseOfInformationPatientsPatientIdReleaseOfInformationPost(patientId, releaseOfInformationPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload Patient Lab
         * @param {PatientId} patientId 
         * @param {UploadPatientLabPayload} uploadPatientLabPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPatientLabPatientPatientIdLabsPost(patientId: PatientId, uploadPatientLabPayload: UploadPatientLabPayload, options?: RawAxiosRequestConfig): AxiosPromise<PatientLabResponse> {
            return localVarFp.uploadPatientLabPatientPatientIdLabsPost(patientId, uploadPatientLabPayload, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PatientApi - object-oriented interface
 */
export class PatientApi extends BaseAPI {
    /**
     * 
     * @summary Add Patient Lab Feedback
     * @param {string} labId 
     * @param {PatientId} patientId 
     * @param {AddPatientLabFeedbackPayload} addPatientLabFeedbackPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addPatientLabFeedbackPatientPatientIdLabsLabIdFeedbackPost(labId: string, patientId: PatientId, addPatientLabFeedbackPayload: AddPatientLabFeedbackPayload, options?: RawAxiosRequestConfig) {
        return PatientApiFp(this.configuration).addPatientLabFeedbackPatientPatientIdLabsLabIdFeedbackPost(labId, patientId, addPatientLabFeedbackPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Public endpoint to check if a phone number is available for registration.  This endpoint is restricted to requests from signup.faynutrition.com domains and is rate-limited to prevent enumeration attacks.  Returns:     PhoneAvailabilityResponse: Object with \'available\' boolean field
     * @summary Check Phone Availability
     * @param {string} phoneNumber Phone number to check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public checkPhoneAvailabilityPatientsPhoneAvailabilityGet(phoneNumber: string, options?: RawAxiosRequestConfig) {
        return PatientApiFp(this.configuration).checkPhoneAvailabilityPatientsPhoneAvailabilityGet(phoneNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new booking code. Only accessible by admin users.
     * @summary Create Booking Code
     * @param {CreateBookingCodePayload} createBookingCodePayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createBookingCodeBookingCodesPost(createBookingCodePayload: CreateBookingCodePayload, options?: RawAxiosRequestConfig) {
        return PatientApiFp(this.configuration).createBookingCodeBookingCodesPost(createBookingCodePayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Journal Entry
     * @param {CreateJournalEntryPayload} createJournalEntryPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createJournalEntryPatientJournalEntriesPost(createJournalEntryPayload: CreateJournalEntryPayload, options?: RawAxiosRequestConfig) {
        return PatientApiFp(this.configuration).createJournalEntryPatientJournalEntriesPost(createJournalEntryPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete an existing booking code. Only accessible by admin users.
     * @summary Delete Booking Code
     * @param {string} bookingCodeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteBookingCodeBookingCodesBookingCodeIdDelete(bookingCodeId: string, options?: RawAxiosRequestConfig) {
        return PatientApiFp(this.configuration).deleteBookingCodeBookingCodesBookingCodeIdDelete(bookingCodeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Journal Entry
     * @param {string} journalEntryId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteJournalEntryPatientJournalEntriesJournalEntryIdDelete(journalEntryId: string, options?: RawAxiosRequestConfig) {
        return PatientApiFp(this.configuration).deleteJournalEntryPatientJournalEntriesJournalEntryIdDelete(journalEntryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Soft deletes a patient\'s account upon request of the patient.  Note: this does not delete the patient from our system - just marks them as deleted and triggers patient data cleanup.
     * @summary Delete Patient Account
     * @param {PatientId} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deletePatientAccountPatientsPatientIdDelete(patientId: PatientId, options?: RawAxiosRequestConfig) {
        return PatientApiFp(this.configuration).deletePatientAccountPatientsPatientIdDelete(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary External Facing Details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public externalFacingDetailsPatientExternalFacingDetailsGet(options?: RawAxiosRequestConfig) {
        return PatientApiFp(this.configuration).externalFacingDetailsPatientExternalFacingDetailsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a booking code by its ID.
     * @summary Get Booking Code
     * @param {string} bookingCodeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getBookingCodeBookingCodesBookingCodeIdGet(bookingCodeId: string, options?: RawAxiosRequestConfig) {
        return PatientApiFp(this.configuration).getBookingCodeBookingCodesBookingCodeIdGet(bookingCodeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unauthenticated, retrieve a booking code by its code.
     * @summary Get Booking Code By Code
     * @param {string} code 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getBookingCodeByCodeBookingCodesCodeCodeGet(code: string, options?: RawAxiosRequestConfig) {
        return PatientApiFp(this.configuration).getBookingCodeByCodeBookingCodesCodeCodeGet(code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the current booking code for a patient.
     * @summary Get Booking Code For Patient
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getBookingCodeForPatientPatientsBookingCodeConfigGet(options?: RawAxiosRequestConfig) {
        return PatientApiFp(this.configuration).getBookingCodeForPatientPatientsBookingCodeConfigGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve all booking codes. Only accessible by admin users.  Args:     booking_code_types: Optional list of booking code types to filter by.                        If not provided, defaults to all types except patient_referral.     booking_code_application: The application service to retrieve booking codes.
     * @summary Get Booking Codes
     * @param {Array<BookingCodeType> | null} [bookingCodeTypes] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getBookingCodesBookingCodesGet(bookingCodeTypes?: Array<BookingCodeType> | null, options?: RawAxiosRequestConfig) {
        return PatientApiFp(this.configuration).getBookingCodesBookingCodesGet(bookingCodeTypes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Journal Entry
     * @param {string} journalEntryId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getJournalEntryPatientJournalEntriesJournalEntryIdGet(journalEntryId: string, options?: RawAxiosRequestConfig) {
        return PatientApiFp(this.configuration).getJournalEntryPatientJournalEntriesJournalEntryIdGet(journalEntryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Journal Streak
     * @param {string | null} [timezone] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getJournalStreakPatientJournalStreakGet(timezone?: string | null, options?: RawAxiosRequestConfig) {
        return PatientApiFp(this.configuration).getJournalStreakPatientJournalStreakGet(timezone, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Patient Confirmation Status By Onboarding Code
     * @param {string} onboardingCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPatientConfirmationStatusByOnboardingCodePatientConfirmCodeOnboardingCodeGet(onboardingCode: string, options?: RawAxiosRequestConfig) {
        return PatientApiFp(this.configuration).getPatientConfirmationStatusByOnboardingCodePatientConfirmCodeOnboardingCodeGet(onboardingCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Patient Confirmation Status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPatientConfirmationStatusPatientConfirmGet(options?: RawAxiosRequestConfig) {
        return PatientApiFp(this.configuration).getPatientConfirmationStatusPatientConfirmGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Patient Details By Email
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPatientDetailsByEmailAdminPatientsByEmailGet(email: string, options?: RawAxiosRequestConfig) {
        return PatientApiFp(this.configuration).getPatientDetailsByEmailAdminPatientsByEmailGet(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Patient Details
     * @param {PatientId} patientId 
     * @param {Array<PatientDetailsInclusions> | null} [include] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPatientDetailsPatientsPatientIdGet(patientId: PatientId, include?: Array<PatientDetailsInclusions> | null, options?: RawAxiosRequestConfig) {
        return PatientApiFp(this.configuration).getPatientDetailsPatientsPatientIdGet(patientId, include, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Patient Intake Form Answers
     * @param {PatientId} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPatientIntakeFormAnswersPatientsPatientIdIntakeGet(patientId: PatientId, options?: RawAxiosRequestConfig) {
        return PatientApiFp(this.configuration).getPatientIntakeFormAnswersPatientsPatientIdIntakeGet(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve paginated journal entries for the specified patient.  The entries are returned in descending order based on their creation date, with the most recent entries appearing first.  Args:     patient_id (PatientIdAllowingMe): The ID of the patient or \'me\' for the current user.     cursor (str | None): Pagination cursor for fetching the next set of results.     limit (int): Number of entries to return per page (default: 20, max: 100).     application: Application service used to fetch journal entries.     patient_application: Application service for retrieving patient details.     journal_entry_files_service: Service for accessing journal entry files.     user: The authenticated user making the request.  Returns:     CursorPaginatedJournalEntriesResponse: A paginated list of journal entries     and the next pagination cursor.
     * @summary Get Patient Journal Entries
     * @param {PatientId} patientId 
     * @param {string | null} [cursor] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPatientJournalEntriesPatientPatientIdJournalEntriesGet(patientId: PatientId, cursor?: string | null, limit?: number, options?: RawAxiosRequestConfig) {
        return PatientApiFp(this.configuration).getPatientJournalEntriesPatientPatientIdJournalEntriesGet(patientId, cursor, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Patient Lab
     * @param {string} labId 
     * @param {PatientId} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPatientLabPatientPatientIdLabsLabIdGet(labId: string, patientId: PatientId, options?: RawAxiosRequestConfig) {
        return PatientApiFp(this.configuration).getPatientLabPatientPatientIdLabsLabIdGet(labId, patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Patient Labs
     * @param {PatientId} patientId 
     * @param {string | null} [beforeDatetime] Only return labs created before this datetime
     * @param {string | null} [afterDatetime] Only return labs created after this datetime
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPatientLabsPatientPatientIdLabsGet(patientId: PatientId, beforeDatetime?: string | null, afterDatetime?: string | null, options?: RawAxiosRequestConfig) {
        return PatientApiFp(this.configuration).getPatientLabsPatientPatientIdLabsGet(patientId, beforeDatetime, afterDatetime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Patients For Provider
     * @param {Array<PatientDetailsInclusions> | null} [include] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPatientsForProviderPatientsGet(include?: Array<PatientDetailsInclusions> | null, options?: RawAxiosRequestConfig) {
        return PatientApiFp(this.configuration).getPatientsForProviderPatientsGet(include, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Release Form
     * @param {string} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getReleaseFormPatientsPatientIdReleaseFormPdfGet(patientId: string, options?: RawAxiosRequestConfig) {
        return PatientApiFp(this.configuration).getReleaseFormPatientsPatientIdReleaseFormPdfGet(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Release Form Preview Url
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getReleaseFormPreviewUrlPatientsFilesReleaseFormPreviewUrlGet(options?: RawAxiosRequestConfig) {
        return PatientApiFp(this.configuration).getReleaseFormPreviewUrlPatientsFilesReleaseFormPreviewUrlGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Patient Confirmation By Code
     * @param {PatientConfirmationByCodePayload} patientConfirmationByCodePayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public patientConfirmationByCodePatientConfirmCodePost(patientConfirmationByCodePayload: PatientConfirmationByCodePayload, options?: RawAxiosRequestConfig) {
        return PatientApiFp(this.configuration).patientConfirmationByCodePatientConfirmCodePost(patientConfirmationByCodePayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Patient Confirmation
     * @param {PatientConfirmationPayload} patientConfirmationPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public patientConfirmationPatientConfirmPost(patientConfirmationPayload: PatientConfirmationPayload, options?: RawAxiosRequestConfig) {
        return PatientApiFp(this.configuration).patientConfirmationPatientConfirmPost(patientConfirmationPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Register Patient
     * @param {RegisterPatientPayload} registerPatientPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public registerPatientAdminPatientsPost(registerPatientPayload: RegisterPatientPayload, options?: RawAxiosRequestConfig) {
        return PatientApiFp(this.configuration).registerPatientAdminPatientsPost(registerPatientPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set Patient Intake Form
     * @param {PatientId} patientId 
     * @param {UpdateIntakePayload} updateIntakePayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public setPatientIntakeFormPatientsPatientIdIntakePost(patientId: PatientId, updateIntakePayload: UpdateIntakePayload, options?: RawAxiosRequestConfig) {
        return PatientApiFp(this.configuration).setPatientIntakeFormPatientsPatientIdIntakePost(patientId, updateIntakePayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Submit Booking Email
     * @param {PatientBookingSubmitEmailPayload} patientBookingSubmitEmailPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public submitBookingEmailPatientsBookingSubmitEmailPost(patientBookingSubmitEmailPayload: PatientBookingSubmitEmailPayload, options?: RawAxiosRequestConfig) {
        return PatientApiFp(this.configuration).submitBookingEmailPatientsBookingSubmitEmailPost(patientBookingSubmitEmailPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing booking code description or set activity level. Only accessible by admin users.
     * @summary Update Booking Code
     * @param {string} bookingCodeId 
     * @param {UpdateBookingCodePayload} updateBookingCodePayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateBookingCodeBookingCodesBookingCodeIdPatch(bookingCodeId: string, updateBookingCodePayload: UpdateBookingCodePayload, options?: RawAxiosRequestConfig) {
        return PatientApiFp(this.configuration).updateBookingCodeBookingCodesBookingCodeIdPatch(bookingCodeId, updateBookingCodePayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Journal Entry
     * @param {string} journalEntryId 
     * @param {UpdateJournalEntryPayload} updateJournalEntryPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateJournalEntryPatientJournalEntriesJournalEntryIdPatch(journalEntryId: string, updateJournalEntryPayload: UpdateJournalEntryPayload, options?: RawAxiosRequestConfig) {
        return PatientApiFp(this.configuration).updateJournalEntryPatientJournalEntriesJournalEntryIdPatch(journalEntryId, updateJournalEntryPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Patient
     * @param {PatientId} patientId 
     * @param {UpdatePatientPayload} updatePatientPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updatePatientPatientsPatientIdPatch(patientId: PatientId, updatePatientPayload: UpdatePatientPayload, options?: RawAxiosRequestConfig) {
        return PatientApiFp(this.configuration).updatePatientPatientsPatientIdPatch(patientId, updatePatientPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Release Of Information
     * @param {PatientId} patientId 
     * @param {ReleaseOfInformationPayload} releaseOfInformationPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateReleaseOfInformationPatientsPatientIdReleaseOfInformationPost(patientId: PatientId, releaseOfInformationPayload: ReleaseOfInformationPayload, options?: RawAxiosRequestConfig) {
        return PatientApiFp(this.configuration).updateReleaseOfInformationPatientsPatientIdReleaseOfInformationPost(patientId, releaseOfInformationPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload Patient Lab
     * @param {PatientId} patientId 
     * @param {UploadPatientLabPayload} uploadPatientLabPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadPatientLabPatientPatientIdLabsPost(patientId: PatientId, uploadPatientLabPayload: UploadPatientLabPayload, options?: RawAxiosRequestConfig) {
        return PatientApiFp(this.configuration).uploadPatientLabPatientPatientIdLabsPost(patientId, uploadPatientLabPayload, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PatientBillingApi - axios parameter creator
 */
export const PatientBillingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Contest Async Claim
         * @param {string} billableRemoteEncounterId 
         * @param {PatientId} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contestAsyncClaimBillingPatientIdClaimBillableRemoteEncounterIdContestPost: async (billableRemoteEncounterId: string, patientId: PatientId, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'billableRemoteEncounterId' is not null or undefined
            assertParamExists('contestAsyncClaimBillingPatientIdClaimBillableRemoteEncounterIdContestPost', 'billableRemoteEncounterId', billableRemoteEncounterId)
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('contestAsyncClaimBillingPatientIdClaimBillableRemoteEncounterIdContestPost', 'patientId', patientId)
            const localVarPath = `/billing/{patient_id}/claim/{billable_remote_encounter_id}/contest`
                .replace(`{${"billable_remote_encounter_id"}}`, encodeURIComponent(String(billableRemoteEncounterId)))
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Patient Payment Instrument
         * @param {PatientId} patientId 
         * @param {CreatePaymentInstrumentPayload} createPaymentInstrumentPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientPaymentInstrumentPatientsPatientIdPaymentPost: async (patientId: PatientId, createPaymentInstrumentPayload: CreatePaymentInstrumentPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('createPatientPaymentInstrumentPatientsPatientIdPaymentPost', 'patientId', patientId)
            // verify required parameter 'createPaymentInstrumentPayload' is not null or undefined
            assertParamExists('createPatientPaymentInstrumentPatientsPatientIdPaymentPost', 'createPaymentInstrumentPayload', createPaymentInstrumentPayload)
            const localVarPath = `/patients/{patient_id}/payment`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPaymentInstrumentPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Patient Billing Items
         * @param {PatientId} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientBillingItemsBillingPatientIdBillingItemsGet: async (patientId: PatientId, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getPatientBillingItemsBillingPatientIdBillingItemsGet', 'patientId', patientId)
            const localVarPath = `/billing/{patient_id}/billing-items`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Patient Payment Instrument
         * @param {PatientId} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientPaymentInstrumentPatientsPatientIdPaymentGet: async (patientId: PatientId, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getPatientPaymentInstrumentPatientsPatientIdPaymentGet', 'patientId', patientId)
            const localVarPath = `/patients/{patient_id}/payment`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Partner Booking Verify Payment Method
         * @param {PartnerBookingVerifyPaymentMethodPayload} partnerBookingVerifyPaymentMethodPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerBookingVerifyPaymentMethodPartnersVerifyPaymentMethodPost: async (partnerBookingVerifyPaymentMethodPayload: PartnerBookingVerifyPaymentMethodPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerBookingVerifyPaymentMethodPayload' is not null or undefined
            assertParamExists('partnerBookingVerifyPaymentMethodPartnersVerifyPaymentMethodPost', 'partnerBookingVerifyPaymentMethodPayload', partnerBookingVerifyPaymentMethodPayload)
            const localVarPath = `/partners/verify-payment-method`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(partnerBookingVerifyPaymentMethodPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Refund Patient Charge
         * @param {string} chargeId 
         * @param {PatientId} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refundPatientChargeBillingPatientIdChargeChargeIdRefundPost: async (chargeId: string, patientId: PatientId, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chargeId' is not null or undefined
            assertParamExists('refundPatientChargeBillingPatientIdChargeChargeIdRefundPost', 'chargeId', chargeId)
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('refundPatientChargeBillingPatientIdChargeChargeIdRefundPost', 'patientId', patientId)
            const localVarPath = `/billing/{patient_id}/charge/{charge_id}/refund`
                .replace(`{${"charge_id"}}`, encodeURIComponent(String(chargeId)))
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a Stripe SetupIntent that allows the frontend to securely collect and save payment method details without immediately charging the customer. Supports both authenticated patients and new users.
         * @summary Create a Stripe SetupIntent for saving payment methods
         * @param {SetupPaymentMethodPayload} setupPaymentMethodPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setupPaymentMethodSetupPaymentMethodPost: async (setupPaymentMethodPayload: SetupPaymentMethodPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'setupPaymentMethodPayload' is not null or undefined
            assertParamExists('setupPaymentMethodSetupPaymentMethodPost', 'setupPaymentMethodPayload', setupPaymentMethodPayload)
            const localVarPath = `/setup-payment-method`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setupPaymentMethodPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verify Payment Method
         * @param {VerifyPaymentMethodPayload} verifyPaymentMethodPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyPaymentMethodBookingVerifyPaymentMethodPost: async (verifyPaymentMethodPayload: VerifyPaymentMethodPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verifyPaymentMethodPayload' is not null or undefined
            assertParamExists('verifyPaymentMethodBookingVerifyPaymentMethodPost', 'verifyPaymentMethodPayload', verifyPaymentMethodPayload)
            const localVarPath = `/booking/verify-payment-method`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyPaymentMethodPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PatientBillingApi - functional programming interface
 */
export const PatientBillingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PatientBillingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Contest Async Claim
         * @param {string} billableRemoteEncounterId 
         * @param {PatientId} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async contestAsyncClaimBillingPatientIdClaimBillableRemoteEncounterIdContestPost(billableRemoteEncounterId: string, patientId: PatientId, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.contestAsyncClaimBillingPatientIdClaimBillableRemoteEncounterIdContestPost(billableRemoteEncounterId, patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientBillingApi.contestAsyncClaimBillingPatientIdClaimBillableRemoteEncounterIdContestPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Patient Payment Instrument
         * @param {PatientId} patientId 
         * @param {CreatePaymentInstrumentPayload} createPaymentInstrumentPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPatientPaymentInstrumentPatientsPatientIdPaymentPost(patientId: PatientId, createPaymentInstrumentPayload: CreatePaymentInstrumentPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentInstrumentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPatientPaymentInstrumentPatientsPatientIdPaymentPost(patientId, createPaymentInstrumentPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientBillingApi.createPatientPaymentInstrumentPatientsPatientIdPaymentPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Patient Billing Items
         * @param {PatientId} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientBillingItemsBillingPatientIdBillingItemsGet(patientId: PatientId, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetPatientBillingItemsBillingPatientIdBillingItemsGet200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientBillingItemsBillingPatientIdBillingItemsGet(patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientBillingApi.getPatientBillingItemsBillingPatientIdBillingItemsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Patient Payment Instrument
         * @param {PatientId} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientPaymentInstrumentPatientsPatientIdPaymentGet(patientId: PatientId, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentInstrumentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientPaymentInstrumentPatientsPatientIdPaymentGet(patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientBillingApi.getPatientPaymentInstrumentPatientsPatientIdPaymentGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Partner Booking Verify Payment Method
         * @param {PartnerBookingVerifyPaymentMethodPayload} partnerBookingVerifyPaymentMethodPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnerBookingVerifyPaymentMethodPartnersVerifyPaymentMethodPost(partnerBookingVerifyPaymentMethodPayload: PartnerBookingVerifyPaymentMethodPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerifyPaymentMethodResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partnerBookingVerifyPaymentMethodPartnersVerifyPaymentMethodPost(partnerBookingVerifyPaymentMethodPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientBillingApi.partnerBookingVerifyPaymentMethodPartnersVerifyPaymentMethodPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Refund Patient Charge
         * @param {string} chargeId 
         * @param {PatientId} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refundPatientChargeBillingPatientIdChargeChargeIdRefundPost(chargeId: string, patientId: PatientId, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refundPatientChargeBillingPatientIdChargeChargeIdRefundPost(chargeId, patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientBillingApi.refundPatientChargeBillingPatientIdChargeChargeIdRefundPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a Stripe SetupIntent that allows the frontend to securely collect and save payment method details without immediately charging the customer. Supports both authenticated patients and new users.
         * @summary Create a Stripe SetupIntent for saving payment methods
         * @param {SetupPaymentMethodPayload} setupPaymentMethodPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setupPaymentMethodSetupPaymentMethodPost(setupPaymentMethodPayload: SetupPaymentMethodPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SetupPaymentMethodResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setupPaymentMethodSetupPaymentMethodPost(setupPaymentMethodPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientBillingApi.setupPaymentMethodSetupPaymentMethodPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Verify Payment Method
         * @param {VerifyPaymentMethodPayload} verifyPaymentMethodPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyPaymentMethodBookingVerifyPaymentMethodPost(verifyPaymentMethodPayload: VerifyPaymentMethodPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerifyPaymentMethodResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyPaymentMethodBookingVerifyPaymentMethodPost(verifyPaymentMethodPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientBillingApi.verifyPaymentMethodBookingVerifyPaymentMethodPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PatientBillingApi - factory interface
 */
export const PatientBillingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PatientBillingApiFp(configuration)
    return {
        /**
         * 
         * @summary Contest Async Claim
         * @param {string} billableRemoteEncounterId 
         * @param {PatientId} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contestAsyncClaimBillingPatientIdClaimBillableRemoteEncounterIdContestPost(billableRemoteEncounterId: string, patientId: PatientId, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.contestAsyncClaimBillingPatientIdClaimBillableRemoteEncounterIdContestPost(billableRemoteEncounterId, patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Patient Payment Instrument
         * @param {PatientId} patientId 
         * @param {CreatePaymentInstrumentPayload} createPaymentInstrumentPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientPaymentInstrumentPatientsPatientIdPaymentPost(patientId: PatientId, createPaymentInstrumentPayload: CreatePaymentInstrumentPayload, options?: RawAxiosRequestConfig): AxiosPromise<PaymentInstrumentResponse> {
            return localVarFp.createPatientPaymentInstrumentPatientsPatientIdPaymentPost(patientId, createPaymentInstrumentPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Patient Billing Items
         * @param {PatientId} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientBillingItemsBillingPatientIdBillingItemsGet(patientId: PatientId, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetPatientBillingItemsBillingPatientIdBillingItemsGet200ResponseInner>> {
            return localVarFp.getPatientBillingItemsBillingPatientIdBillingItemsGet(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Patient Payment Instrument
         * @param {PatientId} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientPaymentInstrumentPatientsPatientIdPaymentGet(patientId: PatientId, options?: RawAxiosRequestConfig): AxiosPromise<PaymentInstrumentResponse> {
            return localVarFp.getPatientPaymentInstrumentPatientsPatientIdPaymentGet(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Partner Booking Verify Payment Method
         * @param {PartnerBookingVerifyPaymentMethodPayload} partnerBookingVerifyPaymentMethodPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerBookingVerifyPaymentMethodPartnersVerifyPaymentMethodPost(partnerBookingVerifyPaymentMethodPayload: PartnerBookingVerifyPaymentMethodPayload, options?: RawAxiosRequestConfig): AxiosPromise<VerifyPaymentMethodResponse> {
            return localVarFp.partnerBookingVerifyPaymentMethodPartnersVerifyPaymentMethodPost(partnerBookingVerifyPaymentMethodPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Refund Patient Charge
         * @param {string} chargeId 
         * @param {PatientId} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refundPatientChargeBillingPatientIdChargeChargeIdRefundPost(chargeId: string, patientId: PatientId, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.refundPatientChargeBillingPatientIdChargeChargeIdRefundPost(chargeId, patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a Stripe SetupIntent that allows the frontend to securely collect and save payment method details without immediately charging the customer. Supports both authenticated patients and new users.
         * @summary Create a Stripe SetupIntent for saving payment methods
         * @param {SetupPaymentMethodPayload} setupPaymentMethodPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setupPaymentMethodSetupPaymentMethodPost(setupPaymentMethodPayload: SetupPaymentMethodPayload, options?: RawAxiosRequestConfig): AxiosPromise<SetupPaymentMethodResponse> {
            return localVarFp.setupPaymentMethodSetupPaymentMethodPost(setupPaymentMethodPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verify Payment Method
         * @param {VerifyPaymentMethodPayload} verifyPaymentMethodPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyPaymentMethodBookingVerifyPaymentMethodPost(verifyPaymentMethodPayload: VerifyPaymentMethodPayload, options?: RawAxiosRequestConfig): AxiosPromise<VerifyPaymentMethodResponse> {
            return localVarFp.verifyPaymentMethodBookingVerifyPaymentMethodPost(verifyPaymentMethodPayload, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PatientBillingApi - object-oriented interface
 */
export class PatientBillingApi extends BaseAPI {
    /**
     * 
     * @summary Contest Async Claim
     * @param {string} billableRemoteEncounterId 
     * @param {PatientId} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public contestAsyncClaimBillingPatientIdClaimBillableRemoteEncounterIdContestPost(billableRemoteEncounterId: string, patientId: PatientId, options?: RawAxiosRequestConfig) {
        return PatientBillingApiFp(this.configuration).contestAsyncClaimBillingPatientIdClaimBillableRemoteEncounterIdContestPost(billableRemoteEncounterId, patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Patient Payment Instrument
     * @param {PatientId} patientId 
     * @param {CreatePaymentInstrumentPayload} createPaymentInstrumentPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createPatientPaymentInstrumentPatientsPatientIdPaymentPost(patientId: PatientId, createPaymentInstrumentPayload: CreatePaymentInstrumentPayload, options?: RawAxiosRequestConfig) {
        return PatientBillingApiFp(this.configuration).createPatientPaymentInstrumentPatientsPatientIdPaymentPost(patientId, createPaymentInstrumentPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Patient Billing Items
     * @param {PatientId} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPatientBillingItemsBillingPatientIdBillingItemsGet(patientId: PatientId, options?: RawAxiosRequestConfig) {
        return PatientBillingApiFp(this.configuration).getPatientBillingItemsBillingPatientIdBillingItemsGet(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Patient Payment Instrument
     * @param {PatientId} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPatientPaymentInstrumentPatientsPatientIdPaymentGet(patientId: PatientId, options?: RawAxiosRequestConfig) {
        return PatientBillingApiFp(this.configuration).getPatientPaymentInstrumentPatientsPatientIdPaymentGet(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Partner Booking Verify Payment Method
     * @param {PartnerBookingVerifyPaymentMethodPayload} partnerBookingVerifyPaymentMethodPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public partnerBookingVerifyPaymentMethodPartnersVerifyPaymentMethodPost(partnerBookingVerifyPaymentMethodPayload: PartnerBookingVerifyPaymentMethodPayload, options?: RawAxiosRequestConfig) {
        return PatientBillingApiFp(this.configuration).partnerBookingVerifyPaymentMethodPartnersVerifyPaymentMethodPost(partnerBookingVerifyPaymentMethodPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Refund Patient Charge
     * @param {string} chargeId 
     * @param {PatientId} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public refundPatientChargeBillingPatientIdChargeChargeIdRefundPost(chargeId: string, patientId: PatientId, options?: RawAxiosRequestConfig) {
        return PatientBillingApiFp(this.configuration).refundPatientChargeBillingPatientIdChargeChargeIdRefundPost(chargeId, patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a Stripe SetupIntent that allows the frontend to securely collect and save payment method details without immediately charging the customer. Supports both authenticated patients and new users.
     * @summary Create a Stripe SetupIntent for saving payment methods
     * @param {SetupPaymentMethodPayload} setupPaymentMethodPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public setupPaymentMethodSetupPaymentMethodPost(setupPaymentMethodPayload: SetupPaymentMethodPayload, options?: RawAxiosRequestConfig) {
        return PatientBillingApiFp(this.configuration).setupPaymentMethodSetupPaymentMethodPost(setupPaymentMethodPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verify Payment Method
     * @param {VerifyPaymentMethodPayload} verifyPaymentMethodPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public verifyPaymentMethodBookingVerifyPaymentMethodPost(verifyPaymentMethodPayload: VerifyPaymentMethodPayload, options?: RawAxiosRequestConfig) {
        return PatientBillingApiFp(this.configuration).verifyPaymentMethodBookingVerifyPaymentMethodPost(verifyPaymentMethodPayload, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PatientRecapApi - axios parameter creator
 */
export const PatientRecapApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Patient Recap
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientRecapPatientRecapPatientIdGet: async (patientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getPatientRecapPatientRecapPatientIdGet', 'patientId', patientId)
            const localVarPath = `/patient-recap/{patient_id}`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PatientRecapApi - functional programming interface
 */
export const PatientRecapApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PatientRecapApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Patient Recap
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientRecapPatientRecapPatientIdGet(patientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientRecapResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientRecapPatientRecapPatientIdGet(patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatientRecapApi.getPatientRecapPatientRecapPatientIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PatientRecapApi - factory interface
 */
export const PatientRecapApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PatientRecapApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Patient Recap
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientRecapPatientRecapPatientIdGet(patientId: string, options?: RawAxiosRequestConfig): AxiosPromise<PatientRecapResponse> {
            return localVarFp.getPatientRecapPatientRecapPatientIdGet(patientId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PatientRecapApi - object-oriented interface
 */
export class PatientRecapApi extends BaseAPI {
    /**
     * 
     * @summary Get Patient Recap
     * @param {string} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPatientRecapPatientRecapPatientIdGet(patientId: string, options?: RawAxiosRequestConfig) {
        return PatientRecapApiFp(this.configuration).getPatientRecapPatientRecapPatientIdGet(patientId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PayoutApi - axios parameter creator
 */
export const PayoutApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Account Session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccountSessionProviderStripeAccountSessionPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/provider/stripe/account-session`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Finalize Payouts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finalizePayoutsAdminPayoutsFinalizePost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/payouts/finalize`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Payouts For Provider
         * @param {string | null} [providerId] Provider ID to get payouts for, leave empty for currently-authenticated provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayoutsForProviderPayoutsGet: async (providerId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/payouts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (providerId !== undefined) {
                localVarQueryParameter['provider_id'] = providerId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get provider payout settings.
         * @summary Get Provider Payout Settings
         * @param {string | null} [providerId] Provider ID to get settings for, leave empty for currently-authenticated provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderPayoutSettingsProviderPayoutSettingsGet: async (providerId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/provider/payout/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (providerId !== undefined) {
                localVarQueryParameter['provider_id'] = providerId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sync provider details with Stripe Connect account.  This endpoint is called during provider onboarding after the provider has completed their profile and is ready to set up their payout account.  The request body accepts an optional business_type field. If provided, it updates the provider\'s payout settings with the business type before syncing to Stripe. If not provided, the existing business_type from settings is used.  The sync operation is idempotent and will update Stripe with the provider\'s current details including name, email, phone, SSN, and business type configuration.  Raises:     HTTPException 404: Provider payout settings not found     HTTPException 409: Provider does not have a Stripe account configured, or         business_type has not been set (either in request or previously in settings)
         * @summary Sync Provider Details To Stripe
         * @param {SyncProviderDetailsRequest} syncProviderDetailsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncProviderDetailsToStripeProviderPayoutStripeSyncDetailsPost: async (syncProviderDetailsRequest: SyncProviderDetailsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'syncProviderDetailsRequest' is not null or undefined
            assertParamExists('syncProviderDetailsToStripeProviderPayoutStripeSyncDetailsPost', 'syncProviderDetailsRequest', syncProviderDetailsRequest)
            const localVarPath = `/provider/payout/stripe/sync-details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(syncProviderDetailsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update payout settings for a provider.  This endpoint allows admins to update provider payout settings such as the group practice lead configuration.  Raises:     HTTPException 404: Provider payout settings not found     HTTPException 409: Invalid configuration (e.g., circular GP lead reference)
         * @summary Update Provider Payout Settings
         * @param {string} providerId 
         * @param {UpdateProviderPayoutSettingsRequest} updateProviderPayoutSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProviderPayoutSettingsAdminProviderProviderIdPayoutSettingsPatch: async (providerId: string, updateProviderPayoutSettingsRequest: UpdateProviderPayoutSettingsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('updateProviderPayoutSettingsAdminProviderProviderIdPayoutSettingsPatch', 'providerId', providerId)
            // verify required parameter 'updateProviderPayoutSettingsRequest' is not null or undefined
            assertParamExists('updateProviderPayoutSettingsAdminProviderProviderIdPayoutSettingsPatch', 'updateProviderPayoutSettingsRequest', updateProviderPayoutSettingsRequest)
            const localVarPath = `/admin/provider/{provider_id}/payout/settings`
                .replace(`{${"provider_id"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProviderPayoutSettingsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PayoutApi - functional programming interface
 */
export const PayoutApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PayoutApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Account Session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAccountSessionProviderStripeAccountSessionPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountSessionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAccountSessionProviderStripeAccountSessionPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayoutApi.createAccountSessionProviderStripeAccountSessionPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Finalize Payouts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async finalizePayoutsAdminPayoutsFinalizePost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.finalizePayoutsAdminPayoutsFinalizePost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayoutApi.finalizePayoutsAdminPayoutsFinalizePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Payouts For Provider
         * @param {string | null} [providerId] Provider ID to get payouts for, leave empty for currently-authenticated provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPayoutsForProviderPayoutsGet(providerId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PayoutsListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPayoutsForProviderPayoutsGet(providerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayoutApi.getPayoutsForProviderPayoutsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get provider payout settings.
         * @summary Get Provider Payout Settings
         * @param {string | null} [providerId] Provider ID to get settings for, leave empty for currently-authenticated provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProviderPayoutSettingsProviderPayoutSettingsGet(providerId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProviderPayoutSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProviderPayoutSettingsProviderPayoutSettingsGet(providerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayoutApi.getProviderPayoutSettingsProviderPayoutSettingsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sync provider details with Stripe Connect account.  This endpoint is called during provider onboarding after the provider has completed their profile and is ready to set up their payout account.  The request body accepts an optional business_type field. If provided, it updates the provider\'s payout settings with the business type before syncing to Stripe. If not provided, the existing business_type from settings is used.  The sync operation is idempotent and will update Stripe with the provider\'s current details including name, email, phone, SSN, and business type configuration.  Raises:     HTTPException 404: Provider payout settings not found     HTTPException 409: Provider does not have a Stripe account configured, or         business_type has not been set (either in request or previously in settings)
         * @summary Sync Provider Details To Stripe
         * @param {SyncProviderDetailsRequest} syncProviderDetailsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncProviderDetailsToStripeProviderPayoutStripeSyncDetailsPost(syncProviderDetailsRequest: SyncProviderDetailsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncProviderDetailsToStripeProviderPayoutStripeSyncDetailsPost(syncProviderDetailsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayoutApi.syncProviderDetailsToStripeProviderPayoutStripeSyncDetailsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update payout settings for a provider.  This endpoint allows admins to update provider payout settings such as the group practice lead configuration.  Raises:     HTTPException 404: Provider payout settings not found     HTTPException 409: Invalid configuration (e.g., circular GP lead reference)
         * @summary Update Provider Payout Settings
         * @param {string} providerId 
         * @param {UpdateProviderPayoutSettingsRequest} updateProviderPayoutSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProviderPayoutSettingsAdminProviderProviderIdPayoutSettingsPatch(providerId: string, updateProviderPayoutSettingsRequest: UpdateProviderPayoutSettingsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProviderPayoutSettingsAdminProviderProviderIdPayoutSettingsPatch(providerId, updateProviderPayoutSettingsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayoutApi.updateProviderPayoutSettingsAdminProviderProviderIdPayoutSettingsPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PayoutApi - factory interface
 */
export const PayoutApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PayoutApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Account Session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccountSessionProviderStripeAccountSessionPost(options?: RawAxiosRequestConfig): AxiosPromise<AccountSessionResponse> {
            return localVarFp.createAccountSessionProviderStripeAccountSessionPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Finalize Payouts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finalizePayoutsAdminPayoutsFinalizePost(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.finalizePayoutsAdminPayoutsFinalizePost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Payouts For Provider
         * @param {string | null} [providerId] Provider ID to get payouts for, leave empty for currently-authenticated provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayoutsForProviderPayoutsGet(providerId?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<PayoutsListResponse> {
            return localVarFp.getPayoutsForProviderPayoutsGet(providerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get provider payout settings.
         * @summary Get Provider Payout Settings
         * @param {string | null} [providerId] Provider ID to get settings for, leave empty for currently-authenticated provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderPayoutSettingsProviderPayoutSettingsGet(providerId?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<ProviderPayoutSettingsResponse> {
            return localVarFp.getProviderPayoutSettingsProviderPayoutSettingsGet(providerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sync provider details with Stripe Connect account.  This endpoint is called during provider onboarding after the provider has completed their profile and is ready to set up their payout account.  The request body accepts an optional business_type field. If provided, it updates the provider\'s payout settings with the business type before syncing to Stripe. If not provided, the existing business_type from settings is used.  The sync operation is idempotent and will update Stripe with the provider\'s current details including name, email, phone, SSN, and business type configuration.  Raises:     HTTPException 404: Provider payout settings not found     HTTPException 409: Provider does not have a Stripe account configured, or         business_type has not been set (either in request or previously in settings)
         * @summary Sync Provider Details To Stripe
         * @param {SyncProviderDetailsRequest} syncProviderDetailsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncProviderDetailsToStripeProviderPayoutStripeSyncDetailsPost(syncProviderDetailsRequest: SyncProviderDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.syncProviderDetailsToStripeProviderPayoutStripeSyncDetailsPost(syncProviderDetailsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update payout settings for a provider.  This endpoint allows admins to update provider payout settings such as the group practice lead configuration.  Raises:     HTTPException 404: Provider payout settings not found     HTTPException 409: Invalid configuration (e.g., circular GP lead reference)
         * @summary Update Provider Payout Settings
         * @param {string} providerId 
         * @param {UpdateProviderPayoutSettingsRequest} updateProviderPayoutSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProviderPayoutSettingsAdminProviderProviderIdPayoutSettingsPatch(providerId: string, updateProviderPayoutSettingsRequest: UpdateProviderPayoutSettingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateProviderPayoutSettingsAdminProviderProviderIdPayoutSettingsPatch(providerId, updateProviderPayoutSettingsRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PayoutApi - object-oriented interface
 */
export class PayoutApi extends BaseAPI {
    /**
     * 
     * @summary Create Account Session
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createAccountSessionProviderStripeAccountSessionPost(options?: RawAxiosRequestConfig) {
        return PayoutApiFp(this.configuration).createAccountSessionProviderStripeAccountSessionPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Finalize Payouts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public finalizePayoutsAdminPayoutsFinalizePost(options?: RawAxiosRequestConfig) {
        return PayoutApiFp(this.configuration).finalizePayoutsAdminPayoutsFinalizePost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Payouts For Provider
     * @param {string | null} [providerId] Provider ID to get payouts for, leave empty for currently-authenticated provider
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPayoutsForProviderPayoutsGet(providerId?: string | null, options?: RawAxiosRequestConfig) {
        return PayoutApiFp(this.configuration).getPayoutsForProviderPayoutsGet(providerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get provider payout settings.
     * @summary Get Provider Payout Settings
     * @param {string | null} [providerId] Provider ID to get settings for, leave empty for currently-authenticated provider
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProviderPayoutSettingsProviderPayoutSettingsGet(providerId?: string | null, options?: RawAxiosRequestConfig) {
        return PayoutApiFp(this.configuration).getProviderPayoutSettingsProviderPayoutSettingsGet(providerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sync provider details with Stripe Connect account.  This endpoint is called during provider onboarding after the provider has completed their profile and is ready to set up their payout account.  The request body accepts an optional business_type field. If provided, it updates the provider\'s payout settings with the business type before syncing to Stripe. If not provided, the existing business_type from settings is used.  The sync operation is idempotent and will update Stripe with the provider\'s current details including name, email, phone, SSN, and business type configuration.  Raises:     HTTPException 404: Provider payout settings not found     HTTPException 409: Provider does not have a Stripe account configured, or         business_type has not been set (either in request or previously in settings)
     * @summary Sync Provider Details To Stripe
     * @param {SyncProviderDetailsRequest} syncProviderDetailsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public syncProviderDetailsToStripeProviderPayoutStripeSyncDetailsPost(syncProviderDetailsRequest: SyncProviderDetailsRequest, options?: RawAxiosRequestConfig) {
        return PayoutApiFp(this.configuration).syncProviderDetailsToStripeProviderPayoutStripeSyncDetailsPost(syncProviderDetailsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update payout settings for a provider.  This endpoint allows admins to update provider payout settings such as the group practice lead configuration.  Raises:     HTTPException 404: Provider payout settings not found     HTTPException 409: Invalid configuration (e.g., circular GP lead reference)
     * @summary Update Provider Payout Settings
     * @param {string} providerId 
     * @param {UpdateProviderPayoutSettingsRequest} updateProviderPayoutSettingsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateProviderPayoutSettingsAdminProviderProviderIdPayoutSettingsPatch(providerId: string, updateProviderPayoutSettingsRequest: UpdateProviderPayoutSettingsRequest, options?: RawAxiosRequestConfig) {
        return PayoutApiFp(this.configuration).updateProviderPayoutSettingsAdminProviderProviderIdPayoutSettingsPatch(providerId, updateProviderPayoutSettingsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProviderApi - axios parameter creator
 */
export const ProviderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary All Onboardable Providers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allOnboardableProvidersAdminOnboardableProvidersGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/onboardable-providers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Google Calendar Oauth
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGoogleCalendarOauthProvidersMeGoogleDelete: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/providers/me/google`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Admin-only endpoint for experimenting with provider ranking calculations.  This endpoint allows admins to test different ranking parameters and see how they affect both individual scores and the distribution of scores when sampling is involved.
         * @summary Experiment Ranking Calculation
         * @param {RankingExperimentRequest} rankingExperimentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        experimentRankingCalculationAdminProvidersRankingExperimentPost: async (rankingExperimentRequest: RankingExperimentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rankingExperimentRequest' is not null or undefined
            assertParamExists('experimentRankingCalculationAdminProvidersRankingExperimentPost', 'rankingExperimentRequest', rankingExperimentRequest)
            const localVarPath = `/admin/providers/ranking/experiment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rankingExperimentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the complete provider profile directly from the source of truth. Used for provider self-management. Requires authentication as the provider or an admin.
         * @summary Get Full Provider Profile
         * @param {ProviderId} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFullProviderProfileProvidersProviderIdFullProfileGet: async (providerId: ProviderId, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('getFullProviderProfileProvidersProviderIdFullProfileGet', 'providerId', providerId)
            const localVarPath = `/providers/{provider_id}/full-profile`
                .replace(`{${"provider_id"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Google Business Review Link
         * @param {string} providerSlug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGoogleBusinessReviewLinkProvidersProviderSlugGoogleBusinessReviewLinkGet: async (providerSlug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerSlug' is not null or undefined
            assertParamExists('getGoogleBusinessReviewLinkProvidersProviderSlugGoogleBusinessReviewLinkGet', 'providerSlug', providerSlug)
            const localVarPath = `/providers/{provider_slug}/google-business-review-link`
                .replace(`{${"provider_slug"}}`, encodeURIComponent(String(providerSlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Google Calendar Oauth
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGoogleCalendarOauthProvidersMeGoogleGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/providers/me/google`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Patient Provider
         * @param {PatientId} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientProviderPatientsPatientIdProviderGet: async (patientId: PatientId, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getPatientProviderPatientsPatientIdProviderGet', 'patientId', patientId)
            const localVarPath = `/patients/{patient_id}/provider`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of available slots for the given provider between the given start and end times. The slots returned are the start times of the available slots in 15 minute increments.
         * @summary Get Provider Available Slots
         * @param {string} providerId 
         * @param {string} start 
         * @param {string} end 
         * @param {string | null} [pcrit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderAvailableSlotsProvidersProviderIdAvailabilitySlotsGet: async (providerId: string, start: string, end: string, pcrit?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('getProviderAvailableSlotsProvidersProviderIdAvailabilitySlotsGet', 'providerId', providerId)
            // verify required parameter 'start' is not null or undefined
            assertParamExists('getProviderAvailableSlotsProvidersProviderIdAvailabilitySlotsGet', 'start', start)
            // verify required parameter 'end' is not null or undefined
            assertParamExists('getProviderAvailableSlotsProvidersProviderIdAvailabilitySlotsGet', 'end', end)
            const localVarPath = `/providers/{provider_id}/availability-slots`
                .replace(`{${"provider_id"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (start !== undefined) {
                localVarQueryParameter['start'] = (start as any instanceof Date) ?
                    (start as any).toISOString() :
                    start;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = (end as any instanceof Date) ?
                    (end as any).toISOString() :
                    end;
            }

            if (pcrit !== undefined) {
                localVarQueryParameter['pcrit'] = pcrit;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Provider Client Referrals
         * @param {ProviderId} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderClientReferralsProvidersProviderIdClientReferralsGet: async (providerId: ProviderId, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('getProviderClientReferralsProvidersProviderIdClientReferralsGet', 'providerId', providerId)
            const localVarPath = `/providers/{provider_id}/client-referrals`
                .replace(`{${"provider_id"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Provider Confirmation Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderConfirmationStatusProviderConfirmGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/provider/confirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Provider Details Basic
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderDetailsBasicProvidersProviderIdBasicGet: async (providerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('getProviderDetailsBasicProvidersProviderIdBasicGet', 'providerId', providerId)
            const localVarPath = `/providers/{provider_id}/basic`
                .replace(`{${"provider_id"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Provider Details
         * @param {ProviderId} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderDetailsProvidersProviderIdGet: async (providerId: ProviderId, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('getProviderDetailsProvidersProviderIdGet', 'providerId', providerId)
            const localVarPath = `/providers/{provider_id}`
                .replace(`{${"provider_id"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Provider Identity
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderIdentityProvidersProviderIdIdentityGet: async (providerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('getProviderIdentityProvidersProviderIdIdentityGet', 'providerId', providerId)
            const localVarPath = `/providers/{provider_id}/identity`
                .replace(`{${"provider_id"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Provider Practice Metrics
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderPracticeMetricsProvidersProviderIdPracticeMetricsGet: async (providerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('getProviderPracticeMetricsProvidersProviderIdPracticeMetricsGet', 'providerId', providerId)
            const localVarPath = `/providers/{provider_id}/practice-metrics`
                .replace(`{${"provider_id"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific provider profile by ID. This will return the full details of the provider profile.
         * @summary Get Provider Profile By Id
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderProfileByIdProviderProfilesProviderIdGet: async (providerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('getProviderProfileByIdProviderProfilesProviderIdGet', 'providerId', providerId)
            const localVarPath = `/provider-profiles/{provider_id}`
                .replace(`{${"provider_id"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific provider profile by slug. This will return the full details of the provider profile.
         * @summary Get Provider Profile By Slug
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderProfileBySlugProviderProfilesBySlugSlugGet: async (slug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('getProviderProfileBySlugProviderProfilesBySlugSlugGet', 'slug', slug)
            const localVarPath = `/provider-profiles/by-slug/{slug}/`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Provider Public Rating
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderPublicRatingProvidersProviderIdPublicRatingGet: async (providerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('getProviderPublicRatingProvidersProviderIdPublicRatingGet', 'providerId', providerId)
            const localVarPath = `/providers/{provider_id}/public-rating`
                .replace(`{${"provider_id"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Provider Public Reputation
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderPublicReputationProvidersProviderIdPublicReputationGet: async (providerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('getProviderPublicReputationProvidersProviderIdPublicReputationGet', 'providerId', providerId)
            const localVarPath = `/providers/{provider_id}/public-reputation`
                .replace(`{${"provider_id"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Admin-only endpoint to fetch a provider\'s current ranking factors and computed score.  Returns all the data that would be used to compute this provider\'s ranking, along with their current computed score and status.  This endpoint now uses the decoupled ranking logic from ProviderRankExportApplication.
         * @summary Get Provider Ranking Factors
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderRankingFactorsAdminProvidersProviderIdRankingFactorsGet: async (providerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('getProviderRankingFactorsAdminProvidersProviderIdRankingFactorsGet', 'providerId', providerId)
            const localVarPath = `/admin/providers/{provider_id}/ranking-factors`
                .replace(`{${"provider_id"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Provider Rates
         * @param {ProviderId} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderRatesProvidersProviderIdRatesGet: async (providerId: ProviderId, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('getProviderRatesProvidersProviderIdRatesGet', 'providerId', providerId)
            const localVarPath = `/providers/{provider_id}/rates`
                .replace(`{${"provider_id"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get reference data for providers, including specialties, modalities, and insurances.
         * @summary Get Provider Reference Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderReferenceDataProviderProfilesReferenceDataGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/provider-profiles/reference-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Provider Reputation
         * @param {ProviderId} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderReputationProvidersProviderIdReputationGet: async (providerId: ProviderId, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('getProviderReputationProvidersProviderIdReputationGet', 'providerId', providerId)
            const localVarPath = `/providers/{provider_id}/reputation`
                .replace(`{${"provider_id"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Provider Review Link
         * @param {string} providerId 
         * @param {string | null} [appointmentId] 
         * @param {number | null} [rating] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderReviewLinkProvidersProviderIdReviewGet: async (providerId: string, appointmentId?: string | null, rating?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('getProviderReviewLinkProvidersProviderIdReviewGet', 'providerId', providerId)
            const localVarPath = `/providers/{provider_id}/review`
                .replace(`{${"provider_id"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (appointmentId !== undefined) {
                localVarQueryParameter['appointment_id'] = appointmentId;
            }

            if (rating !== undefined) {
                localVarQueryParameter['rating'] = rating;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Providers Admin
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string | null} [searchQuery] Search for providers by name or email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProvidersAdminAdminProvidersGet: async (limit?: number, offset?: number, searchQuery?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/providers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['search_query'] = searchQuery;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Providers For Patient
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProvidersForPatientProvidersGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/providers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Admin-only endpoint to fetch the current live ranking configuration.  Returns both dynamic config values and feature flag states that affect provider ranking calculations.
         * @summary Get Ranking Configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRankingConfigurationAdminProvidersRankingConfigurationGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/providers/ranking/configuration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all active provider profiles. Providers will be returned in descending order according to their ranking.
         * @summary List Provider Profiles
         * @param {Set<string>} [insurance] Set of insurances to filter by (specified as slugs). Note: If multiple values are provided, they will be combined with a logical OR.
         * @param {Set<string>} [specialties] Set of provider specialties to filter by (specified as slugs). Note: If multiple values are provided, they will be combined with a logical AND.
         * @param {Set<string>} [modalities] Set of provider modalities to filter by (specified as slugs). Note: If multiple values are provided, they will be combined with a logical AND.
         * @param {Set<string>} [identities] Set of provider identities to filter by (specified as slugs) Note: If multiple values are provided, they will be combined with a logical AND.
         * @param {Set<ProviderAvailabilityType>} [availabilityType] Set of provider availability types to filter by. Note: If multiple values are provided, they will be combined with a logical OR.
         * @param {Set<USState>} [supportedUsStates] Set of US states to filter by. Note: If multiple values are provided, they will be combined with a logical OR.
         * @param {USState | null} [locationUsState] Target providers within the US state, based on their practice location.This is used in sorting (preferencing in-state providers) but not filitering
         * @param {string | null} [locationCoordinates] Targets providers in proximity to the specified coordinates, based on their practice location. This is used in sorting (preferencing proximate providers) and filtering when radius_miles is provided. Expected format is \&#39;lat,lon\&#39; (e.g., \&#39;37.7749,-122.4194\&#39;).
         * @param {number | null} [radiusMiles] Filters providers based on proximity to the location_coordinates. Note: location_coordinates must be provided.
         * @param {number} [page] Page number to retrieve. If provided, this will override the continuation_token for pagination and return a page number in the result set
         * @param {number} [limit] Maximum number of results to return in a single response
         * @param {ProviderProfileSortOrder} [sortOrder] Sort order for the results, will be from highest to lowest
         * @param {boolean} [disableAvailableNowSorting] If true, available now providers will not be prioritized at the top of results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProviderProfilesProviderProfilesGet: async (insurance?: Set<string>, specialties?: Set<string>, modalities?: Set<string>, identities?: Set<string>, availabilityType?: Set<ProviderAvailabilityType>, supportedUsStates?: Set<USState>, locationUsState?: USState | null, locationCoordinates?: string | null, radiusMiles?: number | null, page?: number, limit?: number, sortOrder?: ProviderProfileSortOrder, disableAvailableNowSorting?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/provider-profiles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (insurance) {
                localVarQueryParameter['insurance'] = Array.from(insurance);
            }

            if (specialties) {
                localVarQueryParameter['specialties'] = Array.from(specialties);
            }

            if (modalities) {
                localVarQueryParameter['modalities'] = Array.from(modalities);
            }

            if (identities) {
                localVarQueryParameter['identities'] = Array.from(identities);
            }

            if (availabilityType) {
                localVarQueryParameter['availability_type'] = Array.from(availabilityType);
            }

            if (supportedUsStates) {
                localVarQueryParameter['supported_us_states'] = Array.from(supportedUsStates);
            }

            if (locationUsState !== undefined) {
                localVarQueryParameter['location_us_state'] = locationUsState;
            }

            if (locationCoordinates !== undefined) {
                localVarQueryParameter['location_coordinates'] = locationCoordinates;
            }

            if (radiusMiles !== undefined) {
                localVarQueryParameter['radius_miles'] = radiusMiles;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (disableAvailableNowSorting !== undefined) {
                localVarQueryParameter['disable_available_now_sorting'] = disableAvailableNowSorting;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Offboard Provider
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offboardProviderAdminProvidersProviderIdOffboardPost: async (providerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('offboardProviderAdminProvidersProviderIdOffboardPost', 'providerId', providerId)
            const localVarPath = `/admin/providers/{provider_id}/offboard`
                .replace(`{${"provider_id"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Provider Confirmation
         * @param {ProviderConfirmationPayload} providerConfirmationPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providerConfirmationProviderConfirmPost: async (providerConfirmationPayload: ProviderConfirmationPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerConfirmationPayload' is not null or undefined
            assertParamExists('providerConfirmationProviderConfirmPost', 'providerConfirmationPayload', providerConfirmationPayload)
            const localVarPath = `/provider/confirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(providerConfirmationPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * We should really be careful with this endpoint as it can be used indiscriminately. If an attacker wants to mess with our platform, they could overwhelm our database with fake impressions. We should consider rate limiting this endpoint with a platform-wide rate limiter, probably backed by Redis.
         * @summary Record Client Referral Impression
         * @param {ClientReferralImpressionPayload} clientReferralImpressionPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordClientReferralImpressionProvidersClientReferralsImpressionPost: async (clientReferralImpressionPayload: ClientReferralImpressionPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientReferralImpressionPayload' is not null or undefined
            assertParamExists('recordClientReferralImpressionProvidersClientReferralsImpressionPost', 'clientReferralImpressionPayload', clientReferralImpressionPayload)
            const localVarPath = `/providers/client-referrals/impression`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clientReferralImpressionPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Register Provider
         * @param {RegisterProviderPayload} registerProviderPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerProviderProvidersPost: async (registerProviderPayload: RegisterProviderPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registerProviderPayload' is not null or undefined
            assertParamExists('registerProviderProvidersPost', 'registerProviderPayload', registerProviderPayload)
            const localVarPath = `/providers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerProviderPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resend Provider Invite
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendProviderInviteProvidersResendProviderInvitePost: async (providerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('resendProviderInviteProvidersResendProviderInvitePost', 'providerId', providerId)
            const localVarPath = `/providers/resend-provider-invite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (providerId !== undefined) {
                localVarQueryParameter['provider_id'] = providerId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reset Provider Password
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetProviderPasswordProvidersProviderIdPasswordResetPost: async (providerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('resetProviderPasswordProvidersProviderIdPasswordResetPost', 'providerId', providerId)
            const localVarPath = `/providers/{provider_id}/password/reset`
                .replace(`{${"provider_id"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send Provider Client Referral Sms
         * @param {ProviderId} providerId 
         * @param {SendClientReferralSMSPayload} sendClientReferralSMSPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendProviderClientReferralSmsProvidersProviderIdClientReferralsSmsPost: async (providerId: ProviderId, sendClientReferralSMSPayload: SendClientReferralSMSPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('sendProviderClientReferralSmsProvidersProviderIdClientReferralsSmsPost', 'providerId', providerId)
            // verify required parameter 'sendClientReferralSMSPayload' is not null or undefined
            assertParamExists('sendProviderClientReferralSmsProvidersProviderIdClientReferralsSmsPost', 'sendClientReferralSMSPayload', sendClientReferralSMSPayload)
            const localVarPath = `/providers/{provider_id}/client-referrals/sms`
                .replace(`{${"provider_id"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendClientReferralSMSPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set Google Calendar Oauth
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setGoogleCalendarOauthProvidersMeGooglePost: async (code: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('setGoogleCalendarOauthProvidersMeGooglePost', 'code', code)
            const localVarPath = `/providers/me/google`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Solicit Provider Review
         * @param {string} providerId 
         * @param {SolicitProviderReviewPayload} solicitProviderReviewPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        solicitProviderReviewProvidersProviderIdReviewSolicitationPost: async (providerId: string, solicitProviderReviewPayload: SolicitProviderReviewPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('solicitProviderReviewProvidersProviderIdReviewSolicitationPost', 'providerId', providerId)
            // verify required parameter 'solicitProviderReviewPayload' is not null or undefined
            assertParamExists('solicitProviderReviewProvidersProviderIdReviewSolicitationPost', 'solicitProviderReviewPayload', solicitProviderReviewPayload)
            const localVarPath = `/providers/{provider_id}/review-solicitation`
                .replace(`{${"provider_id"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(solicitProviderReviewPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Provider Feedback
         * @param {string} providerId 
         * @param {string} reviewId 
         * @param {ProviderFeedbackPayload} providerFeedbackPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProviderFeedbackProvidersProviderIdReviewReviewIdPut: async (providerId: string, reviewId: string, providerFeedbackPayload: ProviderFeedbackPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('updateProviderFeedbackProvidersProviderIdReviewReviewIdPut', 'providerId', providerId)
            // verify required parameter 'reviewId' is not null or undefined
            assertParamExists('updateProviderFeedbackProvidersProviderIdReviewReviewIdPut', 'reviewId', reviewId)
            // verify required parameter 'providerFeedbackPayload' is not null or undefined
            assertParamExists('updateProviderFeedbackProvidersProviderIdReviewReviewIdPut', 'providerFeedbackPayload', providerFeedbackPayload)
            const localVarPath = `/providers/{provider_id}/review/{review_id}`
                .replace(`{${"provider_id"}}`, encodeURIComponent(String(providerId)))
                .replace(`{${"review_id"}}`, encodeURIComponent(String(reviewId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(providerFeedbackPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create or replace the profile for a provider.  Requires authentication as the provider or an admin. The background and approach fields must be accompanied by valid JWT validation tokens obtained from the validate-field endpoint.
         * @summary Update Provider Profile
         * @param {ProviderId} providerId 
         * @param {UpdateProviderProfilePayload} updateProviderProfilePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProviderProfileProviderProfilesProviderIdPut: async (providerId: ProviderId, updateProviderProfilePayload: UpdateProviderProfilePayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('updateProviderProfileProviderProfilesProviderIdPut', 'providerId', providerId)
            // verify required parameter 'updateProviderProfilePayload' is not null or undefined
            assertParamExists('updateProviderProfileProviderProfilesProviderIdPut', 'updateProviderProfilePayload', updateProviderProfilePayload)
            const localVarPath = `/provider-profiles/{provider_id}`
                .replace(`{${"provider_id"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProviderProfilePayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Provider
         * @param {ProviderId} providerId 
         * @param {UpdateProviderPayload} updateProviderPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProviderProvidersProviderIdPatch: async (providerId: ProviderId, updateProviderPayload: UpdateProviderPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('updateProviderProvidersProviderIdPatch', 'providerId', providerId)
            // verify required parameter 'updateProviderPayload' is not null or undefined
            assertParamExists('updateProviderProvidersProviderIdPatch', 'updateProviderPayload', updateProviderPayload)
            const localVarPath = `/providers/{provider_id}`
                .replace(`{${"provider_id"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProviderPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate Provider Profile Field
         * @param {ProviderId} providerId 
         * @param {ProviderProfileValidateFieldRequest} providerProfileValidateFieldRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateProviderProfileFieldProviderProfilesProviderIdValidateFieldPost: async (providerId: ProviderId, providerProfileValidateFieldRequest: ProviderProfileValidateFieldRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('validateProviderProfileFieldProviderProfilesProviderIdValidateFieldPost', 'providerId', providerId)
            // verify required parameter 'providerProfileValidateFieldRequest' is not null or undefined
            assertParamExists('validateProviderProfileFieldProviderProfilesProviderIdValidateFieldPost', 'providerProfileValidateFieldRequest', providerProfileValidateFieldRequest)
            const localVarPath = `/provider-profiles/{provider_id}/validate-field`
                .replace(`{${"provider_id"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(providerProfileValidateFieldRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate Provider Profile Image Field
         * @param {string} providerId 
         * @param {ProviderProfileValidationImageRequest} providerProfileValidationImageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateProviderProfileImageFieldProviderProfilesProviderIdValidateImageFieldPost: async (providerId: string, providerProfileValidationImageRequest: ProviderProfileValidationImageRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('validateProviderProfileImageFieldProviderProfilesProviderIdValidateImageFieldPost', 'providerId', providerId)
            // verify required parameter 'providerProfileValidationImageRequest' is not null or undefined
            assertParamExists('validateProviderProfileImageFieldProviderProfilesProviderIdValidateImageFieldPost', 'providerProfileValidationImageRequest', providerProfileValidationImageRequest)
            const localVarPath = `/provider-profiles/{provider_id}/validate-image-field`
                .replace(`{${"provider_id"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(providerProfileValidationImageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verify Provider Client Referral Token
         * @param {string} providerId 
         * @param {VerifyTokenPayload} verifyTokenPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyProviderClientReferralTokenProvidersProviderIdClientReferralsVerifyPost: async (providerId: string, verifyTokenPayload: VerifyTokenPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('verifyProviderClientReferralTokenProvidersProviderIdClientReferralsVerifyPost', 'providerId', providerId)
            // verify required parameter 'verifyTokenPayload' is not null or undefined
            assertParamExists('verifyProviderClientReferralTokenProvidersProviderIdClientReferralsVerifyPost', 'verifyTokenPayload', verifyTokenPayload)
            const localVarPath = `/providers/{provider_id}/client-referrals/verify`
                .replace(`{${"provider_id"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyTokenPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProviderApi - functional programming interface
 */
export const ProviderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProviderApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary All Onboardable Providers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allOnboardableProvidersAdminOnboardableProvidersGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OnboardableProviderResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allOnboardableProvidersAdminOnboardableProvidersGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderApi.allOnboardableProvidersAdminOnboardableProvidersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Google Calendar Oauth
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteGoogleCalendarOauthProvidersMeGoogleDelete(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OAuthResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteGoogleCalendarOauthProvidersMeGoogleDelete(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderApi.deleteGoogleCalendarOauthProvidersMeGoogleDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Admin-only endpoint for experimenting with provider ranking calculations.  This endpoint allows admins to test different ranking parameters and see how they affect both individual scores and the distribution of scores when sampling is involved.
         * @summary Experiment Ranking Calculation
         * @param {RankingExperimentRequest} rankingExperimentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async experimentRankingCalculationAdminProvidersRankingExperimentPost(rankingExperimentRequest: RankingExperimentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RankingExperimentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.experimentRankingCalculationAdminProvidersRankingExperimentPost(rankingExperimentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderApi.experimentRankingCalculationAdminProvidersRankingExperimentPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the complete provider profile directly from the source of truth. Used for provider self-management. Requires authentication as the provider or an admin.
         * @summary Get Full Provider Profile
         * @param {ProviderId} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFullProviderProfileProvidersProviderIdFullProfileGet(providerId: ProviderId, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FullProviderProfileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFullProviderProfileProvidersProviderIdFullProfileGet(providerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderApi.getFullProviderProfileProvidersProviderIdFullProfileGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Google Business Review Link
         * @param {string} providerSlug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGoogleBusinessReviewLinkProvidersProviderSlugGoogleBusinessReviewLinkGet(providerSlug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProviderGoogleBusinessReviewLinkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGoogleBusinessReviewLinkProvidersProviderSlugGoogleBusinessReviewLinkGet(providerSlug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderApi.getGoogleBusinessReviewLinkProvidersProviderSlugGoogleBusinessReviewLinkGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Google Calendar Oauth
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGoogleCalendarOauthProvidersMeGoogleGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OAuthResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGoogleCalendarOauthProvidersMeGoogleGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderApi.getGoogleCalendarOauthProvidersMeGoogleGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Patient Provider
         * @param {PatientId} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientProviderPatientsPatientIdProviderGet(patientId: PatientId, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProviderDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientProviderPatientsPatientIdProviderGet(patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderApi.getPatientProviderPatientsPatientIdProviderGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a list of available slots for the given provider between the given start and end times. The slots returned are the start times of the available slots in 15 minute increments.
         * @summary Get Provider Available Slots
         * @param {string} providerId 
         * @param {string} start 
         * @param {string} end 
         * @param {string | null} [pcrit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProviderAvailableSlotsProvidersProviderIdAvailabilitySlotsGet(providerId: string, start: string, end: string, pcrit?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AvailabilitySlotsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProviderAvailableSlotsProvidersProviderIdAvailabilitySlotsGet(providerId, start, end, pcrit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderApi.getProviderAvailableSlotsProvidersProviderIdAvailabilitySlotsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Provider Client Referrals
         * @param {ProviderId} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProviderClientReferralsProvidersProviderIdClientReferralsGet(providerId: ProviderId, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientReferralResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProviderClientReferralsProvidersProviderIdClientReferralsGet(providerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderApi.getProviderClientReferralsProvidersProviderIdClientReferralsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Provider Confirmation Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProviderConfirmationStatusProviderConfirmGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProviderConfirmationPreflightResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProviderConfirmationStatusProviderConfirmGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderApi.getProviderConfirmationStatusProviderConfirmGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Provider Details Basic
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProviderDetailsBasicProvidersProviderIdBasicGet(providerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProviderDetailsBasicResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProviderDetailsBasicProvidersProviderIdBasicGet(providerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderApi.getProviderDetailsBasicProvidersProviderIdBasicGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Provider Details
         * @param {ProviderId} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProviderDetailsProvidersProviderIdGet(providerId: ProviderId, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProviderDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProviderDetailsProvidersProviderIdGet(providerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderApi.getProviderDetailsProvidersProviderIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Provider Identity
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProviderIdentityProvidersProviderIdIdentityGet(providerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProviderIdentityDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProviderIdentityProvidersProviderIdIdentityGet(providerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderApi.getProviderIdentityProvidersProviderIdIdentityGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Provider Practice Metrics
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProviderPracticeMetricsProvidersProviderIdPracticeMetricsGet(providerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PracticeMetricsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProviderPracticeMetricsProvidersProviderIdPracticeMetricsGet(providerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderApi.getProviderPracticeMetricsProvidersProviderIdPracticeMetricsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a specific provider profile by ID. This will return the full details of the provider profile.
         * @summary Get Provider Profile By Id
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProviderProfileByIdProviderProfilesProviderIdGet(providerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProviderProfileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProviderProfileByIdProviderProfilesProviderIdGet(providerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderApi.getProviderProfileByIdProviderProfilesProviderIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a specific provider profile by slug. This will return the full details of the provider profile.
         * @summary Get Provider Profile By Slug
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProviderProfileBySlugProviderProfilesBySlugSlugGet(slug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProviderProfileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProviderProfileBySlugProviderProfilesBySlugSlugGet(slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderApi.getProviderProfileBySlugProviderProfilesBySlugSlugGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Provider Public Rating
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProviderPublicRatingProvidersProviderIdPublicRatingGet(providerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProviderPublicRatingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProviderPublicRatingProvidersProviderIdPublicRatingGet(providerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderApi.getProviderPublicRatingProvidersProviderIdPublicRatingGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Provider Public Reputation
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProviderPublicReputationProvidersProviderIdPublicReputationGet(providerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProviderPublicReputationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProviderPublicReputationProvidersProviderIdPublicReputationGet(providerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderApi.getProviderPublicReputationProvidersProviderIdPublicReputationGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Admin-only endpoint to fetch a provider\'s current ranking factors and computed score.  Returns all the data that would be used to compute this provider\'s ranking, along with their current computed score and status.  This endpoint now uses the decoupled ranking logic from ProviderRankExportApplication.
         * @summary Get Provider Ranking Factors
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProviderRankingFactorsAdminProvidersProviderIdRankingFactorsGet(providerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProviderRankingFactorsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProviderRankingFactorsAdminProvidersProviderIdRankingFactorsGet(providerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderApi.getProviderRankingFactorsAdminProvidersProviderIdRankingFactorsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Provider Rates
         * @param {ProviderId} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProviderRatesProvidersProviderIdRatesGet(providerId: ProviderId, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProviderRatesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProviderRatesProvidersProviderIdRatesGet(providerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderApi.getProviderRatesProvidersProviderIdRatesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get reference data for providers, including specialties, modalities, and insurances.
         * @summary Get Provider Reference Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProviderReferenceDataProviderProfilesReferenceDataGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProviderReferenceDataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProviderReferenceDataProviderProfilesReferenceDataGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderApi.getProviderReferenceDataProviderProfilesReferenceDataGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Provider Reputation
         * @param {ProviderId} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProviderReputationProvidersProviderIdReputationGet(providerId: ProviderId, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProviderReputationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProviderReputationProvidersProviderIdReputationGet(providerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderApi.getProviderReputationProvidersProviderIdReputationGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Provider Review Link
         * @param {string} providerId 
         * @param {string | null} [appointmentId] 
         * @param {number | null} [rating] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProviderReviewLinkProvidersProviderIdReviewGet(providerId: string, appointmentId?: string | null, rating?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProviderReviewLinkProvidersProviderIdReviewGet(providerId, appointmentId, rating, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderApi.getProviderReviewLinkProvidersProviderIdReviewGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Providers Admin
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string | null} [searchQuery] Search for providers by name or email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProvidersAdminAdminProvidersGet(limit?: number, offset?: number, searchQuery?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminProviderDetailsResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProvidersAdminAdminProvidersGet(limit, offset, searchQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderApi.getProvidersAdminAdminProvidersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Providers For Patient
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProvidersForPatientProvidersGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProviderForPatientDetailsResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProvidersForPatientProvidersGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderApi.getProvidersForPatientProvidersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Admin-only endpoint to fetch the current live ranking configuration.  Returns both dynamic config values and feature flag states that affect provider ranking calculations.
         * @summary Get Ranking Configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRankingConfigurationAdminProvidersRankingConfigurationGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RankingConfigurationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRankingConfigurationAdminProvidersRankingConfigurationGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderApi.getRankingConfigurationAdminProvidersRankingConfigurationGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all active provider profiles. Providers will be returned in descending order according to their ranking.
         * @summary List Provider Profiles
         * @param {Set<string>} [insurance] Set of insurances to filter by (specified as slugs). Note: If multiple values are provided, they will be combined with a logical OR.
         * @param {Set<string>} [specialties] Set of provider specialties to filter by (specified as slugs). Note: If multiple values are provided, they will be combined with a logical AND.
         * @param {Set<string>} [modalities] Set of provider modalities to filter by (specified as slugs). Note: If multiple values are provided, they will be combined with a logical AND.
         * @param {Set<string>} [identities] Set of provider identities to filter by (specified as slugs) Note: If multiple values are provided, they will be combined with a logical AND.
         * @param {Set<ProviderAvailabilityType>} [availabilityType] Set of provider availability types to filter by. Note: If multiple values are provided, they will be combined with a logical OR.
         * @param {Set<USState>} [supportedUsStates] Set of US states to filter by. Note: If multiple values are provided, they will be combined with a logical OR.
         * @param {USState | null} [locationUsState] Target providers within the US state, based on their practice location.This is used in sorting (preferencing in-state providers) but not filitering
         * @param {string | null} [locationCoordinates] Targets providers in proximity to the specified coordinates, based on their practice location. This is used in sorting (preferencing proximate providers) and filtering when radius_miles is provided. Expected format is \&#39;lat,lon\&#39; (e.g., \&#39;37.7749,-122.4194\&#39;).
         * @param {number | null} [radiusMiles] Filters providers based on proximity to the location_coordinates. Note: location_coordinates must be provided.
         * @param {number} [page] Page number to retrieve. If provided, this will override the continuation_token for pagination and return a page number in the result set
         * @param {number} [limit] Maximum number of results to return in a single response
         * @param {ProviderProfileSortOrder} [sortOrder] Sort order for the results, will be from highest to lowest
         * @param {boolean} [disableAvailableNowSorting] If true, available now providers will not be prioritized at the top of results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listProviderProfilesProviderProfilesGet(insurance?: Set<string>, specialties?: Set<string>, modalities?: Set<string>, identities?: Set<string>, availabilityType?: Set<ProviderAvailabilityType>, supportedUsStates?: Set<USState>, locationUsState?: USState | null, locationCoordinates?: string | null, radiusMiles?: number | null, page?: number, limit?: number, sortOrder?: ProviderProfileSortOrder, disableAvailableNowSorting?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProviderProfilesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listProviderProfilesProviderProfilesGet(insurance, specialties, modalities, identities, availabilityType, supportedUsStates, locationUsState, locationCoordinates, radiusMiles, page, limit, sortOrder, disableAvailableNowSorting, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderApi.listProviderProfilesProviderProfilesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Offboard Provider
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async offboardProviderAdminProvidersProviderIdOffboardPost(providerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OffboardStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.offboardProviderAdminProvidersProviderIdOffboardPost(providerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderApi.offboardProviderAdminProvidersProviderIdOffboardPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Provider Confirmation
         * @param {ProviderConfirmationPayload} providerConfirmationPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async providerConfirmationProviderConfirmPost(providerConfirmationPayload: ProviderConfirmationPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.providerConfirmationProviderConfirmPost(providerConfirmationPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderApi.providerConfirmationProviderConfirmPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * We should really be careful with this endpoint as it can be used indiscriminately. If an attacker wants to mess with our platform, they could overwhelm our database with fake impressions. We should consider rate limiting this endpoint with a platform-wide rate limiter, probably backed by Redis.
         * @summary Record Client Referral Impression
         * @param {ClientReferralImpressionPayload} clientReferralImpressionPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recordClientReferralImpressionProvidersClientReferralsImpressionPost(clientReferralImpressionPayload: ClientReferralImpressionPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientReferralImpressionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recordClientReferralImpressionProvidersClientReferralsImpressionPost(clientReferralImpressionPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderApi.recordClientReferralImpressionProvidersClientReferralsImpressionPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Register Provider
         * @param {RegisterProviderPayload} registerProviderPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerProviderProvidersPost(registerProviderPayload: RegisterProviderPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProviderDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerProviderProvidersPost(registerProviderPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderApi.registerProviderProvidersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Resend Provider Invite
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendProviderInviteProvidersResendProviderInvitePost(providerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendProviderInviteProvidersResendProviderInvitePost(providerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderApi.resendProviderInviteProvidersResendProviderInvitePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reset Provider Password
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetProviderPasswordProvidersProviderIdPasswordResetPost(providerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetProviderPasswordProvidersProviderIdPasswordResetPost(providerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderApi.resetProviderPasswordProvidersProviderIdPasswordResetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Send Provider Client Referral Sms
         * @param {ProviderId} providerId 
         * @param {SendClientReferralSMSPayload} sendClientReferralSMSPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendProviderClientReferralSmsProvidersProviderIdClientReferralsSmsPost(providerId: ProviderId, sendClientReferralSMSPayload: SendClientReferralSMSPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendProviderClientReferralSmsProvidersProviderIdClientReferralsSmsPost(providerId, sendClientReferralSMSPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderApi.sendProviderClientReferralSmsProvidersProviderIdClientReferralsSmsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Set Google Calendar Oauth
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setGoogleCalendarOauthProvidersMeGooglePost(code: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setGoogleCalendarOauthProvidersMeGooglePost(code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderApi.setGoogleCalendarOauthProvidersMeGooglePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Solicit Provider Review
         * @param {string} providerId 
         * @param {SolicitProviderReviewPayload} solicitProviderReviewPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async solicitProviderReviewProvidersProviderIdReviewSolicitationPost(providerId: string, solicitProviderReviewPayload: SolicitProviderReviewPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.solicitProviderReviewProvidersProviderIdReviewSolicitationPost(providerId, solicitProviderReviewPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderApi.solicitProviderReviewProvidersProviderIdReviewSolicitationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Provider Feedback
         * @param {string} providerId 
         * @param {string} reviewId 
         * @param {ProviderFeedbackPayload} providerFeedbackPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProviderFeedbackProvidersProviderIdReviewReviewIdPut(providerId: string, reviewId: string, providerFeedbackPayload: ProviderFeedbackPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProviderFeedbackProvidersProviderIdReviewReviewIdPut(providerId, reviewId, providerFeedbackPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderApi.updateProviderFeedbackProvidersProviderIdReviewReviewIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create or replace the profile for a provider.  Requires authentication as the provider or an admin. The background and approach fields must be accompanied by valid JWT validation tokens obtained from the validate-field endpoint.
         * @summary Update Provider Profile
         * @param {ProviderId} providerId 
         * @param {UpdateProviderProfilePayload} updateProviderProfilePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProviderProfileProviderProfilesProviderIdPut(providerId: ProviderId, updateProviderProfilePayload: UpdateProviderProfilePayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateProviderProfileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProviderProfileProviderProfilesProviderIdPut(providerId, updateProviderProfilePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderApi.updateProviderProfileProviderProfilesProviderIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Provider
         * @param {ProviderId} providerId 
         * @param {UpdateProviderPayload} updateProviderPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProviderProvidersProviderIdPatch(providerId: ProviderId, updateProviderPayload: UpdateProviderPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProviderDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProviderProvidersProviderIdPatch(providerId, updateProviderPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderApi.updateProviderProvidersProviderIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Validate Provider Profile Field
         * @param {ProviderId} providerId 
         * @param {ProviderProfileValidateFieldRequest} providerProfileValidateFieldRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateProviderProfileFieldProviderProfilesProviderIdValidateFieldPost(providerId: ProviderId, providerProfileValidateFieldRequest: ProviderProfileValidateFieldRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProviderProfileValidationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateProviderProfileFieldProviderProfilesProviderIdValidateFieldPost(providerId, providerProfileValidateFieldRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderApi.validateProviderProfileFieldProviderProfilesProviderIdValidateFieldPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Validate Provider Profile Image Field
         * @param {string} providerId 
         * @param {ProviderProfileValidationImageRequest} providerProfileValidationImageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateProviderProfileImageFieldProviderProfilesProviderIdValidateImageFieldPost(providerId: string, providerProfileValidationImageRequest: ProviderProfileValidationImageRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProviderProfileValidationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateProviderProfileImageFieldProviderProfilesProviderIdValidateImageFieldPost(providerId, providerProfileValidationImageRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderApi.validateProviderProfileImageFieldProviderProfilesProviderIdValidateImageFieldPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Verify Provider Client Referral Token
         * @param {string} providerId 
         * @param {VerifyTokenPayload} verifyTokenPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyProviderClientReferralTokenProvidersProviderIdClientReferralsVerifyPost(providerId: string, verifyTokenPayload: VerifyTokenPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerifyTokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyProviderClientReferralTokenProvidersProviderIdClientReferralsVerifyPost(providerId, verifyTokenPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProviderApi.verifyProviderClientReferralTokenProvidersProviderIdClientReferralsVerifyPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProviderApi - factory interface
 */
export const ProviderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProviderApiFp(configuration)
    return {
        /**
         * 
         * @summary All Onboardable Providers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allOnboardableProvidersAdminOnboardableProvidersGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<OnboardableProviderResponse>> {
            return localVarFp.allOnboardableProvidersAdminOnboardableProvidersGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Google Calendar Oauth
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGoogleCalendarOauthProvidersMeGoogleDelete(options?: RawAxiosRequestConfig): AxiosPromise<OAuthResponse> {
            return localVarFp.deleteGoogleCalendarOauthProvidersMeGoogleDelete(options).then((request) => request(axios, basePath));
        },
        /**
         * Admin-only endpoint for experimenting with provider ranking calculations.  This endpoint allows admins to test different ranking parameters and see how they affect both individual scores and the distribution of scores when sampling is involved.
         * @summary Experiment Ranking Calculation
         * @param {RankingExperimentRequest} rankingExperimentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        experimentRankingCalculationAdminProvidersRankingExperimentPost(rankingExperimentRequest: RankingExperimentRequest, options?: RawAxiosRequestConfig): AxiosPromise<RankingExperimentResponse> {
            return localVarFp.experimentRankingCalculationAdminProvidersRankingExperimentPost(rankingExperimentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the complete provider profile directly from the source of truth. Used for provider self-management. Requires authentication as the provider or an admin.
         * @summary Get Full Provider Profile
         * @param {ProviderId} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFullProviderProfileProvidersProviderIdFullProfileGet(providerId: ProviderId, options?: RawAxiosRequestConfig): AxiosPromise<FullProviderProfileResponse> {
            return localVarFp.getFullProviderProfileProvidersProviderIdFullProfileGet(providerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Google Business Review Link
         * @param {string} providerSlug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGoogleBusinessReviewLinkProvidersProviderSlugGoogleBusinessReviewLinkGet(providerSlug: string, options?: RawAxiosRequestConfig): AxiosPromise<ProviderGoogleBusinessReviewLinkResponse> {
            return localVarFp.getGoogleBusinessReviewLinkProvidersProviderSlugGoogleBusinessReviewLinkGet(providerSlug, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Google Calendar Oauth
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGoogleCalendarOauthProvidersMeGoogleGet(options?: RawAxiosRequestConfig): AxiosPromise<OAuthResponse> {
            return localVarFp.getGoogleCalendarOauthProvidersMeGoogleGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Patient Provider
         * @param {PatientId} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientProviderPatientsPatientIdProviderGet(patientId: PatientId, options?: RawAxiosRequestConfig): AxiosPromise<ProviderDetailsResponse> {
            return localVarFp.getPatientProviderPatientsPatientIdProviderGet(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list of available slots for the given provider between the given start and end times. The slots returned are the start times of the available slots in 15 minute increments.
         * @summary Get Provider Available Slots
         * @param {string} providerId 
         * @param {string} start 
         * @param {string} end 
         * @param {string | null} [pcrit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderAvailableSlotsProvidersProviderIdAvailabilitySlotsGet(providerId: string, start: string, end: string, pcrit?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<AvailabilitySlotsResponse> {
            return localVarFp.getProviderAvailableSlotsProvidersProviderIdAvailabilitySlotsGet(providerId, start, end, pcrit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Provider Client Referrals
         * @param {ProviderId} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderClientReferralsProvidersProviderIdClientReferralsGet(providerId: ProviderId, options?: RawAxiosRequestConfig): AxiosPromise<ClientReferralResponse> {
            return localVarFp.getProviderClientReferralsProvidersProviderIdClientReferralsGet(providerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Provider Confirmation Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderConfirmationStatusProviderConfirmGet(options?: RawAxiosRequestConfig): AxiosPromise<ProviderConfirmationPreflightResponse> {
            return localVarFp.getProviderConfirmationStatusProviderConfirmGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Provider Details Basic
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderDetailsBasicProvidersProviderIdBasicGet(providerId: string, options?: RawAxiosRequestConfig): AxiosPromise<ProviderDetailsBasicResponse> {
            return localVarFp.getProviderDetailsBasicProvidersProviderIdBasicGet(providerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Provider Details
         * @param {ProviderId} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderDetailsProvidersProviderIdGet(providerId: ProviderId, options?: RawAxiosRequestConfig): AxiosPromise<ProviderDetailsResponse> {
            return localVarFp.getProviderDetailsProvidersProviderIdGet(providerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Provider Identity
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderIdentityProvidersProviderIdIdentityGet(providerId: string, options?: RawAxiosRequestConfig): AxiosPromise<ProviderIdentityDetailsResponse> {
            return localVarFp.getProviderIdentityProvidersProviderIdIdentityGet(providerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Provider Practice Metrics
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderPracticeMetricsProvidersProviderIdPracticeMetricsGet(providerId: string, options?: RawAxiosRequestConfig): AxiosPromise<PracticeMetricsResponse> {
            return localVarFp.getProviderPracticeMetricsProvidersProviderIdPracticeMetricsGet(providerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific provider profile by ID. This will return the full details of the provider profile.
         * @summary Get Provider Profile By Id
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderProfileByIdProviderProfilesProviderIdGet(providerId: string, options?: RawAxiosRequestConfig): AxiosPromise<ProviderProfileResponse> {
            return localVarFp.getProviderProfileByIdProviderProfilesProviderIdGet(providerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific provider profile by slug. This will return the full details of the provider profile.
         * @summary Get Provider Profile By Slug
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderProfileBySlugProviderProfilesBySlugSlugGet(slug: string, options?: RawAxiosRequestConfig): AxiosPromise<ProviderProfileResponse> {
            return localVarFp.getProviderProfileBySlugProviderProfilesBySlugSlugGet(slug, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Provider Public Rating
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderPublicRatingProvidersProviderIdPublicRatingGet(providerId: string, options?: RawAxiosRequestConfig): AxiosPromise<ProviderPublicRatingResponse> {
            return localVarFp.getProviderPublicRatingProvidersProviderIdPublicRatingGet(providerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Provider Public Reputation
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderPublicReputationProvidersProviderIdPublicReputationGet(providerId: string, options?: RawAxiosRequestConfig): AxiosPromise<ProviderPublicReputationResponse> {
            return localVarFp.getProviderPublicReputationProvidersProviderIdPublicReputationGet(providerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Admin-only endpoint to fetch a provider\'s current ranking factors and computed score.  Returns all the data that would be used to compute this provider\'s ranking, along with their current computed score and status.  This endpoint now uses the decoupled ranking logic from ProviderRankExportApplication.
         * @summary Get Provider Ranking Factors
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderRankingFactorsAdminProvidersProviderIdRankingFactorsGet(providerId: string, options?: RawAxiosRequestConfig): AxiosPromise<ProviderRankingFactorsResponse> {
            return localVarFp.getProviderRankingFactorsAdminProvidersProviderIdRankingFactorsGet(providerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Provider Rates
         * @param {ProviderId} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderRatesProvidersProviderIdRatesGet(providerId: ProviderId, options?: RawAxiosRequestConfig): AxiosPromise<ProviderRatesResponse> {
            return localVarFp.getProviderRatesProvidersProviderIdRatesGet(providerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get reference data for providers, including specialties, modalities, and insurances.
         * @summary Get Provider Reference Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderReferenceDataProviderProfilesReferenceDataGet(options?: RawAxiosRequestConfig): AxiosPromise<ProviderReferenceDataResponse> {
            return localVarFp.getProviderReferenceDataProviderProfilesReferenceDataGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Provider Reputation
         * @param {ProviderId} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderReputationProvidersProviderIdReputationGet(providerId: ProviderId, options?: RawAxiosRequestConfig): AxiosPromise<ProviderReputationResponse> {
            return localVarFp.getProviderReputationProvidersProviderIdReputationGet(providerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Provider Review Link
         * @param {string} providerId 
         * @param {string | null} [appointmentId] 
         * @param {number | null} [rating] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderReviewLinkProvidersProviderIdReviewGet(providerId: string, appointmentId?: string | null, rating?: number | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getProviderReviewLinkProvidersProviderIdReviewGet(providerId, appointmentId, rating, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Providers Admin
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string | null} [searchQuery] Search for providers by name or email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProvidersAdminAdminProvidersGet(limit?: number, offset?: number, searchQuery?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminProviderDetailsResponse>> {
            return localVarFp.getProvidersAdminAdminProvidersGet(limit, offset, searchQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Providers For Patient
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProvidersForPatientProvidersGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<ProviderForPatientDetailsResponse>> {
            return localVarFp.getProvidersForPatientProvidersGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Admin-only endpoint to fetch the current live ranking configuration.  Returns both dynamic config values and feature flag states that affect provider ranking calculations.
         * @summary Get Ranking Configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRankingConfigurationAdminProvidersRankingConfigurationGet(options?: RawAxiosRequestConfig): AxiosPromise<RankingConfigurationResponse> {
            return localVarFp.getRankingConfigurationAdminProvidersRankingConfigurationGet(options).then((request) => request(axios, basePath));
        },
        /**
         * List all active provider profiles. Providers will be returned in descending order according to their ranking.
         * @summary List Provider Profiles
         * @param {Set<string>} [insurance] Set of insurances to filter by (specified as slugs). Note: If multiple values are provided, they will be combined with a logical OR.
         * @param {Set<string>} [specialties] Set of provider specialties to filter by (specified as slugs). Note: If multiple values are provided, they will be combined with a logical AND.
         * @param {Set<string>} [modalities] Set of provider modalities to filter by (specified as slugs). Note: If multiple values are provided, they will be combined with a logical AND.
         * @param {Set<string>} [identities] Set of provider identities to filter by (specified as slugs) Note: If multiple values are provided, they will be combined with a logical AND.
         * @param {Set<ProviderAvailabilityType>} [availabilityType] Set of provider availability types to filter by. Note: If multiple values are provided, they will be combined with a logical OR.
         * @param {Set<USState>} [supportedUsStates] Set of US states to filter by. Note: If multiple values are provided, they will be combined with a logical OR.
         * @param {USState | null} [locationUsState] Target providers within the US state, based on their practice location.This is used in sorting (preferencing in-state providers) but not filitering
         * @param {string | null} [locationCoordinates] Targets providers in proximity to the specified coordinates, based on their practice location. This is used in sorting (preferencing proximate providers) and filtering when radius_miles is provided. Expected format is \&#39;lat,lon\&#39; (e.g., \&#39;37.7749,-122.4194\&#39;).
         * @param {number | null} [radiusMiles] Filters providers based on proximity to the location_coordinates. Note: location_coordinates must be provided.
         * @param {number} [page] Page number to retrieve. If provided, this will override the continuation_token for pagination and return a page number in the result set
         * @param {number} [limit] Maximum number of results to return in a single response
         * @param {ProviderProfileSortOrder} [sortOrder] Sort order for the results, will be from highest to lowest
         * @param {boolean} [disableAvailableNowSorting] If true, available now providers will not be prioritized at the top of results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProviderProfilesProviderProfilesGet(insurance?: Set<string>, specialties?: Set<string>, modalities?: Set<string>, identities?: Set<string>, availabilityType?: Set<ProviderAvailabilityType>, supportedUsStates?: Set<USState>, locationUsState?: USState | null, locationCoordinates?: string | null, radiusMiles?: number | null, page?: number, limit?: number, sortOrder?: ProviderProfileSortOrder, disableAvailableNowSorting?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<ProviderProfilesResponse> {
            return localVarFp.listProviderProfilesProviderProfilesGet(insurance, specialties, modalities, identities, availabilityType, supportedUsStates, locationUsState, locationCoordinates, radiusMiles, page, limit, sortOrder, disableAvailableNowSorting, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Offboard Provider
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offboardProviderAdminProvidersProviderIdOffboardPost(providerId: string, options?: RawAxiosRequestConfig): AxiosPromise<OffboardStatusResponse> {
            return localVarFp.offboardProviderAdminProvidersProviderIdOffboardPost(providerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Provider Confirmation
         * @param {ProviderConfirmationPayload} providerConfirmationPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providerConfirmationProviderConfirmPost(providerConfirmationPayload: ProviderConfirmationPayload, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.providerConfirmationProviderConfirmPost(providerConfirmationPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * We should really be careful with this endpoint as it can be used indiscriminately. If an attacker wants to mess with our platform, they could overwhelm our database with fake impressions. We should consider rate limiting this endpoint with a platform-wide rate limiter, probably backed by Redis.
         * @summary Record Client Referral Impression
         * @param {ClientReferralImpressionPayload} clientReferralImpressionPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordClientReferralImpressionProvidersClientReferralsImpressionPost(clientReferralImpressionPayload: ClientReferralImpressionPayload, options?: RawAxiosRequestConfig): AxiosPromise<ClientReferralImpressionResponse> {
            return localVarFp.recordClientReferralImpressionProvidersClientReferralsImpressionPost(clientReferralImpressionPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Register Provider
         * @param {RegisterProviderPayload} registerProviderPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerProviderProvidersPost(registerProviderPayload: RegisterProviderPayload, options?: RawAxiosRequestConfig): AxiosPromise<ProviderDetailsResponse> {
            return localVarFp.registerProviderProvidersPost(registerProviderPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resend Provider Invite
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendProviderInviteProvidersResendProviderInvitePost(providerId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.resendProviderInviteProvidersResendProviderInvitePost(providerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reset Provider Password
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetProviderPasswordProvidersProviderIdPasswordResetPost(providerId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.resetProviderPasswordProvidersProviderIdPasswordResetPost(providerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send Provider Client Referral Sms
         * @param {ProviderId} providerId 
         * @param {SendClientReferralSMSPayload} sendClientReferralSMSPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendProviderClientReferralSmsProvidersProviderIdClientReferralsSmsPost(providerId: ProviderId, sendClientReferralSMSPayload: SendClientReferralSMSPayload, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.sendProviderClientReferralSmsProvidersProviderIdClientReferralsSmsPost(providerId, sendClientReferralSMSPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set Google Calendar Oauth
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setGoogleCalendarOauthProvidersMeGooglePost(code: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.setGoogleCalendarOauthProvidersMeGooglePost(code, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Solicit Provider Review
         * @param {string} providerId 
         * @param {SolicitProviderReviewPayload} solicitProviderReviewPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        solicitProviderReviewProvidersProviderIdReviewSolicitationPost(providerId: string, solicitProviderReviewPayload: SolicitProviderReviewPayload, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.solicitProviderReviewProvidersProviderIdReviewSolicitationPost(providerId, solicitProviderReviewPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Provider Feedback
         * @param {string} providerId 
         * @param {string} reviewId 
         * @param {ProviderFeedbackPayload} providerFeedbackPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProviderFeedbackProvidersProviderIdReviewReviewIdPut(providerId: string, reviewId: string, providerFeedbackPayload: ProviderFeedbackPayload, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.updateProviderFeedbackProvidersProviderIdReviewReviewIdPut(providerId, reviewId, providerFeedbackPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Create or replace the profile for a provider.  Requires authentication as the provider or an admin. The background and approach fields must be accompanied by valid JWT validation tokens obtained from the validate-field endpoint.
         * @summary Update Provider Profile
         * @param {ProviderId} providerId 
         * @param {UpdateProviderProfilePayload} updateProviderProfilePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProviderProfileProviderProfilesProviderIdPut(providerId: ProviderId, updateProviderProfilePayload: UpdateProviderProfilePayload, options?: RawAxiosRequestConfig): AxiosPromise<UpdateProviderProfileResponse> {
            return localVarFp.updateProviderProfileProviderProfilesProviderIdPut(providerId, updateProviderProfilePayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Provider
         * @param {ProviderId} providerId 
         * @param {UpdateProviderPayload} updateProviderPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProviderProvidersProviderIdPatch(providerId: ProviderId, updateProviderPayload: UpdateProviderPayload, options?: RawAxiosRequestConfig): AxiosPromise<ProviderDetailsResponse> {
            return localVarFp.updateProviderProvidersProviderIdPatch(providerId, updateProviderPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Validate Provider Profile Field
         * @param {ProviderId} providerId 
         * @param {ProviderProfileValidateFieldRequest} providerProfileValidateFieldRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateProviderProfileFieldProviderProfilesProviderIdValidateFieldPost(providerId: ProviderId, providerProfileValidateFieldRequest: ProviderProfileValidateFieldRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProviderProfileValidationResponse> {
            return localVarFp.validateProviderProfileFieldProviderProfilesProviderIdValidateFieldPost(providerId, providerProfileValidateFieldRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Validate Provider Profile Image Field
         * @param {string} providerId 
         * @param {ProviderProfileValidationImageRequest} providerProfileValidationImageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateProviderProfileImageFieldProviderProfilesProviderIdValidateImageFieldPost(providerId: string, providerProfileValidationImageRequest: ProviderProfileValidationImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProviderProfileValidationResponse> {
            return localVarFp.validateProviderProfileImageFieldProviderProfilesProviderIdValidateImageFieldPost(providerId, providerProfileValidationImageRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verify Provider Client Referral Token
         * @param {string} providerId 
         * @param {VerifyTokenPayload} verifyTokenPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyProviderClientReferralTokenProvidersProviderIdClientReferralsVerifyPost(providerId: string, verifyTokenPayload: VerifyTokenPayload, options?: RawAxiosRequestConfig): AxiosPromise<VerifyTokenResponse> {
            return localVarFp.verifyProviderClientReferralTokenProvidersProviderIdClientReferralsVerifyPost(providerId, verifyTokenPayload, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProviderApi - object-oriented interface
 */
export class ProviderApi extends BaseAPI {
    /**
     * 
     * @summary All Onboardable Providers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public allOnboardableProvidersAdminOnboardableProvidersGet(options?: RawAxiosRequestConfig) {
        return ProviderApiFp(this.configuration).allOnboardableProvidersAdminOnboardableProvidersGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Google Calendar Oauth
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteGoogleCalendarOauthProvidersMeGoogleDelete(options?: RawAxiosRequestConfig) {
        return ProviderApiFp(this.configuration).deleteGoogleCalendarOauthProvidersMeGoogleDelete(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Admin-only endpoint for experimenting with provider ranking calculations.  This endpoint allows admins to test different ranking parameters and see how they affect both individual scores and the distribution of scores when sampling is involved.
     * @summary Experiment Ranking Calculation
     * @param {RankingExperimentRequest} rankingExperimentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public experimentRankingCalculationAdminProvidersRankingExperimentPost(rankingExperimentRequest: RankingExperimentRequest, options?: RawAxiosRequestConfig) {
        return ProviderApiFp(this.configuration).experimentRankingCalculationAdminProvidersRankingExperimentPost(rankingExperimentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the complete provider profile directly from the source of truth. Used for provider self-management. Requires authentication as the provider or an admin.
     * @summary Get Full Provider Profile
     * @param {ProviderId} providerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFullProviderProfileProvidersProviderIdFullProfileGet(providerId: ProviderId, options?: RawAxiosRequestConfig) {
        return ProviderApiFp(this.configuration).getFullProviderProfileProvidersProviderIdFullProfileGet(providerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Google Business Review Link
     * @param {string} providerSlug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getGoogleBusinessReviewLinkProvidersProviderSlugGoogleBusinessReviewLinkGet(providerSlug: string, options?: RawAxiosRequestConfig) {
        return ProviderApiFp(this.configuration).getGoogleBusinessReviewLinkProvidersProviderSlugGoogleBusinessReviewLinkGet(providerSlug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Google Calendar Oauth
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getGoogleCalendarOauthProvidersMeGoogleGet(options?: RawAxiosRequestConfig) {
        return ProviderApiFp(this.configuration).getGoogleCalendarOauthProvidersMeGoogleGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Patient Provider
     * @param {PatientId} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPatientProviderPatientsPatientIdProviderGet(patientId: PatientId, options?: RawAxiosRequestConfig) {
        return ProviderApiFp(this.configuration).getPatientProviderPatientsPatientIdProviderGet(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list of available slots for the given provider between the given start and end times. The slots returned are the start times of the available slots in 15 minute increments.
     * @summary Get Provider Available Slots
     * @param {string} providerId 
     * @param {string} start 
     * @param {string} end 
     * @param {string | null} [pcrit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProviderAvailableSlotsProvidersProviderIdAvailabilitySlotsGet(providerId: string, start: string, end: string, pcrit?: string | null, options?: RawAxiosRequestConfig) {
        return ProviderApiFp(this.configuration).getProviderAvailableSlotsProvidersProviderIdAvailabilitySlotsGet(providerId, start, end, pcrit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Provider Client Referrals
     * @param {ProviderId} providerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProviderClientReferralsProvidersProviderIdClientReferralsGet(providerId: ProviderId, options?: RawAxiosRequestConfig) {
        return ProviderApiFp(this.configuration).getProviderClientReferralsProvidersProviderIdClientReferralsGet(providerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Provider Confirmation Status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProviderConfirmationStatusProviderConfirmGet(options?: RawAxiosRequestConfig) {
        return ProviderApiFp(this.configuration).getProviderConfirmationStatusProviderConfirmGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Provider Details Basic
     * @param {string} providerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProviderDetailsBasicProvidersProviderIdBasicGet(providerId: string, options?: RawAxiosRequestConfig) {
        return ProviderApiFp(this.configuration).getProviderDetailsBasicProvidersProviderIdBasicGet(providerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Provider Details
     * @param {ProviderId} providerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProviderDetailsProvidersProviderIdGet(providerId: ProviderId, options?: RawAxiosRequestConfig) {
        return ProviderApiFp(this.configuration).getProviderDetailsProvidersProviderIdGet(providerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Provider Identity
     * @param {string} providerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProviderIdentityProvidersProviderIdIdentityGet(providerId: string, options?: RawAxiosRequestConfig) {
        return ProviderApiFp(this.configuration).getProviderIdentityProvidersProviderIdIdentityGet(providerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Provider Practice Metrics
     * @param {string} providerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProviderPracticeMetricsProvidersProviderIdPracticeMetricsGet(providerId: string, options?: RawAxiosRequestConfig) {
        return ProviderApiFp(this.configuration).getProviderPracticeMetricsProvidersProviderIdPracticeMetricsGet(providerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific provider profile by ID. This will return the full details of the provider profile.
     * @summary Get Provider Profile By Id
     * @param {string} providerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProviderProfileByIdProviderProfilesProviderIdGet(providerId: string, options?: RawAxiosRequestConfig) {
        return ProviderApiFp(this.configuration).getProviderProfileByIdProviderProfilesProviderIdGet(providerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific provider profile by slug. This will return the full details of the provider profile.
     * @summary Get Provider Profile By Slug
     * @param {string} slug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProviderProfileBySlugProviderProfilesBySlugSlugGet(slug: string, options?: RawAxiosRequestConfig) {
        return ProviderApiFp(this.configuration).getProviderProfileBySlugProviderProfilesBySlugSlugGet(slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Provider Public Rating
     * @param {string} providerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProviderPublicRatingProvidersProviderIdPublicRatingGet(providerId: string, options?: RawAxiosRequestConfig) {
        return ProviderApiFp(this.configuration).getProviderPublicRatingProvidersProviderIdPublicRatingGet(providerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Provider Public Reputation
     * @param {string} providerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProviderPublicReputationProvidersProviderIdPublicReputationGet(providerId: string, options?: RawAxiosRequestConfig) {
        return ProviderApiFp(this.configuration).getProviderPublicReputationProvidersProviderIdPublicReputationGet(providerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Admin-only endpoint to fetch a provider\'s current ranking factors and computed score.  Returns all the data that would be used to compute this provider\'s ranking, along with their current computed score and status.  This endpoint now uses the decoupled ranking logic from ProviderRankExportApplication.
     * @summary Get Provider Ranking Factors
     * @param {string} providerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProviderRankingFactorsAdminProvidersProviderIdRankingFactorsGet(providerId: string, options?: RawAxiosRequestConfig) {
        return ProviderApiFp(this.configuration).getProviderRankingFactorsAdminProvidersProviderIdRankingFactorsGet(providerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Provider Rates
     * @param {ProviderId} providerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProviderRatesProvidersProviderIdRatesGet(providerId: ProviderId, options?: RawAxiosRequestConfig) {
        return ProviderApiFp(this.configuration).getProviderRatesProvidersProviderIdRatesGet(providerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get reference data for providers, including specialties, modalities, and insurances.
     * @summary Get Provider Reference Data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProviderReferenceDataProviderProfilesReferenceDataGet(options?: RawAxiosRequestConfig) {
        return ProviderApiFp(this.configuration).getProviderReferenceDataProviderProfilesReferenceDataGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Provider Reputation
     * @param {ProviderId} providerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProviderReputationProvidersProviderIdReputationGet(providerId: ProviderId, options?: RawAxiosRequestConfig) {
        return ProviderApiFp(this.configuration).getProviderReputationProvidersProviderIdReputationGet(providerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Provider Review Link
     * @param {string} providerId 
     * @param {string | null} [appointmentId] 
     * @param {number | null} [rating] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProviderReviewLinkProvidersProviderIdReviewGet(providerId: string, appointmentId?: string | null, rating?: number | null, options?: RawAxiosRequestConfig) {
        return ProviderApiFp(this.configuration).getProviderReviewLinkProvidersProviderIdReviewGet(providerId, appointmentId, rating, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Providers Admin
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string | null} [searchQuery] Search for providers by name or email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProvidersAdminAdminProvidersGet(limit?: number, offset?: number, searchQuery?: string | null, options?: RawAxiosRequestConfig) {
        return ProviderApiFp(this.configuration).getProvidersAdminAdminProvidersGet(limit, offset, searchQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Providers For Patient
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProvidersForPatientProvidersGet(options?: RawAxiosRequestConfig) {
        return ProviderApiFp(this.configuration).getProvidersForPatientProvidersGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Admin-only endpoint to fetch the current live ranking configuration.  Returns both dynamic config values and feature flag states that affect provider ranking calculations.
     * @summary Get Ranking Configuration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRankingConfigurationAdminProvidersRankingConfigurationGet(options?: RawAxiosRequestConfig) {
        return ProviderApiFp(this.configuration).getRankingConfigurationAdminProvidersRankingConfigurationGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all active provider profiles. Providers will be returned in descending order according to their ranking.
     * @summary List Provider Profiles
     * @param {Set<string>} [insurance] Set of insurances to filter by (specified as slugs). Note: If multiple values are provided, they will be combined with a logical OR.
     * @param {Set<string>} [specialties] Set of provider specialties to filter by (specified as slugs). Note: If multiple values are provided, they will be combined with a logical AND.
     * @param {Set<string>} [modalities] Set of provider modalities to filter by (specified as slugs). Note: If multiple values are provided, they will be combined with a logical AND.
     * @param {Set<string>} [identities] Set of provider identities to filter by (specified as slugs) Note: If multiple values are provided, they will be combined with a logical AND.
     * @param {Set<ProviderAvailabilityType>} [availabilityType] Set of provider availability types to filter by. Note: If multiple values are provided, they will be combined with a logical OR.
     * @param {Set<USState>} [supportedUsStates] Set of US states to filter by. Note: If multiple values are provided, they will be combined with a logical OR.
     * @param {USState | null} [locationUsState] Target providers within the US state, based on their practice location.This is used in sorting (preferencing in-state providers) but not filitering
     * @param {string | null} [locationCoordinates] Targets providers in proximity to the specified coordinates, based on their practice location. This is used in sorting (preferencing proximate providers) and filtering when radius_miles is provided. Expected format is \&#39;lat,lon\&#39; (e.g., \&#39;37.7749,-122.4194\&#39;).
     * @param {number | null} [radiusMiles] Filters providers based on proximity to the location_coordinates. Note: location_coordinates must be provided.
     * @param {number} [page] Page number to retrieve. If provided, this will override the continuation_token for pagination and return a page number in the result set
     * @param {number} [limit] Maximum number of results to return in a single response
     * @param {ProviderProfileSortOrder} [sortOrder] Sort order for the results, will be from highest to lowest
     * @param {boolean} [disableAvailableNowSorting] If true, available now providers will not be prioritized at the top of results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listProviderProfilesProviderProfilesGet(insurance?: Set<string>, specialties?: Set<string>, modalities?: Set<string>, identities?: Set<string>, availabilityType?: Set<ProviderAvailabilityType>, supportedUsStates?: Set<USState>, locationUsState?: USState | null, locationCoordinates?: string | null, radiusMiles?: number | null, page?: number, limit?: number, sortOrder?: ProviderProfileSortOrder, disableAvailableNowSorting?: boolean, options?: RawAxiosRequestConfig) {
        return ProviderApiFp(this.configuration).listProviderProfilesProviderProfilesGet(insurance, specialties, modalities, identities, availabilityType, supportedUsStates, locationUsState, locationCoordinates, radiusMiles, page, limit, sortOrder, disableAvailableNowSorting, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Offboard Provider
     * @param {string} providerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public offboardProviderAdminProvidersProviderIdOffboardPost(providerId: string, options?: RawAxiosRequestConfig) {
        return ProviderApiFp(this.configuration).offboardProviderAdminProvidersProviderIdOffboardPost(providerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Provider Confirmation
     * @param {ProviderConfirmationPayload} providerConfirmationPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public providerConfirmationProviderConfirmPost(providerConfirmationPayload: ProviderConfirmationPayload, options?: RawAxiosRequestConfig) {
        return ProviderApiFp(this.configuration).providerConfirmationProviderConfirmPost(providerConfirmationPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * We should really be careful with this endpoint as it can be used indiscriminately. If an attacker wants to mess with our platform, they could overwhelm our database with fake impressions. We should consider rate limiting this endpoint with a platform-wide rate limiter, probably backed by Redis.
     * @summary Record Client Referral Impression
     * @param {ClientReferralImpressionPayload} clientReferralImpressionPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public recordClientReferralImpressionProvidersClientReferralsImpressionPost(clientReferralImpressionPayload: ClientReferralImpressionPayload, options?: RawAxiosRequestConfig) {
        return ProviderApiFp(this.configuration).recordClientReferralImpressionProvidersClientReferralsImpressionPost(clientReferralImpressionPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Register Provider
     * @param {RegisterProviderPayload} registerProviderPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public registerProviderProvidersPost(registerProviderPayload: RegisterProviderPayload, options?: RawAxiosRequestConfig) {
        return ProviderApiFp(this.configuration).registerProviderProvidersPost(registerProviderPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resend Provider Invite
     * @param {string} providerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public resendProviderInviteProvidersResendProviderInvitePost(providerId: string, options?: RawAxiosRequestConfig) {
        return ProviderApiFp(this.configuration).resendProviderInviteProvidersResendProviderInvitePost(providerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reset Provider Password
     * @param {string} providerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public resetProviderPasswordProvidersProviderIdPasswordResetPost(providerId: string, options?: RawAxiosRequestConfig) {
        return ProviderApiFp(this.configuration).resetProviderPasswordProvidersProviderIdPasswordResetPost(providerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send Provider Client Referral Sms
     * @param {ProviderId} providerId 
     * @param {SendClientReferralSMSPayload} sendClientReferralSMSPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sendProviderClientReferralSmsProvidersProviderIdClientReferralsSmsPost(providerId: ProviderId, sendClientReferralSMSPayload: SendClientReferralSMSPayload, options?: RawAxiosRequestConfig) {
        return ProviderApiFp(this.configuration).sendProviderClientReferralSmsProvidersProviderIdClientReferralsSmsPost(providerId, sendClientReferralSMSPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set Google Calendar Oauth
     * @param {string} code 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public setGoogleCalendarOauthProvidersMeGooglePost(code: string, options?: RawAxiosRequestConfig) {
        return ProviderApiFp(this.configuration).setGoogleCalendarOauthProvidersMeGooglePost(code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Solicit Provider Review
     * @param {string} providerId 
     * @param {SolicitProviderReviewPayload} solicitProviderReviewPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public solicitProviderReviewProvidersProviderIdReviewSolicitationPost(providerId: string, solicitProviderReviewPayload: SolicitProviderReviewPayload, options?: RawAxiosRequestConfig) {
        return ProviderApiFp(this.configuration).solicitProviderReviewProvidersProviderIdReviewSolicitationPost(providerId, solicitProviderReviewPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Provider Feedback
     * @param {string} providerId 
     * @param {string} reviewId 
     * @param {ProviderFeedbackPayload} providerFeedbackPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateProviderFeedbackProvidersProviderIdReviewReviewIdPut(providerId: string, reviewId: string, providerFeedbackPayload: ProviderFeedbackPayload, options?: RawAxiosRequestConfig) {
        return ProviderApiFp(this.configuration).updateProviderFeedbackProvidersProviderIdReviewReviewIdPut(providerId, reviewId, providerFeedbackPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create or replace the profile for a provider.  Requires authentication as the provider or an admin. The background and approach fields must be accompanied by valid JWT validation tokens obtained from the validate-field endpoint.
     * @summary Update Provider Profile
     * @param {ProviderId} providerId 
     * @param {UpdateProviderProfilePayload} updateProviderProfilePayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateProviderProfileProviderProfilesProviderIdPut(providerId: ProviderId, updateProviderProfilePayload: UpdateProviderProfilePayload, options?: RawAxiosRequestConfig) {
        return ProviderApiFp(this.configuration).updateProviderProfileProviderProfilesProviderIdPut(providerId, updateProviderProfilePayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Provider
     * @param {ProviderId} providerId 
     * @param {UpdateProviderPayload} updateProviderPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateProviderProvidersProviderIdPatch(providerId: ProviderId, updateProviderPayload: UpdateProviderPayload, options?: RawAxiosRequestConfig) {
        return ProviderApiFp(this.configuration).updateProviderProvidersProviderIdPatch(providerId, updateProviderPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Validate Provider Profile Field
     * @param {ProviderId} providerId 
     * @param {ProviderProfileValidateFieldRequest} providerProfileValidateFieldRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateProviderProfileFieldProviderProfilesProviderIdValidateFieldPost(providerId: ProviderId, providerProfileValidateFieldRequest: ProviderProfileValidateFieldRequest, options?: RawAxiosRequestConfig) {
        return ProviderApiFp(this.configuration).validateProviderProfileFieldProviderProfilesProviderIdValidateFieldPost(providerId, providerProfileValidateFieldRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Validate Provider Profile Image Field
     * @param {string} providerId 
     * @param {ProviderProfileValidationImageRequest} providerProfileValidationImageRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateProviderProfileImageFieldProviderProfilesProviderIdValidateImageFieldPost(providerId: string, providerProfileValidationImageRequest: ProviderProfileValidationImageRequest, options?: RawAxiosRequestConfig) {
        return ProviderApiFp(this.configuration).validateProviderProfileImageFieldProviderProfilesProviderIdValidateImageFieldPost(providerId, providerProfileValidationImageRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verify Provider Client Referral Token
     * @param {string} providerId 
     * @param {VerifyTokenPayload} verifyTokenPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public verifyProviderClientReferralTokenProvidersProviderIdClientReferralsVerifyPost(providerId: string, verifyTokenPayload: VerifyTokenPayload, options?: RawAxiosRequestConfig) {
        return ProviderApiFp(this.configuration).verifyProviderClientReferralTokenProvidersProviderIdClientReferralsVerifyPost(providerId, verifyTokenPayload, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StreakApi - axios parameter creator
 */
export const StreakApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Claim Prize
         * @param {string} prizeId 
         * @param {PatientId} patientId 
         * @param {ClaimPrizePayload} [claimPrizePayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimPrizePatientsPatientIdPrizesPrizeIdClaimPost: async (prizeId: string, patientId: PatientId, claimPrizePayload?: ClaimPrizePayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prizeId' is not null or undefined
            assertParamExists('claimPrizePatientsPatientIdPrizesPrizeIdClaimPost', 'prizeId', prizeId)
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('claimPrizePatientsPatientIdPrizesPrizeIdClaimPost', 'patientId', patientId)
            const localVarPath = `/patients/{patient_id}/prizes/{prize_id}/claim`
                .replace(`{${"prize_id"}}`, encodeURIComponent(String(prizeId)))
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(claimPrizePayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Claim Reward
         * @param {string} rewardId 
         * @param {PatientId} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimRewardPatientsPatientIdRewardsRewardIdClaimPost: async (rewardId: string, patientId: PatientId, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rewardId' is not null or undefined
            assertParamExists('claimRewardPatientsPatientIdRewardsRewardIdClaimPost', 'rewardId', rewardId)
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('claimRewardPatientsPatientIdRewardsRewardIdClaimPost', 'patientId', patientId)
            const localVarPath = `/patients/{patient_id}/rewards/{reward_id}/claim`
                .replace(`{${"reward_id"}}`, encodeURIComponent(String(rewardId)))
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Complete Patient Goal
         * @param {string} goalId 
         * @param {PatientId} patientId 
         * @param {CompleteGoalPayload} completeGoalPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completePatientGoalPatientsPatientIdGoalsGoalIdCompletePost: async (goalId: string, patientId: PatientId, completeGoalPayload: CompleteGoalPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'goalId' is not null or undefined
            assertParamExists('completePatientGoalPatientsPatientIdGoalsGoalIdCompletePost', 'goalId', goalId)
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('completePatientGoalPatientsPatientIdGoalsGoalIdCompletePost', 'patientId', patientId)
            // verify required parameter 'completeGoalPayload' is not null or undefined
            assertParamExists('completePatientGoalPatientsPatientIdGoalsGoalIdCompletePost', 'completeGoalPayload', completeGoalPayload)
            const localVarPath = `/patients/{patient_id}/goals/{goal_id}/complete`
                .replace(`{${"goal_id"}}`, encodeURIComponent(String(goalId)))
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeGoalPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Goal
         * @param {PatientId} patientId 
         * @param {CreateGoalPayload} createGoalPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGoalPatientsPatientIdGoalsPost: async (patientId: PatientId, createGoalPayload: CreateGoalPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('createGoalPatientsPatientIdGoalsPost', 'patientId', patientId)
            // verify required parameter 'createGoalPayload' is not null or undefined
            assertParamExists('createGoalPatientsPatientIdGoalsPost', 'createGoalPayload', createGoalPayload)
            const localVarPath = `/patients/{patient_id}/goals`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createGoalPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Patient Goal
         * @param {string} goalId 
         * @param {PatientId} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePatientGoalPatientsPatientIdGoalsGoalIdDelete: async (goalId: string, patientId: PatientId, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'goalId' is not null or undefined
            assertParamExists('deletePatientGoalPatientsPatientIdGoalsGoalIdDelete', 'goalId', goalId)
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('deletePatientGoalPatientsPatientIdGoalsGoalIdDelete', 'patientId', patientId)
            const localVarPath = `/patients/{patient_id}/goals/{goal_id}`
                .replace(`{${"goal_id"}}`, encodeURIComponent(String(goalId)))
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Challenges
         * @param {PatientId} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChallengesChallengesPatientIdGet: async (patientId: PatientId, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getChallengesChallengesPatientIdGet', 'patientId', patientId)
            const localVarPath = `/challenges/{patient_id}`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Patient Goals
         * @param {PatientId} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientGoalsPatientsPatientIdGoalsGet: async (patientId: PatientId, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getPatientGoalsPatientsPatientIdGoalsGet', 'patientId', patientId)
            const localVarPath = `/patients/{patient_id}/goals`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Patient Has Goals Feature Flag
         * @param {PatientId} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientHasGoalsFeatureFlagPatientsPatientIdHasGoalsFeatureGet: async (patientId: PatientId, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getPatientHasGoalsFeatureFlagPatientsPatientIdHasGoalsFeatureGet', 'patientId', patientId)
            const localVarPath = `/patients/{patient_id}/has-goals-feature`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Patient Prizes
         * @param {PatientId} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientPrizesPatientsPatientIdPrizesGet: async (patientId: PatientId, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getPatientPrizesPatientsPatientIdPrizesGet', 'patientId', patientId)
            const localVarPath = `/patients/{patient_id}/prizes`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Patient Referrer Profile
         * @param {PatientId} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientReferrerProfilePatientsPatientIdReferrerProfileGet: async (patientId: PatientId, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getPatientReferrerProfilePatientsPatientIdReferrerProfileGet', 'patientId', patientId)
            const localVarPath = `/patients/{patient_id}/referrer-profile`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Patient Rewards
         * @param {PatientId} patientId 
         * @param {boolean} [includeSpent] Whether to include spent rewards in the response.
         * @param {Array<RewardSourceType>} [acceptedSourceTypes] Accepted source types the client can handle.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientRewardsPatientsPatientIdRewardsGet: async (patientId: PatientId, includeSpent?: boolean, acceptedSourceTypes?: Array<RewardSourceType>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getPatientRewardsPatientsPatientIdRewardsGet', 'patientId', patientId)
            const localVarPath = `/patients/{patient_id}/rewards`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeSpent !== undefined) {
                localVarQueryParameter['include_spent'] = includeSpent;
            }

            if (acceptedSourceTypes) {
                localVarQueryParameter['accepted_source_types'] = acceptedSourceTypes;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * A public facing endpoint for fetching referral page details.
         * @summary Get Referrer Profile By Booking Code
         * @param {string} bookingCodeCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferrerProfileByBookingCodePatientsReferrerProfileBookingCodeCodeGet: async (bookingCodeCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingCodeCode' is not null or undefined
            assertParamExists('getReferrerProfileByBookingCodePatientsReferrerProfileBookingCodeCodeGet', 'bookingCodeCode', bookingCodeCode)
            const localVarPath = `/patients/referrer-profile/{booking_code_code}`
                .replace(`{${"booking_code_code"}}`, encodeURIComponent(String(bookingCodeCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Streaks
         * @param {string | null} [timezone] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStreaksStreaksGet: async (timezone?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/streaks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (timezone !== undefined) {
                localVarQueryParameter['timezone'] = timezone;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get sweepstakes expiration date.
         * @summary Get Sweepstakes Expiration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSweepstakesExpirationSweepstakesExpirationGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/sweepstakes-expiration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Post App Open
         * @param {string | null} [timezone] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAppOpenStreaksAppOpenPost: async (timezone?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/streaks/app-open`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (timezone !== undefined) {
                localVarQueryParameter['timezone'] = timezone;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Post Shared Content
         * @param {PatientId} patientId 
         * @param {SharedContentPayload} sharedContentPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postSharedContentPatientsPatientIdActivitiesSharedContentPost: async (patientId: PatientId, sharedContentPayload: SharedContentPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('postSharedContentPatientsPatientIdActivitiesSharedContentPost', 'patientId', patientId)
            // verify required parameter 'sharedContentPayload' is not null or undefined
            assertParamExists('postSharedContentPatientsPatientIdActivitiesSharedContentPost', 'sharedContentPayload', sharedContentPayload)
            const localVarPath = `/patients/{patient_id}/activities/shared-content`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sharedContentPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Post Shared Referral
         * @param {PatientId} patientId 
         * @param {SharedReferralPayload} sharedReferralPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postSharedReferralPatientsPatientIdActivitiesSharedReferralPost: async (patientId: PatientId, sharedReferralPayload: SharedReferralPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('postSharedReferralPatientsPatientIdActivitiesSharedReferralPost', 'patientId', patientId)
            // verify required parameter 'sharedReferralPayload' is not null or undefined
            assertParamExists('postSharedReferralPatientsPatientIdActivitiesSharedReferralPost', 'sharedReferralPayload', sharedReferralPayload)
            const localVarPath = `/patients/{patient_id}/activities/shared-referral`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sharedReferralPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Patient Goal
         * @param {string} goalId 
         * @param {PatientId} patientId 
         * @param {UpdateGoalPayload} updateGoalPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientGoalPatientsPatientIdGoalsGoalIdPut: async (goalId: string, patientId: PatientId, updateGoalPayload: UpdateGoalPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'goalId' is not null or undefined
            assertParamExists('updatePatientGoalPatientsPatientIdGoalsGoalIdPut', 'goalId', goalId)
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('updatePatientGoalPatientsPatientIdGoalsGoalIdPut', 'patientId', patientId)
            // verify required parameter 'updateGoalPayload' is not null or undefined
            assertParamExists('updatePatientGoalPatientsPatientIdGoalsGoalIdPut', 'updateGoalPayload', updateGoalPayload)
            const localVarPath = `/patients/{patient_id}/goals/{goal_id}`
                .replace(`{${"goal_id"}}`, encodeURIComponent(String(goalId)))
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateGoalPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StreakApi - functional programming interface
 */
export const StreakApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StreakApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Claim Prize
         * @param {string} prizeId 
         * @param {PatientId} patientId 
         * @param {ClaimPrizePayload} [claimPrizePayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async claimPrizePatientsPatientIdPrizesPrizeIdClaimPost(prizeId: string, patientId: PatientId, claimPrizePayload?: ClaimPrizePayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrizeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.claimPrizePatientsPatientIdPrizesPrizeIdClaimPost(prizeId, patientId, claimPrizePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StreakApi.claimPrizePatientsPatientIdPrizesPrizeIdClaimPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Claim Reward
         * @param {string} rewardId 
         * @param {PatientId} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async claimRewardPatientsPatientIdRewardsRewardIdClaimPost(rewardId: string, patientId: PatientId, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimRewardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.claimRewardPatientsPatientIdRewardsRewardIdClaimPost(rewardId, patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StreakApi.claimRewardPatientsPatientIdRewardsRewardIdClaimPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Complete Patient Goal
         * @param {string} goalId 
         * @param {PatientId} patientId 
         * @param {CompleteGoalPayload} completeGoalPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completePatientGoalPatientsPatientIdGoalsGoalIdCompletePost(goalId: string, patientId: PatientId, completeGoalPayload: CompleteGoalPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompletePatientGoalResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completePatientGoalPatientsPatientIdGoalsGoalIdCompletePost(goalId, patientId, completeGoalPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StreakApi.completePatientGoalPatientsPatientIdGoalsGoalIdCompletePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Goal
         * @param {PatientId} patientId 
         * @param {CreateGoalPayload} createGoalPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createGoalPatientsPatientIdGoalsPost(patientId: PatientId, createGoalPayload: CreateGoalPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientGoalResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createGoalPatientsPatientIdGoalsPost(patientId, createGoalPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StreakApi.createGoalPatientsPatientIdGoalsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Patient Goal
         * @param {string} goalId 
         * @param {PatientId} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePatientGoalPatientsPatientIdGoalsGoalIdDelete(goalId: string, patientId: PatientId, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePatientGoalPatientsPatientIdGoalsGoalIdDelete(goalId, patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StreakApi.deletePatientGoalPatientsPatientIdGoalsGoalIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Challenges
         * @param {PatientId} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChallengesChallengesPatientIdGet(patientId: PatientId, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChallengesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChallengesChallengesPatientIdGet(patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StreakApi.getChallengesChallengesPatientIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Patient Goals
         * @param {PatientId} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientGoalsPatientsPatientIdGoalsGet(patientId: PatientId, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientGoalsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientGoalsPatientsPatientIdGoalsGet(patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StreakApi.getPatientGoalsPatientsPatientIdGoalsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Patient Has Goals Feature Flag
         * @param {PatientId} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientHasGoalsFeatureFlagPatientsPatientIdHasGoalsFeatureGet(patientId: PatientId, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HasGoalsFeatureResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientHasGoalsFeatureFlagPatientsPatientIdHasGoalsFeatureGet(patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StreakApi.getPatientHasGoalsFeatureFlagPatientsPatientIdHasGoalsFeatureGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Patient Prizes
         * @param {PatientId} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientPrizesPatientsPatientIdPrizesGet(patientId: PatientId, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientPrizesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientPrizesPatientsPatientIdPrizesGet(patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StreakApi.getPatientPrizesPatientsPatientIdPrizesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Patient Referrer Profile
         * @param {PatientId} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientReferrerProfilePatientsPatientIdReferrerProfileGet(patientId: PatientId, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientReferrerProfileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientReferrerProfilePatientsPatientIdReferrerProfileGet(patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StreakApi.getPatientReferrerProfilePatientsPatientIdReferrerProfileGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Patient Rewards
         * @param {PatientId} patientId 
         * @param {boolean} [includeSpent] Whether to include spent rewards in the response.
         * @param {Array<RewardSourceType>} [acceptedSourceTypes] Accepted source types the client can handle.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatientRewardsPatientsPatientIdRewardsGet(patientId: PatientId, includeSpent?: boolean, acceptedSourceTypes?: Array<RewardSourceType>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientRewardsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientRewardsPatientsPatientIdRewardsGet(patientId, includeSpent, acceptedSourceTypes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StreakApi.getPatientRewardsPatientsPatientIdRewardsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * A public facing endpoint for fetching referral page details.
         * @summary Get Referrer Profile By Booking Code
         * @param {string} bookingCodeCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReferrerProfileByBookingCodePatientsReferrerProfileBookingCodeCodeGet(bookingCodeCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientReferrerProfileDisplayResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReferrerProfileByBookingCodePatientsReferrerProfileBookingCodeCodeGet(bookingCodeCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StreakApi.getReferrerProfileByBookingCodePatientsReferrerProfileBookingCodeCodeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Streaks
         * @param {string | null} [timezone] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStreaksStreaksGet(timezone?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StreakSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStreaksStreaksGet(timezone, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StreakApi.getStreaksStreaksGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get sweepstakes expiration date.
         * @summary Get Sweepstakes Expiration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSweepstakesExpirationSweepstakesExpirationGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SweepstakesExpirationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSweepstakesExpirationSweepstakesExpirationGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StreakApi.getSweepstakesExpirationSweepstakesExpirationGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Post App Open
         * @param {string | null} [timezone] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAppOpenStreaksAppOpenPost(timezone?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpenAppResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAppOpenStreaksAppOpenPost(timezone, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StreakApi.postAppOpenStreaksAppOpenPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Post Shared Content
         * @param {PatientId} patientId 
         * @param {SharedContentPayload} sharedContentPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postSharedContentPatientsPatientIdActivitiesSharedContentPost(patientId: PatientId, sharedContentPayload: SharedContentPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RewardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postSharedContentPatientsPatientIdActivitiesSharedContentPost(patientId, sharedContentPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StreakApi.postSharedContentPatientsPatientIdActivitiesSharedContentPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Post Shared Referral
         * @param {PatientId} patientId 
         * @param {SharedReferralPayload} sharedReferralPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postSharedReferralPatientsPatientIdActivitiesSharedReferralPost(patientId: PatientId, sharedReferralPayload: SharedReferralPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SharedReferralResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postSharedReferralPatientsPatientIdActivitiesSharedReferralPost(patientId, sharedReferralPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StreakApi.postSharedReferralPatientsPatientIdActivitiesSharedReferralPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Patient Goal
         * @param {string} goalId 
         * @param {PatientId} patientId 
         * @param {UpdateGoalPayload} updateGoalPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePatientGoalPatientsPatientIdGoalsGoalIdPut(goalId: string, patientId: PatientId, updateGoalPayload: UpdateGoalPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientGoalResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePatientGoalPatientsPatientIdGoalsGoalIdPut(goalId, patientId, updateGoalPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StreakApi.updatePatientGoalPatientsPatientIdGoalsGoalIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StreakApi - factory interface
 */
export const StreakApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StreakApiFp(configuration)
    return {
        /**
         * 
         * @summary Claim Prize
         * @param {string} prizeId 
         * @param {PatientId} patientId 
         * @param {ClaimPrizePayload} [claimPrizePayload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimPrizePatientsPatientIdPrizesPrizeIdClaimPost(prizeId: string, patientId: PatientId, claimPrizePayload?: ClaimPrizePayload, options?: RawAxiosRequestConfig): AxiosPromise<PrizeResponse> {
            return localVarFp.claimPrizePatientsPatientIdPrizesPrizeIdClaimPost(prizeId, patientId, claimPrizePayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Claim Reward
         * @param {string} rewardId 
         * @param {PatientId} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimRewardPatientsPatientIdRewardsRewardIdClaimPost(rewardId: string, patientId: PatientId, options?: RawAxiosRequestConfig): AxiosPromise<ClaimRewardResponse> {
            return localVarFp.claimRewardPatientsPatientIdRewardsRewardIdClaimPost(rewardId, patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Complete Patient Goal
         * @param {string} goalId 
         * @param {PatientId} patientId 
         * @param {CompleteGoalPayload} completeGoalPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completePatientGoalPatientsPatientIdGoalsGoalIdCompletePost(goalId: string, patientId: PatientId, completeGoalPayload: CompleteGoalPayload, options?: RawAxiosRequestConfig): AxiosPromise<CompletePatientGoalResponse> {
            return localVarFp.completePatientGoalPatientsPatientIdGoalsGoalIdCompletePost(goalId, patientId, completeGoalPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Goal
         * @param {PatientId} patientId 
         * @param {CreateGoalPayload} createGoalPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGoalPatientsPatientIdGoalsPost(patientId: PatientId, createGoalPayload: CreateGoalPayload, options?: RawAxiosRequestConfig): AxiosPromise<PatientGoalResponse> {
            return localVarFp.createGoalPatientsPatientIdGoalsPost(patientId, createGoalPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Patient Goal
         * @param {string} goalId 
         * @param {PatientId} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePatientGoalPatientsPatientIdGoalsGoalIdDelete(goalId: string, patientId: PatientId, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deletePatientGoalPatientsPatientIdGoalsGoalIdDelete(goalId, patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Challenges
         * @param {PatientId} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChallengesChallengesPatientIdGet(patientId: PatientId, options?: RawAxiosRequestConfig): AxiosPromise<ChallengesResponse> {
            return localVarFp.getChallengesChallengesPatientIdGet(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Patient Goals
         * @param {PatientId} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientGoalsPatientsPatientIdGoalsGet(patientId: PatientId, options?: RawAxiosRequestConfig): AxiosPromise<PatientGoalsResponse> {
            return localVarFp.getPatientGoalsPatientsPatientIdGoalsGet(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Patient Has Goals Feature Flag
         * @param {PatientId} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientHasGoalsFeatureFlagPatientsPatientIdHasGoalsFeatureGet(patientId: PatientId, options?: RawAxiosRequestConfig): AxiosPromise<HasGoalsFeatureResponse> {
            return localVarFp.getPatientHasGoalsFeatureFlagPatientsPatientIdHasGoalsFeatureGet(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Patient Prizes
         * @param {PatientId} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientPrizesPatientsPatientIdPrizesGet(patientId: PatientId, options?: RawAxiosRequestConfig): AxiosPromise<PatientPrizesResponse> {
            return localVarFp.getPatientPrizesPatientsPatientIdPrizesGet(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Patient Referrer Profile
         * @param {PatientId} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientReferrerProfilePatientsPatientIdReferrerProfileGet(patientId: PatientId, options?: RawAxiosRequestConfig): AxiosPromise<PatientReferrerProfileResponse> {
            return localVarFp.getPatientReferrerProfilePatientsPatientIdReferrerProfileGet(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Patient Rewards
         * @param {PatientId} patientId 
         * @param {boolean} [includeSpent] Whether to include spent rewards in the response.
         * @param {Array<RewardSourceType>} [acceptedSourceTypes] Accepted source types the client can handle.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientRewardsPatientsPatientIdRewardsGet(patientId: PatientId, includeSpent?: boolean, acceptedSourceTypes?: Array<RewardSourceType>, options?: RawAxiosRequestConfig): AxiosPromise<PatientRewardsResponse> {
            return localVarFp.getPatientRewardsPatientsPatientIdRewardsGet(patientId, includeSpent, acceptedSourceTypes, options).then((request) => request(axios, basePath));
        },
        /**
         * A public facing endpoint for fetching referral page details.
         * @summary Get Referrer Profile By Booking Code
         * @param {string} bookingCodeCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferrerProfileByBookingCodePatientsReferrerProfileBookingCodeCodeGet(bookingCodeCode: string, options?: RawAxiosRequestConfig): AxiosPromise<PatientReferrerProfileDisplayResponse> {
            return localVarFp.getReferrerProfileByBookingCodePatientsReferrerProfileBookingCodeCodeGet(bookingCodeCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Streaks
         * @param {string | null} [timezone] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStreaksStreaksGet(timezone?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<StreakSummaryResponse> {
            return localVarFp.getStreaksStreaksGet(timezone, options).then((request) => request(axios, basePath));
        },
        /**
         * Get sweepstakes expiration date.
         * @summary Get Sweepstakes Expiration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSweepstakesExpirationSweepstakesExpirationGet(options?: RawAxiosRequestConfig): AxiosPromise<SweepstakesExpirationResponse> {
            return localVarFp.getSweepstakesExpirationSweepstakesExpirationGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Post App Open
         * @param {string | null} [timezone] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAppOpenStreaksAppOpenPost(timezone?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<OpenAppResponse> {
            return localVarFp.postAppOpenStreaksAppOpenPost(timezone, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Post Shared Content
         * @param {PatientId} patientId 
         * @param {SharedContentPayload} sharedContentPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postSharedContentPatientsPatientIdActivitiesSharedContentPost(patientId: PatientId, sharedContentPayload: SharedContentPayload, options?: RawAxiosRequestConfig): AxiosPromise<RewardResponse> {
            return localVarFp.postSharedContentPatientsPatientIdActivitiesSharedContentPost(patientId, sharedContentPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Post Shared Referral
         * @param {PatientId} patientId 
         * @param {SharedReferralPayload} sharedReferralPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postSharedReferralPatientsPatientIdActivitiesSharedReferralPost(patientId: PatientId, sharedReferralPayload: SharedReferralPayload, options?: RawAxiosRequestConfig): AxiosPromise<SharedReferralResponse> {
            return localVarFp.postSharedReferralPatientsPatientIdActivitiesSharedReferralPost(patientId, sharedReferralPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Patient Goal
         * @param {string} goalId 
         * @param {PatientId} patientId 
         * @param {UpdateGoalPayload} updateGoalPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatientGoalPatientsPatientIdGoalsGoalIdPut(goalId: string, patientId: PatientId, updateGoalPayload: UpdateGoalPayload, options?: RawAxiosRequestConfig): AxiosPromise<PatientGoalResponse> {
            return localVarFp.updatePatientGoalPatientsPatientIdGoalsGoalIdPut(goalId, patientId, updateGoalPayload, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StreakApi - object-oriented interface
 */
export class StreakApi extends BaseAPI {
    /**
     * 
     * @summary Claim Prize
     * @param {string} prizeId 
     * @param {PatientId} patientId 
     * @param {ClaimPrizePayload} [claimPrizePayload] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public claimPrizePatientsPatientIdPrizesPrizeIdClaimPost(prizeId: string, patientId: PatientId, claimPrizePayload?: ClaimPrizePayload, options?: RawAxiosRequestConfig) {
        return StreakApiFp(this.configuration).claimPrizePatientsPatientIdPrizesPrizeIdClaimPost(prizeId, patientId, claimPrizePayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Claim Reward
     * @param {string} rewardId 
     * @param {PatientId} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public claimRewardPatientsPatientIdRewardsRewardIdClaimPost(rewardId: string, patientId: PatientId, options?: RawAxiosRequestConfig) {
        return StreakApiFp(this.configuration).claimRewardPatientsPatientIdRewardsRewardIdClaimPost(rewardId, patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Complete Patient Goal
     * @param {string} goalId 
     * @param {PatientId} patientId 
     * @param {CompleteGoalPayload} completeGoalPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public completePatientGoalPatientsPatientIdGoalsGoalIdCompletePost(goalId: string, patientId: PatientId, completeGoalPayload: CompleteGoalPayload, options?: RawAxiosRequestConfig) {
        return StreakApiFp(this.configuration).completePatientGoalPatientsPatientIdGoalsGoalIdCompletePost(goalId, patientId, completeGoalPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Goal
     * @param {PatientId} patientId 
     * @param {CreateGoalPayload} createGoalPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createGoalPatientsPatientIdGoalsPost(patientId: PatientId, createGoalPayload: CreateGoalPayload, options?: RawAxiosRequestConfig) {
        return StreakApiFp(this.configuration).createGoalPatientsPatientIdGoalsPost(patientId, createGoalPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Patient Goal
     * @param {string} goalId 
     * @param {PatientId} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deletePatientGoalPatientsPatientIdGoalsGoalIdDelete(goalId: string, patientId: PatientId, options?: RawAxiosRequestConfig) {
        return StreakApiFp(this.configuration).deletePatientGoalPatientsPatientIdGoalsGoalIdDelete(goalId, patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Challenges
     * @param {PatientId} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getChallengesChallengesPatientIdGet(patientId: PatientId, options?: RawAxiosRequestConfig) {
        return StreakApiFp(this.configuration).getChallengesChallengesPatientIdGet(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Patient Goals
     * @param {PatientId} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPatientGoalsPatientsPatientIdGoalsGet(patientId: PatientId, options?: RawAxiosRequestConfig) {
        return StreakApiFp(this.configuration).getPatientGoalsPatientsPatientIdGoalsGet(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Patient Has Goals Feature Flag
     * @param {PatientId} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPatientHasGoalsFeatureFlagPatientsPatientIdHasGoalsFeatureGet(patientId: PatientId, options?: RawAxiosRequestConfig) {
        return StreakApiFp(this.configuration).getPatientHasGoalsFeatureFlagPatientsPatientIdHasGoalsFeatureGet(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Patient Prizes
     * @param {PatientId} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPatientPrizesPatientsPatientIdPrizesGet(patientId: PatientId, options?: RawAxiosRequestConfig) {
        return StreakApiFp(this.configuration).getPatientPrizesPatientsPatientIdPrizesGet(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Patient Referrer Profile
     * @param {PatientId} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPatientReferrerProfilePatientsPatientIdReferrerProfileGet(patientId: PatientId, options?: RawAxiosRequestConfig) {
        return StreakApiFp(this.configuration).getPatientReferrerProfilePatientsPatientIdReferrerProfileGet(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Patient Rewards
     * @param {PatientId} patientId 
     * @param {boolean} [includeSpent] Whether to include spent rewards in the response.
     * @param {Array<RewardSourceType>} [acceptedSourceTypes] Accepted source types the client can handle.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPatientRewardsPatientsPatientIdRewardsGet(patientId: PatientId, includeSpent?: boolean, acceptedSourceTypes?: Array<RewardSourceType>, options?: RawAxiosRequestConfig) {
        return StreakApiFp(this.configuration).getPatientRewardsPatientsPatientIdRewardsGet(patientId, includeSpent, acceptedSourceTypes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * A public facing endpoint for fetching referral page details.
     * @summary Get Referrer Profile By Booking Code
     * @param {string} bookingCodeCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getReferrerProfileByBookingCodePatientsReferrerProfileBookingCodeCodeGet(bookingCodeCode: string, options?: RawAxiosRequestConfig) {
        return StreakApiFp(this.configuration).getReferrerProfileByBookingCodePatientsReferrerProfileBookingCodeCodeGet(bookingCodeCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Streaks
     * @param {string | null} [timezone] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getStreaksStreaksGet(timezone?: string | null, options?: RawAxiosRequestConfig) {
        return StreakApiFp(this.configuration).getStreaksStreaksGet(timezone, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get sweepstakes expiration date.
     * @summary Get Sweepstakes Expiration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSweepstakesExpirationSweepstakesExpirationGet(options?: RawAxiosRequestConfig) {
        return StreakApiFp(this.configuration).getSweepstakesExpirationSweepstakesExpirationGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Post App Open
     * @param {string | null} [timezone] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postAppOpenStreaksAppOpenPost(timezone?: string | null, options?: RawAxiosRequestConfig) {
        return StreakApiFp(this.configuration).postAppOpenStreaksAppOpenPost(timezone, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Post Shared Content
     * @param {PatientId} patientId 
     * @param {SharedContentPayload} sharedContentPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postSharedContentPatientsPatientIdActivitiesSharedContentPost(patientId: PatientId, sharedContentPayload: SharedContentPayload, options?: RawAxiosRequestConfig) {
        return StreakApiFp(this.configuration).postSharedContentPatientsPatientIdActivitiesSharedContentPost(patientId, sharedContentPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Post Shared Referral
     * @param {PatientId} patientId 
     * @param {SharedReferralPayload} sharedReferralPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postSharedReferralPatientsPatientIdActivitiesSharedReferralPost(patientId: PatientId, sharedReferralPayload: SharedReferralPayload, options?: RawAxiosRequestConfig) {
        return StreakApiFp(this.configuration).postSharedReferralPatientsPatientIdActivitiesSharedReferralPost(patientId, sharedReferralPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Patient Goal
     * @param {string} goalId 
     * @param {PatientId} patientId 
     * @param {UpdateGoalPayload} updateGoalPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updatePatientGoalPatientsPatientIdGoalsGoalIdPut(goalId: string, patientId: PatientId, updateGoalPayload: UpdateGoalPayload, options?: RawAxiosRequestConfig) {
        return StreakApiFp(this.configuration).updatePatientGoalPatientsPatientIdGoalsGoalIdPut(goalId, patientId, updateGoalPayload, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VideoApi - axios parameter creator
 */
export const VideoApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add Recording Bot To Meeting
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRecordingBotToMeetingAppointmentsAppointmentIdRecordPost: async (appointmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentId' is not null or undefined
            assertParamExists('addRecordingBotToMeetingAppointmentsAppointmentIdRecordPost', 'appointmentId', appointmentId)
            const localVarPath = `/appointments/{appointment_id}/record`
                .replace(`{${"appointment_id"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Appointment Video Call
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentVideoCallAppointmentsAppointmentIdVideoCallGet: async (appointmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appointmentId' is not null or undefined
            assertParamExists('getAppointmentVideoCallAppointmentsAppointmentIdVideoCallGet', 'appointmentId', appointmentId)
            const localVarPath = `/appointments/{appointment_id}/video-call`
                .replace(`{${"appointment_id"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VideoApi - functional programming interface
 */
export const VideoApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VideoApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add Recording Bot To Meeting
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addRecordingBotToMeetingAppointmentsAppointmentIdRecordPost(appointmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addRecordingBotToMeetingAppointmentsAppointmentIdRecordPost(appointmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VideoApi.addRecordingBotToMeetingAppointmentsAppointmentIdRecordPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Appointment Video Call
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppointmentVideoCallAppointmentsAppointmentIdVideoCallGet(appointmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppointmentVideoCallResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppointmentVideoCallAppointmentsAppointmentIdVideoCallGet(appointmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VideoApi.getAppointmentVideoCallAppointmentsAppointmentIdVideoCallGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VideoApi - factory interface
 */
export const VideoApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VideoApiFp(configuration)
    return {
        /**
         * 
         * @summary Add Recording Bot To Meeting
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRecordingBotToMeetingAppointmentsAppointmentIdRecordPost(appointmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.addRecordingBotToMeetingAppointmentsAppointmentIdRecordPost(appointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Appointment Video Call
         * @param {string} appointmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentVideoCallAppointmentsAppointmentIdVideoCallGet(appointmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<AppointmentVideoCallResponse> {
            return localVarFp.getAppointmentVideoCallAppointmentsAppointmentIdVideoCallGet(appointmentId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VideoApi - object-oriented interface
 */
export class VideoApi extends BaseAPI {
    /**
     * 
     * @summary Add Recording Bot To Meeting
     * @param {string} appointmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addRecordingBotToMeetingAppointmentsAppointmentIdRecordPost(appointmentId: string, options?: RawAxiosRequestConfig) {
        return VideoApiFp(this.configuration).addRecordingBotToMeetingAppointmentsAppointmentIdRecordPost(appointmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Appointment Video Call
     * @param {string} appointmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAppointmentVideoCallAppointmentsAppointmentIdVideoCallGet(appointmentId: string, options?: RawAxiosRequestConfig) {
        return VideoApiFp(this.configuration).getAppointmentVideoCallAppointmentsAppointmentIdVideoCallGet(appointmentId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WebflowApi - axios parameter creator
 */
export const WebflowApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Webflow Oauth Callback
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webflowOauthCallbackWebflowOauthCallbackGet: async (code: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('webflowOauthCallbackWebflowOauthCallbackGet', 'code', code)
            const localVarPath = `/webflow/oauth-callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WebflowApi - functional programming interface
 */
export const WebflowApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WebflowApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Webflow Oauth Callback
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webflowOauthCallbackWebflowOauthCallbackGet(code: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webflowOauthCallbackWebflowOauthCallbackGet(code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebflowApi.webflowOauthCallbackWebflowOauthCallbackGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WebflowApi - factory interface
 */
export const WebflowApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WebflowApiFp(configuration)
    return {
        /**
         * 
         * @summary Webflow Oauth Callback
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webflowOauthCallbackWebflowOauthCallbackGet(code: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.webflowOauthCallbackWebflowOauthCallbackGet(code, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WebflowApi - object-oriented interface
 */
export class WebflowApi extends BaseAPI {
    /**
     * 
     * @summary Webflow Oauth Callback
     * @param {string} code 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public webflowOauthCallbackWebflowOauthCallbackGet(code: string, options?: RawAxiosRequestConfig) {
        return WebflowApiFp(this.configuration).webflowOauthCallbackWebflowOauthCallbackGet(code, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WithingsApi - axios parameter creator
 */
export const WithingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Prefill Data
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrefillDataWithingsPrefillGet: async (token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('getPrefillDataWithingsPrefillGet', 'token', token)
            const localVarPath = `/withings/prefill`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Record Withings Referral Impression
         * @param {WithingsReferralImpressionPayload} withingsReferralImpressionPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordWithingsReferralImpressionWithingsImpressionPost: async (withingsReferralImpressionPayload: WithingsReferralImpressionPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'withingsReferralImpressionPayload' is not null or undefined
            assertParamExists('recordWithingsReferralImpressionWithingsImpressionPost', 'withingsReferralImpressionPayload', withingsReferralImpressionPayload)
            const localVarPath = `/withings/impression`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(withingsReferralImpressionPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WithingsApi - functional programming interface
 */
export const WithingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WithingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Prefill Data
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrefillDataWithingsPrefillGet(token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WithingsReferralPrefillResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrefillDataWithingsPrefillGet(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WithingsApi.getPrefillDataWithingsPrefillGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Record Withings Referral Impression
         * @param {WithingsReferralImpressionPayload} withingsReferralImpressionPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recordWithingsReferralImpressionWithingsImpressionPost(withingsReferralImpressionPayload: WithingsReferralImpressionPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recordWithingsReferralImpressionWithingsImpressionPost(withingsReferralImpressionPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WithingsApi.recordWithingsReferralImpressionWithingsImpressionPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WithingsApi - factory interface
 */
export const WithingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WithingsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Prefill Data
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrefillDataWithingsPrefillGet(token: string, options?: RawAxiosRequestConfig): AxiosPromise<WithingsReferralPrefillResponse> {
            return localVarFp.getPrefillDataWithingsPrefillGet(token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Record Withings Referral Impression
         * @param {WithingsReferralImpressionPayload} withingsReferralImpressionPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordWithingsReferralImpressionWithingsImpressionPost(withingsReferralImpressionPayload: WithingsReferralImpressionPayload, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.recordWithingsReferralImpressionWithingsImpressionPost(withingsReferralImpressionPayload, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WithingsApi - object-oriented interface
 */
export class WithingsApi extends BaseAPI {
    /**
     * 
     * @summary Get Prefill Data
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPrefillDataWithingsPrefillGet(token: string, options?: RawAxiosRequestConfig) {
        return WithingsApiFp(this.configuration).getPrefillDataWithingsPrefillGet(token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Record Withings Referral Impression
     * @param {WithingsReferralImpressionPayload} withingsReferralImpressionPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public recordWithingsReferralImpressionWithingsImpressionPost(withingsReferralImpressionPayload: WithingsReferralImpressionPayload, options?: RawAxiosRequestConfig) {
        return WithingsApiFp(this.configuration).recordWithingsReferralImpressionWithingsImpressionPost(withingsReferralImpressionPayload, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ZocdocIntegrationApi - axios parameter creator
 */
export const ZocdocIntegrationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Cancel Appointment
         * @param {ZocdocAppointmentIdPayload} zocdocAppointmentIdPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelAppointmentPartnersZocdocAppointmentsCancelPost: async (zocdocAppointmentIdPayload: ZocdocAppointmentIdPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'zocdocAppointmentIdPayload' is not null or undefined
            assertParamExists('cancelAppointmentPartnersZocdocAppointmentsCancelPost', 'zocdocAppointmentIdPayload', zocdocAppointmentIdPayload)
            const localVarPath = `/partners/zocdoc/appointments/cancel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(zocdocAppointmentIdPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Appointment
         * @param {ZocdocCreateAppointmentPayload} zocdocCreateAppointmentPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAppointmentPartnersZocdocAppointmentsPost: async (zocdocCreateAppointmentPayload: ZocdocCreateAppointmentPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'zocdocCreateAppointmentPayload' is not null or undefined
            assertParamExists('createAppointmentPartnersZocdocAppointmentsPost', 'zocdocCreateAppointmentPayload', zocdocCreateAppointmentPayload)
            const localVarPath = `/partners/zocdoc/appointments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(zocdocCreateAppointmentPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Patient
         * @param {ZocdocCreatePatientPayload} zocdocCreatePatientPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientPartnersZocdocPatientsPost: async (zocdocCreatePatientPayload: ZocdocCreatePatientPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'zocdocCreatePatientPayload' is not null or undefined
            assertParamExists('createPatientPartnersZocdocPatientsPost', 'zocdocCreatePatientPayload', zocdocCreatePatientPayload)
            const localVarPath = `/partners/zocdoc/patients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(zocdocCreatePatientPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Appointment Cancellation Reasons
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentCancellationReasonsPartnersZocdocAppointmentCancellationReasonsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/partners/zocdoc/appointment_cancellation_reasons`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Appointment Statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentStatusesPartnersZocdocAppointmentStatusesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/partners/zocdoc/appointment_statuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Appointments By Ids
         * @param {Array<ZocdocAppointmentIdPayload>} zocdocAppointmentIdPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentsByIdsPartnersZocdocAppointmentsByIdsPost: async (zocdocAppointmentIdPayload: Array<ZocdocAppointmentIdPayload>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'zocdocAppointmentIdPayload' is not null or undefined
            assertParamExists('getAppointmentsByIdsPartnersZocdocAppointmentsByIdsPost', 'zocdocAppointmentIdPayload', zocdocAppointmentIdPayload)
            const localVarPath = `/partners/zocdoc/appointments/by_ids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(zocdocAppointmentIdPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Available Slot Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableSlotTypesPartnersZocdocAvailableSlotTypesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/partners/zocdoc/available_slot_types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Available Slots By Provider
         * @param {string} providerId 
         * @param {StartDate} startDate 
         * @param {EndDate} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableSlotsByProviderPartnersZocdocAvailableSlotsByProviderGet: async (providerId: string, startDate: StartDate, endDate: EndDate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('getAvailableSlotsByProviderPartnersZocdocAvailableSlotsByProviderGet', 'providerId', providerId)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getAvailableSlotsByProviderPartnersZocdocAvailableSlotsByProviderGet', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getAvailableSlotsByProviderPartnersZocdocAvailableSlotsByProviderGet', 'endDate', endDate)
            const localVarPath = `/partners/zocdoc/available_slots/by_provider`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (providerId !== undefined) {
                localVarQueryParameter['provider_id'] = providerId;
            }

            if (startDate !== undefined) {
                for (const [key, value] of Object.entries(startDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (endDate !== undefined) {
                for (const [key, value] of Object.entries(endDate)) {
                    localVarQueryParameter[key] = value;
                }
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Locations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationsPartnersZocdocLocationsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/partners/zocdoc/locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Provider
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderPartnersZocdocProvidersProviderIdGet: async (providerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('getProviderPartnersZocdocProvidersProviderIdGet', 'providerId', providerId)
            const localVarPath = `/partners/zocdoc/providers/{provider_id}`
                .replace(`{${"provider_id"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Providers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProvidersPartnersZocdocProvidersGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/partners/zocdoc/providers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Schedulable Resources
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchedulableResourcesPartnersZocdocSchedulableResourcesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/partners/zocdoc/schedulable_resources`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVersionPartnersZocdocVersionGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/partners/zocdoc/version`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Visit Reasons
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVisitReasonsPartnersZocdocVisitReasonsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/partners/zocdoc/visit_reasons`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The Zocdoc patient search is an OR-behavior search by a lot of information, but we only pay attention to email and phone number. We used to only search by email, but with phone number uniqueness [by way of has_phone_authentication_authority], we can now search by phone number as well.  Per Zocdoc\'s team, this search is an OR search, so a patient with a mismatched email but a matched phone number will still be returned, and vice versa. If a patient is found by both email and phone number, it should only appear once in the list, but ranked higher for a higher match.
         * @summary Search Patients
         * @param {ZocdocPatientSearchPayload} zocdocPatientSearchPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPatientsPartnersZocdocPatientsSearchPost: async (zocdocPatientSearchPayload: ZocdocPatientSearchPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'zocdocPatientSearchPayload' is not null or undefined
            assertParamExists('searchPatientsPartnersZocdocPatientsSearchPost', 'zocdocPatientSearchPayload', zocdocPatientSearchPayload)
            const localVarPath = `/partners/zocdoc/patients/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(zocdocPatientSearchPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ZocdocIntegrationApi - functional programming interface
 */
export const ZocdocIntegrationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ZocdocIntegrationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Cancel Appointment
         * @param {ZocdocAppointmentIdPayload} zocdocAppointmentIdPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelAppointmentPartnersZocdocAppointmentsCancelPost(zocdocAppointmentIdPayload: ZocdocAppointmentIdPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ZocdocAppointmentCancelResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelAppointmentPartnersZocdocAppointmentsCancelPost(zocdocAppointmentIdPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ZocdocIntegrationApi.cancelAppointmentPartnersZocdocAppointmentsCancelPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Appointment
         * @param {ZocdocCreateAppointmentPayload} zocdocCreateAppointmentPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAppointmentPartnersZocdocAppointmentsPost(zocdocCreateAppointmentPayload: ZocdocCreateAppointmentPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ZocdocCreateAppointmentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAppointmentPartnersZocdocAppointmentsPost(zocdocCreateAppointmentPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ZocdocIntegrationApi.createAppointmentPartnersZocdocAppointmentsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Patient
         * @param {ZocdocCreatePatientPayload} zocdocCreatePatientPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPatientPartnersZocdocPatientsPost(zocdocCreatePatientPayload: ZocdocCreatePatientPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ZocdocCreatePatientResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPatientPartnersZocdocPatientsPost(zocdocCreatePatientPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ZocdocIntegrationApi.createPatientPartnersZocdocPatientsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Appointment Cancellation Reasons
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppointmentCancellationReasonsPartnersZocdocAppointmentCancellationReasonsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<any>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppointmentCancellationReasonsPartnersZocdocAppointmentCancellationReasonsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ZocdocIntegrationApi.getAppointmentCancellationReasonsPartnersZocdocAppointmentCancellationReasonsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Appointment Statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppointmentStatusesPartnersZocdocAppointmentStatusesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ZocdocAppointmentStatus>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppointmentStatusesPartnersZocdocAppointmentStatusesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ZocdocIntegrationApi.getAppointmentStatusesPartnersZocdocAppointmentStatusesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Appointments By Ids
         * @param {Array<ZocdocAppointmentIdPayload>} zocdocAppointmentIdPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppointmentsByIdsPartnersZocdocAppointmentsByIdsPost(zocdocAppointmentIdPayload: Array<ZocdocAppointmentIdPayload>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ZocdocAppointment>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppointmentsByIdsPartnersZocdocAppointmentsByIdsPost(zocdocAppointmentIdPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ZocdocIntegrationApi.getAppointmentsByIdsPartnersZocdocAppointmentsByIdsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Available Slot Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableSlotTypesPartnersZocdocAvailableSlotTypesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<any>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableSlotTypesPartnersZocdocAvailableSlotTypesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ZocdocIntegrationApi.getAvailableSlotTypesPartnersZocdocAvailableSlotTypesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Available Slots By Provider
         * @param {string} providerId 
         * @param {StartDate} startDate 
         * @param {EndDate} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableSlotsByProviderPartnersZocdocAvailableSlotsByProviderGet(providerId: string, startDate: StartDate, endDate: EndDate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ZocdocAvailabilitySlot>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableSlotsByProviderPartnersZocdocAvailableSlotsByProviderGet(providerId, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ZocdocIntegrationApi.getAvailableSlotsByProviderPartnersZocdocAvailableSlotsByProviderGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Locations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocationsPartnersZocdocLocationsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocationsPartnersZocdocLocationsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ZocdocIntegrationApi.getLocationsPartnersZocdocLocationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Provider
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProviderPartnersZocdocProvidersProviderIdGet(providerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ZocdocProvider>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProviderPartnersZocdocProvidersProviderIdGet(providerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ZocdocIntegrationApi.getProviderPartnersZocdocProvidersProviderIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Providers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProvidersPartnersZocdocProvidersGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ZocdocProvider>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProvidersPartnersZocdocProvidersGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ZocdocIntegrationApi.getProvidersPartnersZocdocProvidersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Schedulable Resources
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSchedulableResourcesPartnersZocdocSchedulableResourcesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<any>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSchedulableResourcesPartnersZocdocSchedulableResourcesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ZocdocIntegrationApi.getSchedulableResourcesPartnersZocdocSchedulableResourcesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVersionPartnersZocdocVersionGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVersionPartnersZocdocVersionGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ZocdocIntegrationApi.getVersionPartnersZocdocVersionGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Visit Reasons
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVisitReasonsPartnersZocdocVisitReasonsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ZocdocVisitReason>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVisitReasonsPartnersZocdocVisitReasonsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ZocdocIntegrationApi.getVisitReasonsPartnersZocdocVisitReasonsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The Zocdoc patient search is an OR-behavior search by a lot of information, but we only pay attention to email and phone number. We used to only search by email, but with phone number uniqueness [by way of has_phone_authentication_authority], we can now search by phone number as well.  Per Zocdoc\'s team, this search is an OR search, so a patient with a mismatched email but a matched phone number will still be returned, and vice versa. If a patient is found by both email and phone number, it should only appear once in the list, but ranked higher for a higher match.
         * @summary Search Patients
         * @param {ZocdocPatientSearchPayload} zocdocPatientSearchPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchPatientsPartnersZocdocPatientsSearchPost(zocdocPatientSearchPayload: ZocdocPatientSearchPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ZocdocPatient>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchPatientsPartnersZocdocPatientsSearchPost(zocdocPatientSearchPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ZocdocIntegrationApi.searchPatientsPartnersZocdocPatientsSearchPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ZocdocIntegrationApi - factory interface
 */
export const ZocdocIntegrationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ZocdocIntegrationApiFp(configuration)
    return {
        /**
         * 
         * @summary Cancel Appointment
         * @param {ZocdocAppointmentIdPayload} zocdocAppointmentIdPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelAppointmentPartnersZocdocAppointmentsCancelPost(zocdocAppointmentIdPayload: ZocdocAppointmentIdPayload, options?: RawAxiosRequestConfig): AxiosPromise<ZocdocAppointmentCancelResponse> {
            return localVarFp.cancelAppointmentPartnersZocdocAppointmentsCancelPost(zocdocAppointmentIdPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Appointment
         * @param {ZocdocCreateAppointmentPayload} zocdocCreateAppointmentPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAppointmentPartnersZocdocAppointmentsPost(zocdocCreateAppointmentPayload: ZocdocCreateAppointmentPayload, options?: RawAxiosRequestConfig): AxiosPromise<ZocdocCreateAppointmentResponse> {
            return localVarFp.createAppointmentPartnersZocdocAppointmentsPost(zocdocCreateAppointmentPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Patient
         * @param {ZocdocCreatePatientPayload} zocdocCreatePatientPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientPartnersZocdocPatientsPost(zocdocCreatePatientPayload: ZocdocCreatePatientPayload, options?: RawAxiosRequestConfig): AxiosPromise<ZocdocCreatePatientResponse> {
            return localVarFp.createPatientPartnersZocdocPatientsPost(zocdocCreatePatientPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Appointment Cancellation Reasons
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentCancellationReasonsPartnersZocdocAppointmentCancellationReasonsGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<any>> {
            return localVarFp.getAppointmentCancellationReasonsPartnersZocdocAppointmentCancellationReasonsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Appointment Statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentStatusesPartnersZocdocAppointmentStatusesGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<ZocdocAppointmentStatus>> {
            return localVarFp.getAppointmentStatusesPartnersZocdocAppointmentStatusesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Appointments By Ids
         * @param {Array<ZocdocAppointmentIdPayload>} zocdocAppointmentIdPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentsByIdsPartnersZocdocAppointmentsByIdsPost(zocdocAppointmentIdPayload: Array<ZocdocAppointmentIdPayload>, options?: RawAxiosRequestConfig): AxiosPromise<Array<ZocdocAppointment>> {
            return localVarFp.getAppointmentsByIdsPartnersZocdocAppointmentsByIdsPost(zocdocAppointmentIdPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Available Slot Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableSlotTypesPartnersZocdocAvailableSlotTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<any>> {
            return localVarFp.getAvailableSlotTypesPartnersZocdocAvailableSlotTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Available Slots By Provider
         * @param {string} providerId 
         * @param {StartDate} startDate 
         * @param {EndDate} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableSlotsByProviderPartnersZocdocAvailableSlotsByProviderGet(providerId: string, startDate: StartDate, endDate: EndDate, options?: RawAxiosRequestConfig): AxiosPromise<Array<ZocdocAvailabilitySlot>> {
            return localVarFp.getAvailableSlotsByProviderPartnersZocdocAvailableSlotsByProviderGet(providerId, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Locations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationsPartnersZocdocLocationsGet(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getLocationsPartnersZocdocLocationsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Provider
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderPartnersZocdocProvidersProviderIdGet(providerId: string, options?: RawAxiosRequestConfig): AxiosPromise<ZocdocProvider> {
            return localVarFp.getProviderPartnersZocdocProvidersProviderIdGet(providerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Providers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProvidersPartnersZocdocProvidersGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<ZocdocProvider>> {
            return localVarFp.getProvidersPartnersZocdocProvidersGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Schedulable Resources
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchedulableResourcesPartnersZocdocSchedulableResourcesGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<any>> {
            return localVarFp.getSchedulableResourcesPartnersZocdocSchedulableResourcesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVersionPartnersZocdocVersionGet(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getVersionPartnersZocdocVersionGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Visit Reasons
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVisitReasonsPartnersZocdocVisitReasonsGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<ZocdocVisitReason>> {
            return localVarFp.getVisitReasonsPartnersZocdocVisitReasonsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * The Zocdoc patient search is an OR-behavior search by a lot of information, but we only pay attention to email and phone number. We used to only search by email, but with phone number uniqueness [by way of has_phone_authentication_authority], we can now search by phone number as well.  Per Zocdoc\'s team, this search is an OR search, so a patient with a mismatched email but a matched phone number will still be returned, and vice versa. If a patient is found by both email and phone number, it should only appear once in the list, but ranked higher for a higher match.
         * @summary Search Patients
         * @param {ZocdocPatientSearchPayload} zocdocPatientSearchPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPatientsPartnersZocdocPatientsSearchPost(zocdocPatientSearchPayload: ZocdocPatientSearchPayload, options?: RawAxiosRequestConfig): AxiosPromise<Array<ZocdocPatient>> {
            return localVarFp.searchPatientsPartnersZocdocPatientsSearchPost(zocdocPatientSearchPayload, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ZocdocIntegrationApi - object-oriented interface
 */
export class ZocdocIntegrationApi extends BaseAPI {
    /**
     * 
     * @summary Cancel Appointment
     * @param {ZocdocAppointmentIdPayload} zocdocAppointmentIdPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public cancelAppointmentPartnersZocdocAppointmentsCancelPost(zocdocAppointmentIdPayload: ZocdocAppointmentIdPayload, options?: RawAxiosRequestConfig) {
        return ZocdocIntegrationApiFp(this.configuration).cancelAppointmentPartnersZocdocAppointmentsCancelPost(zocdocAppointmentIdPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Appointment
     * @param {ZocdocCreateAppointmentPayload} zocdocCreateAppointmentPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createAppointmentPartnersZocdocAppointmentsPost(zocdocCreateAppointmentPayload: ZocdocCreateAppointmentPayload, options?: RawAxiosRequestConfig) {
        return ZocdocIntegrationApiFp(this.configuration).createAppointmentPartnersZocdocAppointmentsPost(zocdocCreateAppointmentPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Patient
     * @param {ZocdocCreatePatientPayload} zocdocCreatePatientPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createPatientPartnersZocdocPatientsPost(zocdocCreatePatientPayload: ZocdocCreatePatientPayload, options?: RawAxiosRequestConfig) {
        return ZocdocIntegrationApiFp(this.configuration).createPatientPartnersZocdocPatientsPost(zocdocCreatePatientPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Appointment Cancellation Reasons
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAppointmentCancellationReasonsPartnersZocdocAppointmentCancellationReasonsGet(options?: RawAxiosRequestConfig) {
        return ZocdocIntegrationApiFp(this.configuration).getAppointmentCancellationReasonsPartnersZocdocAppointmentCancellationReasonsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Appointment Statuses
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAppointmentStatusesPartnersZocdocAppointmentStatusesGet(options?: RawAxiosRequestConfig) {
        return ZocdocIntegrationApiFp(this.configuration).getAppointmentStatusesPartnersZocdocAppointmentStatusesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Appointments By Ids
     * @param {Array<ZocdocAppointmentIdPayload>} zocdocAppointmentIdPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAppointmentsByIdsPartnersZocdocAppointmentsByIdsPost(zocdocAppointmentIdPayload: Array<ZocdocAppointmentIdPayload>, options?: RawAxiosRequestConfig) {
        return ZocdocIntegrationApiFp(this.configuration).getAppointmentsByIdsPartnersZocdocAppointmentsByIdsPost(zocdocAppointmentIdPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Available Slot Types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAvailableSlotTypesPartnersZocdocAvailableSlotTypesGet(options?: RawAxiosRequestConfig) {
        return ZocdocIntegrationApiFp(this.configuration).getAvailableSlotTypesPartnersZocdocAvailableSlotTypesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Available Slots By Provider
     * @param {string} providerId 
     * @param {StartDate} startDate 
     * @param {EndDate} endDate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAvailableSlotsByProviderPartnersZocdocAvailableSlotsByProviderGet(providerId: string, startDate: StartDate, endDate: EndDate, options?: RawAxiosRequestConfig) {
        return ZocdocIntegrationApiFp(this.configuration).getAvailableSlotsByProviderPartnersZocdocAvailableSlotsByProviderGet(providerId, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Locations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getLocationsPartnersZocdocLocationsGet(options?: RawAxiosRequestConfig) {
        return ZocdocIntegrationApiFp(this.configuration).getLocationsPartnersZocdocLocationsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Provider
     * @param {string} providerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProviderPartnersZocdocProvidersProviderIdGet(providerId: string, options?: RawAxiosRequestConfig) {
        return ZocdocIntegrationApiFp(this.configuration).getProviderPartnersZocdocProvidersProviderIdGet(providerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Providers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProvidersPartnersZocdocProvidersGet(options?: RawAxiosRequestConfig) {
        return ZocdocIntegrationApiFp(this.configuration).getProvidersPartnersZocdocProvidersGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Schedulable Resources
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSchedulableResourcesPartnersZocdocSchedulableResourcesGet(options?: RawAxiosRequestConfig) {
        return ZocdocIntegrationApiFp(this.configuration).getSchedulableResourcesPartnersZocdocSchedulableResourcesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVersionPartnersZocdocVersionGet(options?: RawAxiosRequestConfig) {
        return ZocdocIntegrationApiFp(this.configuration).getVersionPartnersZocdocVersionGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Visit Reasons
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVisitReasonsPartnersZocdocVisitReasonsGet(options?: RawAxiosRequestConfig) {
        return ZocdocIntegrationApiFp(this.configuration).getVisitReasonsPartnersZocdocVisitReasonsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The Zocdoc patient search is an OR-behavior search by a lot of information, but we only pay attention to email and phone number. We used to only search by email, but with phone number uniqueness [by way of has_phone_authentication_authority], we can now search by phone number as well.  Per Zocdoc\'s team, this search is an OR search, so a patient with a mismatched email but a matched phone number will still be returned, and vice versa. If a patient is found by both email and phone number, it should only appear once in the list, but ranked higher for a higher match.
     * @summary Search Patients
     * @param {ZocdocPatientSearchPayload} zocdocPatientSearchPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchPatientsPartnersZocdocPatientsSearchPost(zocdocPatientSearchPayload: ZocdocPatientSearchPayload, options?: RawAxiosRequestConfig) {
        return ZocdocIntegrationApiFp(this.configuration).searchPatientsPartnersZocdocPatientsSearchPost(zocdocPatientSearchPayload, options).then((request) => request(this.axios, this.basePath));
    }
}



